import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import DOMPurify from "dompurify";
import {
  FormControlLabel,
  Checkbox,
  Button,
  Box,
  Grid,
  CircularProgress,
  Typography,
  Snackbar,
  Alert,
  RadioGroup,
  Switch,
  InputAdornment,
  useTheme,
  useMediaQuery,
  Tooltip,
  IconButton as IconButtonMui,
} from "@mui/material";
import { Skeleton } from "@mui/material";
import OfferCheckLoader from "../../ui/OfferCheckLoader";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, RootState } from "../../../services/redux/store";
import { RadioButton } from "../../ui/RadioButton";
import { IconButton } from "../../ui/Button";
import EntranceExamDetailsSection from "./EntranceExamDetailsSection";
import {
  nextVerticalStep,
  prevVerticalStep,
  updateFormData,
  setSelectedProduct,
  setIsMobileVerified,
  setIsEmailVerified,
  setTrackingId,
  setApplicationId,
  setApplicantId,
  setAadhaarApplicationNo,
  setHasPan,
  setIsPanVerified,
  setPanNumber,
  setAadhaarMandatory,
  setShowAadhaar,
  setLastPanNumber,
  setLastVerifiedPhoneNumber,
  setLastVerifiedEmail,
  setIsDocumentVerified,
  setAadhaarVerifiedDetails,
  setCoApplicantVerification,
  setCurrentCoApplicantIdx,
  setCgpaMode,
  setActiveHorizontalIndex,
  setBreData,
  setBreStatus,
  setIsEligible,
  setIsDocumentVerifiedCoApplicant,
  setAadhaarApplicationNoCoApplicant,
  setAadhaarVerifiedDetailsCoApplicant,
  setActiveVerticalIndex,
  setCoApplicantZipCodeData,
  setCheckIsLeadApiInvoked,
  setLeadSequenceId,
  setAssignedSMIdValue,
  setAadhaarSeedingStatus,
  setVerificationMessage,
  setApplicationSource,
  setEncryptionKey,
  setFetchUserApplicationData,
  setDisplayHorizontalSteps,
  bumpFormJsonRefreshNonce,
  setSummaryApplicationEditActive,
  setSummaryEditOpenedFromCoApplicantSection,
  setSummarySaveInProgress,
  setSkipNextSummaryRefetch,
  setreferenceOneId,
  setreferenceTwoId,
  setLoanDetailCoApplicantCollapseValue,
} from "../../../services/redux/slices/stepperDynamicFormSlice";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { setAdditionalSummaryActiveTab } from "../../../services/redux/slices/tabsSlice";
import eligibilityCheckServices from "../../../services/api/service/eligibilityCheckService";
import applicantDetailsServices from "../../../services/api/service/applicantDetailsService";
import applicationDetailsServices from "../../../services/api/service/applicationDetails";
import losServices from "../../../services/api/service/losService";
import { SectionHeader } from "../../ui/SectionHeader";
import idIcon from "./../../../assets/svgIcons/id.svg";
import booksIcon from "./../../../assets/svgIcons/book line.svg";
import loanIcon from "./../../../assets/svgIcons/Loan.svg";
import locationIcon from "./../../../assets/svgIcons/live-view.svg";
import academicIcon from "./../../../assets/svgIcons/academic-cap-green.svg";
import greenCheckVerified from "./../../../assets/svgIcons/green-check-verified.svg";
import arrowRightVerify from "./../../../assets/svgIcons/arrow-right-verify.svg";
import { CustomRadioGroup } from "../../ui/CustomRadioGroup";
import { InputField } from "../../ui/Inputs";
import AutoCompleteOptions from "../../ui/AutoComplete";
import ModalPopup from "../../ui/ModalPopup";
import OtpInputForm from "../../../pages/common-features/OtpInputForm";
import SelectOptions from "../../ui/SelectOptions";
import { PrimaryButton } from "../../ui/Button";
import postsServices from "../../../services/api/service/postsService";
import dropdownService from "../../../services/api/service/dropdownService";
import { getValidationSchema } from "../../../utils/validationSchemas";
import { isValidJourneyEmail } from "../../../utils/emailValidation";
import EligibilityConfirmation from "../../../pages/eligibility-check/EligibilityConfirmation";
import { FormGrid } from "../../ui/FormGrid";
import { authStatusSelector } from "../../../services/redux/slices/authSlice";
import type { FormikProps } from "formik";
import { decrypt, encryptData } from "../../../utils/crypto";
import CourseDetailsSection from "./CourseDetailsSection";
import CoApplicantDetailsSection from "./CoApplicantDetailsSection";
import LoaderBackdrop from "../../ui/LoaderBackdrop";
import { AnyCnameRecord } from "node:dns";
import { fetchUserApplicationsFormData } from "../../../services/api/service/userApplicationService";
import { getMasterOptionName } from "./formDataHelper";
import { setSalesUserId } from "../../../services/redux/slices/chatSlice";
import { getCollateralSaveErrorMessage, formatDateToDDMMYYYY, removeSalutation, debounce, mapGender, handleOwnershipStatusValue, handleUnwanted, splitAddressByWords,mapCollateral,numberToWord, buildCollateralFormDataEntries, getCollateralFormValue, getMergedCollateralFieldDefinitions, getCompleteCollateralNumbers, isFirstCollateralWithData, hasDuplicateCoOwnerNamesForCollateral, buildCoOwnerOwnershipDetailsList, buildSaveCollateralPayload, resolveCoOwnerApplicantIdMap, isCoOwnerCollateralNameField, getCoOwnerNameAutocompleteOptions, handleCoOwnerNameSelection, resolveCollateralNumbersToSave, normalizeBirthCityOption, resolveBirthCityId, applyCollateralAddressFromPincode, FUND_EXPENSE_CURRENCY_FIELDS, FUND_EXPENSE_CONDITIONAL_FIELDS, FUND_EXPENSE_LOAN_AMOUNT_FIELD, isAdmissionStatusConfirmed, getFundExpenseValidationState, getCollateralNumberFromFieldName, fieldBelongsToCollateralNumber, getReferenceCollateralValidationErrors, isCollateralStepAlreadySaved, isCoApplicantFieldLockedByCoOwner, extractFetchedApplicationVals, mergeSavedCoOwnersIntoFetchedData } from "../../../utils/helpers";
import { getSanitizedPublicKeyFromResponse } from "../../../utils/piiKey";
import { hasCoApplicantPayPartyChanged, getFetchedCoApplicantPayParty,getSavedCoApplicantFieldValues } from "./helperDynamic";
import {
  buildCoApplicantSaveIdDto,
  buildApplicantIdDtosBySection,
  APPLICANT_SECTION_BY_VERTICAL_INDEX,
} from "./helperDto";
import { useLocation, useNavigate } from "react-router-dom";
import { topCountry } from "../../../data/stepsData";
import { persistor } from "../../../services/redux/store";
import BasicDatePicker from "../../ui/BasicDatePicker";
import dayjs from "dayjs";
import {
  autoCompleteOffFields,
  callSaveCoApplicantApi,
  getCombinedApplicationSteps,
  getGAEligibilityStatements,
  getGAProvisionalOfferStatements,
  resolveRefreshSubmissionId,
  resolveRefreshSubmissionIdFromResponse,
  setZeroForFundAndExpenses,
} from "./helper";
import { OutlinedPrimaryButton } from "../../../components/ui/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { trackCustomerJourneyEvent } from "../../../utils/ga";
import SummarySectionHeader from "../../applicantDetailsTabs/SummarySectionHeader";
import { useApplicantMasterData } from "../../../hooks/useApplicantMasterData";
import ApplicantAdditionalDetails from "./AdditionalDetailsDocuments/ApplicantAdditionalDetails";
import FundExpenseDetails from "./AdditionalDetailsDocuments/FundExpenseDetails";
import ReferenceCollateralDetails from "./AdditionalDetailsDocuments/ReferenceCollateralDetails";
import AdditionalSummaryDetail from "../../../pages/summary/AdditionalSummaryDetail";
import { ROUTES } from "../../../routes/routerConfig";
import CoApplicantAdditionalDetails from "./AdditionalDetailsDocuments/CoApplicantAdditionalDetails";
import SingleCoApplicantAdditionalDetails from "./AdditionalDetailsDocuments/SingleCoApplicantAdditionalDetails";

/** Normalizes API/Redux boolean-ish flags (true, "true", 1, "1"). */
const isTruthyFormFlag = (value: unknown): boolean =>
  value === true ||
  value === "true" ||
  value === 1 ||
  value === "1";

const getAutocompleteOptionValue = (value: any): string => {
  if (value && typeof value === "object") {
    return String(value?.value ?? value?.label ?? "").trim();
  }

  return String(value ?? "").trim();
};

/**
 * Aadhaar / KYC payloads sometimes return locality fields as plain strings and
 * sometimes as nested objects (e.g. parsed XML). City autocomplete expects a
 * string or { value, label }; storing a raw object surfaces as "[object Object]".
 */
const normalizeAadhaarAddressPart = (raw: unknown): string => {
  if (raw === undefined || raw === null) return "";
  if (typeof raw === "string" || typeof raw === "number") {
    return String(raw).trim();
  }
  if (typeof raw === "object") {
    const o = raw as Record<string, unknown>;
    const nested =
      o.label ??
      o.value ??
      o.name ??
      o.districtName ??
      o.cityName ??
      o._ ??
      o.$ ??
      (o as { "#text"?: unknown })["#text"];
    if (nested !== undefined && nested !== null) {
      return normalizeAadhaarAddressPart(nested);
    }
  }
  return "";
};

const normalizeReferenceDetailsForSummary = (referenceRaw: any[]): any[] => {
  if (!Array.isArray(referenceRaw) || referenceRaw.length === 0) return [];

  const grouped = new Map<number, any[]>();
  const getReferenceIndex = (name: string, label: string, fallback: number) => {
    const source = `${name} ${label}`.toLowerCase();
    const specificMatch = source.match(
      /(?:basic|address)reference\s*(\d+)|(?:basic|address)reference(\d+)/i,
    );
    if (specificMatch?.[1] || specificMatch?.[2]) {
      return Number(specificMatch[1] || specificMatch[2]);
    }

    const genericMatch = source.match(/reference\s*(\d+)|reference(\d+)/i);
    return Number(genericMatch?.[1] || genericMatch?.[2]) || fallback;
  };

  referenceRaw.forEach((section: any, sectionIndex: number) => {
    const sectionKey = Object.keys(section || {})[0];
    const sectionFields = Array.isArray(section?.[sectionKey])
      ? section[sectionKey]
      : [];

    sectionFields.forEach((field: any) => {
      const referenceIndex = getReferenceIndex(
        String(field?.name || ""),
        String(field?.label || ""),
        sectionIndex + 1,
      );

      if (!grouped.has(referenceIndex)) grouped.set(referenceIndex, []);
      grouped.get(referenceIndex)!.push(field);
    });
  });

  if (grouped.size === 0) return referenceRaw;

  return Array.from(grouped.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([idx, fields]) => {
      const validPrefixes = [`basicreference${idx}`, `addressreference${idx}`];
      const filteredFields = fields.filter((field: any) => {
        const fieldName = String(field?.name || "").toLowerCase();
        if (!fieldName) return true;
        return validPrefixes.some((prefix) => fieldName.startsWith(prefix));
      });

      return {
        [`reference${idx}`]: filteredFields,
      };
    })
    .filter((item: any) => {
      const key = Object.keys(item || {})[0];
      return Array.isArray(item?.[key]) && item[key].length > 0;
    });
};

const normalizeCollateralDetailsForSummary = (collateralRaw: any[]): any[] => {
  if (!Array.isArray(collateralRaw) || collateralRaw.length === 0) return [];

  const grouped = new Map<number, { collateral: any[]; ownership: any[] }>();
  const ensureGroup = (idx: number) => {
    if (!grouped.has(idx)) {
      grouped.set(idx, { collateral: [], ownership: [] });
    }
    return grouped.get(idx)!;
  };

  const detectCollateralIndex = (field: any, fallback: number): number => {
    const source = `${field?.name || ""} ${field?.label || ""}`.toLowerCase();
    const match = source.match(/collateral\s*(\d+)|collateral(\d+)/i);
    const detected = Number(match?.[1] || match?.[2]);
    return Number.isFinite(detected) && detected > 0 ? detected : fallback;
  };

  collateralRaw.forEach((item: any, itemIndex: number) => {
    const itemKey = Object.keys(item || {})[0];
    const itemValue = item?.[itemKey] || {};

    const collateralFields = Array.isArray(itemValue?.collateral)
      ? itemValue.collateral
      : [];
    const ownershipItems = Array.isArray(itemValue?.ownership)
      ? itemValue.ownership
      : [];

    collateralFields.forEach((field: any) => {
      const idx = detectCollateralIndex(field, itemIndex + 1);
      ensureGroup(idx).collateral.push(field);
    });

    ownershipItems.forEach((ownerItem: any) => {
      const ownerKey = Object.keys(ownerItem || {})[0];
      const ownerFields = Array.isArray(ownerItem?.[ownerKey])
        ? ownerItem[ownerKey]
        : [];

      const idx = detectCollateralIndex(
        ownerFields?.[0] || { name: ownerKey, label: ownerKey },
        itemIndex + 1,
      );
      ensureGroup(idx).ownership.push({ [ownerKey]: ownerFields });
    });
  });

  if (grouped.size === 0) return collateralRaw;

  return Array.from(grouped.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([idx, details]) => {
      const collateralPrefix = `collateral${idx}`;
      const filteredCollateral = details.collateral.filter((field: any) => {
        const fieldName = String(field?.name || "").toLowerCase();
        if (!fieldName) return true;
        return fieldName.startsWith(collateralPrefix);
      });

      const ownershipPrefix = `coownercollateral${idx}_`;
      const filteredOwnership = details.ownership
        .map((ownerItem: any) => {
          const ownerKey = String(Object.keys(ownerItem || {})[0] || "");
          const ownerFields = Array.isArray(ownerItem?.[ownerKey])
            ? ownerItem[ownerKey]
            : [];

          const relevantOwnerFields = ownerFields.filter((field: any) => {
            const fieldName = String(field?.name || "").toLowerCase();
            if (!fieldName) return false;
            return fieldName.startsWith(ownershipPrefix);
          });

          return relevantOwnerFields.length > 0
            ? { [ownerKey || `coOwnerCollateral${idx}_1`]: relevantOwnerFields }
            : null;
        })
        .filter(Boolean);

      return {
        [`collateral${idx}`]: {
          collateral: filteredCollateral,
          ownership: filteredOwnership,
        },
      };
    })
    .filter((item: any) => {
      const key = Object.keys(item || {})[0];
      const val = item?.[key];
      return (
        (Array.isArray(val?.collateral) && val.collateral.length > 0) ||
        (Array.isArray(val?.ownership) && val.ownership.length > 0)
      );
    });
};

interface DynamicFormProps {
  fields?: any[];
  pageType: string;
  module?: string;
  activeHorizontalIndex?: number;
  activeVerticalIndex?: number;
  initialReferenceCollateralTab?: number;
  fetchData?:() => void;
  forceInlineFieldRender?: boolean;
  onSummaryCoApplicantSectionSave?: (tabIndex: number) => boolean | void;
  /** Matches requestSummaryFormSave(target); this editor ignores Saves aimed at another one. */
  summarySaveTargetKey?: string;
}
const FormEdit = ({ fields: rawFields, pageType = "SUMMARY", activeHorizontalIndex: propHorizontalIndex, activeVerticalIndex: propVerticalIndex, initialReferenceCollateralTab,fetchData, forceInlineFieldRender = false, onSummaryCoApplicantSectionSave, summarySaveTargetKey = "application" }: DynamicFormProps) => {
  const fields = useMemo(() => {
    if (!Array.isArray(rawFields)) return [];
    return rawFields
      .map((field) => ({
        ...field,
      }));
  }, [rawFields]);
  const dispatch = useDispatch<AppDispatch>();
  // For SUMMARY mode, use the passed indices; otherwise use Redux state
  const reduxState = useSelector((state: RootState) => ({
    activeHorizontalIndex: state?.stepper?.activeHorizontalIndex ?? 0,
    activeVerticalIndex: state?.stepper?.activeVerticalIndex ?? 0,
  }));
  
  const activeHorizontalIndex = pageType === "SUMMARY" && propHorizontalIndex !== undefined ? propHorizontalIndex : (reduxState?.activeHorizontalIndex ?? 0);
  const activeVerticalIndex = pageType === "SUMMARY" && propVerticalIndex !== undefined ? propVerticalIndex : (reduxState?.activeVerticalIndex ?? 0);
  const isReferenceCollateralEditStep =
    activeVerticalIndex === 3 &&
    (activeHorizontalIndex === 3 || activeHorizontalIndex === 4);

  const getRequiredFieldErrors = useCallback(
    (values: any): Record<string, string> => {
      const currentStepFieldNames = (fields || [])
        .map((f: any) => f?.name)
        .filter((name: string | undefined): name is string => Boolean(name));

      const isBlankFieldValue = (val: any): boolean => {
        if (val === undefined || val === null) return true;
        if (typeof val === "string") return val.trim() === "";
        if (typeof val === "object") {
          const inner = (val as any)?.value ?? (val as any)?.label;
          return inner == null || String(inner).trim() === "";
        }
        return false;
      };

      const applyAdmissionUndecided =
        activeHorizontalIndex === 0 &&
        activeVerticalIndex === 1 &&
        values?.admissionStatus === "Undecided";

      const applyEmploymentNotEmployed =
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 2 &&
        values?.employmentisEmployed === "No";

      const isFarmerOrOthers = (employmentType: any) =>
        employmentType === "Farmer" || employmentType === "Others";

      const applyEmploymentLimitedFields =
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 2 &&
        isFarmerOrOthers(values?.employmentType);

      const isEmploymentSubFieldExcluded = (fieldName: string): boolean => {
        if (
          applyEmploymentNotEmployed &&
          fieldName !== "employmentisEmployed" &&
          /^employment/i.test(fieldName)
        ) {
          return true;
        }
        if (
          applyEmploymentLimitedFields &&
          ["employmentYear", "employmentMonth", "employmentDesignation"].includes(
            fieldName,
          )
        ) {
          return true;
        }
        const coAppMatch = fieldName.match(/^employmentCoApplicant(\d+)(.+)$/);
        if (coAppMatch) {
          const [, coNum, suffix] = coAppMatch;
          if (suffix === "employmentisEmployed" || suffix === "isEmployed") {
            return false;
          }
          const isEmployedFieldName =
            (fields || []).find((f: any) =>
              new RegExp(
                `^employmentCoApplicant${coNum}(employmentisEmployed|isEmployed)$`,
              ).test(String(f?.name || "")),
            )?.name || `employmentCoApplicant${coNum}employmentisEmployed`;
          if (values?.[isEmployedFieldName] === "No") {
            return true;
          }
          const coEmploymentType =
            values?.[`employmentCoApplicant${coNum}employmentType`];
          if (
            isFarmerOrOthers(coEmploymentType) &&
            suffix !== "employmentType" &&
            suffix !== "monthlyIncome" &&
            suffix !== "monthlyObligation"
          ) {
            return true;
          }
        }
        return false;
      };

      const isMandatoryCoApplicantEmploymentAmountField = (name: string) =>
        /^employmentCoApplicant\d+(monthlyObligation|monthlyIncome)$/i.test(
          name || "",
        );

      const MANDATORY_COMPANY_ADDRESS_EMPLOYMENT_TYPES = [
        "Salaried",
        "SEP",
        "SENP",
      ];
      const isMandatoryCoApplicantCompanyAddressField = (name: string) => {
        const match = String(name || "").match(
          /^employmentCoApplicant(\d+)(companyName|companyAddress1|companyAddress2|companyAddress3|landmark|pincode)$/i,
        );
        if (!match) return false;
        const empType =
          values?.[`employmentCoApplicant${match[1]}employmentType`];
        return MANDATORY_COMPANY_ADDRESS_EMPLOYMENT_TYPES.includes(empType);
      };

      const isOptionalAddressLine2Or3Field = (name: string) =>
        /^(addressCoApplicant\d+)?(permanent|current)AddressLine[23]$/i.test(
          String(name || ""),
        );

      // Entrance Exam (1,4): mirror isEntranceExamContinueDisabled's own
      // filters so answering "No" to an exam or to "Received Your Results?"
      // doesn't re-impose the fields that answer hides.
      const isEntranceExamFieldExcluded = (name: string): boolean => {
        if (!(activeHorizontalIndex === 1 && activeVerticalIndex === 4)) {
          return false;
        }
        const fieldName = String(name || "");
        const isCore = fieldName.startsWith("core");
        const isLanguage = fieldName.startsWith("language");
        if (!isCore && !isLanguage) return false;
        if (
          fieldName === "coreExamApplied" ||
          fieldName === "languageExamApplied"
        ) {
          return false;
        }
        const appliedKey = isCore ? "coreExamApplied" : "languageExamApplied";
        if (values?.[appliedKey] !== "Yes") return true;

        const suffixMatch = fieldName.match(/_(\d+)$/);
        const suffix = suffixMatch ? `_${suffixMatch[1]}` : "";
        const scoreReceived =
          values?.[
            isCore
              ? `coreScoreReceived${suffix}`
              : `languageScoreReceived${suffix}`
          ];

        if (/(ExamScore|TotalMarks)(_\d+)?$/.test(fieldName)) {
          return scoreReceived === "No";
        }
        if (/ScoreExpectedOn(_\d+)?$/.test(fieldName)) {
          return scoreReceived !== "No";
        }
        if (/Exam(ID|Id)(_\d+)?$/.test(fieldName)) {
          return true;
        }
        return false;
      };

      // Fund/Expense amounts on (4,2) are reconciled by their own
      // total-must-match check, not by a per-field required rule.
      let currentFields = fields;
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 2) {
        currentFields = (fields || []).filter(
          (fieldDef: any) =>
            !(
              fieldDef?.name?.toLowerCase().startsWith("fund") ||
              fieldDef?.name?.toLowerCase().startsWith("expense")
            ),
        );
      }

      const messageFor = (fieldDef: any) => {
        const label = fieldDef?.label || fieldDef?.name || "this field";
        switch (fieldDef?.type) {
          case "dropdown":
          case "autocomplete":
          case "radio":
          case "date":
            return `Please select ${label}.`;
          case "checkbox":
            return `${label} is required.`;
          default:
            return `Please enter ${label}.`;
        }
      };

      const requiredErrors: Record<string, string> = {};
      (currentFields || []).forEach((fieldDef: any) => {
        const name = fieldDef?.name;
        if (!name) return;
        if (isOptionalAddressLine2Or3Field(name)) return;

        const isRequired =
          (fieldDef?.required && name !== "basicCoApplicant1PayParty") ||
          isMandatoryCoApplicantEmploymentAmountField(name) ||
          isMandatoryCoApplicantCompanyAddressField(name);
        if (!isRequired) return;
        if (!currentStepFieldNames.includes(name)) return;

        if (
          applyAdmissionUndecided &&
          (name === "university" ||
            name === "institute" ||
            name === "courseName")
        ) {
          return;
        }
        if (isEmploymentSubFieldExcluded(name)) return;
        if (isEntranceExamFieldExcluded(name)) return;

        if (isBlankFieldValue(values?.[name])) {
          requiredErrors[name] = messageFor(fieldDef);
        }
      });

      return requiredErrors;
    },
    [fields, activeHorizontalIndex, activeVerticalIndex],
  );

  const store = useStore<RootState>();
  const formikRef = useRef<FormikProps<any>>(null);
  // Formik's submitForm() resolves successfully even when it blocks the
  // submission because of validation errors elsewhere in the form (it never
  // calls onSubmit/handleSubmit in that case) — this ref lets the summary
  // save effect tell that apart from a real, completed handleSubmit run.
  const summarySubmitInvokedRef = useRef(false);
  const lastHandledSummarySaveRequestRef = useRef<number | null>(null);
  const lastReferenceCollateralSaveRequestRef = useRef<string>("");
  const skipSummaryRefreshAfterSubmitRef = useRef(false);
  const summaryEligibilityLeadSyncInitializedRef = useRef(false);
  const lastSummaryEligibilityLeadPayloadRef = useRef("");
  const isAuthenticated = useSelector(authStatusSelector);
  const location = useLocation();
  const navigate = useNavigate();
  // Loan summary relies on inline field errors only — no "fill all required
  // fields" snackbar on Save there.
  const showRequiredFieldsSnackbar = () => {
    if (location.pathname === ROUTES.Application.loanSummary.locationPath) return;
    setSnackbar({
      open: true,
      message: "Please fill all required fields.",
      severity: "error",
    });
  };
  // Load testing flag - if true, auto-verify PAN and Aadhaar
  const isLoadTesting = process.env.REACT_APP_LOAD_TESTING == "true";
  const [activeTab, setActiveTab] = useState(
    typeof initialReferenceCollateralTab === "number"
      ? initialReferenceCollateralTab
      : 0,
  );

  useEffect(() => {
    const isReferenceCollateralStep =
      isReferenceCollateralEditStep;

    if (
      pageType === "SUMMARY" &&
      isReferenceCollateralStep &&
      typeof initialReferenceCollateralTab === "number"
    ) {
      setActiveTab(initialReferenceCollateralTab);
    }
  }, [
    pageType,
    activeHorizontalIndex,
    activeVerticalIndex,
    initialReferenceCollateralTab,
  ]);

  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [isSubmittingToAPI, setIsSubmittingToAPI] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  // Loader for BRE checkOffer API
  const [isCheckingOffer, setIsCheckingOffer] = useState(false);
  const [openEmailOtp, setOpenEmailOtp] = useState(false);
  const [openCoApplicantModal, setOpenCoApplicantModal] = useState(false);
  const [openAnchorModal, setOpenAnchorModal] = useState(false);
  const [anchorModalContent, setAnchorModalContent] = useState("");
  const [enableContinue, setenableContinue] = useState(false);
  const purposeItems = useMemo(() => {
    return anchorModalContent
      .split(/\n\s*\n/) // split on blank lines
      .map((item) => item.replace(/;+$/, "").trim()) // remove trailing semicolons
      .filter(Boolean);
  }, [anchorModalContent]);
  // State for dropdown data
  const [dropdownData, setDropdownData] = useState<{
    countries: Array<{ value: string; label: string; countryId?: string }>;
    institutes: Array<{ value: string; label: string; code: string }>;
    universities: Array<{ value: string; label: string; code: string }>;
    courses: Array<{ value: string; label: string; code: string }>;
    courseCategory?: Array<{ value: string; label: string }>;
    admissionStatus?: Array<{ value: string; label: string }>;
    courseType?: Array<{ value: string; label: string }>;
    maritalStatuses?: Array<{ value: string; label: string }>;
    salutations?: Array<{ value: string; label: string }>;
    languageExamTypes?: Array<{ value: string; label: string; id: string }>;
    entranceExamTypes?: Array<{ value: string; label: string; id: string }>;
    designations?: Array<{ value: string; label: string }>;
    loanTenureVal?: Array<{ value: string; label: string; id: string }>;
  }>({
    countries: [],
    institutes: [],
    universities: [],
    courses: [],
    courseCategory: [],
    admissionStatus: [],
    courseType: [],
    maritalStatuses: [],
    languageExamTypes: [],
    entranceExamTypes: [],
    designations: [],
    loanTenureVal:[],
  });
  const [loadingDropdowns, setLoadingDropdowns] = useState({
    countries: false,
    institutes: false,
    universities: false,
    courses: false,
  });
  // State to track form values for dependent dropdowns
  const [formValues, setFormValues] = useState<{
    countryId?: string;
    universityId?: string;
    instituteId?: string;
    instituteName?: string;
    universityName?: string;
    courseName?: string;
  }>({});
  const [productOptions, setProductOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [zipCodeLoading, setZipCodeLoading] = useState(false);
  const {
    countryOptions: birthCountryMasterOptions,
    nationalityOptions: nationalityMasterOptions,
    maritalStatusOptions: maritalStatusMasterOptions,
    fetchCitiesByCountryState,
    getCityOptionsForCountry,
  } = useApplicantMasterData();
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity?: "error" | "success";
  }>({
    open: false,
    message: "",
    severity: "error",
  });

  const [tabIndex, setTabIndex] = React.useState<Record<string, number>>(
    {}
  );
  const [otpEmailFieldName, setOtpEmailFieldName] = useState("email");
  const [otpMobileFieldName, setOtpMobileFieldName] = useState("phone_number");
  const [errorMsg, setErrorMsg] = useState("");
  // For Mobile Verification Step 1
  const [otpMobileNumber, setOtpMobileNumber] = useState("");
  const [otpKey, setOtpKey] = useState("");
  const [otpTime, setOtpTime] = useState("");
  // For Email Verification Step 1
  const [otpEmail, setOtpEmail] = useState("");
  const [otpEmailKey, setOtpEmailKey] = useState("");
  const [otpEmailTime, setOtpEmailTime] = useState("");
  const [cityList, setCityList] = useState<any[]>([]);
  const [birthCityList, setBirthCityList] = useState<any[]>([]);
  const [birthCityLoading, setBirthCityLoading] = useState(false);
  // Birth-city options cached per country (lowercased country name -> options).
  // A single co-applicant summary page can show several co-applicants at once,
  // each with a different birth country, so one shared "last fetched" list
  // (birthCityList above) isn't enough to resolve every one of them correctly.
  const [birthCityListByCountry, setBirthCityListByCountry] = useState<
    Record<string, any[]>
  >({});
  const lastBirthCityCountryRef = useRef<string>("");
  const birthCityInFlightCountryRef = useRef<string>("");
  const birthCityRequestIdRef = useRef<number>(0);
  // Flag to prevent API calls during form initialization
  const [isFormInitialized, setIsFormInitialized] = useState(false);
  // For Co-applicant Pan Verification API Loading State
  const [coApplicantPanLoading, setCoApplicantPanLoading] = useState<{
    [key: string]: boolean;
  }>({});
  // Inline PAN verify error per co-applicant PAN field; shown in place of the schema error
  const [coApplicantPanVerifyError, setCoApplicantPanVerifyError] = useState<{
    [key: string]: string;
  }>({});
  // Store entrance exam master data
  const [entranceExamMaster, setEntranceExamMaster] = useState([]);
  // Loading state for API calls in useEffect
  const [isApiLoading, setIsApiLoading] = useState(false);
  // Track pushed documents to prevent duplicates
  const pushedDocumentsRef = useRef<Set<string>>(new Set());
  // Track ongoing Aadhaar verification calls to prevent concurrent processing
  const processingAadhaarVerificationRef = useRef<Set<string>>(new Set());

  // Function to check for specific purposes anchor tag
  const hasSpecificPurposesAnchor = (htmlString: string): boolean => {
    return htmlString.includes("<a>purposes</a>");
  };

  // const fetchSanitizedPiiPublicKey = useCallback(async () => {
  //   const piiKeyResponse: any = await losServices.getPiiKey();
  //   if (piiKeyResponse?.status !== 200) return "";

  //   return getSanitizedPublicKeyFromResponse(piiKeyResponse?.data?.p_k);
  // }, []);

  const isPreviousButton = process.env.REACT_APP_ENABLE_PREVIOUS_BUTTON == "true";
  // Function to handle purposes anchor clicks
  const handlePurposesClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    if (target.tagName === "A" && target.textContent?.trim() === "purposes") {
      event.preventDefault();
      setAnchorModalContent(`For relying upon KYC documents supplied to us, whether by you or through our representative/service provider, for meeting our legal, regulatory and compliance obligations such as customer due diligence, know your customer/re-KYC/anti-money laundering checks, processing your loan application details and other value-added services;

For providing your application details to Central KYC Registry, UIDAI, credit information companies/credit bureaus for verification purposes;

For verifying the applied (i) course or admission details with the institute/university, (ii) credentials with the relevant third parties required in respect of the loan application, (iii) enrollment verifications from organizations/entity in possession of such data;

For enabling repayment and ensuring recovery of amounts due from you including through our appointed recovery agents, etc.

For our general administration and granting services in relation to the above;

For contacting you over, Emails, WhatsApp, call and SMS, overriding NDNC registration.`);
      setOpenAnchorModal(true);
    }
  };

  // Get all form data from Redux
  const formData = useSelector((state: RootState) => state.stepper.formData);

  const {
    horizontalSteps,
    templateId,
    trackingId,
    isMobileVerified,
    isEmailVerified,
    collateralId,
    referenceOneId,
    referenceTwoId,
    lastVerifiedPhoneNumber,
    lastVerifiedEmail,
    hasPan,
    panNumber,
    isPanVerified,
    adharMandatory,
    showAadhaar,
    isDocumentVerified,
    aadhaarApplicationNo,
    aadhaarVerifiedDetails,
    aadhaarVerifiedDetailsCoApplicant,
    coApplicantVerification,
    breData,
    aadhaarApplicationNoCoApplicant,
    isDocumentVerifiedCoApplicant,
    loanDetailCoApplicantCollapseValue,
    checkIsLeadApiInvoked,
    leadSequenceId,
    assignedSMIdValue,
    coApplicantZipCodeData,
    aadhaarSeedingStatus,
    verificationMessage,
    applicationSource,
    encryptionKey,
    customerConsentTime,
     summarySaveRequestId,
    summarySaveTarget,
    fetchUserApplicationData,
  } = useSelector((state: RootState) => state.stepper);
  // Every mounted FormEdit (section row editor + open co-applicant cards)
  // sees the same summarySaveRequestId. Only advance this editor's copy for
  // Saves aimed at it, so e.g. a Reference Save doesn't also submit an open
  // co-applicant card (save-coapplicant).
  const targetedSummarySaveRequestIdRef = useRef(summarySaveRequestId);
  if (
    summarySaveTarget === null ||
    summarySaveTarget === summarySaveTargetKey
  ) {
    targetedSummarySaveRequestIdRef.current = summarySaveRequestId;
  }
  const targetedSummarySaveRequestId = targetedSummarySaveRequestIdRef.current;
  // DIY journey: no partner has started the application on the customer's
  // behalf. Requested Tenure / Requested ROI are hidden and hardcoded by
  // the backend (120 / 13) for this journey.
  const isDIYJourney = !fetchUserApplicationData?.partnerStartedJourney;
  // Saved (fetched) values used to lock co-applicant First/Last Name & Mobile
  // once that co-applicant is a collateral co-owner.
  const fetchedApplicationVals = useMemo(
    () => extractFetchedApplicationVals(fetchUserApplicationData),
    [fetchUserApplicationData],
  );

  // Reference & Collateral step: once both references are saved AND Collateral
  // was actually saved before (hasCollateral = No, or a real collateral group
  // with a saved Type), the overall Continue button doesn't need the applicant
  // to click Collateral's Save & Next again. This re-derives on every visit
  // (not just right after a save click) from the FETCHED data — not live
  // Formik/redux values, which would fire mid-typing before anything is
  // actually saved — so navigating back into this step also works.
  useEffect(() => {
    const bothReferencesSaved = Boolean(referenceOneId) && Boolean(referenceTwoId);
    // if (bothReferencesSaved && isCollateralStepAlreadySaved(fetchUserApplicationData)) {
    //   setenableContinue(true);
    // }
  }, [referenceOneId, referenceTwoId, fetchUserApplicationData]);

  const fetchSanitizedPiiPublicKey = useCallback(async () => {
    if (encryptionKey) {
      return getSanitizedPublicKeyFromResponse(encryptionKey);
    }
    const piiKeyResponse: any = await losServices.getPiiKey();
    if (piiKeyResponse?.status !== 200) return "";

    const rawKey = piiKeyResponse?.data?.p_k;
    const rawKeyStr = typeof rawKey === "string" ? rawKey : "";
    dispatch(setEncryptionKey(rawKeyStr));

    return getSanitizedPublicKeyFromResponse(rawKey);
  }, [encryptionKey, dispatch]);

  /** After createApplicant save: refetch application from API and mirror into Redux (same pattern as Summary.tsx). */
  const refreshReduxFromUserApplicationFetch = useCallback(
    async (submissionIdOverride?: string) => {
      const submissionId = resolveRefreshSubmissionId(
        submissionIdOverride,
        trackingId,
        summarySaveRequestId ? String(summarySaveRequestId) : undefined,
      );
      if (!isAuthenticated || !submissionId) return;
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      if (!token) return;
      try {
        const res: any = await fetchUserApplicationsFormData(
          token,
          submissionId
        );
        const applicationData = res.data?.applications?.[0];
        if (!applicationData) return;

        dispatch(setFetchUserApplicationData(applicationData));

        

        const finalSteps = getCombinedApplicationSteps(applicationData);
        dispatch(setDisplayHorizontalSteps(finalSteps));

        const lengthOfHorizontalSteps =
          applicationData?.horizontalSteps?.length ?? 0;
        let apiFormData: any = {};
        for (let i = 0; i < lengthOfHorizontalSteps; i++) {
          const verticalSteps =
            applicationData?.horizontalSteps?.[i]?.verticalSteps;
          for (let j = 0; j < verticalSteps?.length; j++) {
            const stepFields = verticalSteps?.[j]?.fields;
            for (let k = 0; k < stepFields?.length; k++) {
              const field = stepFields?.[k];
              apiFormData = { ...apiFormData, ...field };
            }
          }
        }
        dispatch(updateFormData(apiFormData));

        if (applicationData?.applicationId != null) {
          dispatch(setApplicationId(String(applicationData.applicationId)));
        }
        if (applicationData?.applicantId != null) {
          dispatch(setApplicantId(String(applicationData.applicantId)));
        }

        dispatch(bumpFormJsonRefreshNonce());
      } catch (err) {
        console.error("refreshReduxFromUserApplicationFetch failed:", err);
      }
    },
    [dispatch, isAuthenticated, trackingId]
  );
  
  const canAdvanceStepper = pageType !== "SUMMARY";
  const moveToNextStep = useCallback(() => {
    if (!canAdvanceStepper) return;
    dispatch(nextVerticalStep());
  }, [canAdvanceStepper, dispatch]);
  const moveToStep = useCallback(
    (horizontalIndex: number, verticalIndex: number) => {
      if (!canAdvanceStepper) return;
      dispatch(setActiveHorizontalIndex(horizontalIndex));
      dispatch(setActiveVerticalIndex(verticalIndex));
    },
    [canAdvanceStepper, dispatch]
  );
  const previousStepRef = useRef({
    horizontal: activeHorizontalIndex,
    vertical: activeVerticalIndex,
  });
   useEffect(() => {
    if (pageType !== "SUMMARY") return;
    if (lastHandledSummarySaveRequestRef.current === null) {
      // Baseline on first summary render; do not auto-submit on Edit/open.
      lastHandledSummarySaveRequestRef.current = targetedSummarySaveRequestId;
      return;
    }
    if (targetedSummarySaveRequestId === lastHandledSummarySaveRequestRef.current) return;
    lastHandledSummarySaveRequestRef.current = targetedSummarySaveRequestId;
    (async () => {
      const formikInstance = formikRef.current;
      if (!formikInstance) {
        dispatch(setSkipNextSummaryRefetch(true));
        dispatch(setSummarySaveInProgress(false));
        return;
      }
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 3) {
        // Reference/Collateral summary saves are delegated to ReferenceCollateralDetails
        const referenceCollateralTouched = (fields || []).reduce(
          (acc: Record<string, boolean>, f: any) => {
            if (f?.name) acc[f.name] = true;
            return acc;
          },
          {}
        );
        formikInstance.setTouched(
          {
            ...(formikInstance.touched || {}),
            ...referenceCollateralTouched,
          },
          false
        );
        await formikInstance.validateForm();
        return;
      }

      let currentStepFieldNames = (fields || [])
        .map((f: any) => f?.name)
        .filter((name: string | undefined): name is string => Boolean(name));

      let touchedFields = currentStepFieldNames.reduce(
        (acc: Record<string, boolean>, fieldName: string) => {
          acc[fieldName] = true;
          return acc;
        },
        {}
      );
      // that are no longer shown for them either.
      const dynamicEmploymentTypeKeys = Object.keys(touchedFields).filter((key) =>
        /^employmentCoApplicant\d+employmentType$/i.test(key)
      );
      const dynamicDesignationKeys = Object.keys(touchedFields).filter((key) =>
        /^employmentCoApplicant\d+designation$/i.test(key)
      );
      dynamicDesignationKeys.forEach((key) => {
        delete formikInstance.errors[key];
      });

      dynamicEmploymentTypeKeys.forEach((dynamicEmploymentTypeKey) => {
        const match = dynamicEmploymentTypeKey.match(/\d+/);
        const currentCoAppNum = match ? match[0] : "";
        if (!currentCoAppNum) return;

        if (
          (formData[dynamicEmploymentTypeKey] === "Others" ||
            formData[dynamicEmploymentTypeKey] === "Farmer")
        ) {
          Object.keys(touchedFields).forEach((key) => {
            if (
              key.startsWith(`employmentCoApplicant${currentCoAppNum}`) &&
              key !== `employmentCoApplicant${currentCoAppNum}employmentType` &&
              key !== `employmentCoApplicant${currentCoAppNum}monthlyIncome` &&
              key !== `employmentCoApplicant${currentCoAppNum}monthlyObligation` &&
              key !== `employmentCoApplicant${currentCoAppNum}employmentisEmployed`
            ) {
              delete touchedFields[key];
            }
          });
        }
      });

      formikInstance.setTouched(
        {
          ...(formikInstance.touched || {}),
          ...touchedFields,
        },
        false
      );

      const errors = await formikInstance.validateForm();
      const hasCurrentStepErrors = currentStepFieldNames.some(
        (fieldName: string) => Boolean((errors as Record<string, any>)?.[fieldName])
      );
      if (hasCurrentStepErrors) {
        showRequiredFieldsSnackbar();
        dispatch(setSkipNextSummaryRefetch(true));
        dispatch(setSummarySaveInProgress(false));
        const firstErrorField = currentStepFieldNames.find((fieldName: string) =>
          Boolean((errors as Record<string, any>)?.[fieldName])
        );
        if (firstErrorField) {
          setTimeout(() => {
            const el = document.querySelector(
              `[name="${firstErrorField}"]`
            ) as HTMLElement | null;
            if (el && typeof el.scrollIntoView === "function") {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 50);
        }
        return;
      }

      const isBlankFieldValue = (val: any): boolean => {
        if (val === undefined || val === null) return true;
        if (typeof val === "string") return val.trim() === "";
        if (typeof val === "object") {
          const inner = (val as any)?.value ?? (val as any)?.label;
          return inner == null || String(inner).trim() === "";
        }
        return false;
      };
      let hasEmptyRequiredField: boolean;
      if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
        hasEmptyRequiredField = isEntranceExamContinueDisabled(
          formikInstance.values
        );
      } else {
        const applyAdmissionUndecided =
          activeHorizontalIndex === 0 &&
          activeVerticalIndex === 1 &&
          formikInstance.values?.admissionStatus === "Undecided";
        const applyEmploymentNotEmployed =
          activeHorizontalIndex === 1 &&
          activeVerticalIndex === 2 &&
          formikInstance.values?.employmentisEmployed === "No";
        const isFarmerOrOthers = (employmentType: any) =>
          employmentType === "Farmer" || employmentType === "Others";
        const applyEmploymentLimitedFields =
          activeHorizontalIndex === 1 &&
          activeVerticalIndex === 2 &&
          isFarmerOrOthers(formikInstance.values?.employmentType);
        const isEmploymentSubFieldExcluded = (fieldName: string): boolean => {
          if (
            applyEmploymentNotEmployed &&
            fieldName !== "employmentisEmployed" &&
            /^employment/i.test(fieldName)
          ) {
            return true;
          }
          if (
            applyEmploymentLimitedFields &&
            ["employmentYear", "employmentMonth", "employmentDesignation"].includes(
              fieldName,
            )
          ) {
            return true;
          }
          const coAppMatch = fieldName.match(/^employmentCoApplicant(\d+)(.+)$/);
          if (coAppMatch) {
            const [, coNum, suffix] = coAppMatch;
            if (suffix === "employmentisEmployed" || suffix === "isEmployed") {
              return false;
            }
            const isEmployedFieldName =
              (fields || []).find((f: any) =>
                new RegExp(
                  `^employmentCoApplicant${coNum}(employmentisEmployed|isEmployed)$`,
                ).test(String(f?.name || "")),
              )?.name || `employmentCoApplicant${coNum}employmentisEmployed`;
            if (formikInstance.values?.[isEmployedFieldName] === "No") {
              return true;
            }
            const coEmploymentType =
              formikInstance.values?.[
                `employmentCoApplicant${coNum}employmentType`
              ];
            if (
              isFarmerOrOthers(coEmploymentType) &&
              suffix !== "employmentType" &&
              suffix !== "monthlyIncome" &&
              suffix !== "monthlyObligation"
            ) {
              return true;
            }
          }
          return false;
        };
        const isMandatoryCoApplicantEmploymentAmountField = (name: string) =>
          /^employmentCoApplicant\d+(monthlyObligation|monthlyIncome)$/i.test(
            name || "",
          );
        // Company address (address lines, landmark, pincode) comes back from
        const MANDATORY_COMPANY_ADDRESS_EMPLOYMENT_TYPES = ["Salaried", "SEP", "SENP"];
        const isMandatoryCoApplicantCompanyAddressField = (name: string) => {
          const match = String(name || "").match(
            /^employmentCoApplicant(\d+)(companyName|companyAddress1|companyAddress2|companyAddress3|landmark|pincode)$/i,
          );
          if (!match) return false;
          const coNum = match[1];
          const empType =
            formikInstance.values?.[
              `employmentCoApplicant${coNum}employmentType`
            ];
          return MANDATORY_COMPANY_ADDRESS_EMPLOYMENT_TYPES.includes(empType);
        };

        // Address Line 2 / Line 3 (permanent & current, main applicant and
        const isOptionalAddressLine2Or3Field = (name: string) =>
          /^(addressCoApplicant\d+)?(permanent|current)AddressLine[23]$/i.test(
            String(name || ""),
          );

        let currentFields = fields;
        if(activeHorizontalIndex === 4 && activeVerticalIndex === 2) {
          currentFields = fields?.filter((fieldDef: any) => {
          // exclude fund and expense fields from required field check for step 4-2
            if (
              (fieldDef?.name?.toLowerCase().startsWith("fund") ||
                fieldDef?.name?.toLowerCase().startsWith("expense"))
            ) {
              return false;
            }
            return true;
          });
        }
        
        hasEmptyRequiredField = (currentFields || []).some((fieldDef: any) => {
          if (isOptionalAddressLine2Or3Field(fieldDef?.name)) return false;
          const isRequired =
            (fieldDef?.required && fieldDef?.name!="basicCoApplicant1PayParty") ||
            isMandatoryCoApplicantEmploymentAmountField(fieldDef?.name) ||
            isMandatoryCoApplicantCompanyAddressField(fieldDef?.name);
            if (!isRequired || !fieldDef?.name) return false;
          if (!currentStepFieldNames.includes(fieldDef.name)) return false;
          if (
            applyAdmissionUndecided &&
            (fieldDef.name === "university" ||
              fieldDef.name === "institute" ||
              fieldDef.name === "courseName")
          ) {
            return false;
          }
          if (isEmploymentSubFieldExcluded(fieldDef.name)) {
            return false;
          }
          return isBlankFieldValue(formikInstance.values?.[fieldDef.name]);
        });
      }
      if (hasEmptyRequiredField) {
        showRequiredFieldsSnackbar();
        dispatch(setSkipNextSummaryRefetch(true));
        dispatch(setSummarySaveInProgress(false));
        return;
      }

      // Fund vs Expense balance check (step 4-2) — mirrors DynamicForm's
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 2) {
        const _feNorm = (name: any) =>
          String(name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
        const _feStartsWith = (name: any, prefixes: string[]) => {
          const n = _feNorm(name);
          return prefixes.some((p) => n.startsWith(p) || n.startsWith(`ad${p}`));
        };
        const _feIncludes = (value: any, keywords: string[]) => {
          const n = _feNorm(value);
          return keywords.some((k) => n.includes(k));
        };
        const _feSortedFields = (Array.isArray(fields) ? [...fields] : []).sort(
          (a: any, b: any) => (a?.fieldOrder ?? 0) - (b?.fieldOrder ?? 0)
        );
        const _feExpenseFields = _feSortedFields.filter((f: any) => {
          const byPrefix = _feStartsWith(f?.name, ["expense", "expenses"]);
          const byText =
            _feIncludes(f?.name, ["totalexpense", "expense"]) ||
            _feIncludes(f?.label, ["totalexpense", "expense"]);
          return byPrefix || byText;
        });
        const _feFundFields = _feSortedFields.filter((f: any) =>
          _feStartsWith(f?.name, ["fund", "fundrequest", "funds"])
        );
        const _feToNum = (raw: any): number => {
          if (raw === null || raw === undefined || raw === "") return 0;
          if (typeof raw === "number") return isNaN(raw) ? 0 : raw;
          const candidate =
            typeof raw === "object" && raw !== null && "value" in raw
              ? (raw as any).value
              : raw;
          const normalized = String(candidate)
            .replace(/,/g, "")
            .replace(/[^0-9.-]/g, "")
            .trim();
          if (!normalized) return 0;
          const parsed = parseFloat(normalized);
          return isNaN(parsed) ? 0 : parsed;
        };
        const _feComputeTotal = (
          sectionFields: any[],
          keywords: string[]
        ): number => {
          const isExact = (val: any, kws: string[]) => {
            const n = _feNorm(val);
            return kws.some((k) => n === k || n.endsWith(k) || n.startsWith(k));
          };
          const directField = sectionFields.find(
            (f: any) => isExact(f?.name, keywords) || isExact(f?.label, keywords)
          );
          const keys = sectionFields
            .map((f: any) => f?.name)
            .filter((n: string) => !!n && n !== directField?.name);
          const sum = keys.reduce(
            (acc: number, key: string) =>
              acc + _feToNum(formikInstance.values?.[key]),
            0
          );
          if (sum > 0) return sum;
          if (directField?.name) {
            const dv = _feToNum(formikInstance.values?.[directField.name]);
            if (dv > 0) return dv;
          }
          return sum;
        };
        const _feTotalExpense = _feComputeTotal(_feExpenseFields, [
          "totalexpense",
          "expensetotal",
        ]);
        const _feTotalFund = _feComputeTotal(_feFundFields, [
          "totalfund",
          "fundtotal",
        ]);
        const _feRestBlank = (sectionFields: any[]) =>
          sectionFields
            .slice(1)
            .every((f: any) => isBlankFieldValue(formikInstance.values?.[f?.name]));
        const _feOnlyFirstFieldsFilled =
          _feExpenseFields.length > 0 &&
          _feFundFields.length > 0 &&
          !isBlankFieldValue(formikInstance.values?.[_feExpenseFields[0]?.name]) &&
          !isBlankFieldValue(formikInstance.values?.[_feFundFields[0]?.name]) &&
          _feRestBlank(_feExpenseFields) &&
          _feRestBlank(_feFundFields);
        if (!_feOnlyFirstFieldsFilled && _feTotalExpense !== _feTotalFund) {
          setSnackbar({
            open: true,
            message: `Total Fund (₹${_feTotalFund.toLocaleString(
              "en-IN"
            )}) and Total Expenses (₹${_feTotalExpense.toLocaleString(
              "en-IN"
            )}) must be equal before you can save.`,
            severity: "error",
          });
          dispatch(setSkipNextSummaryRefetch(true));
          dispatch(setSummarySaveInProgress(false));
          return;
        }
      }

      // Reset the failure/invoked signals before this attempt so state left
      // over from a previous save can't leak into this one.
      dispatch(setSkipNextSummaryRefetch(false));
      summarySubmitInvokedRef.current = false;

      // After user hits Summary Save, switch UI back to non-editable Summary view.
      formikInstance.submitForm().then(async () => {
        if (!summarySubmitInvokedRef.current) {
          showRequiredFieldsSnackbar();
          dispatch(setSummarySaveInProgress(false));
          return;
        }

        if (store.getState()?.stepper?.skipNextSummaryRefetch) {
          return;
        }

        if (skipSummaryRefreshAfterSubmitRef.current) {
          skipSummaryRefreshAfterSubmitRef.current = false;
          dispatch(setSummarySaveInProgress(false));
          return;
        }

        // Ensure Summary view updates immediately after successful save
        await refreshReduxFromUserApplicationFetch();

        // Close editor only after Redux refresh is triggered
        dispatch(setSummaryApplicationEditActive(false));
        dispatch(setSummaryEditOpenedFromCoApplicantSection(false));
      }).catch(() => {
        dispatch(setSkipNextSummaryRefetch(true));
        dispatch(setSummarySaveInProgress(false));
      });
    })();
  }, [
    pageType,
    targetedSummarySaveRequestId,
    fields,
    activeHorizontalIndex,
    activeVerticalIndex,
  ]);
  useEffect(() => {
    const isSummaryEligibilitySection =
      pageType === "SUMMARY" &&
      activeHorizontalIndex === 0 &&
      [0, 1, 2].includes(activeVerticalIndex);

    if (!isSummaryEligibilitySection || !trackingId) {
      summaryEligibilityLeadSyncInitializedRef.current = false;
      lastSummaryEligibilityLeadPayloadRef.current = "";
      return;
    }

    // Don't send full `formData` to update-lead API; only use it to detect changes.
    const updateLeadPayload = {
      trackingId: String(trackingId),
      //leadId:String(leadSequenceId)
    };
    const payloadSignature = JSON.stringify({
      trackingId: String(trackingId),
      formData,
    });

    // Skip first run when summary section opens; only send on user changes.
    if (!summaryEligibilityLeadSyncInitializedRef.current) { 
      summaryEligibilityLeadSyncInitializedRef.current = true;
      lastSummaryEligibilityLeadPayloadRef.current = payloadSignature;
      return;
    }

    if (payloadSignature === lastSummaryEligibilityLeadPayloadRef.current) return;

    const timer = setTimeout(async () => {
      try {
          let leadData=await losServices.getDataByLeadId(String(trackingId));
          if(leadData?.data?.data?.configs && leadData?.status===200) {
            let dataval=leadData?.data?.data?.configs;
            let payloadData={
              trackingId: String(trackingId),
              leadType:dataval?.leadType,
              leadSource:dataval?.leadSource,
              leadSystem: dataval?.leadSystem,
              partnerLead: dataval?.partnerLead,
              qualifiedPartner: dataval?.qualifiedPartner,
              marketingLead:dataval?. marketingLead,
              leadSubSource: dataval?.leadSubSource,
              undergraduateFlag: dataval?.undergraduateFlag,
              partnerFirmId:dataval?.partnerFirmId,
            }
            await losServices.updateLead(payloadData);
          }
            lastSummaryEligibilityLeadPayloadRef.current = payloadSignature;
         
          } catch (error: any) {
        console.error("Summary eligibility update lead sync failed:", error);
      }
    }, 450);

    return () => clearTimeout(timer);
  }, [
    pageType,
    activeHorizontalIndex,
    activeVerticalIndex,
    trackingId,
    formData,
  ]);
  const reduxLastPanNumber = useSelector(
    (state: RootState) => state.stepper.lastPanNumber
  );
  const isEligibilityCheckSubmitted = useSelector(
    (state: RootState) => state.stepper.isEligibilityCheckSubmitted
  );
  const userProfile = useSelector(
    (state: RootState) => state?.auth?.userProfile
  );
  const notInList = useSelector(
    (state: RootState) => state?.stepper?.notInList
  );
  const applicationIdApp = useSelector(
    (state: RootState) => state?.stepper?.applicationId
  );
  const applicantIdApp = useSelector(
    (state: RootState) => state?.stepper?.applicantId
  );

  const validationSchema = getValidationSchema(
    fields,
    activeHorizontalIndex,
    activeVerticalIndex,
    notInList,
    pageType
  );

  // Formik lets `validate` errors override the schema's for the same field, so
  // the generic "Please enter <label>." would hide the step-specific message the
  // extended journey shows. Drop a generic error whenever the schema reports its
  // own for that field — the field stays blocked either way.
  const preferSchemaMessages = (
    errors: Record<string, string>,
    vals: any,
  ): Record<string, string> =>
    Object.fromEntries(
      Object.entries(errors).filter(([name]) => {
        try {
          validationSchema.validateSyncAt(name, vals);
          return true;
        } catch (err: any) {
          return err?.name !== "ValidationError";
        }
      }),
    );

  useEffect(() => {
    if (
      pageType !== "SUMMARY" ||
      activeHorizontalIndex !== 0 ||
      activeVerticalIndex !== 0 ||
      !formikRef.current
    ) {
      return;
    }
    formikRef.current.setFieldValue("terms_conditions", true, false);
    formikRef.current.setFieldValue("privacy_policy", true, false);
    dispatch(
      updateFormData({
        terms_conditions: true,
        privacy_policy: true,
      })
    );
  }, [pageType, activeHorizontalIndex, activeVerticalIndex, dispatch]);
  // For Step 2 (PAN radio/options).
  // SUMMARY edit mode must use the same PAN step condition as the journey flow.
  const isPanStep = activeHorizontalIndex === 1 && activeVerticalIndex === 0;

  const [isAadharLoading, setIsAadharLoading] = useState(false);
  const [isAadharCoApplicantLoading, setIsAadharCoApplicantLoading] = useState<
    Record<string, boolean>
  >({});
  const [isCurrentSameAsPermanent, setIsCurrentSameAsPermanent] =
    useState(false);
  // To prevent eaadhaar API call on verify now button click
  const [isEaadhaarOnVerifyNow, setIsEaadhaarOnVerifyNow] = useState(false);

  const MobileNumberTooltipContent = (
    <Typography variant="caption">
      Mobile number should be the one which is linked with Aadhaar.
    </Typography>
  );

  // Configure DOMPurify once (can be at top of your component file)
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank"); // opens in new tab
      node.setAttribute("rel", "noopener noreferrer"); // security best practice
    }
  });

  useEffect(() => {
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      setIsCurrentSameAsPermanent(formikRef?.current?.values?.currentsameAsPermanent);
    }
  }, [formikRef?.current?.values?.currentsameAsPermanent, activeHorizontalIndex, activeVerticalIndex])

  useEffect(() => {
    const previousStep = previousStepRef.current;
    const isHorizontalStepChanged =
      activeHorizontalIndex !== previousStep.horizontal;
    const isVerticalStepIncreased =
      activeVerticalIndex > previousStep.vertical;

    if (isHorizontalStepChanged || isVerticalStepIncreased) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    previousStepRef.current = {
      horizontal: activeHorizontalIndex,
      vertical: activeVerticalIndex,
    };
  }, [activeHorizontalIndex, activeVerticalIndex]);


  useEffect(() => {
    if (formikRef.current) {
      // For Applicant Step 0 Form 0 - Personal Details
      formikRef.current.setFieldValue(
        "isMobileVerified",
        isMobileVerified ? true : false
      );
      formikRef.current.setFieldValue(
        "isEmailVerified",
        isEmailVerified ? true : false
      );
      // For Student Loan - Applicant
      formikRef.current.setFieldValue(
        "isPanVerified",
        isPanVerified ? true : false
      );
      formikRef.current.setFieldValue(
        "isAadhaarVerified",
        isDocumentVerified ? true : false
      );

      // Dynamic for all co-applicants
      Object.keys(coApplicantVerification).forEach((idx) => {
        const num = Number(idx) + 1;
        // Only set if Redux value is not undefined, else preserve Formik value
        if (typeof coApplicantVerification[idx]?.panVerified !== "undefined") {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsPanVerified`,
            coApplicantVerification[idx]?.panVerified
          );
        }
        if (
          typeof coApplicantVerification[idx]?.emailVerified !== "undefined"
        ) {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsEmailVerified`,
            coApplicantVerification[idx]?.emailVerified
          );
        }
        if (
          typeof coApplicantVerification[idx]?.mobileVerified !== "undefined"
        ) {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsMobileVerified`,
            coApplicantVerification[idx]?.mobileVerified
          );
        }
      });

      // Set AadhaarVerified field for all co-applicants from isDocumentVerifiedCoApplicant
      if (
        typeof isDocumentVerifiedCoApplicant === "object" &&
        isDocumentVerifiedCoApplicant !== null
      ) {
        Object.keys(isDocumentVerifiedCoApplicant).forEach((coAppKey) => {
          // coAppKey is like 'CoApplicant1', extract number
          const match = coAppKey.match(/CoApplicant(\d+)/);
          if (match) {
            const num = match[1];
            if (formikRef.current) {
              formikRef.current.setFieldValue(
                `basicCoApplicant${num}AadhaarVerified`,
                isDocumentVerifiedCoApplicant[coAppKey] ? true : ""
              );
            }
          }
        });
      }
    }
  }, [
    isMobileVerified,
    isEmailVerified,
    isPanVerified,
    isDocumentVerified,
    coApplicantVerification,
    isDocumentVerifiedCoApplicant,
  ]);

  // Safely hydrate Formik from Redux formData (especially after refresh fetch flow)
   useEffect(() => {
    if (pageType === "SUMMARY") return;
    if (!formikRef.current || !formData) return;

    // (Non-SUMMARY mode) hydrate missing values from Redux while preserving user edits.


    const currentValues = formikRef.current.values || {};
    let hasChanges = false;
    const nextValues: Record<string, any> = { ...currentValues };

    Object.entries(formData).forEach(([key, reduxValue]) => {
      const currentValue = currentValues[key];
      const isCurrentBlank =
        currentValue === undefined || currentValue === null || currentValue === "";

      const hasReduxValue =
        reduxValue !== undefined && reduxValue !== null && reduxValue !== "";

      if (isCurrentBlank && hasReduxValue) {
        nextValues[key] = reduxValue;
        hasChanges = true;
      }
    });

    if (hasChanges) {
      formikRef.current.setValues(nextValues, false);
    }
  }, [formData, pageType]);
  const [relationshipOptions, setRelationshipOptions] = useState<any>([]);
  const [applicantNationalityOptions, setApplicantNationalityOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);

  useEffect(() => {
    let isMounted = true;
    if(isAuthenticated) {
      dropdownService
        .getNationalityList()
        .then((fetched) => {
          if (isMounted) {
            setApplicantNationalityOptions(Array.isArray(fetched) ? fetched : []);
          }
        })
        .catch((error) => {
          console.error("Error fetching applicant nationality list:", error);
        });
    }
    return () => {
      isMounted = false;
    };
  }, []);
  const resolveApplicantNationalityOption = useCallback(
    (rawValue: any) => {
      const searchValue = String(
        rawValue && typeof rawValue === "object"
          ? rawValue?.value ?? rawValue?.label ?? ""
          : rawValue ?? "",
      )
        .trim()
        .toLowerCase();

      if (!searchValue) {
        return null;
      }

      return (
        applicantNationalityOptions.find(
          (opt) =>
            String(opt?.value ?? "").trim().toLowerCase() === searchValue ||
            String(opt?.label ?? "").trim().toLowerCase() === searchValue,
        ) || null
      );
    },
    [applicantNationalityOptions],
  );
  const handleRelationMasterApi = async () => {
    setIsApiLoading(true);
    try {
      const data = await losServices.relationMaster();
      if (data.status == 200) {
        const optionsData = data?.data?.data?.map((item: any) => ({
          label: item.descInPennant,
          value: item.codeInPennant,
        }));
        setRelationshipOptions(optionsData);
      }
    } catch (error: any) {
    } finally {
      setIsApiLoading(false);
    }
  };

  useEffect(() => {
    const profileEmail = (decrypt(userProfile?.email) || "").toLowerCase();
    const existingEmail =
      formikRef?.current?.values?.studentDetailEmail ||
      formikRef?.current?.values?.email ||
      formData?.studentDetailEmail ||
      formData?.email ||
      "";
    const resolvedEmail = existingEmail || profileEmail;
    const shouldAutoVerifyPrefilledEmail =
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0 &&
      !!profileEmail &&
      String(resolvedEmail || "").trim().toLowerCase() ===
        String(profileEmail || "").trim().toLowerCase();

    // Applicant loan — Student Details (same trust as step 0): logged-in profile email is verified.
    const shouldAutoVerifyApplicantLoanPrefilledEmail =
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      !!profileEmail &&
      String(resolvedEmail || "").trim().toLowerCase() ===
        String(profileEmail || "").trim().toLowerCase();

    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      (userProfile?.email || userProfile?.phoneNumber)
    ) {
      let fullname = userProfile?.fullName?.split(" ");
      formikRef?.current?.setFieldValue("email", resolvedEmail);
      formikRef?.current?.setFieldValue("studentDetailEmail", resolvedEmail);
      if (shouldAutoVerifyApplicantLoanPrefilledEmail) {
        dispatch(setIsEmailVerified(true));
        formikRef?.current?.setFieldValue("isEmailVerified", true, false);
      }
      if (!lastVerifiedEmail && resolvedEmail) {
        dispatch(setLastVerifiedEmail(resolvedEmail));
      }
      formikRef?.current?.setFieldValue(
        "phone_number",
        decrypt(userProfile?.phoneNumber)
      );
      
        const finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
        const finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];
      
        formikRef?.current?.setFieldValue("firstName", finalFirstName);
        formikRef?.current?.setFieldValue("lastName", finalLastName); 
      //dispatch(setIsMobileVerified(true));
      dispatch(setLastVerifiedPhoneNumber(decrypt(userProfile?.phoneNumber)));
      dispatch(updateFormData({
          email: resolvedEmail,
          studentDetailEmail: resolvedEmail,
          firstName: formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0],
          lastName: formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1],
          phone_number:  decrypt(userProfile?.phoneNumber),
          ...(shouldAutoVerifyApplicantLoanPrefilledEmail
            ? { isEmailVerified: true }
            : {}),
        }));
    }else{
      if (!(userProfile?.email || userProfile?.phoneNumber)) return;
      if (!formikRef?.current) return;

      const fullname = userProfile?.fullName?.split(" ") ?? [];
      const decryptedPhone = decrypt(userProfile?.phoneNumber);
      const firstName = fullname[0] || "";
      const lastName = fullname[1] || "";
        formikRef.current.setFieldValue("email", resolvedEmail);
        formikRef.current.setFieldValue("studentDetailEmail", resolvedEmail);
        if (shouldAutoVerifyPrefilledEmail) {
            dispatch(setIsEmailVerified(true));
            dispatch(setIsMobileVerified(true));
        }
        if (!lastVerifiedEmail && resolvedEmail) {
          dispatch(setLastVerifiedEmail(resolvedEmail));
        }

        formikRef.current.setFieldValue("phone_number", decryptedPhone);
        dispatch(setLastVerifiedPhoneNumber(decryptedPhone));

        // Also prefill studentDetails fields (used on student details page)
        // Only set if not already populated — preserves any user edits
        if (!formikRef.current.values?.studentDetailsFirstName) {
          formikRef.current.setFieldValue("studentDetailsFirstName", firstName);
        }
        if (!formikRef.current.values?.studentDetailsLastName) {
          formikRef.current.setFieldValue("studentDetailsLastName", lastName);
        }
        if (!formikRef.current.values?.studentDetailsPhone_number) {
          formikRef.current.setFieldValue("studentDetailsPhone_number", decryptedPhone);
        }
        if (!formikRef.current.values?.studentDetailEmail) {
          formikRef.current.setFieldValue("studentDetailEmail", resolvedEmail);
        }
        let finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
        let finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];
      
        formikRef?.current?.setFieldValue("firstName", finalFirstName);
        formikRef?.current?.setFieldValue("lastName", finalLastName);  
      // Persist to Redux formData so initialValues mapping also picks them up on re-render
        dispatch(updateFormData({
          email: resolvedEmail,
          studentDetailEmail: resolvedEmail,
          firstName: formikRef.current?.values?.studentDetailsFirstName || formikRef.current?.values?.firstName || fullname[0],
          lastName: formikRef.current?.values?.studentDetailsLastName || formikRef.current?.values?.lastName || fullname[1],
          phone_number: decryptedPhone,
        }));
      }
      const fullname = userProfile?.fullName?.split(" ") ?? [];
      const finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
      const finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];

  }, [activeHorizontalIndex, activeVerticalIndex, userProfile, formData?.email, formData?.studentDetailEmail, lastVerifiedEmail]);
  // Dropdown / master-data fetchers shared by the step-load effect below and
  // handleLeadCreationFlow — each caller decides which ones to run for its step.
  const fetchProducts = async () => {
    setLoadingProducts(true);
    try {
      const res = await dropdownService.getProducts();
      setProductOptions(
        res.data.map((prod) => ({
          value: prod.code,
          label: prod.name,
        }))
      );
    } catch (error) {
      setProductOptions([]);
    } finally {
      setLoadingProducts(false);
    }
  };
  // Fetch master data for dropdowns like courseCategory, admissionStatus, courseType
  const fetchMasterData = async () => {
    try {
      const res = await eligibilityCheckServices.getMasters();
      if (res.data?.status === "success") {
        setDropdownData((prev) => ({
          ...prev,
          courseCategory: (res.data.data.categories || []).map(
            (cat: any) => ({
              value: cat.categoryCode,
              label: cat.categoryName,
            })
          ),
          admissionStatus: (res.data.data.statusesOfAdmission || []).map(
            (stat: any) => ({
              value: stat.statusName,
              label: stat.statusName,
            })
          ),
          courseType: (res.data.data.courseTypes || []).map((type: any) => ({
            value: type.typeCode,
            label: type.typeName,
          })),
        }));
      }
    } catch (error) {
      // Optionally handle error or fallback to static data
      console.error("Failed to fetch master data", error);
    }
  };

  // Fetch Countries on component mount
  const fetchCountries = async () => {
    setLoadingDropdowns((prev) => ({ ...prev, countries: true }));
    try {
      const countriesResponse = await dropdownService.getCountries();
      const allCountries = countriesResponse.data
        // .filter((country) => country.active)
        .map((country) => ({
          value: country.countryId,
          label: country.countryDesc,
          countryId: String(country.countryId ?? ""),
        }));
      // Separate top countries and rest
      const topCountries: any[] = [];
      const restCountries: any[] = [];

      allCountries.forEach((country) => {
        const countryLabel = country.label.toUpperCase();
        const isTopCountry = topCountry.some((topName: any) =>
          countryLabel.includes(topName)
        );

        if (isTopCountry) {
          topCountries.push(country);
        } else {
          restCountries.push(country);
        }
      });

      // Sort top countries by the order in topCountryNames array
      topCountries.sort((a, b) => {
        const aIndex = topCountry.findIndex((name: any) =>
          a.label.toUpperCase().includes(name)
        );
        const bIndex = topCountry.findIndex((name: any) =>
          b.label.toUpperCase().includes(name)
        );
        return aIndex - bIndex;
      });

      // Sort rest of countries alphabetically
      restCountries.sort((a, b) => a.label.localeCompare(b.label));

      // Combine: top countries first, then rest
      const countriesOptions = [...topCountries, ...restCountries];
      setDropdownData((prev) => ({
        ...prev,
        countries: countriesOptions,
      }));
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
    }
  };
  // Fetch Salutations on component mount
  const fetchSalutations = async () => {
    setLoadingDropdowns((prev) => ({ ...prev, salutations: true }));
    try {
      const salutationResponse = await dropdownService.getSalutations();
      const salutationsOptions = salutationResponse.data
        // .filter((sal) => sal.active)
        .map((sal) => ({
          value: sal.salutationCode,
          label: sal.salutationDesc,
        }));

      setDropdownData((prev) => ({
        ...prev,
        salutations: salutationsOptions,
      }));
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      //setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
    }
  };
const fetchMaritalStatuses = async () => {
    try {
      const response = await dropdownService.getMaritalStatusMaster();
      const raw = response?.data || [];

      const maritalStatusOptions = (Array.isArray(raw) ? raw : []).map((item: any) => ({
        value: String(
          item?.maritalStatusCode ??
            item?.code ??
            item?.statusId ??
            item?.id ??
            item?.value ??
            item?.label ??
            item?.name ??
            "",
        ),
        label: String(
            item?.maritalStatusName ??
            item?.maritalStatusDesc ??
            item?.desc ??
            item?.value ??
            item?.label ??
            item?.name ??
            item?.code ??
            "",
        ),
      }));

      setDropdownData((prev) => ({
        ...prev,
        maritalStatuses: maritalStatusOptions.filter(
          (opt: any) => String(opt?.value ?? "").trim() && String(opt?.label ?? "").trim(),
        ),
      }));
    } catch (error) {
      console.error("Error fetching marital status master:", error);
    }
  };
  // Fetch System Values after Salutations
  const fetchSystemValues = async () => {
    try {
      const systemValuesResponse =
        await eligibilityCheckServices.getSystemValues();

      if (systemValuesResponse.data?.status === "success") {
        const systemValues = systemValuesResponse.data.data;

        // Filter and process Language Exam Types
        const languageExamTypes = systemValues
          .filter(
            (item: any) => item.name === "LANGUAGE_EXAM_TYPE" && item.active
          )
          .map((item: any) => ({
            value: item.code,
            label: item.value,
            id: item.serialId,
          }));

        // Filter and process Entrance Exam Types
        const entranceExamTypes = systemValues
          .filter(
            (item: any) => item.name === "ENTRANCE_EXAM_TYPE" && item.active
          )
          .map((item: any) => ({
            value: item.code,
            label: item.value,
            id: item.serialId,
          }));
        // Filter and process loan tenure Exam Types
        const loanTenureVal = systemValues
          .filter(
            (item: any) => item.name === "LOAN_TENURE_INMONTH" && item.active
          )
          .map((item: any) => ({
            value: item.code,
            label: item.value,
            id: item.serialId,
          }));

        // Update dropdown data with system values
        setDropdownData((prev) => ({
          ...prev,
          languageExamTypes,
          entranceExamTypes,
          loanTenureVal
        }));
      }
    } catch (error) {
      console.error("Error fetching system values:", error);
    }
  };

  // Get Entrance Exam Master
  const getEntranceExamMaster = async () => {
    try {
      const response = await eligibilityCheckServices.getEntranceExamMaster();
      if (response?.data?.data) {
        setEntranceExamMaster(response.data.data);
      }
    } catch (error: any) {
      setEntranceExamMaster([]);
    }
  };

  // Fetch Designations
  const fetchDesignations = async () => {
    try {
      const designationResponse =
        await eligibilityCheckServices.getDesignations();
      if (designationResponse?.data?.status === "success") {
        const designationsOptions = designationResponse.data.data.map(
          (designation: any) => ({
            value: designation.genDesignation,
            label: designation.genDesgDesc,
          })
        );

        setDropdownData((prev) => ({
          ...prev,
          designations: designationsOptions,
        }));
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  /**
   * Fetch initial data required for the dynamic form on component mount.
   *
   * This effect runs once when the component mounts and fetches three types of data:
   * 1. Product options - Available loan products with their codes and names
   * 2. Master data - Course categories, admission statuses, and course types for dropdowns
   * 3. Countries - List of available countries for address and other location fields
   *
   * All fetched data is stored in component state to populate dropdown fields throughout
   * the form. Loading states are managed to provide user feedback during data fetching.
   * Error handling ensures the form remains functional even if some data fails to load.
   *
   * @effect
   * @dependencies [] - Empty dependency array means this runs only on mount
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  useEffect(() => {
    // Fetch Products on component mount

    if (
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 || activeVerticalIndex === 5)
    ) {
      handleRelationMasterApi();
    }

    // Execute API calls based on step conditions
    const executeApiCalls = async () => {
      const promises: Promise<void>[] = [];

      if (activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
        promises.push(fetchProducts());
      }

      if (
        activeHorizontalIndex === 0 &&
        (activeVerticalIndex === 1 || activeVerticalIndex === 5)
      ) {
        promises.push(fetchMasterData());
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
        // The form's own pincode first — on the loan summary the editor is seeded from the
        // fetched application, which formData may not reflect.
        debouncedZipCodeCall(
          formikRef?.current?.values?.permanentPincode || formData.permanentPincode,
          undefined,
          "permanent"
        );
        debouncedZipCodeCall(
          formikRef?.current?.values?.currentPincode || formData.currentPincode,
          undefined,
          "current"
        );
      }

      const isCoApplicantAddressStep = (fields || []).some((f: any) =>
        /^addressCoApplicant\d+/i.test(String(f?.name || "")),
      );
      const isCoApplicantEmploymentStep = (fields || []).some((f: any) =>
        /^employmentCoApplicant\d+/i.test(String(f?.name || "")),
      );

      if (
        /^CoApplicant\d+$/.test(loanDetailCoApplicantCollapseValue) &&
        isCoApplicantAddressStep
      ) {
        const coNum = loanDetailCoApplicantCollapseValue.replace(
          "CoApplicant",
          ""
        );
        debouncedZipCodeCall(
          formData[`addressCoApplicant${coNum}permanentPincode`],
          loanDetailCoApplicantCollapseValue,
          "permanent"
        );
        debouncedZipCodeCall(
          formData[`addressCoApplicant${coNum}currentPincode`],
          loanDetailCoApplicantCollapseValue,
          "current"
        );
      }

      if (
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 5 &&
        /^CoApplicant\d+$/.test(loanDetailCoApplicantCollapseValue) &&
        isCoApplicantEmploymentStep
      ) {
        const coNum = loanDetailCoApplicantCollapseValue.replace(
          "CoApplicant",
          ""
        );
        debouncedZipCodeCall(
          formData[`employmentCoApplicant${coNum}pincode`],
          coNum,
          "company"
        );
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 2) {
        debouncedCompanyZipCodeCall(formData.employmentCompanyPincode);
      }

      if (
        (activeHorizontalIndex === 0 && activeVerticalIndex === 1) ||
        (activeHorizontalIndex === 1 &&
          (activeVerticalIndex === 1 ||
            activeVerticalIndex === 2 ||
            activeVerticalIndex === 5))
      ) {
        promises.push(fetchCountries());
      }

      if (
        activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 0 || activeVerticalIndex === 5)
      ) {
        promises.push(fetchSalutations());
        promises.push(fetchMaritalStatuses());
      }
      if ((activeHorizontalIndex === 3 && activeVerticalIndex === 0)|| (activeHorizontalIndex === 4 && activeVerticalIndex === 0)) {
        promises.push(fetchSalutations());
        promises.push(fetchMaritalStatuses());
        promises.push(fetchCountries());
        promises.push(fetchSystemValues());
      }
      if ((activeHorizontalIndex === 3 && activeVerticalIndex === 3) || (activeHorizontalIndex === 4 && activeVerticalIndex === 3)  ) {
        promises.push(fetchCountries());
      }
      // Co-applicant additional details: save sends the designation's full name.
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 1) {
        promises.push(fetchDesignations());
      }
      if (
        activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 2 || activeVerticalIndex === 5 )
      ) {
        promises.push(fetchDesignations());
        handleInvokCompanyZipCode(String(formData.employmentCompanyPincode));
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
        promises.push(getEntranceExamMaster());
        promises.push(fetchSystemValues());
      }

      // Set loading state at the start
      if (promises.length > 0) {
        setIsApiLoading(true);
        try {
          // Wait for all API calls to complete
          await Promise.all(promises);
        } finally {
          setIsApiLoading(false);
        }
      }
    };

    executeApiCalls();
  }, [activeHorizontalIndex, activeVerticalIndex, tabIndex, loanDetailCoApplicantCollapseValue]);

   useEffect(() => {
    if (pageType !== "SUMMARY") return;
    const coAppFieldName = (fields || [])
      .map((f: any) => String(f?.name || ""))
      .find((name: string) => /^(basic|address|employment)CoApplicant\d+/i.test(name));
    const coAppNum = coAppFieldName?.match(/CoApplicant(\d+)/i)?.[1];
    if (!coAppNum) return;
    const collapseKey = `CoApplicant${coAppNum}`;
    if (loanDetailCoApplicantCollapseValue !== collapseKey) {
      dispatch(setLoanDetailCoApplicantCollapseValue(collapseKey));
    }
  }, [pageType, fields, loanDetailCoApplicantCollapseValue]);

  // Initialize courseXTypeId fields and default courseXType values on academic details page load
  useEffect(() => {
    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 3 &&
      formikRef.current
    ) {
      const currentFormData = { ...formData };
      let hasChanges = false;

      // Define default course type values
      const defaultCourseTypes: { [key: string]: string } = {
        course1Type: "10th",
        course2Type: "12th",
        course3Type: "Graduation",
      };

      // Set default values for course types if not already set
      Object.entries(defaultCourseTypes).forEach(
        ([fieldName, defaultValue]) => {
          if (
            !formData?.[fieldName] &&
            !formikRef.current?.values?.[fieldName]
          ) {
            formikRef.current?.setFieldValue(fieldName, defaultValue, false);
            currentFormData[fieldName] = defaultValue;
            hasChanges = true;
          }
        }
      );

      // Iterate through formData to find courseXType fields and calculate TypeId
      Object.keys(currentFormData).forEach((key) => {
        const courseTypeMatch = key.match(/^course(\d+)Type$/);
        if (courseTypeMatch && currentFormData[key]) {
          const courseNumber = courseTypeMatch[1];
          const courseTypeIdField = `course${courseNumber}TypeID`;
          const courseTypeValue = currentFormData[key];

          // Calculate examTypeIdValue based on course type
          let examTypeIdValue: number = 0;
          if (courseTypeValue === "10th") {
            examTypeIdValue = 283;
          } else if (courseTypeValue === "12th") {
            examTypeIdValue = 284;
          } else if (courseTypeValue === "Diploma") {
            examTypeIdValue = 285;
          } else if (courseTypeValue === "Graduation") {
            examTypeIdValue = 286;
          }

          // Set the TypeId field in form values and Redux if not already set
          if (examTypeIdValue !== 0 && !currentFormData[courseTypeIdField]) {
            formikRef.current?.setFieldValue(
              courseTypeIdField,
              examTypeIdValue,
              false
            );
            currentFormData[courseTypeIdField] = examTypeIdValue;
            hasChanges = true;
          }
        }
      });

      // Update Redux only if there are changes
      if (hasChanges) {
        dispatch(updateFormData(currentFormData));
      }
    }
  }, [activeHorizontalIndex, activeVerticalIndex, dispatch]);

  const handleExamDropdownChange = (
    field: string,
    value: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    // Support dynamic field names with suffixes, e.g., languageExamName_6;
    let examType = field?.startsWith("coreExamName")
      ? "CORE_EXAM"
      : "LANGUAGE_EXAM";
    const found: any = entranceExamMaster.find(
      (exam: any) => exam.examTypeName === examType && exam.examName === value
    );
    // Determine suffix (e.g., _6)
    const suffixMatch = field.match(/_(\d+)$/);
    const suffix = suffixMatch ? `_${suffixMatch[1]}` : "";
    const marksField = field?.startsWith("coreExamName")
      ? `coreTotalMarks${suffix}`
      : `languageTotalMarks${suffix}`;
    // Set exam name WITHOUT triggering cascade validation on other fields
    setFieldValue(field, value, false);
    if (found && found.totalMarks) {
      setFieldValue(marksField, found.totalMarks, false);
    } else {
      setFieldValue(marksField, "", false);
    }

    // Store exam ID in Redux and form values
    const isCoreExam = field?.startsWith("coreExamName");
    const examIdField = isCoreExam
      ? `coreExamID${suffix}`
      : `languageExamID${suffix}`;
    const examIdFieldLowercase = isCoreExam
      ? `coreExamId${suffix}`
      : `languageExamId${suffix}`;

    // Find the exam ID from dropdownData
    const examTypes = isCoreExam
      ? dropdownData?.entranceExamTypes
      : dropdownData?.languageExamTypes;

    const selectedExam = examTypes?.find((exam: any) => exam.label === value);
    const examId = selectedExam?.id || "";

    // Set exam ID WITHOUT triggering cascade validation on other fields
    setFieldValue(examIdField, examId, false);
    setFieldValue(examIdFieldLowercase, examId, false);

    // Store exam name and ID in Redux
    const currentFormData = { ...formData };
    currentFormData[field] = value; // Store exam name (e.g., coreExamName, coreExamName_7)
    currentFormData[examIdField] = examId; // Store exam ID uppercase (e.g., coreExamID, coreExamID_7)
    currentFormData[examIdFieldLowercase] = examId; // Store exam ID lowercase (e.g., coreExamId, coreExamId_7)

    dispatch(updateFormData(currentFormData));
  };

  // Retry wrapper function for API calls
  const retryApiCall = async (
    apiCall: () => Promise<any>,
    maxRetries: number = 3,
    delay: number = 1000
  ): Promise<any> => {
    let lastError: any;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await apiCall();
        return response;
      } catch (error) {
        lastError = error;

        // If this is not the last attempt, wait before retrying
        if (attempt < maxRetries) {
          await new Promise((resolve) => setTimeout(resolve, delay));
          // Optional: Increase delay for next retry (exponential backoff)
          delay *= 1.5;
        }
      }
    }

    // If all retries failed, throw the last error
    throw lastError;
  };

  useEffect(() => {
    if (isLoadTesting) {
      dispatch(setIsDocumentVerified(true));
      const formikInstance = formikRef?.current;
      if (!formikInstance) {
        return;
      }
      // Only set AadhaarVerified flags (avoid touching other Formik fields)
      formikInstance.setFieldValue("isAadhaarVerified", true, false);
      const aadhaarVerifiedKeys = Object.keys(formikInstance.values).filter(
        (key) => /^basicCoApplicant(\d+)AadhaarVerified$/.test(key)
      );
      aadhaarVerifiedKeys.forEach((key) => {
        formikInstance.setFieldValue(key, true, false);
      });
    }
  }, [isLoadTesting, formikRef?.current?.values]);

  const handleInvokAadharApi = (
    applicationNo: string,
    payload: any,
    coAppKey?: string
  ): Promise<any> => {
    // Create unique verification key to track this specific verification call
    const verificationKey = `${payload?.typeOfApplicant}-${applicationNo}-${trackingId}`;

    // Check if this verification is already being processed
    if (processingAadhaarVerificationRef.current.has(verificationKey)) {
      return Promise.resolve(); // Skip duplicate call
    }

    // Mark this verification as being processed
    processingAadhaarVerificationRef.current.add(verificationKey);

    // Co-applicant Aadhaar verification is triggered from two steps: the
    // Loan Details step (1,5) and the Additional Details step (4,1).
    const isCoApplicantVerificationStep =
      (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
      (activeHorizontalIndex === 4 && activeVerticalIndex === 1);

    if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
      setIsAadharLoading(true);
    }

    if (isCoApplicantVerificationStep) {
      setIsAadharCoApplicantLoading((prev) => ({
        ...prev,
        [String(coAppKey)]: true,
      }));
    }
    // Use retry wrapper for the API call
    return retryApiCall(
      () => applicantDetailsServices.verifyAadhaarApplication(payload),
      3,
      1000
    )
      .then((res) => {
        const detailsObject = {
          ...res.data.data.proofOfAddress,
          ...res.data.data.proofOfIdentity,
        };
        if (Number(applicationIdApp) != 0 && activeVerticalIndex !== 1) {
          const uploadedDocuments = res?.data?.data?.uploadedDocuments || [];
          // Loop through each uploaded document and call push document API sequentially
          let coApp = `1`;
          if (coAppKey) {
            coApp = coAppKey.replace("CoApplicant", "");
          }

          // Sequential processing of documents using async/await
          (async () => {
            for (const document of uploadedDocuments) {
              const docNamed = document?.docName?.replace(/\s+/g, "").toUpperCase();
              if (document?.docName) {
                // Create unique key for this document to prevent duplicate pushes
                const documentKey = `${payload?.typeOfApplicant}-${document?.docType}-${document?.key}-${trackingId}`;

                // Check if this document has already been pushed
                if (pushedDocumentsRef.current.has(documentKey)) {
                  continue; // Skip this document
                }

                let pushPayload: any = {
                  eventName:
                    payload?.typeOfApplicant === "Applicant"
                      ? `APPLICANT_${docNamed}_PUSH_DOCUMENT`
                      : `COAPPLICANT${coApp}_${docNamed}_PUSH_DOCUMENT`,
                  trackingId: trackingId,
                  docType: document?.docNameDms || "",
                  applicantId:
                    payload?.typeOfApplicant === "Applicant"
                      ? Number(applicantIdApp)
                      : 0,
                  applicationId: applicationIdApp ? Number(applicationIdApp) : 0,
                  documentFilePath: document?.key || "",
                  userApplicantType: payload?.typeOfApplicant,
                };

                if (document?.docType === "PANCR") {
                  pushPayload.applicantHasPanCardFlag = true;
                }

                // Call push document API for each document sequentially
                if (pushPayload.docType && ((payload?.typeOfApplicant === "Applicant" && pushPayload.applicantId > 0 && pushPayload.applicationId > 0) || (payload?.typeOfApplicant !== "Applicant" && pushPayload.applicationId > 0))) {
                  // Mark this document as pushed before making the API call
                  pushedDocumentsRef.current.add(documentKey);

                  try {
                    await eligibilityCheckServices.pushDocument(pushPayload);
                  } catch (pushError: any) {
                    console.error(
                      "Push document failed for document:",
                      document,
                      pushError
                    );
                    // Remove from set if push failed so it can be retried
                    pushedDocumentsRef.current.delete(documentKey);
                  }
                }
              }
            }
          })();


        }
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          setIsAadharLoading(false);
        }
        if (isCoApplicantVerificationStep) {
          setIsAadharCoApplicantLoading((prev) => ({
            ...prev,
            [String(coAppKey)]: false,
          }));
          callSaveCoApplicantApi(formData, fields, coAppKey, trackingId, res?.data?.data?.isAadhaarConsent || false, "ADHAAR", res.data.data.proofOfAddress)
        }

        // Remove from processing set after successful completion
        processingAadhaarVerificationRef.current.delete(verificationKey);

        if (!res?.data?.data?.isAadhaarConsent) {
          dispatch(
            setVerificationMessage({
              index:
                isCoApplicantVerificationStep && coAppKey
                  ? coAppKey
                  : `CoApplicant1`,
              applicantType:
                activeHorizontalIndex === 1 && activeVerticalIndex === 0
                  ? "applicant"
                  : "coapplicant",
              field: "aadhar",
              status: "error",
              message:
                "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
            })
          );
          return;
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          dispatch(
            setVerificationMessage({
              // index: "",
              applicantType: "applicant",
              field: "aadhar",
              status: "success",
              message: "Yay! Your Aadhaar has been verified successfully.",
            })
          );
        } else if (isCoApplicantVerificationStep) {
          dispatch(
            setVerificationMessage({
              index: coAppKey ? coAppKey : `CoApplicant1`,
              applicantType: "coapplicant",
              field: "aadhar",
              status: "success",
              message:
                "Yay! The co-applicant’s Aadhaar has been successfully verified.",
            })
          );
        }

        // Clear document_verified param from URL
        if ((activeHorizontalIndex === 1 && activeVerticalIndex !== 0) || isCoApplicantVerificationStep) {
          const url = new URL(window.location.href);
          if (url.searchParams.has("document_verified")) {
            url.searchParams.delete("document_verified");
            window.history.replaceState({}, document.title, url.toString());
          }
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(setAadhaarVerifiedDetails(detailsObject));
          dispatch(setIsDocumentVerified(true));
          dispatch(setAadhaarApplicationNo(applicationNo));
          formikRef?.current?.setFieldValue("aadhaar", applicationNo);
          localStorage.removeItem("aadhaarApplicationNo");
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(setAadhaarVerifiedDetails(detailsObject));
          // Unlike the (1,0) Student Details step, this block never marked
          // the verification as done — the SUMMARY Address Details "Verify
          // Aadhaar Number" button reads formData.isAadhaarVerified (see
          // AdhaarVerifyFiled's call site), so without this the button stayed
          // stuck on "Verify Via Digilocker" after a successful redirect back.
          dispatch(updateFormData({ isAadhaarVerified: true }));
          formikRef?.current?.setFieldValue("isAadhaarVerified", true, false);

          // Check if user has manually entered any permanent address data
          const hasManualPermanentAddress = (
            (formikRef?.current?.values?.permanentAddressLine1 && formikRef?.current?.values?.permanentAddressLine1.trim() !== "") ||
            (formikRef?.current?.values?.permanentAddressLine2 && formikRef?.current?.values?.permanentAddressLine2.trim() !== "") ||
            (formikRef?.current?.values?.permanentAddressLine3 && formikRef?.current?.values?.permanentAddressLine3.trim() !== "")
          );

          // Only prefill if user hasn't manually entered data
          if (!hasManualPermanentAddress) {
            // Prefill address fields from Aadhaar data on address page
            const conCatPermanentAddress: string = [
              handleUnwanted(detailsObject.house),
              handleUnwanted(detailsObject.street),
              handleUnwanted(detailsObject.landmark),
              handleUnwanted(detailsObject.locality),
              //detailsObject.vtc,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            let chunkSize: boolean = conCatPermanentAddress.length > 50;

            if (chunkSize) {
              // const permanentAddr1: string = conCatPermanentAddress.slice(0, 50);
              // const permanentAddr2: string = conCatPermanentAddress.slice(50, 100);
              // const permanentAddr3: string = conCatPermanentAddress.slice(100, 150);
              const addressLines = splitAddressByWords(conCatPermanentAddress);
              const permanentAddr1: string = addressLines[0] || "";
              const permanentAddr2: string = addressLines[1] || "";
              const permanentAddr3: string = addressLines[2] || "";
              formikRef?.current?.setFieldValue(
                "permanentAddressLine1",
                permanentAddr1 || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine2",
                permanentAddr2 || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine3",
                permanentAddr3 || ""
              );
            } else {
              formikRef?.current?.setFieldValue(
                "permanentAddressLine1",
                detailsObject.house || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine2",
                `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim()
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine3",
                `${detailsObject.locality || ""}`.trim()
              );
            }
          }

          // Set pincode, city, state, country (only if not manually entered)
          if (detailsObject.pincode && !formikRef?.current?.values?.permanentPincode) {
            formikRef?.current?.setFieldValue(
              "permanentPincode",
              detailsObject.pincode || ""
            );
            // Trigger pincode API to fetch city, state data
            handleInvokZipCode(detailsObject.pincode, undefined, "permanent");
          }

          if (!formikRef?.current?.values?.permanentCity) {
            formikRef?.current?.setFieldValue(
              "permanentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
          }

          if (!formikRef?.current?.values?.permanentState) {
            formikRef?.current?.setFieldValue(
              "permanentState",
              detailsObject.state || ""
            );
          }

          if (!formikRef?.current?.values?.permanentCountry) {
            formikRef?.current?.setFieldValue(
              "permanentCountry",
              detailsObject.country || "India"
            );
          }

          // Update filled fields count for all address fields (only if they were prefilled)
          if (!hasManualPermanentAddress) {
            handleFilledFieldsCount("permanentAddressLine1", detailsObject.house || "");
            handleFilledFieldsCount("permanentAddressLine2", `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim());
            handleFilledFieldsCount("permanentAddressLine3", `${detailsObject.locality || ""}`.trim());
            handleFilledFieldsCount("permanentPincode", detailsObject.pincode || "");
            handleFilledFieldsCount(
              "permanentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
            handleFilledFieldsCount("permanentState", detailsObject.state || "");
            handleFilledFieldsCount("permanentCountry", detailsObject.country || "India");
          }

          // Handle current address - check if manually entered
          const hasManualCurrentAddress = (
            (formikRef?.current?.values?.currentAddressLine1 && formikRef?.current?.values?.currentAddressLine1.trim() !== "") ||
            (formikRef?.current?.values?.currentAddressLine2 && formikRef?.current?.values?.currentAddressLine2.trim() !== "") ||
            (formikRef?.current?.values?.currentAddressLine3 && formikRef?.current?.values?.currentAddressLine3.trim() !== "")
          );

          // Only prefill current address if user hasn't manually entered data
          if (!hasManualCurrentAddress) {
            const conCatCurrentAddress: string = [
              handleUnwanted(detailsObject.house),
              handleUnwanted(detailsObject.street),
              handleUnwanted(detailsObject.landmark),
              handleUnwanted(detailsObject.locality),
              //detailsObject.vtc,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            let currentChunkSize: boolean = conCatCurrentAddress.length > 50;

            if (currentChunkSize) {
              const currentAddr1: string = conCatCurrentAddress.slice(0, 50);
              const currentAddr2: string = conCatCurrentAddress.slice(50, 100);
              const currentAddr3: string = conCatCurrentAddress.slice(100, 150);

              formikRef?.current?.setFieldValue(
                "currentAddressLine1",
                currentAddr1 || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine2",
                currentAddr2 || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine3",
                currentAddr3 || ""
              );
            } else {
              formikRef?.current?.setFieldValue(
                "currentAddressLine1",
                detailsObject.house || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine2",
                `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim()
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine3",
                `${detailsObject.locality || ""}`.trim()
              );
            }
          }

          // Set current address pincode, city, state, country (only if not manually entered)
          if (detailsObject.pincode && !formikRef?.current?.values?.currentPincode) {
            formikRef?.current?.setFieldValue(
              "currentPincode",
              detailsObject.pincode || ""
            );
            handleInvokZipCode(detailsObject.pincode, undefined, "current");
          }

          if (!formikRef?.current?.values?.currentCity) {
            formikRef?.current?.setFieldValue(
              "currentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
          }

          if (!formikRef?.current?.values?.currentState) {
            formikRef?.current?.setFieldValue(
              "currentState",
              detailsObject.state || ""
            );
          }

          if (!formikRef?.current?.values?.currentCountry) {
            formikRef?.current?.setFieldValue(
              "currentCountry",
              detailsObject.country || "India"
            );
          }

          // Update filled fields count for current address fields (only if they were prefilled)
          if (!hasManualCurrentAddress) {
            handleFilledFieldsCount("currentAddressLine1", detailsObject.house || "");
            handleFilledFieldsCount("currentAddressLine2", `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim());
            handleFilledFieldsCount("currentAddressLine3", `${detailsObject.locality || ""}`.trim());
            handleFilledFieldsCount("currentPincode", detailsObject.pincode || "");
            handleFilledFieldsCount(
              "currentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
            handleFilledFieldsCount("currentState", detailsObject.state || "");
            handleFilledFieldsCount("currentCountry", detailsObject.country || "India");
          }
        }

        if (isCoApplicantVerificationStep) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(
            setAadhaarVerifiedDetailsCoApplicant({
              coAppKey,
              details: detailsObject,
            })
          );
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: true,
            })
          );
          dispatch(
            setAadhaarApplicationNoCoApplicant({
              coAppKey,
              applicationNo,
            })
          );
          // Set Aadhaar number in the correct co-applicant field
          formikRef?.current?.setFieldValue(
            `basic${coAppKey}AadhaarNumber`,
            applicationNo
          );
          const coAppNum = coAppKey ? coAppKey.replace("CoApplicant", "") : "";

          const conCatPermanentAddress: string = [
            handleUnwanted(detailsObject.house),
            handleUnwanted(detailsObject.street),
            handleUnwanted(detailsObject.landmark),
            handleUnwanted(detailsObject.locality),
            //detailsObject.vtc,
          ]
            .filter(Boolean)
            .join(" ")
            .trim();

          let chunkSize: boolean = conCatPermanentAddress.length > 50; // Condition applied here

          if (chunkSize) {
           
            const addressLines = splitAddressByWords(conCatPermanentAddress);
            const permanentAddr1: string = addressLines[0] || "";
            const permanentAddr2: string = addressLines[1] || "";
            const permanentAddr3: string = addressLines[2] || "";
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine1`,
              permanentAddr1 || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine2`,
              permanentAddr2 || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine3`,
              permanentAddr3 || ""
            );
          } else {
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine1`,
              detailsObject.house || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine2`,
              `${detailsObject.street} ${detailsObject.landmark}` || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine3`,
              `${detailsObject.locality}` || ""
            );
          }

          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentPincode`,
            detailsObject.pincode || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentCity`,
            normalizeAadhaarAddressPart(detailsObject.vtc) ||
              normalizeAadhaarAddressPart(detailsObject.district)
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentState`,
            detailsObject.state || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentCountry`,
            detailsObject.country || ""
          );
          // Optionally trigger zip code lookup for co-applicant
          // if (detailsObject.pincode) {
          //   debouncedZipCodeCall(detailsObject.pincode, coAppNum);
          // }
          localStorage.removeItem("aadhaarApplicationNoCoApplicant");
        }
      })
      .catch((err) => {
        // Remove from processing set on error to allow retry
        processingAadhaarVerificationRef.current.delete(verificationKey);
        dispatch(
          setStatusPopup({
            status: "error",
            message: "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
            // message: err?.response?.data?.message || "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
          })
        );
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          setIsAadharLoading(false);
          dispatch(setIsDocumentVerified(isLoadTesting ? true : false));
        }
        if (isCoApplicantVerificationStep) {
          setIsAadharCoApplicantLoading((prev) => ({
            ...prev,
            [String(coAppKey)]: false,
          }));
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: isLoadTesting ? true : false,
            })
          );
        }
      });
  };

  // check if productName is present in the url and set it in the redux store
  useEffect(() => {
    if (location.pathname === "/apply-now") {
      const urlParams = new URLSearchParams(window.location.search);
      const productName = urlParams.get("productName");
      formikRef?.current?.setFieldValue(
        "product",
        productName?.toUpperCase() || ""
      );
    }
  }, [location, formikRef]);


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const documentVerified = urlParams.get("document_verified");
    // Retrieve co-applicant key from localStorage or another source
    const coAppKey = localStorage.getItem("aadhaarCoAppKey"); // e.g., "CoApplicant1"
    // Get per-coapplicant applicationNo if coAppKey exists, else use applicant's
    const applicationNo =
      coAppKey &&
        aadhaarApplicationNoCoApplicant &&
        aadhaarApplicationNoCoApplicant[coAppKey]
        ? aadhaarApplicationNoCoApplicant[coAppKey]
        : aadhaarApplicationNo;

    // Determine typeOfApplicant value
    // Co-applicant Aadhaar verification is triggered from two steps: the
    // Loan Details step (1,5) and the Additional Details step (4,1).
    const isCoApplicantVerificationStep =
      (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
      (activeHorizontalIndex === 4 && activeVerticalIndex === 1);
    let typeOfApplicant = "Applicant";
    let coAppNum = "";
    if (
      documentVerified === "true" &&
      isCoApplicantVerificationStep &&
      coAppKey
    ) {
      // Extract co-applicant number from coAppKey, e.g., "CoApplicant1" -> "1"
      coAppNum = coAppKey.replace("CoApplicant", "");
      typeOfApplicant = `Co-Applicant ${coAppNum}`;
    }

    const payload = {
      documentId: applicationNo,
      employmentCategory: formData?.applicantType ?? formikRef?.current?.values?.applicantType ?? "student",
      typeOfApplicant,
      formSubmissionTrackingId: trackingId,
    };

    if (
      documentVerified === "true" &&
      applicationNo &&
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      isEaadhaarOnVerifyNow !== true
    ) {
      setIsApiLoading(true);
      handleInvokAadharApi(aadhaarApplicationNo, payload).finally(() => {
        setIsApiLoading(false);
      });
    }

    if (
      activeVerticalIndex === 1 &&
      activeHorizontalIndex === 1 &&
      formData?.aadhaar
    ) {
      const payloadAddress = {
        documentId: formData?.aadhaar,
        employmentCategory: formData?.applicantType ?? formikRef?.current?.values?.applicantType ?? "student",
        typeOfApplicant,
        formSubmissionTrackingId: trackingId,
      };

      setIsApiLoading(true);
      handleInvokAadharApi(aadhaarApplicationNo, payloadAddress).finally(() => {
        setIsApiLoading(false);
      });
    }

    if (
      documentVerified === "true" &&
      isCoApplicantVerificationStep &&
      applicationNo &&
      coAppKey // Make sure you have the key
    ) {
      // coAppNum already set above
      // Set the Aadhaar number for the correct co-applicant field
      if (formikRef.current) {
        formikRef.current.setFieldValue(
          `basicCoApplicant${coAppNum}AadhaarNumber`,
          applicationNo
        );
      }

      setIsApiLoading(true);
      handleInvokAadharApi(applicationNo, payload, coAppKey).finally(() => {
        setIsApiLoading(false);
      });
    }
  }, [
    aadhaarApplicationNo,
    aadhaarApplicationNoCoApplicant,
    trackingId,
    activeHorizontalIndex,
    activeVerticalIndex,
  ]);

  const shouldDisableFields = useMemo(() => {
    return isEligibilityCheckSubmitted && activeHorizontalIndex === 0;
  }, [isEligibilityCheckSubmitted, activeHorizontalIndex]);

  useEffect(() => {
    if (activeHorizontalIndex == 1 && activeVerticalIndex == 1) {
      // Use formData value if present, otherwise default to true
      let value = formData?.currentsameAsPermanent;
      if (value === undefined || value === null || value === "") {
        value = true;
      }
      // Convert string "true"/"false" to boolean
      if (typeof value === "string") {
        value = value === "true";
      }
      formikRef?.current?.setFieldValue("currentsameAsPermanent", value);
    }
  }, [activeHorizontalIndex, activeVerticalIndex, formikRef, formData]);
  const handleCurrentAddressFilledInPermanent = (
    value: any,
    fieldName: any
  ): void => {
    // Only main applicant: copy single permanent field to current field
    if (fieldName.includes("permanent")) {
      formikRef?.current?.setFieldValue(
        fieldName?.replace(/^[a-z]+/, "current"),
        value
      );
    }

    // Co-applicant
    const coAppMatch = fieldName.match(
      /^addressCoApplicant(\d+)permanent(.+)$/
    );
    if (coAppMatch) {
      const coAppNum = coAppMatch[1];
      const fieldSuffix = coAppMatch[2];
      const currentField = `addressCoApplicant${coAppNum}current${fieldSuffix}`;
      formikRef?.current?.setFieldValue(currentField, value);
    }
  };

  /**
   * Update form completion state based on field values.
   *
   * This function tracks the completion status of form fields by checking if they
   * have been filled. It also handles special cases for certain fields, such as
   * current address fields that are dependent on permanent address fields.
   *
   * @function
   * @param {string} fieldName - The name of the field being checked
   * @param {any} value - The value of the field being checked
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const handleFilledFieldsCount = (fieldName: string, value: any) => {
    // Main applicant only: copy single permanent field to current field if sameAsPermanent is true (strict boolean)
    if (
      fieldName.includes("permanent") &&
      formikRef?.current?.values?.currentsameAsPermanent === true
    ) {
      handleCurrentAddressFilledInPermanent(value, fieldName);
    }
    // Co-applicant
    const coAppMatch = fieldName.match(
      /^addressCoApplicant(\d+)permanent(.+)$/
    );
    if (coAppMatch) {
      const coAppNum = coAppMatch[1];
      const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
      if (formikRef?.current?.values?.[sameAsKey] === true) {
        handleCurrentAddressFilledInPermanent(value, fieldName);
      }
    }
  };

  // Function to copy all permanent address fields to current address fields for a given co-applicant
  const copyCoApplicantPermanentToCurrent = (coAppNum: string) => {
    if (!formikRef?.current) return;
    const values = formikRef?.current?.values;
    // Dynamically copy all permanent address fields for this co-applicant
    Object.keys(values)
      .filter(
        (key) =>
          key?.startsWith(`addressCoApplicant${coAppNum}permanent`) &&
          !key.includes("currentsameAsPermanent")
      )
      .forEach((permKey) => {
        const fieldSuffix = permKey.replace(
          `addressCoApplicant${coAppNum}permanent`,
          ""
        );
        const currKey = `addressCoApplicant${coAppNum}current${fieldSuffix}`;
        formikRef?.current?.setFieldValue(currKey, values[permKey] ?? "");
      });
  };

  // Effect: Only copy permanent to current address when checkbox transitions from unchecked to checked
  const prevSameAsPermanentRef = useRef<{ [key: string]: boolean }>({});
  useEffect(() => {
    if (!formikRef.current) return;
    const values = formikRef.current.values;
    Object.keys(values)
      .filter(
        (key) =>
          key?.startsWith("addressCoApplicant") &&
          key.match(/^addressCoApplicant\d+currentsameAsPermanent$/)
      )
      .forEach((key) => {
        const coAppNum = key.match(
          /^addressCoApplicant(\d+)currentsameAsPermanent$/
        )?.[1];
        const prev = prevSameAsPermanentRef.current[key];
        const curr = values[key];
        if (coAppNum && curr && !prev) {
          copyCoApplicantPermanentToCurrent(coAppNum);
        }
        prevSameAsPermanentRef.current[key] = curr;
      });
  }, [formikRef.current?.values]);

  /**
   * Fetch universities when country changes
   *
   * This function fetches universities based on the selected country and updates
   * the dropdown data accordingly. It also handles the case where no country is
   * selected by clearing the universities dropdown.
   *
   * @function
   * @param {any} value - The value of the country being selected
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const resolveFieldId = (
    primary?: any,
    formikFieldName?: string,
    reduxFieldName?: string
  ) => {
    if (primary) return String(primary);
    const formikValue = formikRef?.current?.values?.[formikFieldName || ""];
    if (formikValue?.value) return String(formikValue.value);
    if (formikValue?.countryId) return String(formikValue.countryId);
    if (formikValue?.id) return String(formikValue.id);
    if (
      typeof formikValue === "string" ||
      typeof formikValue === "number"
    ) {
      return String(formikValue);
    }
    const reduxValue = formData?.[reduxFieldName || ""];
    if (reduxValue?.value) return String(reduxValue.value);
    if (
      typeof reduxValue === "string" ||
      typeof reduxValue === "number"
    ) {
      return String(reduxValue);
    }
    return "";
  };
  const handleInvokStatesByCountryApi = async (countryName: string) => {
    const normalizedCountry = String(countryName || "").trim();
    const normalizedCountryLower = normalizedCountry.toLowerCase();

    if (!normalizedCountry) {
      lastBirthCityCountryRef.current = "";
      birthCityInFlightCountryRef.current = "";
      setBirthCityList([]);
      setBirthCityLoading(false);
      return;
    }

    // Already cached (even an empty result) — keep the flat "last searched"
    // list in sync for existing consumers and skip re-fetching.
    if (birthCityListByCountry[normalizedCountryLower] !== undefined) {
      setBirthCityList(birthCityListByCountry[normalizedCountryLower]);
      return;
    }

    const isSameCountryInFlight =
      birthCityInFlightCountryRef.current.toLowerCase() === normalizedCountryLower;

    if (isSameCountryInFlight) {
      return;
    }

    lastBirthCityCountryRef.current = normalizedCountry;
    birthCityInFlightCountryRef.current = normalizedCountry;
    const requestId = ++birthCityRequestIdRef.current;
    setBirthCityLoading(true);

    try {
      const resp = await eligibilityCheckServices.getCitiesByCountryState(
        normalizedCountry,
      );

      const isLatestRequest = requestId === birthCityRequestIdRef.current;

      if (resp.status === 200 && resp.data?.data) {
        const rawCities = Array.isArray(resp.data?.data)
          ? resp.data.data
          : typeof resp.data?.data === "object" && resp.data?.data !== null
            ? Object.values(resp.data.data)
            : [];

        const seenCities = new Set<string>();
        const locationOptions = rawCities
          .map((item: any) => {
            if (item && typeof item === "object") {
              const label = String(
                item?.cityName ??
                  item?.cityDesc ??
                  item?.name ??
                  item?.label ??
                  item?.value ??
                  "",
              )
                .trim()
                .replace(/\s+/g, " ");
              // Prefer city/cityCode — never fall back to cityName (full name).
              const value = String(
                item?.city ??
                  item?.cityCode ??
                  item?.value ??
                  item?.code ??
                  "",
              )
                .trim()
                .replace(/\s+/g, " ");

              if (!label && !value) {
                return null;
              }

              return {
                label: label || value,
                value: value || label,
              };
            }

            const normalizedCity = String(item ?? "")
              .trim()
              .replace(/\s+/g, " ");

            if (!normalizedCity) {
              return null;
            }

            return {
              label: normalizedCity,
              value: normalizedCity,
            };
          })
          .filter((city: any) => city?.label || city?.value)
          .filter((city: any) => {
            const key = `${String(city?.value || "").toLowerCase()}::${String(
              city?.label || "",
            ).toLowerCase()}`;
            if (seenCities.has(key)) {
              return false;
            }
            seenCities.add(key);
            return true;
          });

        setBirthCityListByCountry((prev) => ({
          ...prev,
          [normalizedCountryLower]: locationOptions,
        }));
        if (isLatestRequest) {
          setBirthCityList(locationOptions);
        }
      } else {
        setBirthCityListByCountry((prev) => ({
          ...prev,
          [normalizedCountryLower]: [],
        }));
        if (isLatestRequest) {
          setBirthCityList([]);
        }
      }
    } catch (error: any) {
      setBirthCityListByCountry((prev) => ({
        ...prev,
        [normalizedCountryLower]: prev[normalizedCountryLower] ?? [],
      }));
      if (requestId === birthCityRequestIdRef.current) {
        setBirthCityList([]);
      }
    } finally {
      if (requestId === birthCityRequestIdRef.current) {
        birthCityInFlightCountryRef.current = "";
        setBirthCityLoading(false);
      }
    }
  };

  useEffect(() => {
    if (!Array.isArray(fields) || fields.length === 0) return;

    const activeCoAppNum = String(
      loanDetailCoApplicantCollapseValue || "",
    ).replace("CoApplicant", "");
    let birthCountryField = activeCoAppNum
      ? fields.find(
          (f: any) =>
            f?.name === `basicCoApplicant${activeCoAppNum}CountryOfBirth`,
        )
      : null;

    if (!birthCountryField) {
      birthCountryField = fields.find((f: any) => {
        const name = String(f?.name || "").toLowerCase();
        const label = String(f?.label || "").toLowerCase();
        return (
          /country.*birth|birth.*country|countryofbirth/.test(name) ||
          /country.*birth|birth.*country|country of birth/.test(label)
        );
      });
    }

    if (!birthCountryField?.name) return;

    const rawCountry =
      formikRef?.current?.values?.[`${birthCountryField.name}Name`] ??
      formData?.[`${birthCountryField.name}Name`] ??
      formikRef?.current?.values?.[birthCountryField.name] ??
      formData?.[birthCountryField.name];

    const countryValue =
      rawCountry && typeof rawCountry === "object"
        ? rawCountry.label || rawCountry.value || ""
        : rawCountry;
    const countryName =
      dropdownData?.countries?.find(
        (country: any) =>
          String(country?.value || "") === String(countryValue || "") ||
          String(country?.label || "").toLowerCase() ===
            String(countryValue || "").toLowerCase(),
      )?.label || countryValue;

    if (countryName) {
      handleInvokStatesByCountryApi(String(countryName));
    }
  }, [fields, formData, dropdownData?.countries, loanDetailCoApplicantCollapseValue]);

  // Summary page can show every co-applicant's "City of Birth" at once (e.g.
  // SingleCoApplicantAdditionalDetails), not just whichever one is currently
  // expanded. The effect above only warms the cache for the active
  // co-applicant, so this one walks every co-applicant's own Country of Birth
  // and fetches+caches that country's cities too, so each resolves correctly
  // regardless of which panel is open.
  useEffect(() => {
    if (!Array.isArray(fields) || fields.length === 0) return;
    if (!dropdownData?.countries?.length) return;

    const birthCountryFields = fields.filter((f: any) =>
      /^basicCoApplicant\d+CountryOfBirth$/i.test(String(f?.name || "")),
    );
    if (birthCountryFields.length === 0) return;

    const resolveCountryName = (fieldName: string) => {
      const rawCountry =
        formikRef?.current?.values?.[`${fieldName}Name`] ??
        formData?.[`${fieldName}Name`] ??
        formikRef?.current?.values?.[fieldName] ??
        formData?.[fieldName];

      const countryValue =
        rawCountry && typeof rawCountry === "object"
          ? rawCountry.label || rawCountry.value || ""
          : rawCountry;

      return (
        dropdownData?.countries?.find(
          (country: any) =>
            String(country?.value || "") === String(countryValue || "") ||
            String(country?.label || "").toLowerCase() ===
              String(countryValue || "").toLowerCase(),
        )?.label || countryValue
      );
    };

    const distinctCountries = Array.from(
      new Set(
        birthCountryFields
          .map((f: any) => String(resolveCountryName(f.name) || "").trim())
          .filter(Boolean),
      ),
    );

    (async () => {
      for (const country of distinctCountries) {
        if (birthCityListByCountry[country.toLowerCase()] === undefined) {
          await handleInvokStatesByCountryApi(country);
        }
      }
    })();
  }, [fields, formData, dropdownData?.countries, birthCityListByCountry]);

  // Normalize any country selection (object/string/number) to its country ID.
  // Form fields can hold either an autocomplete option object, the raw ID, or a
  // display label, so this guards every payload from leaking the label as ID.
  const resolveCountryId = (rawValue: any): string => {
    if (rawValue === undefined || rawValue === null || rawValue === "") {
      return "";
    }

    const countries = dropdownData?.countries || [];

    if (typeof rawValue === "object") {
      if (rawValue.value !== undefined && rawValue.value !== null && rawValue.value !== "") {
        return String(rawValue.value);
      }
      if (
        rawValue.countryId !== undefined &&
        rawValue.countryId !== null &&
        rawValue.countryId !== ""
      ) {
        return String(rawValue.countryId);
      }
      if (rawValue.label) {
        const matched = countries.find(
          (c: any) =>
            String(c.label).toLowerCase() === String(rawValue.label).toLowerCase()
        );
        if (matched?.value) return String(matched.value);
      }
      return "";
    }

    const stringValue = String(rawValue).trim();
    if (!stringValue) return "";

    const byId = countries.find(
      (c: any) =>
        String(c.value).toLowerCase() === stringValue.toLowerCase() ||
        String(c.countryId).toLowerCase() === stringValue.toLowerCase()
    );
    if (byId?.value) return String(byId.value);

    const byLabel = countries.find(
      (c: any) => String(c.label).toLowerCase() === stringValue.toLowerCase()
    );
    if (byLabel?.value) return String(byLabel.value);

    return "";
  };

  const fetchUniversities = async (value: any) => {
    const selectedCountryId = resolveFieldId(
      formValues.countryId,
      "country",
      "country"
    );
    if (selectedCountryId) {
      setLoadingDropdowns((prev) => ({ ...prev, universities: true }));
      try {
        const universitiesResponse = await dropdownService.getUniversities({
          universityName: value,
          countryId: dropdownData?.countries?.find((elem: any) => elem?.label == selectedCountryId)?.countryId ?? selectedCountryId,
        });

        const universitiesOptions = universitiesResponse.data
          .filter((university) => university.active)
          .map((university) => ({
            value: university.universityId.toString(),
            label: university.universityName,
            code: university.universityCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          universities: universitiesOptions,
        }));
      } catch (error) {
        console.error("Error fetching universities:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, universities: false }));
      }
    } else {
      // Clear universities if country not selected
      setDropdownData((prev) => ({
        ...prev,
        universities: [],
      }));
    }
  };
  // Fetch institutes when university changes
  const fetchInstitutes = async (value: any) => {
    const selectedCountryId = resolveFieldId(
      formValues.countryId,
      "country",
      "country"
    );
    const selectedUniversityId = resolveFieldId(
      formValues.universityId,
      "university",
      "university"
    );
    if (selectedCountryId && selectedUniversityId) {
      setLoadingDropdowns((prev) => ({ ...prev, institutes: true }));
      try {
        const institutesResponse = await dropdownService.getInstitutes({
          instituteName: value, // Default search term
          universityId: selectedUniversityId,
          countryId: dropdownData?.countries?.find((elem: any) => elem?.label == selectedCountryId)?.countryId ?? selectedCountryId,
        });

        const institutesOptions = institutesResponse.data
          .filter((institute) => institute.active)
          .map((institute) => ({
            value: institute.instituteId.toString(),
            label: institute.instituteName,
            code: institute.instituteCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          institutes: institutesOptions,
        }));
      } catch (error) {
        console.error("Error fetching institutes:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, institutes: false }));
      }
    } else {
      // Clear institutes if dependencies are not met
      setDropdownData((prev) => ({
        ...prev,
        institutes: [],
      }));
    }
  };
  // Fetch courses when institute changes
  const fetchCourses = async (value: any) => {
    const selectedInstituteId = resolveFieldId(
      formValues?.instituteId,
      "institute",
      "institute"
    );
    if (selectedInstituteId) {
      setLoadingDropdowns((prev) => ({ ...prev, courses: true }));
      try {
        const coursesResponse = await dropdownService.getCourses({
          courseName: value,
          instituteId: selectedInstituteId,
        });

        const coursesOptions = coursesResponse.data
          .filter((course) => course.recordStatus === "Approved")
          .map((course) => ({
            value: course.courseId.toString(),
            label: course.courseName,
            code: course.courseCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          courses: coursesOptions,
        }));
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, courses: false }));
      }
    } else {
      // Clear courses if institute not selected
      setDropdownData((prev) => ({
        ...prev,
        courses: [],
      }));
    }
  };
  // Handle dropdown changes to update form values for dependent dropdowns
  // Handle dropdown changes to update form values for dependent dropdowns
    const handleDropdownChange = (
      fieldName: string,
      value: any,
      form: any,
      changeReason?: string,
    ) => {
      const isApplicantCityCountryField =
        String(fieldName || "").toLowerCase() === "applicantcitycountry";
      const isApplicantCityCountryCityMode =
        isApplicantCityCountryField &&
        Array.isArray(birthCityList) &&
        birthCityList.length > 0;
      const isBirthCountryField =
        /birth.*country|country.*birth/i.test(fieldName) ||
        (isApplicantCityCountryField && !isApplicantCityCountryCityMode);
      const isBirthCityField =
        /birth.*city|city.*birth/i.test(fieldName) ||
        isApplicantCityCountryCityMode ||
        String(fieldName || "").toLowerCase() === "applicantcitybirth";
  
      // Selecting an option can be followed by a blur event from MUI Autocomplete.
      // Ignore blur reason for birth-country to avoid duplicate city API calls.
      if (isBirthCountryField && changeReason === "blur") {
        return;
      }
  
      // Keep applicantCityCountry stable on outside-click/transient events.
      if (
        isApplicantCityCountryField &&
        (value === null || value === undefined || value === "")
      ) {
        return;
      }
  
      if (
        isApplicantCityCountryField &&
        changeReason &&
        changeReason !== "selectOption" &&
        changeReason !== "clear"
      ) {
        return;
      }
  
      if (isBirthCityField && changeReason === "blur") {
        return;
      }
  
      // MUI Autocomplete can emit a transient null-like change on blur/outside click.
      // Ignore that for birth-country fields unless it is an explicit clear action.
      if (
        isBirthCountryField &&
        (value === null || value === undefined || value === "") &&
        changeReason !== "clear"
      ) {
        return;
      }
  
      if (
        isBirthCityField &&
        (value === null || value === undefined || value === "") &&
        changeReason !== "clear"
      ) {
        return;
      }
  
      const normalizedValue =
        isBirthCityField && value && typeof value === "object"
          ? normalizeBirthCityOption(value, birthCityList)
          : isApplicantCityCountryField && value && typeof value === "object"
            ? isApplicantCityCountryCityMode
              ? normalizeBirthCityOption(value, birthCityList)
              : String((value as any)?.label || (value as any)?.value || "")
          : value;
  
      // Birth-city fields are often dynamic and missing from Yup schema;
      // validating them throws "schema does not contain the path".
      form.setFieldValue(fieldName, normalizedValue, !isBirthCityField);
      if (isBirthCityField) {
        form.setFieldError?.(fieldName, undefined);
      }
  
      // Re-populate total marks when coreScoreReceived changes to "Yes"
      const coreScoreReceivedMatch = fieldName.match(/^coreScoreReceived(_\d+)?$/);
      if (coreScoreReceivedMatch) {
        const suffix = coreScoreReceivedMatch[1] || "";
        const examNameField = `coreExamName${suffix}`;
        const marksField = `coreTotalMarks${suffix}`;
        const examScoreField = `coreExamScore${suffix}`;
        const expectedOnField = `coreScoreExpectedOn${suffix}`;
  
        if (value === "Yes") {
          // Re-populate total marks from master
          const examNameValue = formikRef?.current?.values?.[examNameField];
          if (examNameValue) {
            const found: any = entranceExamMaster.find(
              (exam: any) => exam.examTypeName === "CORE_EXAM" && exam.examName === examNameValue
            );
            if (found && found.totalMarks) {
              form.setFieldValue(marksField, found.totalMarks, true);
              dispatch(updateFormData({ [marksField]: found.totalMarks }));
            }
          }
          // Clear expected date
          form.setFieldValue(expectedOnField, "", false);
          dispatch(updateFormData({ [expectedOnField]: "" }));
        }
  
        if (value === "No") {
          // Clear marks obtained and total marks
          form.setFieldValue(examScoreField, "", false);
          form.setFieldValue(marksField, "", false);
          dispatch(updateFormData({ [examScoreField]: "", [marksField]: "" }));
          // Clear expected date in case switching back keeps stale value
          form.setFieldValue(expectedOnField, "", false);
          dispatch(updateFormData({ [expectedOnField]: "" }));
        }
      }
  
      // Re-populate total marks when languageScoreReceived changes to "Yes"
      const langScoreReceivedMatch = fieldName.match(/^languageScoreReceived(_\d+)?$/);
      if (langScoreReceivedMatch) {
        const suffix = langScoreReceivedMatch[1] || "";
        const examNameField = `languageExamName${suffix}`;
        const marksField = `languageTotalMarks${suffix}`;
        const examScoreField = `languageExamScore${suffix}`;
        const expectedOnField = `languageScoreExpectedOn${suffix}`;
  
        if (value === "Yes") {
          // Re-populate total marks from master
          const examNameValue = formikRef?.current?.values?.[examNameField];
          if (examNameValue) {
            const found: any = entranceExamMaster.find(
              (exam: any) => exam.examTypeName === "LANGUAGE_EXAM" && exam.examName === examNameValue
            );
            if (found && found.totalMarks) {
              form.setFieldValue(marksField, found.totalMarks, true);
              dispatch(updateFormData({ [marksField]: found.totalMarks }));
            }
          }
          // Clear expected date
          form.setFieldValue(expectedOnField, "", false);
          dispatch(updateFormData({ [expectedOnField]: "" }));
        }
  
        if (value === "No") {
          // Clear marks obtained and total marks
          form.setFieldValue(examScoreField, "", false);
          form.setFieldValue(marksField, "", false);
          dispatch(updateFormData({ [examScoreField]: "", [marksField]: "" }));
          // Clear expected date in case switching back keeps stale value
          form.setFieldValue(expectedOnField, "", false);
          dispatch(updateFormData({ [expectedOnField]: "" }));
        }
      }
  
      // Handle course type fields - set corresponding TypeId field
      const courseTypeMatch = fieldName.match(/^course(\d+)Type$/);
      if (courseTypeMatch) {
        const courseNumber = courseTypeMatch[1];
        const courseTypeIdField = `course${courseNumber}TypeID`;
  
        let examTypeIdValue: number = 0;
        if (value === "10th") {
          examTypeIdValue = 283;
        } else if (value === "12th") {
          examTypeIdValue = 284;
        } else if (value === "Diploma") {
          examTypeIdValue = 285;
        } else if (value === "Graduation") {
          examTypeIdValue = 286;
        }
        // Set the TypeId field in form values
        form.setFieldValue(courseTypeIdField, examTypeIdValue, true);
  
        // Store both course type and TypeId in Redux immediately
        const currentFormData = { ...formData };
        currentFormData[fieldName] = value; // Store course type (e.g., course1Type: "10th")
        currentFormData[courseTypeIdField] = examTypeIdValue; // Store TypeId (e.g., course1TypeId: 283)
        dispatch(updateFormData(currentFormData));
      }
  
      // Don't set field value here as it's already set in the onChange handler
      if (fieldName === "permanentCity" && value) {
        // Only update current city if "same as permanent" is checked
        const isSameAs = formikRef?.current?.values?.currentsameAsPermanent;
        if (isSameAs) {
          form.setFieldValue("currentCity", value?.value || value);
        }
      }
  
      if (fieldName?.toLowerCase()?.includes("coursename")) {
        const courseValue = value?.value || value;
        const courseCode = value?.code || value;
        setFormValues((prev) => ({ ...prev, courseCode: courseCode }));
        formikRef?.current?.setFieldValue("courseCode", courseCode);
        // Force form validation/update after courseName is set
        setTimeout(() => {
          if (formikRef?.current) {
            formikRef?.current.validateForm();
          }
        }, 10);
      }
  
      // Update form values state for dependent dropdowns
      if (fieldName?.toLowerCase()?.includes("study")) {
        // Only clear if the value is being cleared/emptied
        const actualValue = value?.value || value;
        if (!actualValue || actualValue === "" || actualValue === null) {
          // Clear all course-related dependent dropdowns when course category/study/admission status is cleared
          form.setFieldValue("country", "");
          form.setFieldValue("university", "");
          form.setFieldValue("institute", "");
          form.setFieldValue("course", "");
          form.setFieldValue("courseName", "");
          setDropdownData((prev) => ({
            ...prev,
            countries: [],
            universities: [],
            institutes: [],
            courses: [],
          }));
        }
      } else if (isBirthCountryField) {
        const countryName = value?.label || value?.value || value || "";
  
        if (!countryName) {
          if (changeReason === "clear") {
            setBirthCityList([]);
            const birthCityField = fields.find((f: any) =>
              /birth.*city|city.*birth/i.test(String(f?.name || "")) ||
              /birth.*city|city.*birth/i.test(String(f?.label || "")) ||
              String(f?.name || "").toLowerCase() === "applicantcitybirth",
            )?.name;
            if (birthCityField) {
              form.setFieldValue(birthCityField, "");
            }
          }
          return;
        }
        if (
          String(fieldName || "").toLowerCase() === "applicantbirthcountry" ||
          /country.*birth|birth.*country/i.test(String(fieldName || ""))
        ) {
          handleInvokStatesByCountryApi(String(countryName));
        }
        const birthCityField = fields.find((f: any) =>
          /birth.*city|city.*birth/i.test(String(f?.name || "")) ||
          /birth.*city|city.*birth/i.test(String(f?.label || "")) ||
          String(f?.name || "").toLowerCase() === "applicantcitybirth"
        )?.name;
        if (birthCityField) {
          form.setFieldValue(birthCityField, "");
        }
      } else if (fieldName?.toLowerCase()?.includes("country")) {
        const countryValue = value?.value || value;
  
        setFormValues((prev) => ({
          ...prev,
          countryId: countryValue,
          universityCountryId: countryValue,
        }));
        // formikRef.current?.setFieldValue("universityCountryId", countryValue);
        formikRef.current?.setFieldValue("universityCountryId", value?.value);
  
        // Only clear if the value is being cleared/emptied
        if (!countryValue || countryValue === "" || countryValue === null) {
          // Clear dependent dropdowns
          form.setFieldValue("university", "");
          form.setFieldValue("institute", "");
          form.setFieldValue("course", "");
          form.setFieldValue("courseName", "");
          setDropdownData((prev) => ({
            ...prev,
            institutes: [],
            universities: [],
            courses: [],
          }));
        }
      } else if (fieldName?.toLowerCase()?.includes("university")) {
        const universityValue = value?.value || value;
        const universityCode = value?.code || value;
        setFormValues((prev) => ({
          ...prev,
          universityId: universityValue,
          universityCampusId: universityCode,
        }));
        formikRef.current?.setFieldValue("universityCampusId", universityCode);
  
        // Only clear if the value is being cleared/emptied
        if (
          !universityValue ||
          universityValue === "" ||
          universityValue === null
        ) {
          // Clear dependent dropdowns
          form.setFieldValue("institute", "");
          form.setFieldValue("course", "");
          form.setFieldValue("courseName", "");
          setDropdownData((prev) => ({
            ...prev,
            institutes: [],
            courses: [],
          }));
        }
      } else if (fieldName?.toLowerCase()?.includes("institute")) {
        const instituteValue = value?.value || value;
        const instituteCode = value?.code || value;
        setFormValues((prev) => ({
          ...prev,
          instituteId: instituteValue,
          institute_code: instituteCode,
        }));
        formikRef.current?.setFieldValue("institute_code", instituteCode);
  
        // Only clear if the value is being cleared/emptied
        if (!instituteValue || instituteValue === "" || instituteValue === null) {
          // Clear dependent dropdown
          form.setFieldValue("course", "");
          form.setFieldValue("courseName", "");
          setDropdownData((prev) => ({
            ...prev,
            courses: [],
          }));
        }
      } else if (
        fieldName?.toLowerCase()?.includes("course") &&
        !fieldName?.toLowerCase()?.includes("coursename")
      ) {
        // You can add search functionality here if needed for generic "course" fields
        const searchTerm = value?.value || value; // or extract from input
        setFormValues((prev) => ({ ...prev, courseName: searchTerm }));
      } else if (fieldName?.toLowerCase() == "salutation") {
        const salutationValue = value?.value || value;
        const salutationLabel = value?.label || value;
  
        setFormValues((prev) => ({
          ...prev,
          salutation: salutationValue,
          salutationName: salutationLabel,
        }));
        // Set both the main salutation field and salutationName field
        formikRef.current?.setFieldValue(fieldName, salutationValue);
        formikRef.current?.setFieldValue("salutationName", salutationLabel);
      } else if (/coapplicant.*salutation/i.test(fieldName)) {
        const salutationValue = value?.value || value;
        const salutationLabel = value?.label || value;
  
        setFormValues((prev) => ({
          ...prev,
          [fieldName]: salutationValue,
          [`${fieldName}Name`]: salutationLabel,
        }));
        // Set both the main salutation field and salutationName field
        formikRef.current?.setFieldValue(fieldName, salutationValue);
        formikRef.current?.setFieldValue(`${fieldName}Name`, salutationLabel);
      } else if (fieldName?.toLowerCase()?.includes("pincode")) {
        // setFormValues((prev) => ({
        //   ...prev,
        //   salutation: value?.value,
        //   salutationName: value?.label,
        // }));
        // formikRef.current?.setFieldValue("salutationName", value?.label);
      }
      // Handle Language Exam ID and Name storage in Redux
      else if (
        fieldName?.toLowerCase()?.includes("languageexamname") ||
        fieldName?.toLowerCase()?.includes("languageexam")
      ) {
        if (value && typeof value === "object" && value.value && value.label) {
          // Store exam ID in formData instead of separate Redux state
          const currentFormData = { ...formData };
          currentFormData.languageExamId = value.value; // Store the ID
          dispatch(updateFormData(currentFormData));
        }
      }
      // Handle Core Exam ID and Name storage in Redux
      else if (
        fieldName?.toLowerCase()?.includes("coreexamname") ||
        fieldName?.toLowerCase()?.includes("coreexam") ||
        /core.*exam.*name/i.test(fieldName) ||
        /entrance.*exam/i.test(fieldName)
      ) {
        if (value && typeof value === "object" && value.value && value.label) {
          // Store exam ID in formData instead of separate Redux state
          const currentFormData = { ...formData };
          currentFormData.coreExamId = value.value; // Store the ID
          dispatch(updateFormData(currentFormData));
        }
      }
      // Handle direct coreExamID/languageExamID field storage in Redux
      else if (
        /^coreExamID(_\d+)?$/i.test(fieldName) ||
        /^languageExamID(_\d+)?$/i.test(fieldName)
      ) {
        const currentFormData = { ...formData };
        currentFormData[fieldName] = value;
        dispatch(updateFormData(currentFormData));
      }
      // Handle RelationWithStudent field - similar to salutation handling
      else if (/basicCoApplicant\d+RelationWithStudent/i.test(fieldName)) {
        const relationValue = value?.value || value;
        const relationLabel = value?.label || value;
        const relationValueFields = [
          fieldName.replace(
            /RelationWithStudent$/,
            "OtherRelationWithStudent"
          ),
          fieldName.replace(/RelationWithStudent$/, "RelationValue"),
        ];
  
        setFormValues((prev) => ({
          ...prev,
          [fieldName]: relationValue,
          [`${fieldName}Name`]: relationLabel,
        }));
        // Set both the main relation field and relationName field
        formikRef.current?.setFieldValue(fieldName, relationValue);
        formikRef.current?.setFieldValue(`${fieldName}Name`, relationLabel);
        if (relationValue !== "OTHERS") {
          relationValueFields.forEach((relationValueField) => {
            formikRef.current?.setFieldValue(relationValueField, "");
          });
        }
  
        // Update Redux with RelationWithStudent value
        const currentFormData = { ...formData };
        currentFormData[fieldName] = relationValue;
        currentFormData[`${fieldName}Name`] = relationLabel;
        if (relationValue !== "OTHERS") {
          relationValueFields.forEach((relationValueField) => {
            currentFormData[relationValueField] = "";
          });
        }
        dispatch(updateFormData(currentFormData));
      }
    };

  // Helper function to get dropdown options based on field
    const getDropdownOptions = (field: any) => {
      const normalizedFieldName = String(field?.name || "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      const isLoanTenureField = /loan\s*tenure|loantenure/i.test(
        String(field?.name || "") + String(field?.label || ""),
      );
  
      // Use helper-backed options for collateral type fields.
      if (/^collateral\d*type$/.test(normalizedFieldName)) {
        return (mapCollateral() || []).map((opt: any) => ({
          value: String(opt?.value ?? ""),
          label: String(opt?.label ?? ""),
        }));
      }
  
      const isBirthCityField =
        /birth.*city|city.*birth/i.test(String(field?.name || "")) ||
        /birth.*city|city.*birth/i.test(String(field?.label || "")) ||
        String(field?.name || "").toLowerCase() === "applicantcitybirth";
  
      if (field.options && Array.isArray(field.options.options) && !isLoanTenureField) {
        const objectOptions = field.options.options.filter(
          (opt: any) =>
            opt &&
            typeof opt === "object" &&
            ("value" in opt || "label" in opt),
        );
  
        if (objectOptions.length > 0) {
          return objectOptions.map((opt: any) => ({
            value: String(opt?.value ?? opt?.label ?? ""),
            label: String(opt?.label ?? opt?.value ?? ""),
          }));
        }
      }
  
      // Show years from 2000 to current year for "cour" fields in activeHorizontalIndex 1, form 3
      if (
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 3 && // form 3 (0-based index)
        field.name.toLowerCase().includes("year")
      ) {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear - 30; year <= currentYear; year++) {
          years.push({ value: year.toString(), label: year.toString() });
        }
  
        // Filter based on chronological order of courses
        const formValues = formikRef?.current?.values || {};
  
        // Extract course number from field name (e.g., "course1Year", "course1PassingYear" -> 1)
        const currentCourseMatch = field.name.match(/course(\d+)(Year|PassingYear|YearOfPassing|PassYear)/i);
        if (!currentCourseMatch) {
          return [
            { value: "", label: `Select ${field.label || "Year"}` },
            ...years,
          ];
        }
  
        const currentCourseNum = parseInt(currentCourseMatch[1]);
  
        // Get current course type (e.g., "10th", "Diploma", etc.)
        const currentCourseType = formValues[`course${currentCourseNum}Type`] || "";
  
        // Special handling for Diploma: show same options as 10th, but exclude 10th's selected year
        if (currentCourseType === "Diploma") {
          // Find the course that is "10th" and get its selected year
          let tenthSelectedYear: number | null = null;
          Object.keys(formValues).forEach((key) => {
            const typeMatch = key.match(/course(\d+)Type/);
            if (typeMatch && formValues[key] === "10th") {
              const tenthCourseNum = parseInt(typeMatch[1]);
              // Check multiple possible year field name patterns
              const yearFieldPatterns = [
                `course${tenthCourseNum}Year`,
                `course${tenthCourseNum}PassingYear`,
                `course${tenthCourseNum}YearOfPassing`,
                `course${tenthCourseNum}PassYear`,
              ];
  
              for (const yearKey of yearFieldPatterns) {
                const tenthYear = formValues[yearKey];
                if (tenthYear) {
                  const tenthYearValue = parseInt(tenthYear);
                  if (!isNaN(tenthYearValue)) {
                    tenthSelectedYear = tenthYearValue;
                    break; // Found the year, no need to check other patterns
                  }
                }
              }
            }
          });
  
          // Filter years: show only years AFTER the year selected in 10th
          const filteredYears = years.filter((yearOption) => {
            const yearValue = parseInt(yearOption.value);
            // If no 10th year selected, show all years. Otherwise, show only years after the selected 10th year
            if (tenthSelectedYear === null) {
              return true;
            }
            return yearValue > tenthSelectedYear;
          });
  
          return [
            { value: "", label: `Select ${field.label || "Year"}` },
            ...filteredYears,
          ];
        }
  
        // Get all course year fields and their values
        const courseYearData: { courseNum: number; year: number }[] = [];
        Object.keys(formValues).forEach((key) => {
          const match = key.match(/course(\d+)(Year|PassingYear|YearOfPassing|PassYear)/i);
          if (match && formValues[key]) {
            const courseNum = parseInt(match[1]);
            const year = parseInt(formValues[key]);
            if (!isNaN(year)) {
              courseYearData.push({ courseNum, year });
            }
          }
        });
  
        // Find the maximum year from all previous courses
        let minAllowedYear = 1965; // Default minimum
        courseYearData.forEach(({ courseNum, year }) => {
          if (courseNum < currentCourseNum && year >= minAllowedYear) {
            minAllowedYear = year;
          }
        });
  
        // Collect all already selected years (to exclude duplicates)
        const selectedYears = courseYearData
          .filter(({ courseNum }) => courseNum !== currentCourseNum)
          .map(({ year }) => year);
  
        // Filter years: show only years after the previous course and exclude duplicates
        const filteredYears = years.filter((yearOption) => {
          const yearValue = parseInt(yearOption.value);
          return yearValue > minAllowedYear && !selectedYears.includes(yearValue);
        });
  
        return [
          { value: "", label: `Select ${field.label || "Year"}` },
          ...filteredYears,
        ];
      }
  
      // 1. If options are provided directly in the field JSON, use them
      // Exclude fields that should use system values instead
      const isSystemValueField =
        field.name.toLowerCase().includes("salutation") ||
        field.name.toLowerCase().includes("marital") ||
        field.name.toLowerCase().includes("country") ||
        String(field.label || "").toLowerCase().includes("country") ||
        isLoanTenureField ||
        /birth.*city|city.*birth/i.test(String(field.name || "")) ||
        /birth.*city|city.*birth/i.test(String(field.label || "")) ||
        field.name.toLowerCase().includes("coreexamname") ||
        field.name.toLowerCase().includes("coreexam") ||
        field.name.toLowerCase().includes("languageexamname") ||
        field.name.toLowerCase().includes("languageexam") ||
        /core.*exam/i.test(field.name) ||
        /language.*exam/i.test(field.name)||
        /^employmentCoApplicant\d+designation$/i.test(field.name);
  
      if (
        field.options &&
        Array.isArray(field.options.options) &&
        !isSystemValueField
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Option"}` },
          ...field.options.options
            .filter((opt: any) => opt != null && opt !== undefined)
            .map((opt: string) => ({
              value: opt || "",
              label: opt || "",
            })),
        ];
      }
  
      // 2. Existing logic for other dropdowns
      if (
        field.name.toLowerCase().includes("coursecategory") ||
        field.label.toLowerCase().includes("coursecategory")
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Course Category"}` },
          ...(dropdownData?.courseCategory ?? []),
        ];
      }
      if (
        field.name.toLowerCase().includes("coursetype") ||
        field.label.toLowerCase().includes("coursetype")
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Course Type"}` },
          ...(dropdownData?.courseType ?? []),
        ];
      }
  
      if (isBirthCityField) {
        // A co-applicant's own birth-city options must come from THEIR OWN
        // birth country's cache — birthCityList only ever holds whichever
        // country was fetched most recently, which is wrong when several
        // co-applicants (each with a different birth country) render at once.
        const coAppCityMatch = String(field?.name || "").match(
          /^basicCoApplicant(\d+)CityOfBirth$/i,
        );
        if (coAppCityMatch) {
          const coAppCountryFieldName = `basicCoApplicant${coAppCityMatch[1]}CountryOfBirth`;
          const rawCountry =
            formikRef?.current?.values?.[`${coAppCountryFieldName}Name`] ??
            formData?.[`${coAppCountryFieldName}Name`] ??
            formikRef?.current?.values?.[coAppCountryFieldName] ??
            formData?.[coAppCountryFieldName];
          const countryValue =
            rawCountry && typeof rawCountry === "object"
              ? rawCountry.label || rawCountry.value || ""
              : rawCountry;
          const countryName =
            dropdownData?.countries?.find(
              (country: any) =>
                String(country?.value || "") === String(countryValue || "") ||
                String(country?.label || "").toLowerCase() ===
                  String(countryValue || "").toLowerCase(),
            )?.label || countryValue;

          const cached =
            countryName &&
            birthCityListByCountry[String(countryName).toLowerCase()];
          if (cached) {
            return [...cached];
          }
        }

        return [...(birthCityList || [])];
      }
  
      if (
        field.name.toLowerCase().includes("country") ||
        field.label.toLowerCase().includes("country")
      ) {
        const countryOptions = [...(dropdownData?.countries || [])];
        const isStudyDestinationStep =
          activeHorizontalIndex === 0 &&
          activeVerticalIndex === 1 &&
          (
            field.name.toLowerCase().includes("study") ||
            field.name.toLowerCase().includes("destination") ||
            field.label.toLowerCase().includes("study") ||
            field.label.toLowerCase().includes("destination")
          );
  
        if (isStudyDestinationStep) {
          return countryOptions.filter(
            (country: any) =>
              String(country?.label || "").trim().toLowerCase() !== "india"
          );
        }
  
        return [
          // { value: "", label: `Select ${field.label || "Country"}` },
          ...countryOptions,
        ];
      }
      if (
        field.name.toLowerCase().includes("university") ||
        field.label.toLowerCase().includes("university")
      ) {
        return [
          // { value: "", label: `Select ${field.label || "University"}` },
          ...(dropdownData?.universities || []),
        ];
      }
      if (
        field.name.toLowerCase().includes("institute") ||
        field.label.toLowerCase().includes("institute")
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Institute"}` },
          ...(dropdownData?.institutes || []),
        ];
      }
      if (
        field.name.toLowerCase().includes("course") ||
        field.label.toLowerCase().includes("course")
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Course"}` },
          ...(dropdownData?.courses || []),
        ];
      }
      if (field.name.toLowerCase().includes("salutation")) {
        return [
          // { value: "", label: `Select ${field.name || "Salutation"}` },
          ...(dropdownData?.salutations || []),
        ];
      }
      if (field.name.toLowerCase().includes("designation")||
        /^employmentCoApplicant\d+designation$/i.test(field.name) ||
        /^basicCoApplicant\d+Designation/i.test(field.name.replace(/\s+/g, ""))
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Designation"}` },
          ...(dropdownData?.designations || []),
        ];
      }
      if (
        field.name.toLowerCase().includes("marital") ||
        field.label.toLowerCase().includes("marital") ||
        /^basiccoApplicant\d+marital/i.test(field.name.replace(/\s+/g, "")) ||
        /^basicCoApplicant\d+MaritalStatus/i.test(field.name.replace(/\s+/g, ""))
      ) {
        return [...(dropdownData?.maritalStatuses || [])];
      }
      if (isLoanTenureField) {
        return [...(dropdownData?.loanTenureVal || [])];
      }
      if (
        field.name.toLowerCase().includes("admissionstatus") ||
        field.label.toLowerCase().includes("admissionstatus")
      ) {
        return [
          // { value: "", label: `Select ${field.label || "Admission Status"}` },
          ...(dropdownData?.admissionStatus || []),
        ];
      }
  
      if (
        field.name.toLowerCase().includes("permanentcity") ||
        field.name.toLowerCase().includes("currentcity")
      ) {
        return [
          { value: "", label: `Select ${field.label || "City"}` },
          ...(cityList || []),
        ];
      }
      // Handle Language Exam Type fields
      if (
        field.name.toLowerCase().includes("languageexamname") ||
        field.name.toLowerCase().includes("languageexam") ||
        /language.*exam/i.test(field.name)
      ) {
        const options = [
          // { value: "", label: `Select ${field.label || "Language Exam"}` },
          ...(dropdownData?.languageExamTypes || []),
        ];
        return options;
      }
  
      // Handle Entrance/Core Exam Type fields
      if (
        field.name.toLowerCase().includes("coreexamname") ||
        field.name.toLowerCase().includes("coreexam") ||
        /core.*exam.*name/i.test(field.name) ||
        /entrance.*exam/i.test(field.name)
      ) {
        const options = [
          // { value: "", label: `Select ${field.label || "Core Exam"}` },
          ...(dropdownData?.entranceExamTypes || []),
        ];
        return options;
      }
  
      // ---- Master-backed select handling for SUMMARY edit ----
      // Mirrors existing nationality fix so that saved values show up as selected
      // instead of blank (especially for co-applicant SUMMARY edit).

      // Nationality should use master options (especially for co-applicant summary edit)
      // Handle misspelling "naionality" and also real "nationality".
      // Also explicitly handle co-applicant nationality field name: basicCoApplicant{N}Nationality
      if (
        /naionality/i.test(field.name) ||
        /nationality/i.test(field.name) ||
        /nationality/i.test(field.label) ||
        /^basiccoApplicant\d+nationality$/i.test(field.name.replace(/\s+/g, ""))
      ) {
        // Prefer explicit field JSON options if provided
        if (field.options && Array.isArray(field.options)) {
          const objectBased = field.options.filter(
            (opt: any) => opt != null && opt !== undefined
          );
          if (objectBased.length > 0) {
            return objectBased
              .map((opt: any) =>
                typeof opt === "object"
                  ? {
                      value: String(opt?.value ?? opt?.label ?? ""),
                      label: String(opt?.label ?? opt?.value ?? ""),
                    }
                  : { value: String(opt), label: String(opt) },
              )
              .filter((opt: any) => opt.value && opt.label);
          }
        }

        // Fallback to fetched nationality master options
        return (applicantNationalityOptions || []).map((opt) => ({
          value: String(opt?.value ?? ""),
          label: String(opt?.label ?? ""),
        })).filter((o) => o.value && o.label);
      }

      // Marital status master-backed options (SUMMARY edit needs consistent option value->label mapping)
      if (
        /marital/i.test(field.name) ||
        /marital/i.test(field.label) ||
        /^basiccoApplicant\d+marital/i.test(field.name.replace(/\s+/g, "")) ||
        /^basicCoApplicant\d+MaritalStatus/i.test(field.name.replace(/\s+/g, ""))
      ) {
        if (field.options && Array.isArray(field.options)) {
          const objectBased = field.options.filter(
            (opt: any) => opt != null && opt !== undefined
          );
          if (objectBased.length > 0) {
            return objectBased
              .map((opt: any) =>
                typeof opt === "object"
                  ? {
                      value: String(opt?.maritalStatusCode ?? ""),
                      label: String(opt?.maritalStatusName ?? ""),
                    }
                  : { value: String(opt), label: String(opt) },
              )
              .filter((opt: any) => opt.value && opt.label);
          }
        }

        // Use fetched master options (maritalStatuses)
        return (dropdownData?.maritalStatuses || maritalStatusMasterOptions || [])
          .map((opt: any) => ({
            value: String(opt?.value ?? opt?.maritalStatusCode ?? ""),
            label: String(opt?.label ?? opt?.maritalStatusName ??  ""),
          }))
          .filter((o: any) => o.value && o.label);
      }
      return [];
    };

  // Check if dropdown is loading
  const isDropdownLoading = (field: any) => {
    if (field.name.toLowerCase().includes("country")) {
      return loadingDropdowns.countries;
    }
    if (field.name.toLowerCase().includes("university")) {
      return loadingDropdowns.universities;
    }
    if (field.name.toLowerCase().includes("institute")) {
      return loadingDropdowns.institutes;
    }
    if (field.name.toLowerCase().includes("course")) {
      return loadingDropdowns.courses;
    }
    return false;
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isRedirectVerified = urlParams.get("document_verified") === "true";

  // Fix initial values - set proper defaults for different field types
  const initialValues = (() => {
    const getFieldValueFromRawField = (field: any) => {
      if (!field || typeof field !== "object") return undefined;
      const extractValue = (value: any) => {
        if (value === undefined) return undefined;
        if (typeof value === "object" && value !== null && "value" in value) {
          return value.value;
        }
        return value;
      };
      if (field.value !== undefined) {
        return extractValue(field.value);
      }
      if (field.defaultValue !== undefined) {
        return extractValue(field.defaultValue);
      }
      if (field.name && field[field.name] !== undefined) {
        return extractValue(field[field.name]);
      }
      return undefined;
    };

    // Use mergedFields for vertical step 3, fields for others
    const fieldsToUse = fields;
    const values: Record<string, any> = {};

    // Define enableReinitialize based on your logic or set to false by default.
    // Aadhaar journey return fix:
    // When coming back from third-party verification, Redux/formData gets refreshed,
    // and Formik re-initialization overwrites user-entered values.
    // We preserve the in-progress user edits and rely on existing Aadhaar handlers
    // (handleInvokAadharApi) to update Aadhaar-specific fields.
    const isReturningFromAadhaar =
      new URLSearchParams(window.location.search).get("document_verified") === "true" ||
      Boolean(localStorage.getItem("aadhaarCoAppKey")) ||
      Boolean(localStorage.getItem("aadhaarApplicationNoCoApplicant"));

    const enableReinitialize =
      !isReturningFromAadhaar &&
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 ||
        activeVerticalIndex === 1 ||
        activeVerticalIndex === 5);

    fieldsToUse.forEach((field: any) => {
      const fallbackFieldValue = getFieldValueFromRawField(field);
      // Special case for employmentType dropdown to default to 'Student'
      if (field.type === "dropdown" && field.name === "employmentType") {
        if (
          formData &&
          formData[field.name] !== undefined &&
          formData[field.name] !== ""
        ) {
          values[field.name] = formData[field.name];
        } else if (fallbackFieldValue !== undefined && fallbackFieldValue !== "") {
          values[field.name] = fallbackFieldValue;
        } else {
          values[field.name] = "Student";
        }
        return;
      }
      // Skip initial value for co-applicant fields and dob if reinitializing
      if (
        enableReinitialize &&
        (/^(basicCoApplicant\d+|addressCoApplicant\d+|employmentCoApplicant\d+)/.test(
          field.name
        ) ||
          field.name === "dob")
      ) {
        return;
      }

      // Special case for employmentisEmployed radio button to default to "null"
      if (field.type === "radio" && field.name === "employmentisEmployed") {
        if (
          formData &&
          formData[field.name] !== undefined &&
          formData[field.name] !== ""
        ) {
          values[field.name] = formData[field.name];
        } else {
          // values[field.name] = "Yes";
          values[field.name] = "";
        }
        return;
      }
      // For CGPA fields, set the corresponding score type to "CGPA" by default
      // if (
      //   field.name.match(/^course\d+ScoreType$/) &&
      //   (formData?.[field.name] === undefined || formData?.[field.name] === "")
      // ) {
      //   values[field.name] = "CGPA";
      //   return;
      // }
      // Prefill from existing formData in Redux if available
      if (formData && formData[field.name] !== undefined) {
        values[field.name] = formData[field.name];
        return;
      }
      // Use field.value/defaultValue if the summary `fields` already carry the value
      if (fallbackFieldValue !== undefined) {
        values[field.name] = fallbackFieldValue;
        return;
      }
      // Prefill co-applicant fields from coApplicantVerification
      // Co-applicant strict mapping (new field names)
      const coApplicantMatch = field.name.match(
        /^basicCoApplicant(\d+)(Email|PhoneNumber|PanNumber)$/
      );
      if (coApplicantMatch) {
        const idx = coApplicantMatch[1]; // '1' for basicCoApplicant1, '2' for basicCoApplicant2
        const reduxIdx = String(Number(idx) - 1); // '0' for basicCoApplicant1, '1' for basicCoApplicant2
        const type = coApplicantMatch[2];

        // Prefer formData if present
        if (formData[field.name] !== undefined && formData[field.name] !== "") {
          values[field.name] = formData[field.name];
          return;
        }

        // Strictly match field name and reduxIdx
        if (
          type === "PhoneNumber" &&
          coApplicantVerification[reduxIdx]?.lastVerifiedMobileNumber &&
          field.name === `basicCoApplicant${idx}PhoneNumber`
        ) {
          values[field.name] =
            coApplicantVerification[reduxIdx].lastVerifiedMobileNumber;
          return;
        }
        if (
          type === "Email" &&
          coApplicantVerification[reduxIdx]?.lastVerifiedEmail &&
          field.name === `basicCoApplicant${idx}Email`
        ) {
          values[field.name] =
            coApplicantVerification[reduxIdx].lastVerifiedEmail;
          return;
        }
        if (
          type === "PanNumber" &&
          coApplicantVerification[reduxIdx]?.lastPanNumber &&
          field.name === `basicCoApplicant${idx}PanNumber`
        ) {
          values[field.name] = coApplicantVerification[reduxIdx].lastPanNumber;
          return;
        }
      }
      // For indexed exam fields (core/language), prefill all matching keys from formData
      if (
        (field.name?.startsWith("core") || field.name?.startsWith("language")) &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 4 &&
        formData
      ) {
        Object.keys(formData).forEach((key) => {
          if (key?.startsWith(field.name)) {
            values[key] = formData[key];
          }
        });
        if (values[field.name] === undefined) {
          switch (field.type) {
            case "checkbox":
              values[field.name] = false;
              break;
            case "number":
              values[field.name] = "";
              break;
            default:
              values[field.name] = "";
              break;
          }
        }
        return;
      }
      // For indexed course fields (course13Type, etc.), prefill all matching keys from formData
      if (
        field.name?.startsWith("course") &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 3 &&
        formData
      ) {
        Object.keys(formData).forEach((key) => {
          if (key?.startsWith(field.name)) {
            values[key] = formData[key];
          }
        });
        if (values[field.name] === undefined) {
          switch (field.type) {
            case "checkbox":
              values[field.name] = false;
              break;
            case "number":
              values[field.name] = "";
              break;
            default:
              values[field.name] = "";
              break;
          }
        }
        return;
      }
      // Special redirect prefill for phone/email
      if (
        isRedirectVerified &&
        field.name === "phone_number" &&
        lastVerifiedPhoneNumber
      ) {
        values[field.name] = lastVerifiedPhoneNumber;
        return;
      }
      if (isRedirectVerified && field.name === "email" && lastVerifiedEmail) {
        values[field.name] = lastVerifiedEmail;
        return;
      }

      // Default values for all other fields
      switch (field.type) {
        case "checkbox":
          values[field.name] = false;
          break;
        case "number":
          values[field.name] = "";
          break;
        default:
          values[field.name] = "";
          break;
      }
    });

    // Also prefill any indexed keys in formData not present in fieldsToUse
    if (formData) {
      Object.keys(formData).forEach((key) => {
        if (values[key] === undefined) {
          values[key] = formData[key];
        }
      });
      // Map studentDetails fields from main applicant fields if not already set
      if (
        (values["studentDetailEmail"] === undefined ||
          values["studentDetailEmail"] === "") &&
        formData["email"] !== undefined
      ) {
        values["studentDetailEmail"] = formData["email"];
      }
      if (
        (values["studentDetailsFirstName"] === undefined ||
          values["studentDetailsFirstName"] === "") &&
        formData["firstName"] !== undefined
      ) {
        values["studentDetailsFirstName"] = formData["firstName"];
      }
      if (
        (values["studentDetailsLastName"] === undefined ||
          values["studentDetailsLastName"] === "") &&
        formData["lastName"] !== undefined
      ) {
        values["studentDetailsLastName"] = formData["lastName"];
      }
      if (
        (values["studentDetailsPhone_number"] === undefined ||
          values["studentDetailsPhone_number"] === "") &&
        formData["phone_number"] !== undefined
      ) {
        values["studentDetailsPhone_number"] = formData["phone_number"];
      }
      if (
        (values["LoanDetailsLoanAmount"] === undefined ||
          values["LoanDetailsLoanAmount"] === "") &&
        formData["loanAmount"] !== undefined
      ) {
        values["LoanDetailsLoanAmount"] = formData["loanAmount"];
      }
    }
    if (
      pageType === "SUMMARY" &&
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0
    ) {
      if (fieldsToUse.some((f: any) => f.name === "terms_conditions")) {
        values.terms_conditions = true;
      }
      if (fieldsToUse.some((f: any) => f.name === "privacy_policy")) {
        values.privacy_policy = true;
      }
    }
    return values;
  })();

  const handleRadioChange = (fieldName: string, value: string, form: any) => {
    // Check if this is an applicant type field and value is co-applicant
    if (
      fieldName === "applicantType" &&
      value.toLowerCase().includes("co-applicant")
    ) {
      setOpenCoApplicantModal(true);
    }
    // Employment: clear other fields if "No" is selected
    if (fieldName === "employmentisEmployed" && value === "No") {
      fields
        .filter((f) => f.name !== "employmentisEmployed")
        .forEach((field) => {
          form.setFieldValue(field.name, "");
        });
      // Ensure employment type state is reset even if field is hidden/not in current field list.
      form.setFieldValue("employmentType", "");
      form.setFieldValue("employmentTypeId", "");
      form.setFieldValue("employmentTypeDesc", "");
    }
    // Co-applicant Employment: if "No" is selected, clear that co-applicant's employment type
    const coAppEmploymentMatch = fieldName.match(/^employmentCoApplicant(\d+)isEmployed$/);
    if (coAppEmploymentMatch && value === "No") {
      const idx = coAppEmploymentMatch[1];
      const employmentTypeField = `employmentCoApplicant${idx}employmentType`;
      form.setFieldValue(employmentTypeField, "");
    }
    // Exam: clear other fields if "No" is selected
    if (fieldName === "coreExamApplied" && value === "No") {
      coreFields
        .filter((f: any) => f.name !== "coreExamApplied")
        .forEach((field: any) => {
          // For dynamic exam fields, clear all matching keys
          Object.keys(form.values).forEach((key) => {
            if (key?.startsWith(field.name)) {
              form.setFieldValue(key, "");
            }
          });
        });
    }
    if (fieldName === "languageExamApplied" && value === "No") {
      languageFields
        .filter((f: any) => f.name !== "languageExamApplied")
        .forEach((field: any) => {
          Object.keys(form.values).forEach((key) => {
            if (key?.startsWith(field.name)) {
              form.setFieldValue(key, "");
            }
          });
        });
    }

    form.setFieldValue(fieldName, value);
  };


  const handleGAEligibilityStatments = useMemo(
    () => getGAEligibilityStatements(applicationSource),
    [applicationSource]
  );

  const handleGAProvisionalOfferStatments = useMemo(
    () => getGAProvisionalOfferStatements(applicationSource),
    [applicationSource]
  );

  const handleInvokCreateApi = async (payload: any, values: any) => {
    try {
      let resp = null;
      if (isAuthenticated) {
        resp = await postsServices.addPost(
          "api/v1/user-lead/create-verified",
          payload
        );
      } else {
        resp = await postsServices.addPost("api/v1/user-lead/create", payload);
      }

      if (resp.status == 201) {
        trackCustomerJourneyEvent(
          `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
          decrypt(userProfile?.id) ?? "",
          resp.data.data.trackingId,
          {
            label: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            category: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            action: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            page: "EligibiityCheck_Verify Yourself and Provide Consent_Verify",
          }
        );

        // window.scrollTo({ top: 0, behavior: "smooth" });
        dispatch(setTrackingId(resp.data.data.trackingId));
        setIsSubmittingToAPI(false);
        dispatch(
          updateFormData({
            ...values,
            // Prefer the live value from this step's form; otherwise keep
            // whatever Redux already has (e.g. hydrated from the API when a
            // DIY applicant returns to an application whose journey already
            // completed Aadhaar verification) instead of clobbering it back
            // to false just because this step's Formik values don't carry it.
            isAadhaarVerified:
              values?.isAadhaarVerified ?? formData?.isAadhaarVerified ?? false,
          })
        );
        moveToNextStep();
      }
    } catch (error: any) {
      setIsSubmittingToAPI(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "API call failed",
        })
      );
    }
  };

  const normalizePayloadFieldValue = (key: string, rawValue: any): string => {
    if (rawValue === undefined || rawValue === null) return "";

    if (typeof rawValue === "string" || typeof rawValue === "number" || typeof rawValue === "boolean") {
      return String(rawValue);
    }

    if (Array.isArray(rawValue)) {
      return rawValue
        .map((item) => normalizePayloadFieldValue(key, item))
        .filter(Boolean)
        .join(",");
    }

    if (typeof rawValue === "object") {
      const optionLikeValue = rawValue?.value ?? rawValue?.id ?? rawValue?.code;
      const optionLikeLabel = rawValue?.label ?? rawValue?.name ?? rawValue?.desc;

      // IDs/codes should persist as value-like tokens.
      if (/id$/i.test(key) || /code$/i.test(key)) {
        if (optionLikeValue !== undefined && optionLikeValue !== null) {
          return String(optionLikeValue);
        }
      }

      // Display fields should persist readable labels.
      if (optionLikeLabel !== undefined && optionLikeLabel !== null) {
        return String(optionLikeLabel);
      }
      if (optionLikeValue !== undefined && optionLikeValue !== null) {
        return String(optionLikeValue);
      }

      try {
        return JSON.stringify(rawValue);
      } catch {
        return "";
      }
    }

    return String(rawValue);
  };

  // Add debug logging to form submission
  const handleSubmitForm1 = (values: any, { setSubmitting }: any) => {
    // Build the data array as per required payload
    const data: any[] = [];
    const formDataEntries = Object.entries(values);

    formDataEntries.forEach(([key, value]: any) => {
      const fieldDef = fields.find((f) => f.name === key);
      if (fieldDef?.id) {
        let formFieldValue: any = value;
        // Force applicantType to always be "student"
        if (key === "applicantType") {
          formFieldValue = "student";
        }
        // Always send Aadhaar verified as false in payload for now
        if (key === "isAadhaarVerified") {
          formFieldValue = false;
        }

        data.push({
          formFieldId: fieldDef.id, // Use field.id from API response
          formFieldKey: key,
          formFieldValue: normalizePayloadFieldValue(key, formFieldValue),
        });
      }
    });

    // Build the payload object as per required structure
    const payloadObject: any = {
      templateId: templateId,
      formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
      mobileNumber: values?.phone_number,
      data,
    };

    // Extract source values from URL query parameters only when not authenticated
    if (!isAuthenticated) {
      const urlParams = new URLSearchParams(window.location.search);
      const leadOriginSource = urlParams.get("leadoriginsource") || "";
      const subSource = urlParams.get("source") || "";
      const subSubSource = urlParams.get("subsubsource") || "";

      payloadObject.leadOriginSource = leadOriginSource;
      payloadObject.subSource = subSource;
      payloadObject.subSubSource = subSubSource;
    }
    // If trackingId is available, add it to the payload
    if (trackingId) {
      payloadObject.trackingId = trackingId;
    }

    handleInvokCreateApi(payloadObject, values);
  };

  const handleCourseCategoryValue = (value: any) => {
    switch (value) {
      case "UG":
        return "Under Graduation";
      case "PG":
        return "Post Graduation";
      default:
        return "Post Graduation";
    }
  };

  useEffect(() => {
    if (
      fields
        ?.find((f) => f.name === "university")
        ?.name?.toLowerCase()
        .includes("university")
    ) {
      setFormValues((prev) => ({
        ...prev,
        universityNotInList: notInList?.includes(
          fields?.find((f) => f.name === "university")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "universityNotInList",
        notInList?.includes(fields?.find((f) => f.name === "university")?.label)
          ? true
          : false
      );
    }
    if (
      fields
        ?.find((f) => f.name === "institute")
        ?.name?.toLowerCase()
        .includes("institute")
    ) {
      setFormValues((prev) => ({
        ...prev,
        instituteNotInList: notInList?.includes(
          fields?.find((f) => f.name === "institute")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "instituteNotInList",
        notInList?.includes(fields?.find((f) => f.name === "institute")?.label)
          ? true
          : false
      );
    }
    if (
      fields
        ?.find((f) => f.name === "courseName")
        ?.name?.toLowerCase()
        .includes("coursename")
    ) {
      setFormValues((prev) => ({
        ...prev,
        courseNameNotInList: notInList?.includes(
          fields?.find((f) => f.name === "courseName")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "courseNameNotInList",
        notInList?.includes(fields?.find((f) => f.name === "courseName")?.label)
          ? true
          : false
      );
    }
  }, [notInList, setFormValues, formikRef, fields]);

  const shouldAutoInvokeLeadFlow: boolean =
    checkIsLeadApiInvoked.ASSIGN_SM == false ||
    checkIsLeadApiInvoked.CREATE_LEAD == false ||
    checkIsLeadApiInvoked.LEAD_TO_APPLICATION == false;
  const getLeadPayload: any = useMemo(() => {
    if (activeHorizontalIndex == 1) {
      const extractId = (field: any) => {
        const match = field?.match(/^\s*([^-\s]+)\s*(?:-|$)/);
        return match ? match[1] : field?.trim();
      };
      const extractValue = (field: any) =>
        field && typeof field === "object" && "value" in field
          ? field?.value
          : field;
      const extractValueCode = (field: any) =>
        field && typeof field === "object" && "code" in field
          ? field?.code
          : extractId(field)
      
      const partnerLeadPayload: {
        applicationId: any;
        leadFirstName: any;
        leadLastName: any;
        leadMobileNo: any;
        leadEmailAddr: any;
        amountRequested: any;
        admissionStatus: any;
        countryOfStudyId: any;
        universityId: string;
        universityNotInList: any;
        otherUniversityName: any;
        instituteId: string;
        instituteNotInList: any;
        otherInstituteName: any;
        courseId: string;
        courseNotInList: any;
        leadCourseTypeName: any;
        stemFlag: boolean;
        otherCourseName: string;
        assignedSMId?: string;
        pincode?: string;
      } = {
        pincode: formData?.pincode || "",
        applicationId: trackingId || "",
        leadFirstName: formData?.firstName || "",
        leadLastName: formData?.lastName || "",
        leadMobileNo: formData?.phone_number,
        leadEmailAddr: formData?.email || "",
        amountRequested: formData?.loanAmount || "",
        admissionStatus: formData?.admissionStatus || "",
        countryOfStudyId: extractValue(formData?.universityCountryId) || "US",
        universityId: notInList?.includes("University Name")
          ? ""
          : formData.university != null && formData.university != "" ? String(extractValueCode(formData.university)) : "",
        universityNotInList: notInList?.includes("University Name") || false,
        otherUniversityName: notInList?.includes("University Name")
          ? formData.university
          : "",
        instituteId: notInList?.includes("Institute Name")
          ? ""
          : formData.institute != null && formData.institute != "" ? String(extractValueCode(formData.institute)) : "",
        instituteNotInList: notInList?.includes("Institute Name") || false,
        otherInstituteName: notInList?.includes("Institute Name")
          ? formData.institute
          : "",
        courseId: notInList?.includes("Course Name")
          ? ""
          : formData.courseName != null && formData.courseName != "" ? String(extractValueCode(formData.courseName)) : "",
        courseNotInList: notInList?.includes("Course Name") || false,
        leadCourseTypeName: formData.leadCourseTypeName || "Post Graduate",
        stemFlag: formData.courseType == "STEM" ? true : false,
        otherCourseName: notInList?.includes("Course Name")
          ? String(extractValue(formData.courseName))
          : "",
      };

      return partnerLeadPayload;

      // if (shouldAutoInvokeLeadFlow == false) {
      //   handleLeadCreationFlow(partnerLeadPayload);
      // }
    }
  }, [checkIsLeadApiInvoked, formData, activeHorizontalIndex]);

  const handleLeadCreationFlow = async (partnerLeadPayload: any, leadSequenceId: string) => {
    //source
    if (checkIsLeadApiInvoked?.ASSIGN_SM == false && applicationSource == "") {
      const payload = {
        pinCode: formData?.pincode, //this static pincode need to be change later for now we are passing it static
        applicationId: trackingId,
      };
      try {
        await eligibilityCheckServices
          .leadAllocation(payload)
          .then((res: any) => {
            partnerLeadPayload.assignedSMId =
              String(res?.data?.data?.assignedSMId) || "";
            dispatch(
              setAssignedSMIdValue(String(res?.data?.data?.assignedSMId))
            );
            // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
            dispatch(setSalesUserId(String(res?.data?.data?.assignedSMId)));
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "ASSIGN_SM",
                value: true,
              })
            );
          })
          .catch((err: any) => {
            setIsSubmittingToAPI(false);
            console.error("Lead allocation failed:", err);
            return;
          });
      } catch (error) {
        setIsSubmittingToAPI(false);
        console.error("Lead creation flow failed:", error);
        return;
      }
    }

    let leadIdData = "";
    // source
    if (checkIsLeadApiInvoked?.CREATE_LEAD == false && applicationSource == "") {
      const hasLeadSequenceId =
        !!leadSequenceId && String(leadSequenceId).trim().toLowerCase() !== "null";

      if (!hasLeadSequenceId) {
        try {
          partnerLeadPayload.leadPincode = formData?.pincode;
          partnerLeadPayload.assignedSMId =
            partnerLeadPayload.assignedSMId || String(assignedSMIdValue);
          await eligibilityCheckServices
            .createPartnerLead(partnerLeadPayload)
            .then(async (resp: any) => {
              leadIdData = resp?.data?.data?.leadSequence.toString();
              dispatch(
                setLeadSequenceId(resp?.data?.data?.leadSequence.toString())
              );
              if (resp?.status == 200) {
                dispatch(
                  setCheckIsLeadApiInvoked({
                    key: "CREATE_LEAD",
                    value: true,
                  })
                );
              }
            })
            .catch(() => {
              setIsSubmittingToAPI(false);
              return;
            });
        } catch (error: any) {
          console.error("Lead to Application Error:", error);
          return;
        }
      } 
    }
    // lead id
    if (checkIsLeadApiInvoked?.LEAD_TO_APPLICATION == false) {
      try {
        if (leadSequenceId || leadIdData) {
          const leadToAppPayload = {
            leadId: leadSequenceId || leadIdData,
            trackingId: trackingId ?? "",
            // Add any other required fields for lead-to-application
          };

          const leadToAppResp: any = await losServices.leadToApplication(
            leadToAppPayload
          );
          if (leadToAppResp.status == 200) {
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "LEAD_TO_APPLICATION",
                value: true,
              })
            );
            dispatch(
              setApplicationId(leadToAppResp?.data?.data?.applicationId)
            );
            dispatch(setApplicantId(leadToAppResp?.data?.data?.applicantId));

            if (
              activeHorizontalIndex === 1 &&
              (activeVerticalIndex === 0 || activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)
            ) {
              handleRelationMasterApi();
            }

            // Execute API calls based on step conditions
            const executeApiCalls = async () => {
              const promises: Promise<void>[] = [];

              if (activeHorizontalIndex === 0 && (activeVerticalIndex === 0 || activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(fetchProducts());
              }

              if (
                activeHorizontalIndex === 0 &&
                (activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)
              ) {
                promises.push(fetchMasterData());
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                debouncedZipCodeCall(formData.permanentPincode, undefined, "permanent");
                debouncedZipCodeCall(formData.currentPincode, undefined, "current");
              }
              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                debouncedCompanyZipCodeCall(formData.employmentCompanyPincode);
              }

              if (
                (activeHorizontalIndex === 0 && activeVerticalIndex === 1) ||
                (activeHorizontalIndex === 1 &&
                  (activeVerticalIndex === 1 ||
                    activeVerticalIndex === 2 ||
                    activeVerticalIndex === 3 ||
                    activeVerticalIndex === 4 ||
                    activeVerticalIndex === 5))
              ) {
                promises.push(fetchCountries());
              }

              if (
                activeHorizontalIndex === 1 &&
                (activeVerticalIndex === 0 || activeVerticalIndex === 5 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4)
              ) {
                promises.push(fetchSalutations());
              }
              if (activeHorizontalIndex === 3 && activeVerticalIndex === 0) {
                promises.push(fetchMaritalStatuses());
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(fetchDesignations());
                handleInvokCompanyZipCode(String(formData.employmentCompanyPincode));
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(getEntranceExamMaster());
                promises.push(fetchSystemValues());
              }

              // Set loading state at the start
              if (promises.length > 0) {
                setIsApiLoading(true);
                try {
                  // Wait for all API calls to complete
                  await Promise.all(promises);
                } finally {
                  setIsApiLoading(false);
                }
              }
            };

            await executeApiCalls();
          }
        }
      } catch (error: any) {
        console.error("Lead to Application Error:", error);
        dispatch(
          setStatusPopup({
            status: "error",
            message:
              error?.response?.data?.message ||
              error?.message ||
              "Processio API call failed. Please try again.",
          })
        );
      }
    }
  };


  // handleSubmit
  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    summarySubmitInvokedRef.current = true;
    setIsSubmittingToAPI(true);
    // window.scrollTo({ top: 0, behavior: "smooth" });
        const currentHorizontalStepLabel =
      horizontalSteps?.[activeHorizontalIndex]?.stepLabel || "Details";
    const currentVerticalStepLabel =
      horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
        activeVerticalIndex
      ]?.stepLabel || currentHorizontalStepLabel;
    try {
      dispatch(
        updateFormData({
          ...values,
          isAadhaarVerified: values?.isAadhaarVerified ?? false,
        })
      );
      // Co-applicant inline SUMMARY edit should use save-coapplicant flow
      // (same API family as Save & Next in CoApplicantDetailsSection), not createApplicant.
      if (
        pageType === "SUMMARY" &&
        forceInlineFieldRender &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 5
      ) {
        const coAppMatch = (fields || [])
          .map((f: any) => String(f?.name || ""))
          .find((name: string) =>
            /^((basic|address|employment)CoApplicant\d+)/i.test(name),
          )
          ?.match(/CoApplicant(\d+)/i);
        const coAppNum = coAppMatch?.[1] || "1";
        const coAppKey = `CoApplicant${coAppNum}`;
        const coAppType = `Co-Applicant ${coAppNum}`;
        const coAppIndex = String(Number(coAppNum) - 1);
        const fieldNames = (fields || []).map((f: any) =>
          String(f?.name || ""),
        );
        const tabIdx = fieldNames.some((name: string) =>
          /^employmentCoApplicant\d+/i.test(name),
        )
          ? 2
          : fieldNames.some((name: string) =>
              /^addressCoApplicant\d+/i.test(name),
            )
            ? 1
            : 0;

        const normalizeFieldValue = (
          raw: any,
          preferLabel: boolean = false,
        ) => {
          if (raw && typeof raw === "object") {
            if (preferLabel && "label" in raw) return (raw as any).label;
            if ("value" in raw) return (raw as any).value;
            if ("label" in raw) return (raw as any).label;
          }
          return raw ?? "";
        };

        const getValue = (keys: string[], preferLabel: boolean = false) => {
          for (const key of keys) {
            const val = values?.[key];
            if (val !== undefined && val !== null && val !== "") {
              return normalizeFieldValue(val, preferLabel);
            }
          }
          return "";
        };

        const basicKeys = (suffix: string) => [
          `basicCoApplicant${coAppNum}${suffix}`,
          `coApplicant${coAppNum}${suffix}`,
        ];
        const permKeys = (suffix: string) => [
          `addressCoApplicant${coAppNum}permanent${suffix}`,
          `coApplicant${coAppNum}Permanent${suffix}`,
        ];
        const currKeys = (suffix: string) => [
          `addressCoApplicant${coAppNum}current${suffix}`,
          `coApplicant${coAppNum}Current${suffix}`,
        ];
        const empKeys = (suffix: string) => [
          `employmentCoApplicant${coAppNum}${suffix}`,
          `coApplicant${coAppNum}${suffix}`,
        ];
        const companyKeys = (suffix: string) => {
          const lowerSuffix = suffix.charAt(0).toLowerCase() + suffix.slice(1);
          return [
            `employmentCoApplicant${coAppNum}${suffix}`,
            `employmentCoApplicant${coAppNum}${lowerSuffix}`,
            `employmentCoApplicant${coAppNum}company${suffix}`,
            `employmentCoApplicant${coAppNum}Company${suffix}`,
            `coApplicant${coAppNum}${suffix}`,
          ];
        };
        const toNumber = (raw: any, fallback = 0): number => {
          const n = Number(normalizeFieldValue(raw));
          return Number.isFinite(n) ? n : fallback;
        };
        const toTs = (raw: any) =>
          raw && dayjs(raw).isValid() ? dayjs(raw).valueOf() : "";
        const optionByValueOrLabel = (options: any[], raw: any) => {
          const normalized = normalizeFieldValue(raw);
          return (
            options?.find(
              (item: any) =>
                String(item?.value) === String(normalized) ||
                String(item?.label) === String(normalized),
            ) || null
          );
        };

        const saveFormData = (fields || [])
          .filter((field: any) => field?.id && field?.name)
          .map((field: any) => {
            const fieldName = String(field?.name || "");
            let fieldValue = normalizeFieldValue(values?.[field.name]);

            // Nationality/Country of Birth are saved as codes in the form
            // state, but save-coapplicant expects the display value — resolve
            // the code against the master list before sending it. Nationality
            // must resolve against applicantNationalityOptions (the same list
            // that backs the co-applicant SUMMARY edit dropdown), not
            // nationalityMasterOptions — their codes don't match.
            if (/Nationality$/i.test(fieldName)) {
              fieldValue =
                resolveApplicantNationalityOption(fieldValue)?.label ?? fieldValue;
            } else if (/CountryOfBirth$/i.test(fieldName)) {
              fieldValue =
                optionByValueOrLabel(dropdownData?.countries || [], fieldValue)
                  ?.label ?? fieldValue;
            }else if (/MaritalStatus$/i.test(fieldName)) {
              fieldValue =
                optionByValueOrLabel(dropdownData?.maritalStatuses  || [], fieldValue)
                  ?.label ?? fieldValue;
            }else if(fieldName==="basicCoApplicant1PayParty"){
               fieldValue ="Yes";
            } else if (/^employmentCoApplicant\d+designation$/i.test(fieldName)) {
              // Designation is stored as its code; formData carries the full name.
              fieldValue = getMasterOptionName(fieldValue, dropdownData?.designations);
            }

            return {
              formFieldId: field.id,
              fieldKey: field.name,
              fieldValue,
            };
          });

        const mobileNumber = String(getValue(basicKeys("PhoneNumber")) || "");
        const emailRaw = String(getValue(basicKeys("Email")) || "");
        const email = emailRaw ? emailRaw.toLowerCase() : "";
        const aadhaarSeededStatus =
          coApplicantVerification?.[coAppIndex]?.aadhaarSeedingStatus;
        const isAadhaarSeeded =
          aadhaarSeededStatus === undefined ||
          aadhaarSeededStatus === null ||
          aadhaarSeededStatus === ""
            ? false
            : aadhaarSeededStatus;
         let section="basic";
          if(tabIdx===1){
            section="address";
          }else if(tabIdx===2){
            section="employment";
          }
        try {
          // birthCityList only ever holds whatever country this FormEdit
          // instance happened to warm via the CountryOfBirth-watching
          // effects above — those only fire when `fields` (the tab-scoped
          // field set CoApplicantTabs passes in) actually includes a
          // CountryOfBirth field. On the loansummary page's per-tab inline
          // edit (Address/Employment tabs), `fields` doesn't include Basic
          // Details fields, so that cache is never warmed and birthCityId
          // silently went out blank in both the idDto below and the
          // processio call further down. Resolve it the same "aggressive
          // fallback" way CoApplicantDetailsSection/CoApplicantAdditionalDetails
          // do: try the already-fetched cache first, and only hit the API
          // if it doesn't actually resolve this specific city.
          const rawBirthCityForDto = getValue(basicKeys("CityOfBirth"));
          const birthCountryForDtoOption = optionByValueOrLabel(
            dropdownData?.countries || [],
            getValue(basicKeys("CountryOfBirth")),
          );
          const birthCountryLabelForDto = birthCountryForDtoOption?.label || "";
          let cityOptionsForBirthForDto = birthCountryLabelForDto
            ? getCityOptionsForCountry(birthCountryLabelForDto)
            : birthCityList;
          if (
            birthCountryLabelForDto &&
            !resolveBirthCityId(rawBirthCityForDto, cityOptionsForBirthForDto)
          ) {
            cityOptionsForBirthForDto = await fetchCitiesByCountryState(
              birthCountryLabelForDto,
            );
          }

          // idDto: resolved-ID mirror of saveFormData above, for this
          // save-coapplicant call into OUR OWN DB (not the processio/LOS
          // calls further down, which build their own payloads
          // independently). See buildCoApplicantSaveIdDto for why: built
          // entirely from what's already synchronously available
          // (dropdownData lookups, birthCityList, coApplicantZipCodeData) —
          // no new API calls, no reordering. Shared across
          // CoApplicantDetailsSection/CoApplicantAdditionalDetails/FormEdit
          // instead of each carrying its own copy. Nationality is matched
          // against applicantNationalityOptions specifically (not
          // maritalStatusMasterOptions' sibling nationalityMasterOptions) —
          // see the comment on saveFormData above for why.
          const idDto = buildCoApplicantSaveIdDto({
            getField: (fieldSection, suffix) => {
              switch (fieldSection) {
                case "basic":
                  return getValue(basicKeys(suffix));
                case "permanent":
                  return getValue(permKeys(suffix));
                case "current":
                  return getValue(currKeys(suffix));
                case "employment":
                  return getValue(empKeys(suffix));
                case "company":
                  return getValue(companyKeys(suffix), suffix === "Country");
                default:
                  return undefined;
              }
            },
            stage: section as "basic" | "address" | "employment",
            countryOptions: dropdownData?.countries || [],
            maritalStatusOptions: maritalStatusMasterOptions || [],
            nationalityOptions: applicantNationalityOptions || [],
            cityOptionsForBirth: cityOptionsForBirthForDto,
            coApplicantZipCodeData,
            coAppKey,
            designations: dropdownData?.designations,
          });
          const coAppSaveResp: any = await postsServices.addPost(
            "api/v1/applicant/save-coapplicant",
            {
              trackingId,
              mobileNumber,
              coApplicantType: coAppType,
              email,
              isAadhaarSeeded,
              formData: saveFormData,
              section:section,
              idDto,
            },
          );

          const resolvedApplicationId =
            Number(coAppSaveResp?.data?.data?.applicationId) ||
            Number(applicationIdApp) ||
            0;

          const coAppDetailsResp: any = await losServices.getCoApplicantDetails({
            trackingId,
            coApplicantType: coAppType,
          });
          const resolvedApplicantId =
            Number(coAppDetailsResp?.data?.data?.applicantId) ||
            Number(coAppSaveResp?.data?.data?.applicantId) ||
            0;

          // Employment Details' own save, pulled out into its own function
          // (originally just the body of the "tabIdx === 2" branch below) so
          // it can also be re-invoked from the Basic Details branch when
          // payParty changes — Employment carries its own
          // incomeTobeConsideredFlag derived from payParty, which otherwise
          // only gets refreshed when the applicant happens to revisit the
          // Employment tab itself. Kept as a nested function (not hoisted out
          // of this handler) so it still closes over coAppSaveResp/
          // resolvedApplicantId/etc. exactly as before — this is a pure
          // extraction, its own behavior is unchanged.
          // Summary inline edit (SingleCoApplicantAdditionalDetails — both
          // the application summary and the loan summary page) only mounts
          // the CURRENT tab's fields, so when Basic Details is saved Formik
          // `values` carries no employment/company fields at all — fall back
          // to redux formData (kept in sync on every save), then to the
          // saved fetch-application-data response (formData isn't always
          // populated with co-applicant fields, e.g. on loan summary), so
          // the resync sends the saved employment details instead of blanks.
          const employmentSourceValues = {
            ...getSavedCoApplicantFieldValues(fetchUserApplicationData, coAppNum),
            ...(formData || {}),
            ...values,
          };
          const getEmploymentValue = (
            keys: string[],
            preferLabel: boolean = false,
          ) => {
            for (const key of keys) {
              const val = employmentSourceValues?.[key];
              if (val !== undefined && val !== null && val !== "") {
                return normalizeFieldValue(val, preferLabel);
              }
            }
            return "";
          };
          dispatch(updateFormData(values));
          setSnackbar({
            open: true,
            message: `${currentVerticalStepLabel} saved successfully.`,
            severity: "success",
          });
          const keepInlineCoApplicantEditOpen = Boolean(
            onSummaryCoApplicantSectionSave?.(tabIdx),
          );
          skipSummaryRefreshAfterSubmitRef.current = keepInlineCoApplicantEditOpen;
          if (keepInlineCoApplicantEditOpen) {
            dispatch(setSkipNextSummaryRefetch(true));
            dispatch(setSummarySaveInProgress(false));
          } else {
            dispatch(setSummaryApplicationEditActive(false));
          }
          setIsSubmittingToAPI(false);
        } catch (coAppSaveError: any) {
          setIsSubmittingToAPI(false);
          dispatch(setSkipNextSummaryRefetch(true));
          dispatch(setSummarySaveInProgress(false));
          dispatch(
            setStatusPopup({
              status: "error",
              message:
                coAppSaveError?.response?.data?.message ||
                coAppSaveError?.message ||
                "Unable to save co-applicant details.",
            }),
          );
        }
        return;
      }
      // For all vertical steps under horizontal step 2.
      // In SUMMARY mode, horizontal step 0 (vertical 0/1/2) also saves via createApplicant.
      if ((activeVerticalIndex !== 5) && activeHorizontalIndex!==4 &&
        (activeHorizontalIndex === 1 ||
        (pageType === "SUMMARY" &&
          activeHorizontalIndex === 0 &&
          [0, 1, 2].includes(activeVerticalIndex))) 
      ) {
        if (shouldAutoInvokeLeadFlow && pageType !== "SUMMARY") {
          handleLeadCreationFlow(getLeadPayload, leadSequenceId);
        }

        // Build the data array as per required payload
        const data: any[] = [];
        if (activeVerticalIndex === 2) {
          const isEmployed = values.employmentisEmployed;

          // Always include the radio field
          const radioField = fields.find(
            (f) => f.name === "employmentisEmployed"
          );
          if (radioField) {
            data.push({
              formFieldId: radioField.id,
              formFieldKey: radioField.name,
              formFieldValue: isEmployed,
            });
          }

          // Include all other employment fields
          fields
            .filter((f) => f.name !== "employmentisEmployed")
            .forEach((field) => {
              let fieldValue = "";
              if (isEmployed === "Yes") {
                fieldValue = values[field.name] ?? "";
              } else {
                // If not employed, set employmentType to 'Student', others blank
                if (field.name === "employmentType") {
                  fieldValue = "Student";
                } else {
                  fieldValue = values[field.name] ?? "";
                }
              }
              // Designation is stored as its code; formData carries the full name.
              if (field.name === "employmentDesignation") {
                fieldValue = getMasterOptionName(fieldValue, dropdownData?.designations);
              }
              data.push({
                formFieldId: field.id,
                formFieldKey: field.name,
                formFieldValue: normalizePayloadFieldValue(field.name, fieldValue),
              });
            });
        } else if (activeVerticalIndex === 3) {
          // Merge fields and extraCourses for lookup
          const allCourseFields = fields;

          // Build a map of courseXType values to calculate courseXTypeId
          const courseTypeValues: { [key: string]: string } = {};
          Object.keys(values).forEach((key) => {
            if (/^course\d+Type$/.test(key)) {
              courseTypeValues[key] = values[key];
            }
          });

          // Academic Details: skip core/language fields
          Object.entries(values).forEach(([key, value]: any) => {
            // Skip core/language fields (including indexed)
            if (
              key?.startsWith("core") ||
              key?.startsWith("language") ||
              key.match(/^core.*_\d+$/) ||
              key.match(/^language.*_\d+$/)
            ) {
              return;
            }

            // Only process fields that match course patterns (course1, course2, etc.) or educationGap
            // if (!key.match(/^course\d+/) && key !== "educationGap") {
            //   return;
            // }

            const fieldDef = allCourseFields.find((f) => f.name === key);
            // Handle courseXType fields - also add corresponding courseXTypeId
            const courseTypeMatch = key.match(/^course(\d+)Type$/);
            // Below code is commented to stop adding courseXTypeId fields as per duplication issue reported
          
            // Skip courseXTypeId fields since they're added with courseXType above
            const courseTypeIdMatch = key.match(/^course(\d+)TypeID$/);
            if (courseTypeIdMatch) {
              //return; // Skip - already handled above
            }
            if (fieldDef?.id) {
              let fieldValue = value;
              // Special handling for educationGap - pass "0" if blank
              // Fix: Ensure educationGap never becomes "undefined"
              if (key === "educationGap") {
                fieldValue =
                  value !== undefined &&
                    value !== null &&
                    value.toString().trim() !== ""
                    ? value
                    : "0";
              }
              data.push({
                formFieldId: fieldDef.id,
                formFieldKey: key,
                formFieldValue: normalizePayloadFieldValue(key, fieldValue),
              });
            } else {
              console.warn(`Field definition not found for key: ${key}, fieldDef:`, fieldDef);
            }
          });

          const eduGapDef = allCourseFields.find(
            (f) => f.name === "educationGap",
          );

          // If educationGap exists in field definitions but was NOT included in the Formik values → push it (to handle untouched field)
          if (
            eduGapDef &&
            !data.some((item) => item.formFieldKey === "educationGap")
          ) {
            data.push({
              formFieldId: eduGapDef.id,
              formFieldKey: "educationGap",
              formFieldValue: "0", // default value
            });
          }
        } else if (activeVerticalIndex === 4) {
          // Core Exam
          const coreRadioField = coreFields.find(
            (f: any) => f.name === "coreExamApplied"
          );
          if (coreRadioField) {
            data.push({
              formFieldId: coreRadioField.id,
              formFieldKey: coreRadioField.name,
              formFieldValue: values[coreRadioField.name] ?? "",
            });

            // Separate base fields and dynamic fields
            const baseCoreFields = coreFields.filter(
              (f: any) => f.name !== "coreExamApplied" && !f.isRemoved
            );
            const dynamicCoreFields = coreFields.filter(
              (f: any) => f.isRemoved
            );

            // Add base fields (exact match only)
            baseCoreFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include coreExamID/coreExamId fields regardless of "Yes" or "No" status
                const isCoreExamID =
                  /^coreExamID(_\d+)?$/.test(field.name) ||
                  /^coreExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isCoreExamID || values[coreRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });

            // Add dynamic fields with their own IDs
            dynamicCoreFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include coreExamID/coreExamId fields regardless of "Yes" or "No" status
                const isCoreExamID =
                  /^coreExamID(_\d+)?$/.test(field.name) ||
                  /^coreExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isCoreExamID || values[coreRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });
          }

          // Language Exam
          const languageRadioField = languageFields.find(
            (f: any) => f.name === "languageExamApplied"
          );
          if (languageRadioField) {
            data.push({
              formFieldId: languageRadioField.id,
              formFieldKey: languageRadioField.name,
              formFieldValue: values[languageRadioField.name] ?? "",
            });

            // Separate base fields and dynamic fields
            const baseLanguageFields = languageFields.filter(
              (f: any) => f.name !== "languageExamApplied" && !f.isRemoved
            );
            const dynamicLanguageFields = languageFields.filter(
              (f: any) => f.isRemoved
            );

            // Add base fields (exact match only)
            baseLanguageFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include languageExamID/languageExamId fields regardless of "Yes" or "No" status
                const isLanguageExamID =
                  /^languageExamID(_\d+)?$/.test(field.name) ||
                  /^languageExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isLanguageExamID ||
                      values[languageRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });

            // Add dynamic fields with their own IDs
            dynamicLanguageFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include languageExamID/languageExamId fields regardless of "Yes" or "No" status
                const isLanguageExamID =
                  /^languageExamID(_\d+)?$/.test(field.name) ||
                  /^languageExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isLanguageExamID ||
                      values[languageRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });
          }

          // Add any other non-core/language fields if needed
          Object.entries(values).forEach(([key, value]: any) => {
            if (
              !coreFields.some((f: any) => f.name === key) &&
              !languageFields.some((f: any) => f.name === key)
            ) {
              const fieldDef = fields.find((f) => f.name === key);
              if (fieldDef?.id) {
                data.push({
                  formFieldId: fieldDef.id,
                  formFieldKey: key,
                  formFieldValue: normalizePayloadFieldValue(key, value),
                });
              }
            }
          });
        } else {
          // Default mapping for other steps
          Object.entries(values).forEach(([key, value]: any) => {
            // if (key === "aadhaar") return; // Do not include aadhaar field
            const fieldDef = fields.find((f) => f.name === key);
            if (fieldDef?.id) {
              let fieldValue = value;
              // Special handling for PAN
              if (key === "pan") {
                fieldValue = hasPan === "no" ? "no" : panNumber;
              }

              data.push({
                formFieldId: fieldDef.id,
                formFieldKey: key,
                formFieldValue: normalizePayloadFieldValue(key, fieldValue),
              });
            }
          });
        }

        const isAadhaarSeededPayload =
          aadhaarSeedingStatus === undefined ||
            aadhaarSeedingStatus === null ||
            aadhaarSeedingStatus === ""
            ? false
            : aadhaarSeedingStatus;

        const payloadObject: any = {
          data,
          trackingId: trackingId,
          templateId: templateId,
          formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
          mobileNumber: values?.phone_number || formData?.phone_number,
          isAadhaarSeeded: isAadhaarSeededPayload,

        };

        // Applicant sections before Co-Applicant (vertical 0-4) also send the
        // master-data ids for the backend, tagged with the section saved.
        const applicantSection = APPLICANT_SECTION_BY_VERTICAL_INDEX[activeVerticalIndex];
        if (applicantSection) {
          // Saving the address untouched (e.g. first visit on the loan summary) can reach here
          // before any pincode lookup stored the code data — resolve it now so
          // cityId/stateId/pincodeId aren't sent blank.
          let permanentCodeDataForSave = permanentCodeData;
          let currentCodeDataForSave = currentCodeData;
          if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
            if (!permanentCodeDataForSave?.city && values?.permanentPincode) {
              permanentCodeDataForSave =
                (await fetchAddressCodeData(values.permanentPincode)) ?? permanentCodeDataForSave;
            }
            if (!currentCodeDataForSave?.city && values?.currentPincode) {
              currentCodeDataForSave =
                String(values.currentPincode) === String(values?.permanentPincode)
                  ? permanentCodeDataForSave
                  : (await fetchAddressCodeData(values.currentPincode)) ?? currentCodeDataForSave;
            }
          }
          const idDtosBySection = buildApplicantIdDtosBySection({
            values,
            countryOptions: dropdownData?.countries,
            currentCodeData: currentCodeDataForSave,
            permanentCodeData: permanentCodeDataForSave,
            companyCodeData,
            entranceExamTypes: dropdownData?.entranceExamTypes,
            languageExamTypes: dropdownData?.languageExamTypes,
            designations: dropdownData?.designations,
          });
          // Only the dto of the screen being saved.
          payloadObject.idDtos = idDtosBySection[applicantSection];
          payloadObject.section = applicantSection;
        }
        try {
          const resp = await applicantDetailsServices.createApplicant(
            payloadObject
          );

          if (
            resp.data?.status === "success"
          ) {
            // Call create-update-applicant-basic-details after successful applicant creation

            try {
              // Set applicationId if available
              if (resp?.data?.data?.applicationId) {
                dispatch(
                  setApplicationId(resp?.data?.data?.applicationId.toString())
                );
              }
              // Only proceed with LOS API calls if both IDs are present
              if (resp?.data?.data?.applicantId && resp?.data?.data?.applicationId) {
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 0 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      category: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      action: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      page: "ProvisionalOff_Student Details",
                    }
                  );
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 1 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      category: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      action: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      page: "ProvisionalOff_Address Details",
                    }
                  );
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      category: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      action: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      page: "ProvisionalOff_Employment Details",
                    }
                  );
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 3 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      category: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      action: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      page: "ProvisionalOff_Academic Details",
                    }
                  );
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 4 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      category: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      action: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      page: "ProvisionalOff_Entrance Exam Details",
                    }
                  );
                }
              }
            } catch (basicDetailsError: any) {
              console.error(
                "Create/Update Applicant Basic Details Error:",
                basicDetailsError
              );
              // You can choose to show an error or continue silently
              // For now, we'll continue with the normal flow
            }

            // Post-save: refetch application so Redux matches server. Note: some LOS calls in the try above are
            // fire-and-forget (not awaited); this fetch may still reflect partial downstream persistence.
            await refreshReduxFromUserApplicationFetch(
              resp?.data?.data?.trackingId
            );

            // These dispatches are inside the success if block
            dispatch(setTrackingId(resp.data.data.trackingId));
            setIsSubmittingToAPI(false);
            dispatch(
              updateFormData({
                ...values,
                isAadhaarVerified: values?.isAadhaarVerified ?? false,
              })
            );
             if (pageType === "SUMMARY") {
              setSnackbar({
                open: true,
                message: `${currentVerticalStepLabel} saved successfully.`,
                severity: "success",
              });
              dispatch(setSummaryApplicationEditActive(false));
            }
            moveToNextStep();

            if (canAdvanceStepper && activeVerticalIndex === 5) {
              dispatch(setActiveHorizontalIndex(2));
            }
            dispatch(setBreStatus("FROM_FORM"));
          } else {
            setIsSubmittingToAPI(false);
            if (pageType === "SUMMARY") {
              dispatch(setSkipNextSummaryRefetch(true));
              dispatch(setSummarySaveInProgress(false));
              setSnackbar({
                open: true,
                message:
                  resp?.data?.message ||
                  `Failed to save ${currentVerticalStepLabel}.`,
                severity: "error",
              });
            } else {
              dispatch(
                setStatusPopup({
                  status: "error",  
                  message: resp?.data?.message || "Applicant creation failed",
                })
              );
            }
            return;
          }

          // else {
          //   // Error case - resp.data?.status is not "success"
          //   setIsSubmittingToAPI(false);
          //   dispatch(
          //     setStatusPopup({
          //       status: "error",
          //       message: resp.data?.message || "Applicant creation failed",
          //     })
          //   );
          // }
        }
        catch (error: any) {
          // Catch for outer try block (createApplicant API call)
          setIsSubmittingToAPI(false);
           if (pageType === "SUMMARY") {
            dispatch(setSkipNextSummaryRefetch(true));
            dispatch(setSummarySaveInProgress(false));
            setSnackbar({
              open: true,
              message:
                error?.response?.data?.message ||
                `Failed to save ${currentVerticalStepLabel}.`,
              severity: "error",
            });
            } else {
              dispatch(
                setStatusPopup({
                  status: "error",
                  message:
                    error?.response?.data?.message || "Applicant creation failed",
                }),
              );
            }
          // }
        }
        //return;
      }
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 0) {
        setIsSubmittingToAPI(true);
        try {
          const currentValues =
            formikRef?.current?.values || values || {};

          const getFieldBy = (
            matcher: (f: any) => boolean,
          ) => fields.find((f: any) => matcher(f));

          const getFieldValue = (fieldObj: any) =>
            fieldObj ? currentValues[fieldObj.name] : "";

          const toValue = (val: any) => {
            if (val && typeof val === "object" && "value" in val) {
              return val.value;
            }
            return val;
          };

          const toLabel = (val: any) => {
            if (val && typeof val === "object" && "label" in val) {
              return val.label;
            }
            return val;
          };

          const dependentsField = getFieldBy((f: any) =>
            /dependents?/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );
          const maritalField = getFieldBy((f: any) =>
            /marital/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );
          const birthCountryField = getFieldBy((f: any) =>
            /country.*birth|birth.*country/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );
          const birthCityField = getFieldBy((f: any) =>
            /city.*birth|birth.*city/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );

          const loanAmountField = getFieldBy((f: any) =>
            /required\s*loan\s*amount|loan\s*amount/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );
          const loanTenureField = getFieldBy((f: any) =>
            /requested\s*loan\s*tenure|loan\s*tenure|tenure/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );
          const loanRoiField = getFieldBy((f: any) =>
            /requested\s*roi|\broi\b/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );
          const disbursementDateField = getFieldBy((f: any) =>
            /expected\s*date\s*of\s*disbursement|disbursement/i.test(
              String(f?.label || "") + String(f?.name || ""),
            ),
          );

          const dependents = toValue(getFieldValue(dependentsField)) || "";

          const maritalRaw = getFieldValue(maritalField);
          const maritalStatusId = toValue(maritalRaw) || "";
          const maritalStatusLabelFromMaster =
            (dropdownData?.maritalStatuses || []).find(
              (opt: any) =>
                String(opt?.value || "").toLowerCase() ===
                  String(maritalStatusId || "").toLowerCase() ||
                String(opt?.label || "").toLowerCase() ===
                  String(maritalStatusId || "").toLowerCase(),
            )?.label || "";
          const maritalStatus =
            toLabel(maritalRaw) || maritalStatusLabelFromMaster || "";

          const birthCountryRaw = getFieldValue(birthCountryField);
          const birthCountryIdValue = toValue(birthCountryRaw) || "";
          const birthCountry = toLabel(birthCountryRaw) || "";
          const birthCountryId =
            (dropdownData?.countries || []).find(
              (opt: any) =>
                String(opt?.label || "") ===
                  String(birthCountryIdValue || "") || String(opt?.value || "") ===
                  String(birthCountryIdValue || ""),
            )?.value || "";
          const birthCityRaw = getFieldValue(birthCityField);
          const birthCityId = resolveBirthCityId(
            birthCityRaw,
            birthCityList,
          );
          const additionalData: any[] = (fields || [])
            .filter((field: any) => field?.id)
            .map((field: any) => {
              const rawValue = currentValues?.[field.name];
              const isNationalityField =
                /nationality/i.test(String(field?.name || "")) ||
                /naionality/i.test(String(field?.name || ""));
              const nationalityOption = isNationalityField
                ? resolveApplicantNationalityOption(rawValue)
                : null;
              const normalizedValue =
                rawValue && typeof rawValue === "object"
                  ? isNationalityField
                    ? nationalityOption?.label ||
                      ("label" in rawValue
                        ? rawValue.label
                        : "value" in rawValue
                          ? rawValue.value
                          : rawValue)
                    // Every other dropdown-shaped field (country of birth,
                    // marital status, city of birth, etc.) previously sent
                    // rawValue.value (the master's code) here instead of the
                    // human-readable label the create-applicant API expects.
                    : "label" in rawValue
                      ? rawValue.label
                      : "value" in rawValue
                        ? rawValue.value
                        : rawValue
                  : isNationalityField
                    ? nationalityOption?.label || rawValue
                    : rawValue;

              return {
                formFieldId: field.id,
                formFieldKey: field.name,
                formFieldValue: String(normalizedValue ?? ""),
              };
            });

          const isAadhaarSeededPayload =
            aadhaarSeedingStatus === undefined ||
            aadhaarSeedingStatus === null ||
            aadhaarSeedingStatus === ""
              ? false
              : aadhaarSeedingStatus;

          const applicantPayloadObject = {
            data: additionalData,
            trackingId: trackingId,
            templateId: templateId,
            formName:
              horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
            mobileNumber:
              currentValues?.phone_number || formData?.phone_number,
            isAadhaarSeeded: isAadhaarSeededPayload,
          };

          const createApplicantResp: any =
            await applicantDetailsServices.createApplicant(
              applicantPayloadObject,
            );

          if (createApplicantResp?.data?.status !== "success") {
            throw new Error(
              createApplicantResp?.data?.message ||
                "Applicant creation failed",
            );
          }
          const resolvedTrackingId =
            createApplicantResp?.data?.data?.trackingId || trackingId;

          if (createApplicantResp?.data?.data?.trackingId) {
            dispatch(
              setTrackingId(
                createApplicantResp?.data?.data?.trackingId,
              ),
            );
          }
          if (createApplicantResp?.data?.data?.applicationId) {
            dispatch(
              setApplicationId(
                String(
                  createApplicantResp?.data?.data?.applicationId,
                ),
              ),
            );
          }
          if (createApplicantResp?.data?.data?.applicantId) {
            dispatch(
              setApplicantId(
                createApplicantResp?.data?.data?.applicantId,
              ),
            );
          }

          const resolvedApplicantId =
            Number(
              createApplicantResp?.data?.data?.applicantId ||
                applicantIdApp,
            ) || 0;
          const resolvedApplicationId =
            Number(
              createApplicantResp?.data?.data?.applicationId ||
                applicationIdApp,
            ) || 0;

          if (!resolvedApplicantId || !resolvedApplicationId) {
            throw new Error(
              "Applicant/Application ID not available for save.",
            );
          }

          const pickValue = (...candidates: any[]) =>
            candidates.find(
              (candidate) =>
                candidate !== undefined &&
                candidate !== null &&
                String(candidate).trim() !== "",
            );
          const firstName =
            pickValue(
              currentValues?.firstName,
              currentValues?.studentDetailsFirstName,
              formData?.firstName,
              formData?.studentDetailsFirstName,
            ) || "";
          const middleName =
            pickValue(
              currentValues?.middleName,
              currentValues?.studentDetailsMiddleName,
              formData?.middleName,
              formData?.studentDetailsMiddleName,
            ) || "";
          const lastName =
            pickValue(
              currentValues?.lastName,
              currentValues?.studentDetailsLastName,
              formData?.lastName,
              formData?.studentDetailsLastName,
            ) || "";
          const fullname =
            pickValue(
              currentValues?.fullname,
              currentValues?.fullName,
              formData?.fullname,
              formData?.fullName,
            ) ||
            [firstName, middleName, lastName]
              .filter(Boolean)
              .join(" ")
              .trim();

          const emailAddress =
            pickValue(
              currentValues?.email,
              currentValues?.studentDetailEmail,
              formData?.email,
              formData?.studentDetailEmail,
            ) || "";
          const mobileNo =
            pickValue(
              currentValues?.phone_number,
              currentValues?.mobileNo,
              formData?.phone_number,
              formData?.mobileNo,
            ) || "";

          const salutationRaw =
            pickValue(currentValues?.salutation, formData?.salutation) ||
            "";
          const salutationId = toValue(salutationRaw) || "";
          const salutation = (dropdownData?.salutations ?? []).find(
            (salutation: any) =>
              salutation?.value === salutationId
          )?.label;
          const relationshipRaw =
            pickValue(
              currentValues?.relationship,
              formData?.relationship,
            ) || "";
          const relationshipId = toValue(relationshipRaw) || "";
          const relationship =
            toLabel(relationshipRaw) || relationshipId || "STUDENT";

          const nationalityRaw =
            pickValue(
              currentValues?.applicantNationality,
              formData?.applicantNationality,
            ) || "";
          const nationalityOption =
            resolveApplicantNationalityOption(nationalityRaw);
          const nationalityId = nationalityOption?.value;

          const dobRaw =
            pickValue(
              currentValues?.dob,
              currentValues?.dateOfBirth,
              formData?.dob,
              formData?.dateOfBirth,
            ) || "";
          const dateOfBirth = (() => {
            if (typeof dobRaw === "number") return dobRaw;
            const numericDob = Number(dobRaw);
            if (Number.isFinite(numericDob) && String(dobRaw).length >= 10) {
              return numericDob;
            }
            const direct = dayjs(dobRaw);
            if (direct.isValid()) return direct.valueOf();
            const dobMatch = String(dobRaw).match(
              /^(\d{2})[-/](\d{2})[-/](\d{4})$/,
            );
            if (dobMatch) {
              const [, dd, mm, yyyy] = dobMatch;
              const parsed = dayjs(`${yyyy}-${mm}-${dd}`);
              return parsed.isValid() ? parsed.valueOf() : "";
            }
            return "";
          })();

          const additionalBasicDetailsPayload: any = {
            applicantId: resolvedApplicantId,
            applicationId: resolvedApplicationId,
            trackingId: resolvedTrackingId,
            applicantType: "MAIN_APPLICANT",
            //isAddingViaApplicationFlow: true,
            emailAddress: emailAddress,
            firstName: firstName,
            fullname: fullname,
            lastName: lastName,
            //middleName: middleName,
            dateOfBirth: dateOfBirth,
            mobileNo: mobileNo,
            salutation: salutation,
            salutationId: salutationId,
            queryId: "",
            relationship: relationship,
            relationshipId: "CHILDREN",
            eventName: "APPLICANT_ADDITIONAL_BASIC_DETAILS_SAVED",
            noOfDependants: Number(dependents || 0),
            maritalStatusId: maritalStatusId,
            nationalityId: nationalityId,
            birthCountryId: birthCountryId,
            birthCityId: birthCityId,
            otherRelationship: null,
            motherFirstName:currentValues?.motherFirstName || formData?.motherFirstName,
            motherLastName:currentValues?.motherLastName || formData?.motherLastName,
            fatherFirstName:currentValues?.fatherFirstName || formData?.fatherFirstName,
            fatherLastName:currentValues?.fatherLastName|| formData?.fatherLastName,
          };
          const requiredLoanAmount = toValue(
            getFieldValue(loanAmountField),
          );
          const requestedLoanTenure = toValue(
            getFieldValue(loanTenureField),
          );
          const requestloantenureValue=dropdownData?.loanTenureVal?.filter((item:any)=>String(item?.value)===String(requestedLoanTenure))[0]?.id;
          // DIY journey: Requested Tenure is hidden, so resolve the
          // LOAN_TENURE_INMONTH system-value id whose value is 120
          // (dropdownData.loanTenureVal's `label` holds the raw month
          // count) instead of sending the raw number 120.
          const diyLoanTenureId = dropdownData?.loanTenureVal?.find(
            (item: any) => String(item?.label).trim() === "120",
          )?.id;
          const requestedRoi = toValue(
            getFieldValue(loanRoiField),
          );
          const disbursementRaw =
            getFieldValue(disbursementDateField);
          const expectedDateOfDisbursement =
            disbursementRaw && dayjs(disbursementRaw).isValid()
              ? dayjs(disbursementRaw).format("YYYY-MM-DD")
              : toValue(disbursementRaw) || "";

          const updateLeadPayload: any = {
            trackingId: resolvedTrackingId || "",
            amountRequested: requiredLoanAmount || "",
            requestedLoanTenure: requestedLoanTenure || "",
            requestedROI: requestedRoi || "",
            requestedRoi: requestedRoi || "",
            expectedDateOfDisbursement:
              expectedDateOfDisbursement || "",
            requiredLoanAmount: requiredLoanAmount || "",
          };

          const saveLoanRequirementPayload: any = {
            applicationId: resolvedApplicationId ?? 0,
            trackingId: resolvedTrackingId || "",
            eventName: "APPLICANT_SAVE_LOAN_REQUIREMENT_ADDED",
            applicantType: "Applicant",
            amountRequested: Number(requiredLoanAmount) || 0,
            psiAmount: Number(
              currentValues?.psiAmount || formData?.psiAmount || 0,
            ),
            // DIY journey: Requested Tenure / Requested ROI are hidden
            // in the UI and hardcoded by the backend (120 / 13). The
            // loan-requirement API expects the LOAN_TENURE_INMONTH
            // system-value id, not the raw month count.
            // If formik already carries values for these fields (e.g.
            // restored from a saved application), keep them instead of
            // forcing the DIY defaults.
            loantenure: requestedLoanTenure
              ? Number(requestloantenureValue) ||
                Number(requestedLoanTenure) ||
                0
              : isDIYJourney
                ? Number(diyLoanTenureId) || 120
                : Number(requestloantenureValue) || 0,
            requiredRoi: requestedRoi
              ? Number(requestedRoi) || 0
              : isDIYJourney
                ? 13
                : 0,
            queryId: "",
            caseType:
              currentValues?.caseType ||
              formData?.caseType ||
              "ELLOAN",
            expectedDateOfDisbursement:
              expectedDateOfDisbursement || "",
            promoCode:
              currentValues?.promoCode ||
              formData?.promoCode ||
              "",
            isSiblingTag:
              currentValues?.isSiblingTag ||
              formData?.isSiblingTag ||
              "",
          };

          dispatch(updateFormData(currentValues));
          dispatch(setActiveVerticalIndex(1));

          // Continue navigation should not wait for LOS/processio APIs.
          void (async () => {
            try {
              await losServices.createUpdateApplicantBasicDetails(
                additionalBasicDetailsPayload,
              );
              // await losServices.updateLead(updateLeadPayload);
              await losServices.saveLoanRequirement(
                saveLoanRequirementPayload,
              );
              
              await refreshReduxFromUserApplicationFetch(resolvedTrackingId);
            } catch (bgError: any) {
              console.error(
                "Background Applicant Additional save failed:",
                bgError,
              );
            }
          })();
        } catch (error: any) {
          dispatch(
            setStatusPopup({
              status: "error",
              message:
                error?.response?.data?.message ||
                "Unable to save Applicant Additional Details.",
            }),
          );
        } finally {
          setIsSubmittingToAPI(false);
        }
        return;
      }
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 1) {
        dispatch(setActiveVerticalIndex(2));
        return;
      }
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 2) {
          setZeroForFundAndExpenses(formikRef?.current?.setFieldValue, formikRef?.current?.values)
        // ── Fund vs Expense balance validation ──────────────────────
        const _currentValues =
          formikRef?.current?.values || values || {};

        // ── Fund/Expense conditional-required validation ─────────────
        // When admissionStatus is CONFIRMED, either every fund/expense field
        // must be filled, or ONLY the Requested Loan Amount is provided
        // (everything else left blank).
        const _fundExpenseState = getFundExpenseValidationState(_currentValues);
        if (!_fundExpenseState.isValid) {
          dispatch(
            setStatusPopup({
              status: "error",
              message: _fundExpenseState.isLoanAmountFilled
                ? "Please fill all Fund and Expense fields, or provide only the Requested Loan Amount and leave the rest blank."
                : "In case of confirmed please fill all the filled.",
            }),
          );
          return;
        }
        if (_fundExpenseState.isOnlyLoanAmountProvided) {
          // Only the loan amount was provided — the create/save-expense APIs
          // (and any downstream processio call) are intentionally skipped for
          // this step; just persist locally and move on.
          dispatch(updateFormData(_currentValues));
          dispatch(setActiveVerticalIndex(3));
          return;
        }

        const _sortedFields = Array.isArray(fields) ? [...fields] : [];

        const _getNorm = (name: any) =>
          String(name || "").toLowerCase().replace(/[^a-z0-9]/g, "");

        const _startsWith = (name: any, prefixes: string[]) => {
          const n = _getNorm(name);
          return prefixes.some((p) => n.startsWith(p) || n.startsWith(`ad${p}`));
        };

        const _includes = (value: any, keywords: string[]) => {
          const n = _getNorm(value);
          return keywords.some((k) => n.includes(k));
        };

        const _expenseFields = _sortedFields.filter((f: any) => {
          const byPrefix = _startsWith(f?.name, ["expense", "expenses"]);
          const byText =
            _includes(f?.name, ["totalexpense", "expense"]) ||
            _includes(f?.label, ["totalexpense", "expense"]);
          return byPrefix || byText;
        });

        const _fundFields = _sortedFields.filter((f: any) =>
          _startsWith(f?.name, ["fund", "fundrequest", "funds"]),
        );

        const _toNum = (raw: any): number => {
          if (raw === null || raw === undefined || raw === "") return 0;
          if (typeof raw === "number") return isNaN(raw) ? 0 : raw;
          const candidate =
            typeof raw === "object" && raw !== null && "value" in raw
              ? (raw as any).value
              : raw;
          const normalized = String(candidate)
            .replace(/,/g, "")
            .replace(/[^0-9.-]/g, "")
            .trim();
          if (!normalized) return 0;
          const parsed = parseFloat(normalized);
          return isNaN(parsed) ? 0 : parsed;
        };

        const _computeTotal = (sectionFields: any[]): number => {
          const totalKeywords =
            sectionFields === _expenseFields
              ? ["totalexpense", "expensetotal"]
              : ["totalfund", "fundtotal"];
          const isExact = (val: any, kws: string[]) => {
            const n = _getNorm(val);
            return kws.some((k) => n === k || n.endsWith(k) || n.startsWith(k));
          };
          const directField = sectionFields.find(
            (f: any) =>
              isExact(f?.name, totalKeywords) ||
              isExact(f?.label, totalKeywords),
          );
          const keys = sectionFields
            .map((f: any) => f?.name)
            .filter((n: string) => !!n && n !== directField?.name);
          const sum = keys.reduce((acc: number, key: string) => {
            return acc + _toNum(_currentValues?.[key]);
          }, 0);
          if (sum > 0) return sum;
          if (directField?.name) {
            const dv = _toNum(_currentValues?.[directField.name]);
            if (dv > 0) return dv;
          }
          return sum;
        };

        const _totalExpense = _computeTotal(_expenseFields);
        const _totalFund = _computeTotal(_fundFields);

        if (_totalExpense !== _totalFund) {
          dispatch(
            setStatusPopup({
              status: "error",
              message: `Total Fund (₹${_totalFund.toLocaleString("en-IN")}) and Total Expenses (₹${_totalExpense.toLocaleString("en-IN")}) must be equal before you can continue.`,
            }),
          );
          return;
        }
        // ── end validation ───────────────────────────────────────────

        setIsSubmittingToAPI(true);
        try {
          const currentValues =
            formikRef?.current?.values || values || {};

          const fundExpenseData: any[] = (fields || [])
            .filter((field: any) => field?.id)
            .map((field: any) => {
              const rawValue = currentValues?.[field.name];
              const normalizedValue =
                rawValue && typeof rawValue === "object"
                  ? "value" in rawValue
                    ? rawValue.value
                    : "label" in rawValue
                      ? rawValue.label
                      : rawValue
                  : rawValue;

              return {
                formFieldId: field.id,
                formFieldKey: field.name,
                formFieldValue: String(normalizedValue ?? 0),
              };
            });

          const isAadhaarSeededPayload =
            aadhaarSeedingStatus === undefined ||
            aadhaarSeedingStatus === null ||
            aadhaarSeedingStatus === ""
              ? false
              : aadhaarSeedingStatus;

          const fundExpensePayload = {
            data: fundExpenseData,
            trackingId: trackingId,
            templateId: templateId,
            formName:
              horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
            mobileNumber:
              currentValues?.phone_number || formData?.phone_number,
            isAadhaarSeeded: isAadhaarSeededPayload,
          };

          fundExpenseData?.forEach((item:any)=>{
            if(item.formFieldValue === ""){
              item.formFieldValue = "0";
            }
          });

          const createApplicantResp: any =
            await applicantDetailsServices.createApplicant(
              fundExpensePayload,
            );
          if (createApplicantResp?.data?.status !== "success") {
            throw new Error(
              createApplicantResp?.data?.message ||
                "Unable to save Fund and Expense details.",
            );
          }

          if (createApplicantResp?.data?.data?.trackingId) {
            dispatch(
              setTrackingId(
                createApplicantResp?.data?.data?.trackingId,
              ),
            );
          }
          if (createApplicantResp?.data?.data?.applicationId) {
            dispatch(
              setApplicationId(
                String(
                  createApplicantResp?.data?.data?.applicationId,
                ),
              ),
            );
          }
          if (createApplicantResp?.data?.data?.applicantId) {
            dispatch(
              setApplicantId(
                createApplicantResp?.data?.data?.applicantId,
              ),
            );
          }

          const resolvedTrackingId =
            createApplicantResp?.data?.data?.trackingId ||
            trackingId ||
            "";
          const resolvedApplicationId =
            String(
              createApplicantResp?.data?.data?.applicationId ||
                applicationIdApp ||
                "0",
            ) || "0";

          const normalizeFieldText = (value: any) =>
            String(value || "")
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");

          const getNumericByKeywords = (
            keys: string[],
            fallback = 0,
          ): number => {
            const matchedField = (fields || []).find((f: any) => {
              const normalizedName = normalizeFieldText(f?.name);
              const normalizedLabel = normalizeFieldText(f?.label);
              return keys.some(
                (key) =>
                  normalizedName.includes(key) ||
                  normalizedLabel.includes(key),
              );
            });
            if (!matchedField?.name) return fallback;
            return _toNum(currentValues?.[matchedField.name]);
          };

           const livingExpenses = currentValues?.expenseLivingExpenses ? Number(currentValues?.expenseLivingExpenses): 0;
          const livingCardExpenses = currentValues?.expenseVasExpense? Number(currentValues?.expenseVasExpense) : 0;
          const travelExpenses = currentValues?.expenseTravelExpenses ? Number(currentValues?.expenseTravelExpenses): 0;
          const otherExpenses =  currentValues?.expenseOtherExpenses ? Number(currentValues?.expenseOtherExpenses): 0;
          const tuitionFees = currentValues?.expenseTuitionFees ? Number(currentValues?.expenseTuitionFees): 0;

          const loanRequestedAmt =currentValues?.fundRequestedLoanAmount ? Number(currentValues?.fundRequestedLoanAmount): 0;
          const ownSourceAmt =currentValues?.fundOwnSources ? Number(currentValues?.fundOwnSources): 0;
          const scholarshipAmt =currentValues?.fundScholarshipAmount ? Number(currentValues?.fundScholarshipAmount): 0;
          const otherIncomeAmt =currentValues?.fundOtherIncome ?Number(currentValues?.fundOtherIncome): 0;


          const totalExpenses = getNumericByKeywords(
            ["totalexpense", "expensetotal"],
            _totalExpense,
          );
          const totalFundsRequiredAmt = getNumericByKeywords(
            ["totalfund", "fundtotal", "totalfundrequired"],
            _totalFund,
          );

          const saveExpensePayload = {
            trackingId: resolvedTrackingId,
            eventName:
              "APPLICANT_APPLICATION_EXPENSE_FUNDS_DETAILS",
            applicantType: "Applicant",
            applicationId: resolvedApplicationId ?? 0,
            queryId: "",
            livingExpenses,
            livingCardExpenses:livingCardExpenses?livingCardExpenses:0,
            travelExpenses,
            otherExpenses,
            tuitionFees,
            totalExpenses,
            loanRequestedAmt,
            ownSourceAmt,
            scholarshipAmt,
            otherIncomeAmt,
            totalFundsRequiredAmt,
          };

          await losServices.saveExpense(saveExpensePayload);
          await refreshReduxFromUserApplicationFetch(resolvedTrackingId);

          dispatch(updateFormData(currentValues));
          dispatch(setActiveVerticalIndex(3));
        } catch (error: any) {
          dispatch(
            setStatusPopup({
              status: "error",
              message:
                error?.response?.data?.message ||
                error?.message ||
                "Unable to save Fund and Expense details.",
            }),
          );
        } finally {
          setIsSubmittingToAPI(false);
        }
        return;
      }
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 4) {
        const tabState = store.getState().tabs.additionalSummaryActiveTab;
        if (tabState === 0) {
          dispatch(setAdditionalSummaryActiveTab(1));
        } else {
          dispatch(setAdditionalSummaryActiveTab(0));
          navigate(ROUTES.Application.loanSummary.locationPath);
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      if (activeHorizontalIndex === 4 && activeVerticalIndex === 3) {
        // Landing on the Additional Summary step fresh via Continue — clear any tab choice
        // persisted from a previous visit so it doesn't override the Documents-tab reset
        // below (see AdditionalSummaryDetail.tsx's restore effect).
        if (trackingId) {
          localStorage.removeItem(`additionalSummaryActiveTab:${trackingId}`);
        }
        dispatch(setAdditionalSummaryActiveTab(0));
        dispatch(setActiveVerticalIndex(4));
        return;
      }
    } catch (error: any) {
      console.error("Error during form submission:", error);
      if (pageType === "SUMMARY") {
        dispatch(setSkipNextSummaryRefetch(true));
        dispatch(setSummarySaveInProgress(false));
        setSnackbar({
          open: true,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Failed to save. Please try again.",
          severity: "error",
        });
      } else {
        dispatch(
          setStatusPopup({
            status: "error",
            message:
              error?.response?.data?.message ||
              error?.message ||
              "Failed to save. Please try again.",
          }),
        );
      }
    } finally {
      setSubmitting(false);
      // Guarantee the loading indicator clears even if a branch above threw
      // before reaching its own setIsSubmittingToAPI(false) — otherwise the
      // Save button gets stuck showing "Saving" with no error surfaced.
      setIsSubmittingToAPI(false);
    }
  };

  /**
   * Handles filling current address fields based on a boolean value.
   *
   * When the value is "false", this function copies values from permanent address fields
   * to the corresponding current address fields. When the value is "true" or any other value,
   * it clears all current address fields by setting them to empty strings.
   *
   * This function is typically used in address forms where users can choose to use
   * their permanent address as their current address, or enter a different current address.
   *
   * @param {any} value - A string value that determines the behavior:
   *                      - "false": Copy permanent address values to current address fields
   *                      - Any other value: Clear all current address fields
   *
   * @example
   * // Copy permanent address to current address
   * handleFilledCurrentAddressFields("false");
   *
   * // Clear current address fields
   * handleFilledCurrentAddressFields("true");
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const handleFilledCurrentAddressFields = (value: any) => {
    if (value === true) {
      // Copy permanent address fields to current address fields
      formikRef?.current?.setFieldValue(
        "currentAddressLine1",
        formikRef?.current?.values?.permanentAddressLine1 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressLine2",
        formikRef?.current?.values?.permanentAddressLine2 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressLine3",
        formikRef?.current?.values?.permanentAddressLine3 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressType",
        formikRef?.current?.values?.permanentAddressType || ""
      );
      formikRef?.current?.setFieldValue(
        "currentCity",
        formikRef?.current?.values?.permanentCity?.value ||
        formikRef?.current?.values?.permanentCity ||
        ""
      );
      formikRef?.current?.setFieldValue(
        "currentCountry",
        formikRef?.current?.values?.permanentCountry || ""
      );
      formikRef?.current?.setFieldValue(
        "currentOwnershipStatus",
        formikRef?.current?.values?.permanentOwnershipStatus || ""
      );
      formikRef?.current?.setFieldValue(
        "currentPincode",
        formikRef?.current?.values?.permanentPincode || ""
      );
      formikRef?.current?.setFieldValue(
        "currentState",
        formikRef?.current?.values?.permanentState || ""
      );
      formikRef?.current?.setFieldValue(
        "currentYearsInCurrentAddress",
        formikRef?.current?.values?.permanentYearsInCurrentAddress || ""
      );
      formikRef?.current?.setFieldValue(
        "currentYearsInCurrentCity",
        formikRef?.current?.values?.permanentYearsInCurrentCity || ""
      );
    } else {

      // Clear current address fields so user can enter new values
      formikRef?.current?.setFieldValue("currentAddressLine1", "");
      formikRef?.current?.setFieldValue("currentAddressLine2", "");
      formikRef?.current?.setFieldValue("currentAddressLine3", "");
      formikRef?.current?.setFieldValue("currentAddressType", "");
      formikRef?.current?.setFieldValue("currentCity", "");
      formikRef?.current?.setFieldValue("currentCountry", "");
      formikRef?.current?.setFieldValue("currentOwnershipStatus", "");
      formikRef?.current?.setFieldValue("currentPincode", "");
      formikRef?.current?.setFieldValue("currentState", "");
      formikRef?.current?.setFieldValue("currentYearsInCurrentAddress", "");
      formikRef?.current?.setFieldValue("currentYearsInCurrentCity", "");
    }
  };

  // Generic handler for co-applicant address copy/clear
  const handleFilledCurrentAddressFieldsCoApplicant = (
    coAppNum: string,
    value: any
  ) => {
    const prefix = `addressCoApplicant${coAppNum}`;
    if (value === true) {
      // Copy permanent address fields to current address fields

      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine1`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine1`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine2`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine2`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine3`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine3`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentCity`,
        formikRef?.current?.values?.[`${prefix}permanentCity`]?.value ||
        formikRef?.current?.values?.[`${prefix}permanentCity`] ||
        ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentCountry`,
        formikRef?.current?.values?.[`${prefix}permanentCountry`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentOwnershipStatus`,
        formikRef?.current?.values?.[`${prefix}permanentOwnershipStatus`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentPincode`,
        formikRef?.current?.values?.[`${prefix}permanentPincode`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentState`,
        formikRef?.current?.values?.[`${prefix}permanentState`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentAddress`,
        formikRef?.current?.values?.[
        `${prefix}permanentYearsInCurrentAddress`
        ] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentCity`,
        formikRef?.current?.values?.[`${prefix}permanentYearsInCurrentCity`] ||
        ""
      );
    } else {
      // Clear current address fields so user can enter new values
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine1`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine2`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine3`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentCity`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentCountry`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentOwnershipStatus`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentPincode`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentState`, "");
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentAddress`,
        ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentCity`,
        ""
      );
    }
    // Always set the checkbox value as a boolean in Formik
    formikRef?.current?.setFieldValue(
      `${prefix}currentsameAsPermanent`,
      !!value
    );
  };

  // const handleInvokStateApi = async (stateCode: string) => {
  //   try {
  //     const resp = await eligibilityCheckServices.getState(stateCode);
  //     if (resp.status === 200) {
  //       // handleInvokCityApi(cityCode);
  //     }
  //   } catch (error: any) {
  //   }
  // };

  const handleInvokCityApi = async (cityCode: string) => {
    if (!cityCode) return;

    try {
      const resp = await eligibilityCheckServices.getCity(cityCode);
      if (resp.status === 200 && resp.data?.data) {
        const cityLists: any = resp.data.data
          .filter((item: any) => item?.cityName) // Filter out items without cityName
          .map((item: any) => ({
            value: item.cityName || "",
            label: item.cityName || "",
          }));
        setCityList(cityLists);
      }
    } catch (error: any) {
      setCityList([]); // Reset city list on error
    }
  };

  const handleDisablePermanentPincodeBasedFields = (field: any) => {
    const name = field?.name || "";
    const isPincodeField = /pincode/i.test(name);

    // Pincode: lock only on first horizontal + first vertical (Eligibility landing, or merged flows
    // where Address is the first cell). SUMMARY stays editable via form rules elsewhere.
    if (isPincodeField) {
      const stepLabelRaw =
        horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
          activeVerticalIndex
        ]?.stepLabel ?? "";
      const stepLabel = String(stepLabelRaw).trim();
      const verifyConsentStep =
        /verify\s+yourself/i.test(stepLabel) && /consent/i.test(stepLabel);
      const onFirstEligibilityVertical =
        activeHorizontalIndex === 0 && activeVerticalIndex === 0;

      if (verifyConsentStep || onFirstEligibilityVertical) {
        return true;
      }
      return false;
    }

    const staticFields = [
      "permanentCity",
      "permanentState",
      "permanentCountry",
      "currentCity",
      "currentState",
      "currentCountry",
      "employmentCompanyCity",
      "employmentCompanyState",
      "employmentCompanyCountry",
    ];

    // 1. Static field names
    if (staticFields.includes(field.name)) return true;

    // 2. Dynamic co-applicant fields (1, 2, 3, ...)
    const dynamicPattern =
      /^addressCoApplicant\d+(permanentCity|permanentState|permanentCountry|currentCity|currentState|currentCountry)$/;

    // 3. Reference address City/State/Country — auto-filled via pincode lookup, read-only
    const referenceAddressPattern = /^addressReference\d+(City|State|Country)$/;

    // 4. Collateral (property mode) City/State/Country — auto-filled via pincode lookup, read-only
    const collateralAddressPattern = /^collateral\d*(City|State|Country)$/i;

    return (
      dynamicPattern.test(field.name) ||
      referenceAddressPattern.test(field.name) ||
      collateralAddressPattern.test(field.name)
    );
  };

  const [permanentCodeData, setPermanentCodeData] = useState<any>(null);
  const [currentCodeData, setCurrentCodeData] = useState<any>(null);
  const [companyCodeData, setCompanyCodeData] = useState<any>(null);

  const [reference1CodeData, setReference1CodeData] = useState<any>(null);
  const [reference2CodeData, setReference2CodeData] = useState<any>(null);
  const [collateralCodeDataByNumber, setCollateralCodeDataByNumber] = useState<
    Record<string, any>
  >({});
  // Ref to store timeout ID for cleanup
  const zipCodeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [isPinCodeLoading, setIsPinCodeLoading] = useState(false);
  // Same lookups as debouncedZipCodeCall + handleInvokPinCodeApi (zip → stateCode,
  // pincode → city/pinCodeId), returned instead of stored, for a save that needs them now.
  const fetchAddressCodeData = async (pincode: any): Promise<any | null> => {
    const pin = String(pincode ?? "").trim();
    if (pin.length !== 6) return null;
    try {
      // zipcodes → stateCode (stateId); pincodes master → city (cityId) + pinCodeId (pincodeId).
      const zipResp = await eligibilityCheckServices.getZipCode(pin);
      const zipData = zipResp?.data?.data?.[0];
      const pinResp = await eligibilityCheckServices.getPinCode(pin);
      const pinData = pinResp?.data?.data?.[0];
      if (!pinData && !zipData) return null;
      return {
        ...pinData,
        city: pinData?.city ?? zipData?.city,
        stateCode: zipData?.stateCode,
      };
    } catch (error) {
      console.error("Error resolving address code data:", error);
      return null;
    }
  };

  const handleInvokPinCodeApi = async (
    zipCode: string,
    stateCode: string,
    fieldType?: string,
    coAppNum?: string
  ) => {
    try {
      const resp = await eligibilityCheckServices.getPinCode(zipCode);
      if (resp.status === 200) {
        // Read fresh values from Redux store to avoid using stale closure values
        const currentState = store.getState();
        const currentActiveHorizontalIndex = currentState.stepper.activeHorizontalIndex;
        const currentActiveVerticalIndex = currentState.stepper.activeVerticalIndex[currentActiveHorizontalIndex] || 0;
        // Not gated on a specific horizontalIndex/verticalIndex — the
        // Summary editor's "Co-Applicant" section dispatches horizontalIndex
        // 3 (see ApplicationDetails' applicationSteps/handleEditStep), not
        // the 1/5 slot other co-applicant flows use, so a hardcoded index
        // check here missed it. loanDetailCoApplicantCollapseValue already
        // only ever holds a "CoApplicant<n>" value while a co-applicant
        // section is actually being edited, so that alone is enough.
        {
          const latestState = store.getState();
          const collapseVal =
            latestState.stepper.loanDetailCoApplicantCollapseValue;
          if (/^CoApplicant\d+$/.test(collapseVal)) {
            // Always read the latest state from Redux store to handle concurrent updates
            // This ensures we always have the most recent state even when API calls happen in quick succession
            const latestZipCodeData =
              latestState.stepper.coApplicantZipCodeData || {};

            // Create a proper copy of the state to avoid mutations
            // Use spread operator for shallow copy, then deep copy nested objects
            var oldPinCodeData: any = {};
            Object.keys(latestZipCodeData).forEach((key) => {
              if (
                latestZipCodeData[key] &&
                typeof latestZipCodeData[key] === "object"
              ) {
                oldPinCodeData[key] = {
                  current:
                    latestZipCodeData[key].current &&
                    typeof latestZipCodeData[key].current === "object"
                      ? { ...latestZipCodeData[key].current }
                      : latestZipCodeData[key].current,
                  permanent:
                    latestZipCodeData[key].permanent &&
                    typeof latestZipCodeData[key].permanent === "object"
                      ? { ...latestZipCodeData[key].permanent }
                      : latestZipCodeData[key].permanent,
                  company:
                    latestZipCodeData[key].company &&
                    typeof latestZipCodeData[key].company === "object"
                      ? { ...latestZipCodeData[key].company }
                      : latestZipCodeData[key].company,
                };
              } else {
                oldPinCodeData[key] = latestZipCodeData[key];
              }
            });

            let coAppKey = collapseVal;

            // Ensure coAppKey exists in the data structure
            if (!oldPinCodeData[coAppKey]) {
              oldPinCodeData[coAppKey] = {
                current: null,
                permanent: null,
                company: null,
              };
            }

            // Get existing data for this co-applicant, preserving current, permanent and company
            const existingCoAppData = oldPinCodeData[coAppKey] || {};

            // Preserve existing values - these are already deep copied above
            const preservedCurrent =
              existingCoAppData.current !== undefined
                ? existingCoAppData.current
                : null;

            const preservedPermanent =
              existingCoAppData.permanent !== undefined
                ? existingCoAppData.permanent
                : null;

            const preservedCompany =
              existingCoAppData.company !== undefined
                ? existingCoAppData.company
                : null;

            // Prepare the new data object with API response
            const newPinCodeData = {
              ...resp.data.data?.[0],
              stateCode: stateCode,
            };

            const coAppNumValue = collapseVal.split("CoApplicant")[1];
            const currentSameAsPermanent =
              formikRef?.current?.values?.[
                `addressCoApplicant${coAppNumValue}currentsameAsPermanent`
              ];

            if (currentSameAsPermanent && fieldType !== "company") {
              // If same as permanent is checked, update both with same data (not applicable for company address)
              oldPinCodeData[coAppKey] = {
                current: { ...newPinCodeData },
                permanent: { ...newPinCodeData },
                company: preservedCompany,
              };
            } else {
              // Update only the targeted field type, preserving the others
              if (fieldType === "permanent") {
                oldPinCodeData[coAppKey] = {
                  current: preservedCurrent, // Preserve existing current data
                  permanent: { ...newPinCodeData }, // Update permanent with new data
                  company: preservedCompany,
                };
              } else if (fieldType === "current") {
                oldPinCodeData[coAppKey] = {
                  current: { ...newPinCodeData }, // Update current with new data
                  permanent: preservedPermanent, // Preserve existing permanent data
                  company: preservedCompany,
                };
              } else if (fieldType === "company") {
                oldPinCodeData[coAppKey] = {
                  current: preservedCurrent, // Preserve existing current data
                  permanent: preservedPermanent, // Preserve existing permanent data
                  company: { ...newPinCodeData }, // Update company with new data
                };
              } else {
                // If fieldType is not specified, preserve all existing values
                oldPinCodeData[coAppKey] = {
                  current: preservedCurrent,
                  permanent: preservedPermanent,
                  company: preservedCompany,
                };
              }
            }

            // Dispatch the updated state
            dispatch(setCoApplicantZipCodeData(oldPinCodeData));
          }
        }

        // The loan summary editor gets its step from props (activeHorizontalIndex /
        // activeVerticalIndex), not the Redux stepper — checking only Redux there meant
        // the applicant address code data (cityId/stateId/pincodeId) was never stored.
        const isApplicantAddressStep =
          pageType === "SUMMARY" && propHorizontalIndex !== undefined
            ? activeHorizontalIndex === 1 && activeVerticalIndex === 1
            : currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 1;
        if (isApplicantAddressStep) {
          if (isCurrentSameAsPermanent) {
            // Create separate copies for permanent and current to avoid reference sharing
            const permanentData = { ...resp.data.data?.[0], stateCode: stateCode };
            setPermanentCodeData(permanentData);
            setCurrentCodeData(permanentData);
          } else {
            switch (fieldType) {
              case "permanent":
                // Update permanent only, preserve current address with its existing stateCode
                const permanentData = { ...resp.data.data?.[0], stateCode: stateCode };
                setPermanentCodeData(permanentData);
                // currentCodeData remains unchanged - don't touch it
                break;
              case "current":
                // Update current only, preserve permanent address with its existing stateCode
                const currentData = { ...resp.data.data?.[0], stateCode: stateCode };
                setCurrentCodeData(currentData);
                // permanentCodeData remains unchanged - don't touch it
                break;
              default:
                // No action needed for other fieldType values
                break;
            }
          }
        }
        if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 2) {
          // Update company address pincode data state
          if (resp.data?.data?.[0]) {
            const companyData = { ...resp.data.data?.[0], stateCode: stateCode };
            setCompanyCodeData(companyData);
          } else {
            // Clear company code data if no data found
            setCompanyCodeData(null);
          }
        }
        if ((currentActiveHorizontalIndex == 3 || currentActiveHorizontalIndex == 4) && currentActiveVerticalIndex == 3) {
          const referenceData = resp.data?.data?.[0]
            ? { ...resp.data.data?.[0], stateCode: stateCode }
            : null;
          if (fieldType === "reference1") {
            setReference1CodeData(referenceData);
          } else if (fieldType === "reference2") {
            setReference2CodeData(referenceData);
          }
        }
        // Property collateral: store city / pinCodeId / stateCode like reference
        const collateralMatch = fieldType?.match(/^collateral(\d+)$/i);
        if (collateralMatch) {
          const collateralNum = collateralMatch[1];
          const collateralData = resp.data?.data?.[0]
            ? { ...resp.data.data?.[0], stateCode: stateCode }
            : null;
          setCollateralCodeDataByNumber((prev) => {
            const next = { ...prev };
            if (collateralData) {
              next[collateralNum] = collateralData;
            } else {
              delete next[collateralNum];
            }
            return next;
          });
        }
      }
    } catch (error: any) {
      // Clear company code data on error if we're in company address section
      const currentState = store.getState();
      const currentActiveHorizontalIndex = currentState.stepper.activeHorizontalIndex;
      const currentActiveVerticalIndex = currentState.stepper.activeVerticalIndex[currentActiveHorizontalIndex] || 0;
      if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 2) {
        setCompanyCodeData(null);
      }
      if ((currentActiveHorizontalIndex == 3 || currentActiveHorizontalIndex == 4)&& currentActiveVerticalIndex == 3) {
        if (fieldType === "reference1") {
          setReference1CodeData(null);
        } else if (fieldType === "reference2") {
          setReference2CodeData(null);
        }
      }
      const collateralMatch = fieldType?.match(/^collateral(\d+)$/i);
      if (collateralMatch) {
        const collateralNum = collateralMatch[1];
        setCollateralCodeDataByNumber((prev) => {
          const next = { ...prev };
          delete next[collateralNum];
          return next;
        });
      }
    } finally {
      setZipCodeLoading(false);
    }
  };

  const lastUniversityQueryRef = useRef("");
  const lastInstituteQueryRef = useRef("");
  const lastCourseQueryRef = useRef("");

  // Debounced function to handle zip code API calls
  const debouncedZipCodeCall = useCallback(
    async (pincode: string, coAppNum?: string, fieldType?: string) => {
      if (pincode && String(pincode).length === 6) {
        setZipCodeLoading(true);
        try {
          const resp = await eligibilityCheckServices.getZipCode(pincode);
          if (resp.status === 200) {
            // Each address block below sets City/State/Country back to back.
            // Formik's default (shouldValidate: true) setFieldValue validates
            // against the values snapshot from BEFORE any of these calls run,
            // so e.g. the Country call's validation doesn't yet see the City/
            // State values the earlier calls just set — and whichever
            // validation resolves last overwrites the others' correct,
            // error-free result with phantom "Please select a City/State/
            // Country" errors. shouldValidate is explicitly false here, with
            // the error cleared manually, to avoid that race entirely.
            const setAddressFieldSilently = (fieldName: string, val: any) => {
              formikRef?.current?.setFieldValue(fieldName, val, false);
              formikRef?.current?.setFieldError(fieldName, undefined);
            };

            // Several lookups can be in flight for an address (the load-time
            // one, the Aadhaar prefill, user typing). Drop a response whose
            // pincode no longer matches the form, so a late stale one can't
            // overwrite City/State/Country for the pincode now shown.
            const isStaleAddressResponse = () => {
              const addressPrefix = coAppNum ? `addressCoApplicant${coAppNum}` : "";
              const pincodeKey =
                fieldType === "permanent" || fieldType === "current"
                  ? addressPrefix
                    ? `${addressPrefix}${fieldType}Pincode`
                    : `${fieldType}Pincode`
                  : "";
              const formPincode = pincodeKey
                ? formikRef?.current?.values?.[pincodeKey]
                : "";
              return !!formPincode && String(formPincode) !== String(pincode);
            };

            if (resp?.data?.data.length > 0) {
              const { cityName, countryName, stateName, stateCode, city }: any =
                resp?.data?.data?.[0];

              if (isStaleAddressResponse()) return;

              // Awaited so the outer `finally` below (which resets
              // zipCodeLoading) doesn't fire until getPinCode has also
              // settled — previously this ran fire-and-forget, so
              // zipCodeLoading could flip back to false while getPinCode
              // was still in flight.
              await handleInvokPinCodeApi(pincode, stateCode, fieldType, coAppNum);

              if (isStaleAddressResponse()) return;

              // Determine if this is a permanent address field
              const isPermanentField = fieldType === "permanent";
              const isCurrentField = fieldType === "current";
              const isCompanyField = fieldType === "company";
              const isReference1Field = fieldType === "reference1";
              const isReference2Field = fieldType === "reference2";
              const isCollateralField = /^collateral\d+$/i.test(fieldType || "");
              const collateralNumber =
                fieldType?.match(/^collateral(\d+)$/i)?.[1] || "1";

              // Safety check - if fieldType is not specified, don't update any fields to avoid confusion
              if (!fieldType) {
                console.warn(
                  "handleInvokZipCode called without fieldType, skipping field updates"
                );
                return;
              }

              if (coAppNum) {
                const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
                const isSameAs = formikRef?.current?.values?.[sameAsKey];

                if (isPermanentField) {
                  // Update permanent fields when permanent pincode is entered
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}permanentCity`,
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}permanentState`,
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}permanentCountry`,
                    countryName || ""
                  );
                  // Only update current fields if same as permanent is checked
                  if (isSameAs) {
                    handleInvokCityApi(city);
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}currentCity`,
                      cityName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}currentState`,
                      stateName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}currentCountry`,
                      countryName || ""
                    );
                  }
                } else if (isCurrentField) {
                  // Update current fields when current pincode is entered
                  handleInvokCityApi(city);
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}currentCity`,
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}currentState`,
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}currentCountry`,
                    countryName || ""
                  );
                  // Only update permanent fields if same as current is checked
                  if (isSameAs) {
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}permanentCity`,
                      cityName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}permanentState`,
                      stateName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}permanentCountry`,
                      countryName || ""
                    );
                  }
                } else if (isCompanyField) {
                  // Update co-applicant company address fields when company pincode is entered
                  setAddressFieldSilently(
                    `employmentCoApplicant${coAppNum}city`,
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    `employmentCoApplicant${coAppNum}state`,
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    `employmentCoApplicant${coAppNum}companyCountry`,
                    countryName || ""
                  );
                }
              } else {
                const isSameAs =
                  formikRef?.current?.values?.currentsameAsPermanent;

                if (isPermanentField) {
                  // Update permanent fields when permanent pincode is entered
                  setAddressFieldSilently("permanentCity", cityName || "");
                  setAddressFieldSilently("permanentState", stateName || "");
                  setAddressFieldSilently(
                    "permanentCountry",
                    countryName || ""
                  );
                  // Only update current fields if same as permanent is checked
                  if (isSameAs) {
                    handleInvokCityApi(stateCode);
                    setAddressFieldSilently("currentCity", cityName || "");
                    setAddressFieldSilently("currentState", stateName || "");
                    setAddressFieldSilently(
                      "currentCountry",
                      countryName || ""
                    );
                  }
                } else if (isCurrentField) {
                  // Update current fields when current pincode is entered
                  handleInvokCityApi(stateCode);
                  setAddressFieldSilently("currentCity", cityName || "");
                  setAddressFieldSilently("currentState", stateName || "");
                  setAddressFieldSilently("currentCountry", countryName || "");
                  // Only update permanent fields if same as current is checked
                  if (isSameAs) {
                    setAddressFieldSilently("permanentCity", cityName || "");
                    setAddressFieldSilently("permanentState", stateName || "");
                    setAddressFieldSilently(
                      "permanentCountry",
                      countryName || ""
                    );
                  }
                } else if (isReference1Field) {
                  setAddressFieldSilently(
                    "addressReference1City",
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference1State",
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference1Country",
                    countryName || ""
                  );
                } else if (isReference2Field) {
                  setAddressFieldSilently(
                    "addressReference2City",
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference2State",
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference2Country",
                    countryName || ""
                  );
                } else if (isCollateralField) {
                  applyCollateralAddressFromPincode(formikRef, {
                    fields,
                    collateralNumber,
                    cityName: cityName || "",
                    stateName: stateName || "",
                    countryName: countryName || "",
                    countries: dropdownData?.countries || [],
                    onUpdate: (patch) => dispatch(updateFormData(patch)),
                  });
                }
              }
            } else {
              const isPermanentField = fieldType === "permanent";
              const isCurrentField = fieldType === "current";
              const isCompanyField = fieldType === "company";
              const isReference1Field = fieldType === "reference1";
              const isReference2Field = fieldType === "reference2";
              const isCollateralField = /^collateral\d+$/i.test(fieldType || "");
              const collateralNumber =
                fieldType?.match(/^collateral(\d+)$/i)?.[1] || "1";
              if (coAppNum) {
                if (isPermanentField) {
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}permanentCity`, "");
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}permanentState`, "");
                } else if (isCurrentField) {
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}currentCity`, "");
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}currentState`, "");
                } else if (isCompanyField) {
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}city`, "");
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}state`, "");
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}companyCountry`, "");
                }
              } else {
                if (isPermanentField) {
                  formikRef?.current?.setFieldValue("permanentCity", "");
                  formikRef?.current?.setFieldValue("permanentState", "");
                } else if (isCurrentField) {
                  formikRef?.current?.setFieldValue("currentCity", "");
                  formikRef?.current?.setFieldValue("currentState", "");
                } else if (isReference1Field) {
                  formikRef?.current?.setFieldValue("addressReference1City", "");
                  formikRef?.current?.setFieldValue("addressReference1State", "");
                  formikRef?.current?.setFieldValue("addressReference1Country", "");
                } else if (isReference2Field) {
                  formikRef?.current?.setFieldValue("addressReference2City", "");
                  formikRef?.current?.setFieldValue("addressReference2State", "");
                  formikRef?.current?.setFieldValue("addressReference2Country", "");
                } else if (isCollateralField) {
                  applyCollateralAddressFromPincode(formikRef, {
                    fields,
                    collateralNumber,
                    clear: true,
                    onUpdate: (patch) => dispatch(updateFormData(patch)),
                  });
                  setCollateralCodeDataByNumber((prev) => {
                    const next = { ...prev };
                    delete next[String(collateralNumber)];
                    return next;
                  });
                }
              }

              dispatch(
                setStatusPopup({
                  status: "error",
                  message: "Pincode not found. Please enter a valid pincode.",
                })
              );
            }
          }
        } catch (error: any) {
        } finally {
          // Without this, an invalid/not-found pincode (or a failed API call)
          // left zipCodeLoading stuck true forever, since handleInvokPinCodeApi
          // (the only other place that cleared it) is never reached on those
          // paths — permanently blocking Continue via isNavigationDisabled.
          setZipCodeLoading(false);
        }
      }
      // }, 500);
    },
    [
      loanDetailCoApplicantCollapseValue,
      coApplicantZipCodeData,
      formData,
      permanentCodeData,
      currentCodeData,
      isCurrentSameAsPermanent,
      activeHorizontalIndex,
      activeVerticalIndex
    ]
  );

  const debouncedCall = useMemo(
    () =>
      debounce((key: string, value: string) => {
        if (key === "university") fetchUniversities(value);
        if (key === "institute") fetchInstitutes(value);
        if (key === "courseName" || key === "course" || key === "cource") {
          fetchCourses(value);
        }
      }, 1000),
    [formValues.countryId, formData?.country?.value, formValues.universityId, formValues?.instituteId, dropdownData]
  );
  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (zipCodeTimeoutRef.current) {
        clearTimeout(zipCodeTimeoutRef.current);
      }
    };
  }, []);

  const handleInvokZipCode = (
    pincode: string,
    coAppNum?: string,
    fieldType?: string
  ) => {
    // Only call API if pincode is exactly 6 digits
    if (pincode && pincode.length === 6) {
      debouncedZipCodeCall(pincode, coAppNum, fieldType);
    }
  };
  // City/State/Country follow the address's own saved pincode. The Aadhaar
  // pincode is only a fallback for an address that has none yet — once the
  // address was changed (e.g. in the assisted journey), looking up the Aadhaar
  // pincode would overwrite City/State/Country with the old address's values.
  const savedPermanentPincode =
    formikRef?.current?.values?.permanentPincode || formData?.permanentPincode;
   useEffect(() => {
    const permanentPincodeToResolve =
      savedPermanentPincode || aadhaarVerifiedDetails?.pincode;
    if (isCurrentSameAsPermanent == true && activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      setPermanentCodeData(null);
      setCurrentCodeData(null);
      handleInvokZipCode(
        permanentPincodeToResolve,
        undefined,
        "permanent"
      );
    } else {
      if (aadhaarVerifiedDetails?.pincode &&
        activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 1 ||
          activeVerticalIndex === 2 ||
          activeVerticalIndex === 5)
      ) {
        handleInvokZipCode(
          permanentPincodeToResolve,
          undefined,
          "permanent"
        );
      }
    }
  }, [
    aadhaarVerifiedDetails?.pincode,
    activeHorizontalIndex,
    activeVerticalIndex,
    savedPermanentPincode,
    isCurrentSameAsPermanent
  ]);

  // Ref to track last processed employment pincode
  const lastEmploymentPincodeRef = useRef<string>("");

  useEffect(() => {
    if (
      activeHorizontalIndex == 1 &&
      (activeVerticalIndex == 1 ||
        activeVerticalIndex == 2)
    ) {
      const currentPincode = formikRef?.current?.values?.employmentCompanyPincode;
      if (currentPincode && currentPincode !== lastEmploymentPincodeRef.current) {
        lastEmploymentPincodeRef.current = currentPincode;
        handleInvokZipCode(currentPincode);
      }
    }
  }, [formikRef?.current?.values?.employmentCompanyPincode, activeHorizontalIndex, activeVerticalIndex]);

  // For each co-applicant, if Aadhaar details have pincode, trigger handleInvokZipCode with co-applicant number
  useEffect(() => {
    if (!aadhaarVerifiedDetailsCoApplicant) return;
    Object.entries(aadhaarVerifiedDetailsCoApplicant).forEach(
      ([coAppKey, detailsRaw]) => {
        const match = coAppKey.match(/CoApplicant(\d+)/);
        if (!match) return;
        const num = match[1];
        const details = detailsRaw as any;
        if (details?.pincode) {
          handleInvokZipCode(details.pincode, num, "permanent");
        }
      }
    );
  }, [aadhaarVerifiedDetailsCoApplicant]);

  // Ref to store timeout ID for cleanup
  const companyZipCodeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // When user lands on Reference & Collateral step, restore reference/collateral code data
    // by re-triggering pincode API for any existing reference/collateral pincodes
    useEffect(() => {
      if ((activeHorizontalIndex === 3 && activeVerticalIndex === 3) || (activeHorizontalIndex === 4 && activeVerticalIndex === 3)) {
        const fv = formikRef?.current?.values || {};
        const ref1Pincode = fv?.addressReference1Pincode;
        const ref2Pincode = fv?.addressReference2Pincode;
        if (ref1Pincode && String(ref1Pincode).length === 6) {
          handleInvokZipCode(String(ref1Pincode), undefined, "reference1");
        }
        if (ref2Pincode && String(ref2Pincode).length === 6) {
          handleInvokZipCode(String(ref2Pincode), undefined, "reference2");
        }
        Object.keys(fv).forEach((key) => {
          if (
            /^collateral/i.test(key) &&
            /pincode/i.test(key) &&
            !/^coOwnerCollateral/i.test(key)
          ) {
            const normalized = String(key)
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");
            const match = normalized.match(/^collateral(\d+)/);
            const collateralNum = match?.[1] || "1";
            const pin = fv[key];
            const pinStr =
              pin && typeof pin === "object" && "value" in pin
                ? String((pin as any).value ?? "")
                : String(pin ?? "");
            if (pinStr.length === 6) {
              handleInvokZipCode(pinStr, undefined, `collateral${collateralNum}`);
            }
          }
        });
      }
    }, [activeHorizontalIndex, activeVerticalIndex]);
    // Debounced function to handle zip code API calls
  const debouncedCompanyZipCodeCall = useCallback((pincode: string) => {
    // Clear existing timeout
    if (companyZipCodeTimeoutRef.current) {
      clearTimeout(companyZipCodeTimeoutRef.current);
    }

    // Clear loading state when user starts typing again
    setZipCodeLoading(false);

    // Set new timeout
    companyZipCodeTimeoutRef.current = setTimeout(async () => {
      if (pincode && pincode.length === 6) {
        setZipCodeLoading(true);

        try {
          const resp = await eligibilityCheckServices.getZipCode(pincode);
          if (resp.status === 200) {
            if (resp?.data?.data.length > 0) {
              const { cityName, countryName, stateName, stateCode }: any =
                resp?.data?.data?.[0];

              // Awaited so the outer `finally` below doesn't reset
              // zipCodeLoading before getPinCode has also settled.
              await handleInvokPinCodeApi(pincode, stateCode);
              // handleInvokStateApi(stateCode);
              handleInvokCityApi(stateCode);
              formikRef?.current?.setFieldValue(
                "employmentCompanyCity",
                cityName || ""
              );
              formikRef?.current?.setFieldValue(
                "employmentCompanyState",
                stateName || ""
              );
              formikRef?.current?.setFieldValue(
                "employmentCompanyCountry",
                countryName || ""
              );
            } else {
              // Clear company code data if pincode not found
              setCompanyCodeData(null);
              formikRef?.current?.setFieldValue("employmentCompanyCity", "");
              formikRef?.current?.setFieldValue("employmentCompanyState", "");
              formikRef?.current?.setFieldValue("employmentCompanyCountry", "");

              dispatch(
                setStatusPopup({
                  status: "error",
                  message: "Pincode not found. Please enter a valid pincode.",
                })
              );
            }
          }
        } catch (error: any) {
        } finally {
          setZipCodeLoading(false);
        }
      }
    }, 500); // 500ms delay
  }, []);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (companyZipCodeTimeoutRef.current) {
        clearTimeout(companyZipCodeTimeoutRef.current);
      }
    };
  }, []);

  const handleInvokCompanyZipCode = (pincode: string) => {
    // Only call API if pincode is exactly 6 digits
    if (pincode && pincode.length === 6) {
      debouncedCompanyZipCodeCall(pincode);
    }
  };

  const renderField = (field: any) => {
     const isSummaryEligibilityStep0 =
      pageType === "SUMMARY" &&
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0;
    const isAcademicDetailsCourseField = /^course\d+(Type|Cgpa|Percentage|Year)$/i.test(
      field?.name || ""
    );
    const summaryEligibilityThreeColFields = new Set([
      "product",
      "applicantType",
      "studentDetailsFirstName",
      "studentDetailsLastName",
      "firstName",
      "lastName",
      "phone_number",
      "email",
      "studentDetailsPhone_number",
      "studentDetailEmail",
    ]);
    const smForSummaryEligibility = (baseSm: number) =>
      isSummaryEligibilityStep0 && summaryEligibilityThreeColFields.has(field.name)
        ? 3
        : baseSm;
    switch (field.type) {
      case "number":
      case "text":
        if (formikRef?.current?.values?.employmentType !== "Others" && field.name === "employmentYear") {
          const yearField = (
            <Field name="employmentYear">
              {({ field: f, meta, form }: any) => (
                <InputField
                  {...f}
                  fullWidth
                  type="text"
                  placeholder="Total Years"
                  variant="outlined"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  inputProps={{ min: 0, max: 60, maxLength: 2 }}
                  error={!!meta.touched && !!meta.error}
                  helperText={meta.touched && meta.error ? meta.error : ""}
                  autoComplete="new-password"
                  onKeyDown={(e: any) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e: any) => {
                    let v = String(e?.target?.value ?? "");
                    v = v.replace(/\D/g, "");
                    if (v.length > 2) v = v.slice(0, 2);

                    if (v === "") {
                      form.setFieldError("employmentYear", "");
                      form.setFieldValue("employmentYear", ""); // Use setFieldValue for consistency
                      handleFilledFieldsCount("employmentYear", "");
                      return;
                    }

                    const n = parseInt(v, 10);
                    if (!Number.isNaN(n) && n > 60) {
                      const prev = !f.value ? "60" : String(f.value);
                      form.setFieldTouched("employmentYear", true, false);
                      form.setFieldError("employmentYear", "Year cannot be greater than 60");
                      form.setFieldValue("employmentYear", prev, false);
                      handleFilledFieldsCount("employmentYear", prev);
                      return;
                    }

                    if (meta.error === "Year cannot be greater than 60") {
                      form.setFieldError("employmentYear", "");
                    }

                    // NEW LOGIC: If years set to 60, force month to 0
                    if (n === 60) {
                      form.setFieldValue("employmentMonth", "0", false);
                      handleFilledFieldsCount("employmentMonth", "0");
                    }

                    form.setFieldValue("employmentYear", v, false);
                    handleFilledFieldsCount("employmentYear", v);
                  }}
                />
              )}
            </Field>
          );

          const monthField = (
            <Field name="employmentMonth">
              {({ field: f, meta, form }: any) => (
                <InputField
                  {...f}
                  fullWidth
                  type="text"
                  placeholder="Total Months"
                  variant="outlined"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  inputProps={{ min: 0, max: 12, maxLength: 2 }}
                  error={!!meta.touched && !!meta.error}
                  helperText={meta.touched && meta.error ? meta.error : ""}
                  autoComplete="new-password"
                  onKeyDown={(e: any) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e: any) => {
                    let v = String(e?.target?.value ?? "");
                    v = v.replace(/\D/g, "");
                    if (v.length > 2) v = v.slice(0, 2);

                    const currentYear = parseInt(form.values.employmentYear, 10);

                    if (v === "") {
                      form.setFieldError("employmentMonth", "");
                      form.setFieldValue("employmentMonth", "", false);
                      handleFilledFieldsCount("employmentMonth", "");
                      return;
                    }

                    const n = parseInt(v, 10);

                    // LOGIC: If years are 60, force month to 0 and show error if they try to change it
                    if (currentYear === 60 && n > 0) {
                      form.setFieldTouched("employmentMonth", true, false);
                      form.setFieldError("employmentMonth", "Month must be 0 if Year is 60");
                      form.setFieldValue("employmentMonth", "0", false);
                      return;
                    }

                    if (!Number.isNaN(n) && n > 12) {
                      const prev = !f.value ? "12" : String(f.value);
                      form.setFieldTouched("employmentMonth", true, false);
                      form.setFieldError("employmentMonth", "Month cannot be greater than 12");
                      form.setFieldValue("employmentMonth", prev, false);
                      return;
                    }

                    if (meta.error === "Month cannot be greater than 12" || meta.error === "Month must be 0 if Year is 60") {
                      form.setFieldError("employmentMonth", "");
                    }

                    form.setFieldValue("employmentMonth", v, false);
                    handleFilledFieldsCount("employmentMonth", v);
                  }}
                />
              )}
            </Field>
          );

          if (pageType === "SUMMARY") {
            return (
              <React.Fragment key={field.id}>
                <Grid item xs={3}>
                  <label className="text-lable" style={{ display: "block" }}>
                    Total Years <span style={{ color: "red" }}>*</span>
                  </label>
                  {yearField}
                </Grid>
                <Grid item xs={3}>
                  <label className="text-lable" style={{ display: "block" }}>
                    Total Months <span style={{ color: "red" }}>*</span>
                  </label>
                  {monthField}
                </Grid>
              </React.Fragment>
            );
          }

          return (
            <Grid item xs={12} key={field.id} sx={{ mt: 1 }}>
              <Box sx={{ bgcolor: '#00B3B514', p: 2, borderRadius: 2 }}>
                <Box mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {/* {pageType !== "SUMMARY" && <img src={workExperienceIcon} alt="work-experience" />} */}
                  <Typography style={{ color: '#4B465C', fontSize: '13px', fontWeight: 700 }}>
                    Help us with your work experience <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  {/* YEAR FIELD */}
                  <Grid item xs={12} sm={6}>
                    {yearField}
                  </Grid>

                  {/* MONTH FIELD */}
                  <Grid item xs={12} sm={6}>
                    {monthField}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
        }

        // return null for employmentMonth so it doesn't render a second time
        if (field.name === "employmentMonth") {
          return null;
        }
        // Handle main applicant First/Last Name only if value exists and as per bugs in sheet have not change anything in api
        if (
          field.name === "studentDetailsFirstName" ||
          field.name === "studentDetailsLastName" ||
          field.name === "firstName" ||
          field.name === "lastName"
        ) {
          let valueExists = false;
          let valueExistsone = false;
          if (field.name === "studentDetailsFirstName" || field.name === "studentDetailsLastName") {
            valueExists =
              formikRef.current?.values?.[field.name] ||
              formData?.[field.name];
          }
          if (field.name === "firstName" || field.name === "lastName") {
            valueExistsone =
              formikRef.current?.values?.[field.name] ||
              formData?.[field.name];
          }
          if (valueExists || valueExistsone) {
            return (
              <Grid
                item
                xs={isXsOrSm ? 12: pageType === "SUMMARY" ? 3 : 12}
                sm={isXsOrSm ? 12: pageType === "SUMMARY" ? 3 : smForSummaryEligibility(3)}
                key={field.id}
              >
                <Box>
                  <label className="text-lable" style={{ display: "block" }}>
                    {field.label}{" "}
                    {field.required && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <Field name={field.name}>
                    {({ field: f, meta }: any) => (
                      <InputField
                        {...f}
                        fullWidth
                        placeholder={field.placeholder || `Enter ${field.label}`}
                        variant="outlined"
                        inputmode="text"
                        disabled={
                          isApiLoading ||
                          Boolean(valueExists) ||
                          (Boolean(valueExistsone) && isAuthenticated) ||
                          (pageType === "SUMMARY" &&
                            [
                              "firstName",
                              "lastName",
                              "studentDetailsFirstName",
                              "studentDetailsLastName",
                            ].includes(field.name))
                        }
                        error={!!meta.touched && !!meta.error}
                        helperText={meta.touched && meta.error ? meta.error : ""}
                        autoComplete="new-password"
                        inputProps={{ autoComplete: "new-password" }}
                        onInput={(e: any) => {
                          if (valueExists) return;
                          if (
                            pageType === "SUMMARY" &&
                            [
                              "firstName",
                              "lastName",
                              "studentDetailsFirstName",
                              "studentDetailsLastName",
                            ].includes(field.name)
                          ) {
                            return;
                          }
                          e.target.value = e.target.value;
                          handleFilledFieldsCount(field.name, e.target.value);

                          if (
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 5 &&
                            formikRef?.current?.values
                          ) {
                            dispatch(
                              updateFormData({
                                [field.name]: e.target.value,
                              })
                            );
                          }
                        }}
                        onBlur={(e: any) => {
                          if (
                            pageType === "SUMMARY" &&
                            [
                              "firstName",
                              "lastName",
                              "studentDetailsFirstName",
                              "studentDetailsLastName",
                            ].includes(field.name)
                          ) {
                            return;
                          }
                          let value = e.target.value || "";
                          value = value.trim().replace(/\s{2,}/g, " ");
                          e.target.value = value;

                          if (formikRef?.current) {
                            formikRef.current.setFieldValue(field.name, value, true);
                          }

                          handleFilledFieldsCount(field.name, value);

                          if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                            dispatch(
                              updateFormData({
                                [field.name]: value,
                              })
                            );
                          }
                        }}
                      />
                    )}
                  </Field>
                </Box>
              </Grid>
            );
          }
        }
        // PAN field logic for co-applicants
        if (field.name.match(/^basicCoApplicant\d+PanNumber$/)) {
          const coApplicantPanMatch = field.name.match(
            /^basicCoApplicant(\d+)PanNumber$/
          );
          const idx = coApplicantPanMatch
            ? String(Number(coApplicantPanMatch[1]) - 1)
            : null;

          // Verified logic (check both Redux and Formik)
          let isPanVerified = false;
          let lastVerifiedPan = "";
          if (idx !== null) {
            const formikPanVerified = isTruthyFormFlag(
              formikRef.current?.values[
                `basicCoApplicant${Number(idx) + 1}IsPanVerified`
              ]
            );
            const reduxPanVerified = isTruthyFormFlag(
              coApplicantVerification[idx]?.panVerified
            );
            const lastPan =
              coApplicantVerification[idx]?.lastPanNumber ||
              formikRef.current?.values[field.name];
            isPanVerified =
              (formikPanVerified || reduxPanVerified) &&
              formikRef.current?.values[field.name] === lastPan;
            lastVerifiedPan = lastPan;
          }

          // Duplicate PAN validation (include main applicant PAN)
          const allPanFields = Object.keys(
            formikRef.current?.values || {}
          ).filter((key) => key.match(/^basicCoApplicant\d+PanNumber$/));
          const currentPanValue = formikRef.current?.values[field.name];
          // Get main applicant PAN from Redux formData, formik, and panNumber
          let mainApplicantPan = formData?.pan;
          if (
            !mainApplicantPan ||
            mainApplicantPan === "" ||
            mainApplicantPan === "yes" ||
            mainApplicantPan === "no"
          ) {
            // fallback to Formik value if Redux is blank or not a PAN
            const formikPan = formikRef.current?.values?.pan;
            if (
              formikPan &&
              formikPan !== "" &&
              formikPan !== "yes" &&
              formikPan !== "no"
            ) {
              mainApplicantPan = formikPan;
            } else if (
              panNumber &&
              panNumber !== "" &&
              /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panNumber)
            ) {
              // fallback to panNumber from Redux if it's a valid PAN
              mainApplicantPan = panNumber;
            } else {
              mainApplicantPan = undefined;
            }
          }
          const duplicatePan =
            allPanFields
              .filter((key) => key !== field.name)
              .map((key) => formikRef.current?.values[key])
              .includes(currentPanValue) ||
            (mainApplicantPan &&
              currentPanValue &&
              mainApplicantPan?.toUpperCase() ===
              currentPanValue?.toUpperCase());
          return (
            <Grid
              item
              xs={12}
              sm={
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                    : pageType === "SUMMARY" ? 3 : 6
              }
              key={field.id}
            >
              <Box>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Field name={field.name}>
                  {({ field: f, meta, form }: any) => (
                    <InputField
                      {...f}
                      fullWidth
                      placeholder={field.placeholder || "Enter PAN Number"}
                      variant="outlined"
                      inputmode="text"
                      // disabled={isApiLoading || isPanVerified}
                      autoComplete="new-password"
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      error={
                        !!coApplicantPanVerifyError[field.name] ||
                        (!!meta.touched && !!meta.error) ||
                        (duplicatePan && !!currentPanValue)
                      }
                      helperText={
                        coApplicantPanVerifyError[field.name]
                          ? coApplicantPanVerifyError[field.name]
                          : meta.touched && meta.error
                            ? meta.error
                            : duplicatePan && !!currentPanValue
                              ? "This PAN is already used in another field."
                              : ""
                      }
                      onChange={(e) => {
                        let inputValue = e.target.value?.toUpperCase();
                        if (inputValue.length > 10) {
                          inputValue = inputValue.slice(0, 10);
                        }
                        form.setFieldValue(field.name, inputValue);
                        setCoApplicantPanVerifyError((prev) => ({
                          ...prev,
                          [field.name]: "",
                        }));
                        // Reset verification if value changes
                        if (inputValue !== lastVerifiedPan) {
                          if (idx !== null) {
                            dispatch(
                              setCoApplicantVerification({
                                index: idx,
                                data: {
                                  panVerified: false,
                                },
                              })
                            );
                          }
                        } else {
                          if (idx !== null) {
                            dispatch(
                              setCoApplicantVerification({
                                index: idx,
                                data: {
                                  panVerified: true,
                                },
                              })
                            );
                          }
                        }
                      }}
                      onInput={(e: any) => {
                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === "string" &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, "");
                        }
                        let panval = e.target.value?.toUpperCase();
                        handleFilledFieldsCount(field.name, panval);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          // Persist all form values to Redux for refresh survival
                          if (formikRef?.current?.values) {
                            // dispatch(
                            //   updateFormData({
                            //     ...formikRef.current.values,
                            //     [field.name]: e.target.value,
                            //   })
                            // );
                            dispatch(
                              updateFormData({
                                [field.name]: panval,
                              })
                            );
                          }
                        }
                      }}
                      inputProps={{
                        ...(coApplicantPanMatch ? { maxLength: 10 } : {}),
                      }}
                      InputProps={{
                        readOnly: isApiLoading || isPanVerified,
                        style: { textTransform: "uppercase" },
                        endAdornment: (
                          <Button
                            sx={{
                              backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                              color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                              "&:hover": {
                                backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                                color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                                color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                                WebkitTextFillColor: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                                opacity: 1
                              },
                              "& img": {
                                opacity: 1,
                                filter: "brightness(1)",
                              },
                              textTransform: "none",
                              fontSize: isPanVerified && !duplicatePan ? "16px" : "10px",
                              fontWeight: isPanVerified && !duplicatePan ? 400 : 700,
                              px: "15px",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              boxShadow: "none",
                              height: '100%',
                              mr: 0.5,
                            }}
                            onClick={isApiLoading || isPanVerified ? undefined : async () => {
                              if (isPanVerified || duplicatePan) return;
                              setCoApplicantPanLoading((prev) => ({
                                ...prev,
                                [field.name]: true,
                              }));

                              try {
                                const panNumber = form.values[field.name];
                                const firstName =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1
                                  }FirstName`
                                  ] || "";
                                const lastName =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1}LastName`
                                  ] || "";
                                const name = `${firstName} ${lastName}`.trim();
                                const dob =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1}dob`
                                  ] || "";
                                // Check one scenario at a time so only one message shows under the PAN field
                                const panVerifyError = !dob
                                  ? "Please enter your Date of Birth before verifying your PAN."
                                  : !String(panNumber || "").trim()
                                    ? "Please enter your PAN to proceed with verification."
                                    : !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(panNumber).trim().toUpperCase())
                                      ? "Please enter a valid 10-digit PAN number."
                                      : "";
                                setCoApplicantPanVerifyError((prev) => ({
                                  ...prev,
                                  [field.name]: panVerifyError,
                                }));
                                if (panVerifyError) return;
                                const piiPublicKey =
                                  await fetchSanitizedPiiPublicKey();
                                if (!piiPublicKey) return;

                                const payload = await encryptData(
                                  {
                                    panNumber,
                                    fullName: name.trim(),
                                    dob: dob
                                      ? new Date(dob).toLocaleDateString(
                                        "en-GB"
                                      )
                                      : "",
                                    trackingId: trackingId,
                                    applicantType: `Co-Applicant ${Number(idx) + 1}`,
                                  },
                                  ["panNumber"],
                                  piiPublicKey
                                );
                                const resp =
                                  await applicantDetailsServices.verifyPan(payload);
                                if (resp.status === 200) {

                                  // trackCustomerJourneyEvent(
                                  //   `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                  //   decrypt(userProfile?.id) ?? "",
                                  //   trackingId,
                                  //   {
                                  //     label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                  //     category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                  //     action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                  //     page: `ProvisionalOff_Loan Details_COAPP(${Number(idx) + 1}) PAN Verification`,
                                  //   }
                                  // );


                                  // Check for invalid date of birth in PAN API response
                                  if (
                                    resp.data?.data?.dateOfBirth === "invalid" && dob // only if dob is provided
                                  ) {
                                    setCoApplicantPanVerifyError((prev) => ({
                                      ...prev,
                                      [field.name]: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                    }));
                                  } else {
                                    const isAadhaarSeeded =
                                      String(
                                        resp?.data?.data?.aadhaarSeedingStatus || ""
                                      ).toLowerCase() === "y";
                                    dispatch(
                                      setCoApplicantVerification({
                                        index: idx ?? "",
                                        data: {
                                          panVerified: true,
                                          lastPanNumber: panNumber,
                                          aadhaarSeedingStatus: isAadhaarSeeded,
                                        },
                                      })
                                    );
                                    formikRef.current?.setFieldValue(
                                      field.name,
                                      panNumber
                                    );
                                    dispatch(
                                      updateFormData({
                                        [`basicCoApplicant${Number(idx) + 1}IsPanVerified`]: true
                                      })
                                    );
                                    setSnackbar({
                                      open: true,
                                      message:
                                        "Yay! The co-applicant's PAN has been successfully verified.",
                                      severity: "success",
                                    });
                                  }
                                } else if (resp.status === 400) {
                                  setSnackbar({
                                    open: true,
                                    message:
                                      "Uh-oh! We are experiencing some technical issues fetching the co-applicant’s PAN details. Please try again later.",
                                    severity: "error",
                                  });
                                } else {
                                  setCoApplicantPanVerifyError((prev) => ({
                                    ...prev,
                                    [field.name]: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                  }));
                                }
                              } catch (err: any) {
                                setSnackbar({
                                  open: true,
                                  message: "Uh-oh! PAN verification failed. Please check the details and try again.",
                                  severity: "error",
                                });
                              } finally {
                                setCoApplicantPanLoading((prev) => ({
                                  ...prev,
                                  [field.name]: false,
                                }));
                              }
                            }}
                            disabled={
                              isPanVerified ||
                              duplicatePan ||
                              coApplicantPanLoading[field.name]
                            }
                          >
                            {coApplicantPanLoading[field.name] ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : (
                              <>
                                {isPanVerified && !duplicatePan  ? (
                                  <>
                                    <img
                                      src={greenCheckVerified}
                                      alt="Verified"
                                      style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                    <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="inherit">Verify</Typography>
                                    <img
                                      src={arrowRightVerify}
                                      alt="Verified"
                                      style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </Button>
                        ),
                      }}
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }
        // Name fields: block numbers for First Name, Last Name, Co-applicant First/Last Name
        const isReferenceNameField = /^basicReference\d+(FirstName|LastName)$/.test(field.name);
        // FD Holder Name ("...FdHolderName") and Savings Holder Name ("...HolderName") —
        // both end in "HolderName", so this single regex covers both.
        const isCollateralHolderNameField = /^collateral\d*(Fd)?HolderName$/i.test(field.name);
        const isNameField =
          field.name === "firstName" ||
          field.name === "lastName" ||
          field.name === "studentDetailsFirstName" ||
          field.name === "studentDetailsLastName" ||
          field.name === "fatherFirstName" ||
          field.name === "fatherLastName" ||
          field.name === "motherFirstName" ||
          field.name === "motherLastName" ||
          /^basicCoApplicant\d+FirstName$/.test(field.name) ||
          /^basicCoApplicant\d+LastName$/.test(field.name) ||
          isReferenceNameField ||
          isCollateralHolderNameField;
        const isTwentySixCharNameField =
          field.name === "firstName" ||
          field.name === "lastName" ||
          field.name === "studentDetailsFirstName" ||
          field.name === "studentDetailsLastName" ||
          field.name === "fatherFirstName" ||
          field.name === "fatherLastName" ||
          field.name === "motherFirstName" ||
          field.name === "motherLastName" ||
          /^basicCoApplicant\d+FirstName$/.test(field.name) ||
          /^basicCoApplicant\d+LastName$/.test(field.name);
        const isSummaryLockedStudentName =
          pageType === "SUMMARY" &&
          [
            "firstName",
            "lastName",
            "studentDetailsFirstName",
            "studentDetailsLastName",
          ].includes(field.name);

        if (isNameField) {
          return (
            <Grid
              item
              xs={12}
               sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                     : pageType === "SUMMARY" ? 3 : 6
              )}
              key={field.id}
            >
              <Box>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Field name={field.name}>
                  {({ field: f, meta }: any) => (
                    <InputField
                      {...f}
                      fullWidth
                      placeholder={field.placeholder || `Enter ${field.label}`}
                      variant="outlined"
                      inputmode="text"
                      disabled={
                        ((isApiLoading || isSummaryLockedStudentName) && !isCollateralHolderNameField) ||
                        isCoApplicantFieldLockedByCoOwner(fetchedApplicationVals, field.name)
                      }
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error ? meta.error : ""}
                      autoComplete="new-password"
                      inputProps={{
                        maxLength: isReferenceNameField
                          ? 25
                          : isCollateralHolderNameField
                            ? 50
                            : isTwentySixCharNameField
                              ? 26
                              : undefined,
                      }}
                      onCopy={isReferenceNameField ? (e) => e.preventDefault() : undefined}
                      onPaste={isReferenceNameField ? (e) => e.preventDefault() : undefined}
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      onInput={(e: any) => {
                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === "string" &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, "");
                        }
                        // Only allow alphabets and spaces
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        );
                        if (isReferenceNameField || isCollateralHolderNameField) {
                          // Auto Title Case as the user types
                          e.target.value = e.target.value.replace(
                            /\w\S*/g,
                            (word: string) =>
                              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                          );
                        }
                        handleFilledFieldsCount(field.name, e.target.value);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          if (formikRef?.current?.values) {
                            dispatch(
                              updateFormData({
                                [field.name]: e.target.value,
                              })
                            );
                          }
                        }
                      }}
                      onBlur={(e: any) => {
                        let value = e.target.value || "";
                        value = value.trim().replace(/\s{2,}/g, " ");
                        e.target.value = value;

                        if (formikRef?.current) {
                          formikRef.current.setFieldValue(field.name, value, true);
                        }

                        handleFilledFieldsCount(field.name, value);

                        if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }}
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }

        // logic for comma separated values
        const isCurrencyFieldName = (fieldName: string): boolean => {
          const keywords = [
            "amount",
            "price",
            "fees",
            "cost",
            "loan",
            "charge",
            "balance",
            "total",
            "expenses",
            "obligation",
            "income",
          ];
          return keywords.some((keyword) =>
            fieldName.toLowerCase().includes(keyword)
          );
        };
        // Collateral Value (e.g. fdCollateralValue/savingCollateralValue/collateral{n}Value)
        // isn't caught by isCurrencyFieldName's keyword list, but still needs Indian comma formatting.
        const isCollateralValueField = /^collateral\d*value$/i.test(field.name);
        // Fund/Expense fields (Course Duration Funds): explicit match since a
        // couple of names (expenseVasExpense, fundOwnSources) don't contain any
        // of isCurrencyFieldName's generic keywords.
        const isFundExpenseCurrencyField = FUND_EXPENSE_CURRENCY_FIELDS.includes(field.name);
        const isFundExpenseConditionalField =
          field.name === FUND_EXPENSE_LOAN_AMOUNT_FIELD ||
          FUND_EXPENSE_CONDITIONAL_FIELDS.includes(field.name);
        const isFundExpenseRequiredNow =
          isFundExpenseConditionalField &&
          isAdmissionStatusConfirmed(formikRef?.current?.values || {});
        if (isCurrencyFieldName(field.name) || isCollateralValueField || isFundExpenseCurrencyField) {
          const formatNumberIndian = (value: string | number) => {
            if (value) {
              const num = Number(value?.toString().replace(/,/g, ""));
              if (isNaN(num)) return value?.toString();

              return new Intl.NumberFormat("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(num);
            }
          };

          const unformatNumber = (formattedValue: string): string => {
            // Allows decimal points but removes all commas
            return formattedValue.replace(/,/g, "");
          };

          const fieldLabel = field.label || field.name;

          return (
            <Grid
              item
              xs={12}
              sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                    : pageType === "SUMMARY" ? (field?.name?.includes("languageTotalMarks") || field?.name?.includes("coreTotalMarks")) ?12 :3 : 6)}
              sx={{ mt: (activeHorizontalIndex === 1 && activeVerticalIndex === 4) && !isXsOrSm ? '2px' : '0px' }}
              key={field.id}
            >
              <Box>
                {/* Label (Standard Form Label) */}
                <label className="text-lable" style={{ display: "block" }}>
                  {fieldLabel}{" "}
                  {(field.required || isFundExpenseRequiredNow) && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                  {field.labelHint && (
                    <span style={{ color: "#6b7280", fontSize: "12px" }}> {field.labelHint}</span>
                  )}
                </label>

                {/* Input Field with Currency Formatting Logic */}
                <Field name={field.name}>
                  {({ field: f, meta }: any) => (
                    <InputField
                      {...f}
                      type="text" // Set the input type to 'text' to allow comma characters to be displayed
                      inputmode="numeric"
                      pattern="[0-9]*"
                      // disabled={isApiLoading}
                      autoComplete="new-password"
                      // Ensure cleared values render as empty string for currency fields
                      value={formatNumberIndian(f.value) ?? ""}
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\D/g, "");
                        let displayValue = e.target.value;
                        let storeValue = unformatNumber(displayValue);

                        // only allow numbers (and single decimal point)
                        if (
                          storeValue === "" ||
                          /^\d*(\.\d*)?$/.test(storeValue)
                        ) {
                          // Enforce max 15 digits before decimal
                          const [intPart, decPart] = storeValue.split(".");
                          let limitedInt = f?.name === "employmentMonthlyObligation" ? intPart.slice(0, 14) : intPart.slice(0, 15);
                          let limitedValue =
                            decPart !== undefined
                              ? `${limitedInt}.${decPart}`
                              : limitedInt;
                          f.onChange({
                            target: {
                              name: f.name,
                              value: limitedValue,
                            },
                          } as React.ChangeEvent<HTMLInputElement>);
                          handleFilledFieldsCount(field.name, limitedValue);
                        }
                      }}
                      fullWidth
                      placeholder={`Enter ${fieldLabel}`}
                      variant="outlined"
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error}
                      InputProps={{
                        maxLength: isFundExpenseCurrencyField ? 255 : 18, // allow for commas and decimal
                      }}
                      disabled={
                        isApiLoading ||
                        field.name?.startsWith("coreTotalMarks") ||
                        field.name?.startsWith("languageTotalMarks") ||
                        Boolean(field?.disabled)
                      }
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }

        let isEmployeeRequiredField = field.name === "employmentCompanyName"
          || field.name === "employmentCompanyAddress1"
          || field.name === "employmentCompanyAddress2"
          || field.name === "employmentCompanyAddress3"
          || field.name === "employmentLandmark"
          || field.name === "employmentCompanyPincode"
          || field.name === "employmentCompanyCity"
          || field.name === "employmentCompanyState"
          || field.name === "employmentCompanyCountry";

        return (
          <Grid
            item
            xs={12}
             sm={smForSummaryEligibility(
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? field?.name?.includes("educationGap") ?12:3
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                  ? 12
                  : pageType === "SUMMARY" ? (field?.name?.includes("languageExamScore") || field?.name?.includes("coreExamScore")) ?12 :3 : 6
            )}
            sx={{ mt: (activeHorizontalIndex === 1 && activeVerticalIndex === 4) && !isXsOrSm ? '2px' : '0px' }}
            key={field.id}
          >
            <Box>
              <label className="text-lable" style={{ display: "block" }}>
                {field.label}{" "}
                {(field.required || isEmployeeRequiredField) && (
                  <span style={{ color: "red" }}>*</span>
                )}
                {field.labelHint && (
                  <span style={{ color: "#6b7280", fontSize: "12px" }}> {field.labelHint}</span>
                )}
              </label>
              <Field name={field.name}>
                {({ field: f, meta }: any) => {
                  const pinOrDerivedLock =
                    handleDisablePermanentPincodeBasedFields(field);
                  const { disabled: _omitFormikDisabled, ...formikFieldInput } =
                    f;
                  return (
                  <InputField
                    {...formikFieldInput}
                    fullWidth
                    type={
                      field?.name.match(/^course\d+Percentage$/) ||
                        field?.name.match(/^coreExamScore(_\d+)?$/) ||
                        field?.name.match(/^languageExamScore(_\d+)?$/)
                        ? "text"
                        : field.type
                    }
                    inputmode="numeric"
                    pattern="[0-9]*"
                    disabled={isApiLoading || pinOrDerivedLock || Boolean(field?.disabled)}
                    autoComplete="new-password"
                    inputProps={{
                      min: 0,
                      maxLength: /^addressReference\d+(AddressLine1|AddressLine2|Locality|Landmark|Area)$/.test(field.name)
                        ? 50
                        : /^collateral\d*(AddressLine1|AddressLine2|Landmark)$/i.test(field.name)
                          ? 50
                          : /^collateral\d*Area$/i.test(field.name)
                            ? 255
                            : undefined,
                    }}
                    onWheel={(e: any) => {
                      // Prevent mouse wheel from changing number input values
                      if (field.type === "number") {
                        e.target.blur();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (
                        field.type === "number" &&
                        ["e", "E", "+", "-"].includes(e.key)
                      ) {
                        e.preventDefault(); // Block scientific notation and sign keys
                      }
                      // Disallow leading space: only allow space after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        if (
                          !target.value ||
                          (target.selectionStart === 0 &&
                            target.selectionEnd === 0)
                        ) {
                          e.preventDefault();
                        }
                      }
                    }}
                    placeholder={
                      field.name.includes('YearsInCurrentAddress')
                        ? "How long have you been living here (in years)"
                        : field.name.includes('YearsInCurrentCity')
                          ? "How long have you lived in this city (in years)"
                          : field.name === 'pincode'
                            ? 'Enter Area Pincode'
                            : field.placeholder || `Enter ${field.label}`
                    }
                    variant="outlined"
                    error={!!meta.touched && !!meta.error}
                    helperText={
                      (field.name === "permanentPincode" ||
                        field.name === "employmentCompanyPincode" ||
                        /^addressCoApplicant\d+permanentPincode$/.test(
                          field.name
                        ) ||
                        /^addressCoApplicant\d+currentPincode$/.test(
                          field.name
                        )) &&
                        zipCodeLoading
                        ? "Validating pincode..."
                        : meta.touched && meta.error
                    }
                    onInput={(e: any) => {
                      if (field?.disabled) return;
                      if (field.name === "totalCost") {
                        // Use setTimeout to ensure Formik has the latest value of totalCost before validating the dependent field
                        setTimeout(() => {
                          formikRef.current?.validateField("loanAmount");
                        }, 0);
                      }

                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }

                      // Reference address lines: strip characters outside the allowed whitelist
                      if (/^addressReference\d+(AddressLine1|AddressLine2|Locality|Landmark|Area)$/.test(field.name)) {
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9.><,\/!@#$%&()\[\]{} -]/g, "");
                      }

                      // Collateral (property mode) address lines: same whitelist filter
                      if (/^collateral\d*(AddressLine1|AddressLine2|Landmark|Area)$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9.><,\/!@#$%&()\[\]{} -]/g, "");
                      }

                      // FD Number: integers only
                      if (/^collateral\d*FdNumber$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }

                      // No of Units: standard numbers only
                      if (/^collateral\d*NoOfUnits$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }

                      // Account Number: strip commas/formatting characters, digits only
                      if (/^collateral\d*AccountNumber$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }

                      if (field.type === "number") {
                        const sanitized = e.target.value.replace(
                          /[eE+\-]/g,
                          ""
                        );
                        if (sanitized !== e.target.value) {
                          e.target.value = sanitized; // Strip unsupported characters from pasted input
                        }
                      }
                      // Only enforce 6-digit numeric for fields containing 'pincode'
                      if (field.name.toLowerCase().includes("pincode")) {
                        e.target.value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 6);
                      }

                      // Restrict employmentMonth to numeric input only and max 2 digits
                      if (
                        field.name.toLowerCase().includes("employmentmonth")
                      ) {
                        let monthValue = e.target.value.replace(/\D/g, "");
                        // Limit to 2 digits
                        e.target.value = monthValue.slice(0, 2);
                      }

                      let value = e.target.value;

                      if (
                        field.name.match(/^course\d+Percentage$/) ||
                        field.name.match(/^coreExamScore(_\d+)?$/) ||
                        field?.name.match(/^languageExamScore(_\d+)?$/)
                      ) {
                        let v = e.target.value;
                        v = v.replace(/^0/, "");
                        // remove + - e E
                        v = v.replace(/[eE+\-]/g, "");
                        v = v.replace(/[^0-9.]/g, "");
                        // remove commas
                        v = v.replace(/,/g, "");

                        // split by dot
                        const parts = v.split(".");

                        if (parts.length === 1) {
                          // only integers, no dot
                          v = parts[0];
                        } else if (parts.length === 2) {
                          const [i, d] = parts;

                          // ✔ allow trailing dot (like "99.")
                          if (d === "") {
                            v = i + ".";
                          } else {
                            // ✔ allow max 2 decimals
                            v = i + "." + d.slice(0, 2);
                          }
                        } else {
                          // more than one dot → keep only first two parts
                          v = parts[0] + "." + parts[1].slice(0, 2);
                        }

                        e.target.value = v;
                        // Clear error immediately when exam score field has a value
                        if (
                          v &&
                          (field.name.match(/^coreExamScore(_\d+)?$/) ||
                            field.name.match(/^languageExamScore(_\d+)?$/))
                        ) {
                          formikRef.current?.setFieldError(field.name, undefined);
                        }
                      }

                      // If user tries to enter more than 6 digits, do not call any API handlers
                      if (field.name.toLowerCase().includes("pincode")) {
                        if (value.length > 6) {
                          return;
                        }
                      }

                      // For main applicant permanent pincode
                      if (field.name === "permanentPincode") {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "permanent");
                        }
                      }
                      // For main applicant current pincode
                      else if (field.name === "currentPincode") {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "current");
                        }
                        // Do not update permanentPincode when currentPincode changes
                      }
                      // For co-applicant permanent pincode
                      else if (
                        /^addressCoApplicant\d+permanentPincode$/.test(
                          field.name
                        )
                      ) {
                        const match = field.name.match(
                          /^addressCoApplicant(\d+)permanentPincode$/
                        );
                        const coAppNum = match ? match[1] : undefined;
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, coAppNum, "permanent");
                        }
                      }
                      // For co-applicant current pincode
                      else if (
                        /^addressCoApplicant\d+currentPincode$/.test(field.name)
                      ) {
                        const match = field.name.match(
                          /^addressCoApplicant(\d+)currentPincode$/
                        );
                        const coAppNum = match ? match[1] : undefined;
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, coAppNum, "current");
                        }
                        // Only update permanent pincode if the 'same as' checkbox is checked
                        // if (coAppNum) {
                        //   const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
                        //   const isSameAs =
                        //     formikRef?.current?.values?.[sameAsKey];
                        //   if (isSameAs) {
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentPincode`,
                        //       value,
                        //       false
                        //     );
                        //     // Also clear city, state, and country when pincode changes
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentCity`,
                        //       "",
                        //       false
                        //     );
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentState`,
                        //       "",
                        //       false
                        //     );
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentCountry`,
                        //       "",
                        //       false
                        //     );
                        //   }
                        // }
                      }
                      // For co-applicant employment/company pincode
                      else if (
                        /^employmentCoApplicant\d+pincode$/.test(field.name)
                      ) {
                        const match = field.name.match(
                          /^employmentCoApplicant(\d+)pincode$/
                        );
                        const coAppNum = match ? match[1] : undefined;
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, coAppNum, "company");
                        }
                        // Only update permanent pincode if the 'same as' checkbox is checked
                        // if (coAppNum) {
                        //   const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
                        //   const isSameAs =
                        //     formikRef?.current?.values?.[sameAsKey];
                        //   if (isSameAs) {
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentPincode`,
                        //       value,
                        //       false
                        //     );
                        //     // Also clear city, state, and country when pincode changes
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentCity`,
                        //       "",
                        //       false
                        //     );
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentState`,
                        //       "",
                        //       false
                        //     );
                        //     formikRef?.current?.setFieldValue(
                        //       `addressCoApplicant${coAppNum}permanentCountry`,
                        //       "",
                        //       false
                        //     );
                        //   }
                        // }
                      }
                      // For reference address pincodes
                      else if (/^addressReference1Pincode$/.test(field.name)) {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "reference1");
                        }
                      }
                      // For collateral property pincodes
                      else if (
                        /^collateral/i.test(field.name) &&
                        /pincode/i.test(field.name) &&
                        !/^coOwnerCollateral/i.test(field.name)
                      ) {
                        const normalized = String(field.name || "")
                          .toLowerCase()
                          .replace(/[^a-z0-9]/g, "");
                        const match = normalized.match(/^collateral(\d+)/);
                        const collateralNum = match?.[1] || "1";
                        if (value && value.length === 6) {
                          handleInvokZipCode(
                            value,
                            undefined,
                            `collateral${collateralNum}`,
                          );
                        }
                      } else if (/^addressReference2Pincode$/.test(field.name)) {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "reference2");
                        }
                      }
                      if (field.name === "employmentCompanyPincode") {
                        handleInvokCompanyZipCode(value);
                      }
                      handleFilledFieldsCount(field.name, value);

                      // Check and uncheck address checkbox if address fields change
                      if (
                        /^(permanent|current)(AddressLine1|AddressLine2|AddressLine3|Pincode|City|State|Country|OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity)$/.test(field.name) ||
                        /^addressCoApplicant\d+(permanent|current)(AddressLine1|AddressLine2|AddressLine3|Pincode|City|State|Country|OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity)$/.test(field.name)
                      ) {
                        // Use setTimeout to ensure the value is set in formik before checking
                        setTimeout(() => {
                          checkAndUncheckAddressCheckbox();
                        }, 0);
                      }

                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }
                      // setting empty data on input changes
                      if (field.name === "fatherName" || field.name === "motherName") {
                        dispatch(
                          setVerificationMessage({
                            index: "",
                            applicantType: "",
                            field: "",
                            status: "",
                            message: "",
                          })
                        );
                      }
                    }}
                    InputProps={{
                      readOnly: pinOrDerivedLock,
                      endAdornment:
                        (field.name === "permanentPincode" ||
                          field.name === "employmentCompanyPincode" ||
                          /^addressCoApplicant\d+permanentPincode$/.test(
                            field.name
                          ) ||
                          /^addressCoApplicant\d+currentPincode$/.test(
                            field.name
                          )) &&
                          zipCodeLoading ? (
                          <CircularProgress size={20} />
                        ) : undefined,
                    }}
                  />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "phone":
        // Co-applicant phone field check
        const isReferencePhoneField = /^(refBasic\d+|basicReference\d+)(Mobile|PhoneNumber)$/i.test(
          field.name,
        );
        const isCollateralPhoneField = /^(coOwnerCollateral[\d_]*PhoneNumber|collateral\d*PhoneNumber)$/i.test(
          field.name,
        );
        // Reject fraud-pattern numbers (all-repeated-digit) and require first digit 6-9.
        const REFERENCE_MOBILE_FRAUD_REGEX = /^(?!.*^(.)\1+$)[6-9]\d{9}$/;
        const referenceMobileValueForCheck = String(
          formikRef.current?.values[field.name] || "",
        );
        const isReferenceMobileInvalid =
          isReferencePhoneField &&
          referenceMobileValueForCheck.length === 10 &&
          !REFERENCE_MOBILE_FRAUD_REGEX.test(referenceMobileValueForCheck);
        const coApplicantPhoneMatch = field.name.match(
          /^basicCoApplicant(\d+)PhoneNumber$/
        );
        let isMobileVerifiedField = false;
        let lastVerifiedMobile = "";
        if (coApplicantPhoneMatch) {
          const idx = String(Number(coApplicantPhoneMatch[1]) - 1); // 0-based index
          const formikMobileVerified =
            formikRef.current?.values[
            `basicCoApplicant${Number(idx) + 1}IsMobileVerified`
            ];
          const reduxMobileVerified =
            coApplicantVerification[idx]?.mobileVerified;
          const lastMobile =
            coApplicantVerification[idx]?.lastVerifiedMobileNumber ||
            formikRef.current?.values[field.name];
          isMobileVerifiedField =
            (formikMobileVerified || reduxMobileVerified) &&
            formikRef.current?.values[field.name] === lastMobile;
          lastVerifiedMobile = lastMobile;
        } else {
          const applicantMobileVerifiedFlag =
            isMobileVerified === true ||
            isMobileVerified === "true" ||
            formData?.isMobileVerified === true ||
            formData?.isMobileVerified === "true" ||
            formikRef.current?.values?.isMobileVerified === true ||
            formikRef.current?.values?.isMobileVerified === "true";
          const hasLastVerifiedMobile = Boolean(lastVerifiedPhoneNumber);
          const currentMobileValue = formikRef.current?.values[field.name];
          isMobileVerifiedField =
            applicantMobileVerifiedFlag &&
            (
              !hasLastVerifiedMobile ||
              currentMobileValue === lastVerifiedPhoneNumber ||
              pageType === "SUMMARY"
            );
          lastVerifiedMobile = lastVerifiedPhoneNumber;
        }

        // Get all phone field names
        const allPhoneFields = Object.keys(formikRef.current?.values || {}).filter(
          (key) =>
            key === "phone_number" ||
            key.match(/^basicCoApplicant\d+PhoneNumber$/) ||
            key.match(/^coOwnerCollateral\d+(?:_\d+)?PhoneNumber$/)
        );

        const currentPhoneValue = formikRef.current?.values[field.name];

        const duplicatePhone = allPhoneFields
          // 1. Don't compare a field with itself
          .filter((key) => key !== field.name)
          // 2. Filter out allowed skips and exceptions
          .filter((key) => {
            // Check if either the current field OR the comparison field belongs to Collateral
            // (co-owner or base collateral phone fields)
            const isComparisonFieldCollateral = /^(coOwnerCollateral[\d_]*PhoneNumber|collateral\d*PhoneNumber)$/i.test(key);

            // ✅ RULE 1: If either field belongs to Collateral, skip the duplicate check entirely
            if (isCollateralPhoneField || isComparisonFieldCollateral) {
              return false;
            }

            // RULE 2: "phone_number" and "studentDetailsPhone_number" are allowed to match each other
            const isMainAndStudentMatch = 
              (field.name === "phone_number" && key === "studentDetailsPhone_number") ||
              (field.name === "studentDetailsPhone_number" && key === "phone_number");

            if (isMainAndStudentMatch) {
              return false; 
            }

            return true; // Run the duplicate check for any remaining fields (e.g., basicCoApplicants)
          })
          // 3. Extract values and check if the current value matches any remaining field value
          .map((key) => formikRef.current?.values[key])
          .includes(currentPhoneValue);
        return (
          <Grid
            item
            xs={12}
             sm={smForSummaryEligibility(
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                  ? 12
                  : pageType === "SUMMARY" ? 3 : 6
            )}
            key={field.id}
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                {/* {field.label && /(mobile|phone|contact)/i.test(field.label) ? (
                  <Tooltip
                    title={MobileNumberTooltipContent}
                    placement="top-start"
                    arrow
                  >
                    <IconButtonMui
                      size="small"
                      sx={{
                        ml: "5px",
                        padding: 0,
                        "&:hover": {
                          background: "transparent",
                        },
                      }}
                      aria-label="Salesperson contact details"
                    >
                      <InfoOutlinedIcon
                        sx={{
                          fontSize: "14px",
                          color: "#a5a3ae",
                          cursor: "pointer",
                        }}
                      />
                    </IconButtonMui>
                  </Tooltip>
                ) : (
                  <></>
                )} */}
              </Box>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    // type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder={
                      field.placeholder ||
                        isXsOrSm ? "Enter Aadhaar Linked Mobile Number..." : "Enter Aadhaar Linked Mobile Number and Verify"
                    }
                    variant="outlined"
                    error={
                      (!!meta.touched && !!meta.error) ||
                      (duplicatePhone && !!currentPhoneValue) ||
                      isReferenceMobileInvalid
                    }
                    helperText={
                      meta.touched && meta.error
                        ? meta.error
                        : 
                        duplicatePhone && !!currentPhoneValue
                          ? isReferencePhoneField
                            ? "This mobile number has already been used in this application. Please enter a different mobile number for this reference."
                            : "This mobile number is already used in another field."
                          : isReferenceMobileInvalid
                            ? "Enter a valid 10-digit mobile number."
                            : ""
                    }
                    autoComplete="new-password"
                    disabled={/^coOwnerCollateral[\d_]*PhoneNumber$/i.test(field.name) ||
                       isCoApplicantFieldLockedByCoOwner(fetchedApplicationVals, field.name) ||
                      (!!coApplicantPhoneMatch && isMobileVerifiedField)
                    }
                    // disabled={
                    //   isApiLoading ||
                    //   (isAuthenticated &&
                    //     ((activeHorizontalIndex === 1 &&
                    //       activeVerticalIndex === 0) ||
                    //       (activeHorizontalIndex === 0 &&
                    //         activeVerticalIndex === 0 &&
                    //         !!f.value &&
                    //         (formData?.isMobileVerified ||
                    //           formikRef?.current?.values?.isMobileVerified))))
                    // }
                    onKeyDown={(e) => {
                      // Block leading space: allow spaces only after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        const start = target.selectionStart ?? 0;
                        if (start === 0) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      f.onChange(e);

                      const rawValue = e.target.value;
                      const numericValue = rawValue.replace(/\D/g, "");

                      const isValidMobile = numericValue.length === 10;

                      // Always reset verification if not a valid 10-digit number
                      if (
                        !isValidMobile ||
                        numericValue !== lastVerifiedMobile
                      ) {
                        if (coApplicantPhoneMatch) {
                          const idx = String(
                            Number(coApplicantPhoneMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: { mobileVerified: false },
                            })
                          );
                        } else {
                          dispatch(setIsMobileVerified(false));
                        }
                      }

                      // Only set verified = true when it exactly matches last verified number
                      if (
                        isValidMobile &&
                        numericValue === lastVerifiedMobile
                      ) {
                        if (coApplicantPhoneMatch) {
                          const idx = String(
                            Number(coApplicantPhoneMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: { mobileVerified: true },
                            })
                          );
                        } else {
                          dispatch(setIsMobileVerified(true));
                        }
                      }
                    }}
                    onInput={(e: any) => {
                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                      handleFilledFieldsCount(field.name, e.target.value);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: e.target.value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: e.target.value,
                            })
                          );
                        }
                      }
                    }}
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                      readOnly: isApiLoading || (
                        isAuthenticated && (
                          (activeHorizontalIndex === 1 && activeVerticalIndex === 0) ||
                          (activeHorizontalIndex === 0 && activeVerticalIndex === 0 && !!f.value && (formData?.isMobileVerified || formikRef?.current?.values?.isMobileVerified)
                          )
                        )
                      ),
                      autoComplete: "off",
                      endAdornment: coApplicantPhoneMatch || isReferencePhoneField || isCollateralPhoneField ? undefined : (
                        <Button
                          onClick={isApiLoading || (
                            isAuthenticated && (
                              (activeHorizontalIndex === 1 && activeVerticalIndex === 0 && ((formData?.isMobileVerified === "true" || formData?.isMobileVerified === true) || (formikRef?.current?.values?.isMobileVerified === "true" || formikRef?.current?.values?.isMobileVerified === true))) ||
                              (activeHorizontalIndex === 0 && activeVerticalIndex === 0 && !!f.value && ((formData?.isMobileVerified === "true" || formData?.isMobileVerified === true) || (formikRef?.current?.values?.isMobileVerified === "true" || formikRef?.current?.values?.isMobileVerified === true))
                              )
                            )
                          ) ? undefined : async () => {
                            if (
                              isMobileVerifiedField ||
                              duplicatePhone ||
                              !currentPhoneValue
                            )
                              return;
                            try {
                              let name = `${form?.values?.studentDetailsFirstName || form?.values?.firstName || ""} ${form?.values?.studentDetailsLastName || form?.values?.lastName || ""}`.trim();
                              // applicant name
                              const mobileNumber = form.values[field.name];
                              setOtpMobileNumber(mobileNumber);
                              setOtpMobileFieldName(field.name);

                              const coApplicantPhoneMatch = field.name.match(
                                /^basicCoApplicant(\d+)PhoneNumber$/
                              );
                              if (coApplicantPhoneMatch) {
                                dispatch(
                                  setCurrentCoApplicantIdx(
                                    String(Number(coApplicantPhoneMatch[1]) - 1)
                                  )
                                );

                                // this will only work for coapplicant
                                const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantPhoneMatch[1]))}FirstName`;
                                if (form.values[dynamicNameKey]) {
                                  name = form.values[dynamicNameKey];   // co-applicant name
                                }
                              } else {
                                dispatch(setCurrentCoApplicantIdx(null));
                              }

                              const resp =
                                await eligibilityCheckServices.sendOtp({
                                  name,
                                  mobileNumber,
                                });

                              // trackCustomerJourneyEvent(
                              //   `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //   decrypt(userProfile?.id) ?? "",
                              //   trackingId,
                              //   {
                              //       label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //     category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //     action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //     page: `ProvisionalOff_Loan Details_COAPP(${String(Number(coApplicantPhoneMatch[1]))}) Mobile Verification`,
                              //   }
                              // );

                              if (resp?.data?.status === "fail") {
                                dispatch(
                                  setStatusPopup({
                                    status: "error",
                                    message: resp.data.message,
                                  })
                                );
                                return;
                              }
                              setOtpKey(resp.data.data.value);
                              setOtpTime(resp.data.data.otpTime);
                              setOpenOtpModal(true);
                            } catch (err: any) {
                              const apiMsg =
                                err?.response?.data?.errors?.[0]?.constraints
                                  ?.matches;
                              dispatch(
                                setStatusPopup({
                                  status: "info",
                                  message: apiMsg,
                                })
                              );
                            }
                          }}
                          disabled={duplicatePhone || !currentPhoneValue}
                          sx={{
                            backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                            color: isMobileVerifiedField ? "#28C76F" : "#000000",
                            "&:hover": {
                              backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                              color: isMobileVerifiedField ? "#28C76F" : "#000000",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                              color: isMobileVerifiedField ? "#28C76F" : "#000000",
                              WebkitTextFillColor: isMobileVerifiedField ? "#28C76F" : "#000000",
                              opacity: 1,
                            },
                            "& img": {
                              opacity: 1,
                              filter: "brightness(1)",
                            },
                            textTransform: "none",
                            fontSize: isMobileVerifiedField ? "16px" : "10px",
                            fontWeight: isMobileVerifiedField ? 400 : 700,
                            px: "15px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "none",
                            height: '100%',
                            mr: 0.5,
                          }}
                        >
                          {isMobileVerifiedField   ? (
                            <>
                              <img
                                src={greenCheckVerified}
                                alt="Verified"
                                style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                              />
                              <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="inherit">Verify</Typography>
                              <img
                                src={arrowRightVerify}
                                alt="Verified"
                                style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                              />
                            </>
                          )}
                        </Button>
                      ),
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "email":
        // Co-applicant email field check
        const isReferenceEmailField = /^(refBasic\d+|basicReference\d+)(EmailId|Email)$/i.test(
          field.name,
        );
        const isCollateralEmailField = /^(coOwnerCollateral[\d_]*Email|collateral\d*Email)$/i.test(
          field.name,
        );
        const coApplicantEmailMatch = field.name.match(
          /^basicCoApplicant(\d+)Email$/
        );
        const isApplicantStudentEmailField =
          field.name === "email" || field.name === "studentDetailEmail";
        /** Applicant email is not editable on Eligibility consent (0,0) or Student Details (1,0). */
        const disableApplicantEmailField =
          isApplicantStudentEmailField &&
          ((activeHorizontalIndex === 0 && activeVerticalIndex === 0) ||
            (activeHorizontalIndex === 1 && activeVerticalIndex === 0));
        const applicantDisplayEmailNorm = isApplicantStudentEmailField
          ? String(
              formikRef.current?.values?.studentDetailEmail ||
                formikRef.current?.values?.email ||
                ""
            )
              .trim()
              .toLowerCase()
          : "";
        const applicantLastEmailNorm = String(lastVerifiedEmail || "")
          .trim()
          .toLowerCase();
        const applicantEmailVerifiedFlags =
          isTruthyFormFlag(isEmailVerified) ||
          isTruthyFormFlag(formData?.isEmailVerified) ||
          isTruthyFormFlag(formikRef.current?.values?.isEmailVerified) ||
          isTruthyFormFlag((formData as any)?.emailAddressVerifiedFlag);
        const applicantEmailVerifiedFlag = Boolean(
          isApplicantStudentEmailField &&
            !!applicantDisplayEmailNorm &&
            !!applicantLastEmailNorm &&
            applicantDisplayEmailNorm === applicantLastEmailNorm &&
            applicantEmailVerifiedFlags
        );
        let isVerified = false;
        let lastVerified = "";
        let isCoApplicantEmailLocked = false;
        if (coApplicantEmailMatch) {
          const idx = String(Number(coApplicantEmailMatch[1]) - 1); // 0-based index
          const formikEmailVerified = isTruthyFormFlag(
            formikRef.current?.values[
              `basicCoApplicant${Number(idx) + 1}IsEmailVerified`
            ]
          );
          const reduxEmailVerified = isTruthyFormFlag(
            coApplicantVerification[idx]?.emailVerified
          );
          const lastEmail = coApplicantVerification[idx]?.lastVerifiedEmail || "";
          isVerified =
            !!lastEmail &&
            (formikEmailVerified || reduxEmailVerified) &&
            String(formikRef.current?.values[field.name] || "").trim().toLowerCase() ===
              String(lastEmail || "").trim().toLowerCase();
          lastVerified = lastEmail;
          const lockComparisonEmail =
            lastEmail || formikRef.current?.values?.[field.name] || "";
          // An empty email can never be verified — keep it editable
          isCoApplicantEmailLocked =
            !!String(formikRef.current?.values?.[field.name] || "").trim() &&
            (formikEmailVerified || reduxEmailVerified) &&
            String(formikRef.current?.values?.[field.name] || "")
              .trim()
              .toLowerCase() ===
              String(lockComparisonEmail || "").trim().toLowerCase();
        } else {
          isVerified = applicantEmailVerifiedFlag;
          lastVerified = lastVerifiedEmail || "";
        }

        // Check duplicate email only between applicant and co-applicant 1
        const currentEmailValue = formikRef.current?.values[field.name];
        // No OTP for an invalid email (e.g. containing + or -)
        const isCurrentEmailInvalid = !isValidJourneyEmail(currentEmailValue);
        const normalizedCurrentEmail = String(currentEmailValue || "")
          .trim()
          .toLowerCase();
        const normalizeEmail = (value: any) =>
          String(value || "")
            .trim()
            .toLowerCase();
        const applicantEmail = normalizeEmail(formikRef.current?.values?.email);
        const coApplicant1Email = normalizeEmail(
          formikRef.current?.values?.basicCoApplicant1Email
        );
        const isApplicantOrCoApplicant1 =
          field.name === "email" || field.name === "basicCoApplicant1Email";
        const isCoApplicant2Onward = /^basicCoApplicant([2-9]\d*)Email$/.test(
          field.name
        );

        let duplicateEmail = false;
        if (!!normalizedCurrentEmail) {
          if (isApplicantOrCoApplicant1) {
            duplicateEmail =
              normalizedCurrentEmail ===
              normalizeEmail(
                formikRef.current?.values[
                field.name === "email" ? "basicCoApplicant1Email" : "email"
                ]
              );
          } else if (isCoApplicant2Onward) {
            duplicateEmail =
              normalizedCurrentEmail === applicantEmail ||
              normalizedCurrentEmail === coApplicant1Email;
          }
        }

        return (
          <Grid
            item
            xs={12}
             sm={smForSummaryEligibility(
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                  ? 12
                  : pageType === "SUMMARY" ? 3 : 6
            )}
            key={field.id}
          >
            <Box>
              <label className="text-lable" style={{ display: "block" }}>
                {field.label}{" "}
                {field.required && (
                  <span style={{ color: "red" }}>*</span>
                )}
              </label>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    placeholder={
                      field.placeholder || "Enter Email ID and verify"
                    }
                    variant="outlined"
                    inputmode="text"
                    error={
                      ((!!f.value || !!meta.touched) && !!meta.error) ||
                      (duplicateEmail && !!currentEmailValue)
                    }
                    helperText={
                      ((!!f.value || !!meta.touched) && meta.error)
                        ? meta.error
                        : duplicateEmail && !!currentEmailValue
                          ? "This email is already used in another field."
                          : ""
                    }
                    autoComplete="new-password"
                    disabled={isCoApplicantEmailLocked}
                    onKeyDown={(e) => {
                      if (disableApplicantEmailField) {
                        e.preventDefault();
                        return;
                      }
                      // Block leading space: allow spaces only after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        const start = target.selectionStart ?? 0;
                        if (start === 0) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      if (disableApplicantEmailField) {
                        return;
                      }
                      const inputValue = e.target.value;

                      // Keep Formik values in sync between applicant email fields
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        form.setFieldValue("email", inputValue, false);
                        form.setFieldValue("studentDetailEmail", inputValue, false);
                      } else {
                        f.onChange(e);
                      }

                      // Keep Redux formData in sync with latest typed email
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        dispatch(
                          updateFormData({
                            email: inputValue,
                            studentDetailEmail: inputValue,
                          })
                        );
                      } else {
                        dispatch(
                          updateFormData({
                            [field.name]: inputValue,
                          })
                        );
                      }

                      const normalizedInputEmail = String(inputValue || "")
                        .trim()
                        .toLowerCase();
                      const normalizedLastVerifiedEmail = String(lastVerified || "")
                        .trim()
                        .toLowerCase();

                      // Reset verification if value changes (an empty value is never verified)
                      if (
                        normalizedInputEmail !== normalizedLastVerifiedEmail ||
                        !normalizedInputEmail
                      ) {
                        if (coApplicantEmailMatch) {
                          const idx = String(
                            Number(coApplicantEmailMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: {
                                emailVerified: false,
                              },
                            })
                          );
                        } else {
                          dispatch(setIsEmailVerified(false));
                        }
                      } else {
                        if (coApplicantEmailMatch) {
                          const idx = String(
                            Number(coApplicantEmailMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: {
                                emailVerified: true,
                              },
                            })
                          );
                        } else {
                          dispatch(
                            setIsEmailVerified(
                              normalizedInputEmail === normalizedLastVerifiedEmail &&
                                normalizedInputEmail !== "" &&
                                isEmailVerified == true
                            )
                          );
                        }
                      }
                    }}
                    onInput={(e: any) => {
                      if (disableApplicantEmailField) {
                        return;
                      }
                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        dispatch(
                          updateFormData({
                            email: e.target.value,
                            studentDetailEmail: e.target.value,
                          })
                        );
                      }
                      handleFilledFieldsCount(field.name, e.target.value);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: e.target.value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: e.target.value,
                            })
                          );
                        }
                      }
                    }}
                    // disabled={
                    //   isApiLoading ||
                    //   (isAuthenticated &&
                    //     ((activeHorizontalIndex === 1 &&
                    //       activeVerticalIndex === 0) ||
                    //       (activeHorizontalIndex === 0 &&
                    //         activeVerticalIndex === 0 &&
                    //         !!f.value &&
                    //         (formData?.isEmailVerified ||
                    //           formikRef?.current?.values?.isEmailVerified))))
                    // }
                    inputProps={{ autoComplete: "off", maxLength: 40 }}
                    InputProps={{
                      readOnly:
                        disableApplicantEmailField ||
                        isApiLoading ||
                        ((field.name === "email" || field.name === "studentDetailEmail") && applicantEmailVerifiedFlag) ||
                        isCoApplicantEmailLocked,
                      endAdornment: (
                        coApplicantEmailMatch || isReferenceEmailField || isCollateralEmailField
                          ? null
                          : disableApplicantEmailField ? (
                            <InputAdornment position="end">
                              {isVerified ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    color: "#28c76f",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    mr: 0.5,
                                  }}
                                >
                                  <img
                                    src={greenCheckVerified}
                                    alt="Verified"
                                    style={{
                                      width: 14,
                                      height: 14,
                                      objectFit: "contain",
                                      imageRendering: "-webkit-optimize-contrast",
                                    }}
                                  />
                                  Verified
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mr: 0.5,
                                    px: 1,
                                    py: 0.35,
                                    borderRadius: "4px",
                                    bgcolor: "rgba(255, 159, 67, 0.14)",
                                    border: "1px solid rgba(255, 159, 67, 0.45)",
                                  }}
                                >
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#ff9f43",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    Not Verified
                                  </Typography>
                                </Box>
                              )}
                            </InputAdornment>
                          ) : (
                            <Button
                              sx={{
                                backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                color: isVerified ? "#28C76F" : "#000000",
                                "&:hover": {
                                  backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                  color: isVerified ? "#28C76F" : "#000000",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                  color: isVerified ? "#28C76F" : "#000000",
                                  WebkitTextFillColor: isVerified ? "#28C76F" : "#000000",
                                  opacity: 1,
                                },
                                "& img": {
                                  opacity: 1,
                                  filter: "brightness(1)",
                                },
                                textTransform: "none",
                                fontSize: isVerified ? "16px" : "10px",
                                fontWeight: isVerified ? 400 : 700,
                                px: "15px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "none",
                                height: "100%",
                                mr: 0.5,
                              }}
                              onClick={isApiLoading ? undefined : async () => {
                                if (
                                  isVerified ||
                                  duplicateEmail ||
                                  !currentEmailValue ||
                                  isCurrentEmailInvalid
                                )
                                  return;
                                try {
                                  let name = `${form?.values?.studentDetailsFirstName || form?.values?.firstName || ""} ${form?.values?.studentDetailsLastName || form?.values?.lastName || ""}`.trim();

                                  const email = form.values[field.name];
                                  setOtpEmail(email);
                                  setOtpEmailFieldName(field.name);

                                  const coApplicantEmailMatch = field.name.match(
                                    /^basicCoApplicant(\d+)Email$/
                                  );
                                  if (coApplicantEmailMatch) {
                                    dispatch(
                                      setCurrentCoApplicantIdx(
                                        String(Number(coApplicantEmailMatch[1]) - 1)
                                      )
                                    );

                                    // this will only work for coapplicant
                                    const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantEmailMatch[1]))}FirstName`;
                                    if (form.values[dynamicNameKey]) {
                                      name = form.values[dynamicNameKey];   // co-applicant name
                                    }
                                  } else {
                                    dispatch(setCurrentCoApplicantIdx(null));
                                  }

                                  const resp =
                                    await eligibilityCheckServices.sendOtp({
                                      name,
                                      email: email.toLowerCase(),
                                    });
                                  if (resp?.data?.status === "fail") {
                                    dispatch(
                                      setStatusPopup({
                                        status: "error",
                                        message: resp.data.message,
                                      })
                                    );
                                    return;
                                  }
                                  setOtpEmailKey(resp.data.data.value);
                                  setOtpEmailTime(resp.data.data.otpTime);
                                  setOpenEmailOtp(true);
                                } catch (err: any) {
                                  const apiMsg =
                                    err?.response?.data?.errors?.[0]?.constraints
                                      ?.isEmail;
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message: apiMsg,
                                    })
                                  );
                                }
                              }}
                              disabled={isVerified || duplicateEmail || !currentEmailValue || isCurrentEmailInvalid}
                            >
                              {isVerified ? (
                                <>
                                  <img
                                    src={greenCheckVerified}
                                    alt="Verified"
                                    style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                  />
                                  <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                </>
                              ) : (
                                <>
                                  <Typography variant="inherit">Verify</Typography>
                                  <img
                                    src={arrowRightVerify}
                                    alt="Verified"
                                    style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                  />
                                </>
                              )}
                            </Button>
                          )
                      ),
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "dropdown":
        if (field.name === "product") {
          return (
            <Grid
              item
              xs={12}
                sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3 ? 4 : pageType === "SUMMARY" ? 3 : 6
    )}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    useEffect(() => {
                      if (!f.value && productOptions.length > 0 && !loadingProducts) {
                        const defaultValue = productOptions[0].value;
                        form.setFieldValue(field.name, defaultValue);
                        dispatch(setSelectedProduct(defaultValue));
                        handleFilledFieldsCount(field.name, defaultValue);
                      }
                    }, [productOptions, loadingProducts, f.value]);

                    return (
                      <SelectOptions
                        label={field.label}
                        value={f.value}
                        onChange={(value: any) => {
                          form.setFieldValue(field.name, value);
                          dispatch(setSelectedProduct(value));
                          handleFilledFieldsCount(field.name, value);
                        }}
                        options={productOptions}
                        placeholder={field.label}
                        isMandatory={field.required || false}
                        disabled={loadingProducts || pageType === "SUMMARY"}
                        error={!!(form.touched[field.name] && form.errors[field.name])}
                        helperText={
                          form.touched[field.name] && form.errors[field.name]
                            ? String(form.errors[field.name])
                            : ""
                        }
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }

        if (field.name === "courseCategory") {
          return (
            <Grid
              item
              xs={12}
                sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3 ? 4 : pageType === "SUMMARY" ? 3 : 6
              )}              
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    const options = getDropdownOptions(field);

                    useEffect(() => {
                      // Only set default if value is empty and options are available
                      if (!f.value && options.length > 0 && !loadingProducts) {
                        const defaultValue = options[0].value;
                        form.setFieldValue(field.name, defaultValue);

                        // Ensure Redux and trackers are updated on initial mount
                        dispatch(updateFormData({ [field.name]: defaultValue }));
                        handleFilledFieldsCount(field.name, defaultValue);
                      }
                    }, [options, loadingProducts, f.value]);

                    // Normalize value: extract .value if it's an object, otherwise use as-is
                    const normalizedValue =
                      (typeof f.value === "object" && f.value !== null && "value" in f.value)
                        ? f.value.value
                        : f.value;

                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          // Normalize incoming value for storage
                          const valToStore = (typeof value === "object" && value !== null && "value" in value)
                            ? value.value
                            : value;

                          form.setFieldValue(field.name, valToStore);

                          // Standard handlers
                          handleDropdownChange(field.name, value, form);
                          handleFilledFieldsCount(field.name, valToStore);

                          // Persist to Redux for refresh survival
                          dispatch(
                            updateFormData({
                              [field.name]: valToStore,
                            })
                          );
                        }}
                        options={options}
                        placeholder={`Select ${field.label}`}
                        isMandatory={field.required || false}
                        disabled={loadingProducts}
                        error={!!(form.touched[field.name] && form.errors[field.name])}
                        helperText={
                          form.touched[field.name] && form.errors[field.name]
                            ? String(form.errors[field.name])
                            : ""
                        }
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }

        return (
          <>
            <Grid
              item
              xs={12}
                sm={smForSummaryEligibility(
                (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
                  (activeHorizontalIndex === 1 && activeVerticalIndex === 4) ||
                  ((activeHorizontalIndex === 1 &&
                    activeVerticalIndex === 3 &&
                    !isAcademicDetailsCourseField))
                  ? 12
                  : isAcademicDetailsCourseField
                    ? 3
                    : pageType === "SUMMARY"
                      ? 3
                      : 6
              )}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    let options = getDropdownOptions(field);

                    // Restrict duplicate course types
                    const keyItem: any = field.name.match(
                      /^basicCoApplicant(\d+)RelationWithStudent$/
                    );

                    if (field.name.includes(keyItem?.[0])) {
                      options = relationshipOptions;
                    }
                    // Populate applicant + co-applicant names for coOwnerCollateral Name fields
                    if (isCoOwnerCollateralNameField(field.name)) {
                      options = getCoOwnerNameAutocompleteOptions(
                        form.values || {},
                        field.name,
                        f.value,
                      );
                    }
                    // Filter out "Student" option from employmentType
                    if (field.name === "employmentType") {
                      options = options.filter(
                        (opt: any) => opt.value !== "Student"
                      );
                    }

                    if (
                      field.name.includes("course") &&
                      field.name.includes("Type")
                    ) {
                      // Derive selectedCourseTypes from form.values
                      const selectedCourseTypes = Object.keys(form.values)
                        .filter(
                          (key) => key.includes("course") && key.includes("Type")
                        )
                        .map((key) => form.values[key]?.value || form.values[key])
                        .filter(Boolean);

                      options = options.filter(
                        (opt: any) =>
                          !selectedCourseTypes.includes(opt.value) ||
                          opt.value === f.value?.value ||
                          opt.value === f.value
                      );

                      // 12th / Diploma / Graduation are not offered for Qualification 1 (10th)
                      // (kept only if already saved, so the existing value still shows)
                      if (field.name === "course1Type") {
                        const currentCourseType = f.value?.value || f.value;
                        options = options.filter(
                          (opt: any) =>
                            !["12th", "Diploma", "Graduation"].includes(opt.value) ||
                            opt.value === currentCourseType
                        );
                      }
                    }

                    // Restrict duplicate exam names within the same section (core vs language).
                    // Normalize stored values (string vs { value, label }) so filtering matches options.
                    if (
                      /^coreExamName(_\d+)?$/.test(field?.name ?? "") ||
                      /^languageExamName(_\d+)?$/.test(field?.name ?? "")
                    ) {
                      const normalizeExamNameVal = (val: any): string | null => {
                        if (val == null || val === "") return null;
                        if (
                          typeof val === "object" &&
                          val !== null &&
                          "value" in val
                        ) {
                          const v = (val as { value?: unknown }).value;
                          return v == null || v === "" ? null : String(v);
                        }
                        return String(val);
                      };

                      const isCoreExamNameField = /^coreExamName(_\d+)?$/.test(
                        field?.name ?? ""
                      );
                      const nameKeyPattern = isCoreExamNameField
                        ? /^coreExamName(_\d+)?$/
                        : /^languageExamName(_\d+)?$/;

                      const selectedExamNames: string[] = Object.keys(
                        form?.values ?? {}
                      )
                        .filter((key) => nameKeyPattern.test(key))
                        .map((key) => normalizeExamNameVal(form?.values?.[key]))
                        .filter((v): v is string => Boolean(v));

                      const currentVal = normalizeExamNameVal(f?.value);

                      options = options.filter((opt: any) => {
                        const optVal = String(opt?.value ?? "");
                        return (
                          !selectedExamNames.includes(optVal) ||
                          (currentVal != null && optVal === currentVal)
                        );
                      });
                    }

                    if (
                      (field.name === "permanentAddressType" ||
                        /^addressCoApplicant\d+permanentAddressType$/.test(
                          field.name
                        )) &&
                      !f.value
                    ) {
                      form.setFieldValue(field.name, "Permanent Address", false);
                    }

                    if (
                      field.name === "currentAddressType" ||
                      /^addressCoApplicant\d+currentAddressType$/.test(field.name)
                    ) {
                      if (f.value !== "Current address") {
                        form.setFieldValue(field.name, "Current address", false);
                      }
                    }

                    // Default course type values are now handled in useEffect to ensure proper Redux storage

                    // Normalize value for simple dropdowns (like employmentType)
                    let normalizedValue = f.value;

                    if (
                      field.name === "employmentType" &&
                      typeof f.value === "object" &&
                      f.value !== null &&
                      "value" in f.value
                    ) {
                      normalizedValue = f.value.value;
                    }

                    // Special handling for salutation fields
                    if (field.name.toLowerCase().includes("salutation")) {
                      // For salutation, f.value should contain the salutation code (value)
                      // If it's an object, extract the value, otherwise use as-is
                      if (
                        typeof f.value === "object" &&
                        f.value !== null &&
                        "value" in f.value
                      ) {
                        normalizedValue = f.value.value;
                      } else {
                        normalizedValue = f.value;
                      }
                    }

                    // Special handling for designation fields
                    if (field.name.toLowerCase().includes("designation")) {
                      // For designation, f.value should contain the designation code (value)
                      // If it's an object, extract the value, otherwise use as-is
                      if (
                        typeof f.value === "object" &&
                        f.value !== null &&
                        "value" in f.value
                      ) {
                        normalizedValue = f.value.value;
                      } else {
                        normalizedValue = f.value;
                      }
                    }

                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          // For employmentCompanyCountry, set value with validation, then clear error and validate
                          if (field.name === "employmentCompanyCountry") {
                            form.setFieldValue(field.name, value, true); // validate = true
                            handleFilledFieldsCount(field.name, value);
                            form.setFieldTouched(field.name, true, false);
                            form.setFieldError(field.name, undefined);
                            form.validateField(field.name);
                          } else if (field.name === "employmentType") {
                            // Always store as string for employmentType
                            const normalizedEmploymentType =
                              typeof value === "object" &&
                                value !== null &&
                                "value" in value
                                ? (value as any).value
                                : value;

                            form.setFieldValue(field.name, normalizedEmploymentType);
                            handleFilledFieldsCount(field.name, normalizedEmploymentType);

                            // If employmentType is Others, clear other employment-related fields
                            // But preserve monthlyIncome and monthlyObligation
                            if (normalizedEmploymentType === "Others") {
                              const employmentFieldNamesToClear = fields
                                .filter(
                                  (f: any) =>
                                    (f.name?.toLowerCase()?.startsWith("employment") ||
                                      f.name?.toLowerCase()?.startsWith("employmentcompany")) &&
                                    f.name !== "employmentType" &&
                                    f.name !== "employmentisEmployed" &&
                                    f.name !== "employmentMonthlyIncome" &&
                                    f.name !== "employmentMonthlyObligation"
                                )
                                .map((f: any) => f.name);
                              employmentFieldNamesToClear.forEach((fname: string) => {
                                form.setFieldValue(fname, "", false);
                                form.setFieldTouched(fname, false, false);
                                form.setFieldError(fname, undefined);
                                handleFilledFieldsCount(fname, "");
                              });
                            }
                          } else if (
                            field.name?.startsWith("coreExamName") ||
                            field.name?.startsWith("languageExamName")
                          ) {
                            handleExamDropdownChange(
                              field.name,
                              value,
                              form.setFieldValue
                            );
                            handleFilledFieldsCount(field.name, value);
                            // Explicitly clear errors for exam name and all auto-populated/related fields
                            // without triggering cascade validation on other fields
                            if (value) {
                              form.setFieldError(field.name, undefined);
                              const sfxMatch = field.name.match(/_(\d+)$/);
                              const sfx = sfxMatch ? `_${sfxMatch[1]}` : "";
                              const isCore = field.name?.startsWith("coreExamName");
                              const mf = isCore ? `coreTotalMarks${sfx}` : `languageTotalMarks${sfx}`;
                              const scoreField = isCore ? `coreExamScore${sfx}` : `languageExamScore${sfx}`;
                              form.setFieldError(mf, undefined);
                              // Also clear stale range/required errors on the score field
                              // (e.g. "cannot be greater than total marks" from old totalMarks value)
                              form.setFieldError(scoreField, undefined);
                            }
                          } else {
                            // For exam fields, find the full option object to get both ID and name
                            // if (field.name.toLowerCase().includes("exam")) {
                            //   const selectedOption = options.find((opt: any) => opt.value === value);
                            //   if (selectedOption) {
                            //     // Set the form value to just the selected value, but pass full option to handleDropdownChange
                            //     form.setFieldValue(field.name, value.value);
                            //     handleDropdownChange(field.name, selectedOption, form);
                            //   } else {
                            //     form.setFieldValue(field.name, value.value);
                            //     handleDropdownChange(field.name, value, form);
                            //   }
                            // } else

                            if (field.name.toLowerCase().includes("salutation")) {
                              // For salutation fields, find the full option object to get both code and description
                              const selectedOption = options.find(
                                (opt: any) => opt.value === value
                              );
                              if (selectedOption) {
                                // Set the form value to the salutation code (value)
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                );
                                // Pass full option to handleDropdownChange to store both code and description
                                handleDropdownChange(
                                  field.name,
                                  selectedOption,
                                  form
                                );
                              } else {
                                form.setFieldValue(field.name, value);
                                handleDropdownChange(field.name, value, form);
                              }
                            } else if (
                              field.name.toLowerCase().includes("designation")
                            ) {
                              // For designation fields, store only the value (code) but display label
                              // The value passed here is already the code from the selected option
                              form.setFieldValue(field.name, value);
                              handleFilledFieldsCount(field.name, value);
                            } else if (isCoOwnerCollateralNameField(field.name)) {
                              handleCoOwnerNameSelection(
                                field.name,
                                value,
                                form,
                                handleFilledFieldsCount,
                                handleDropdownChange,
                              );
                              //storedValue = value;
                            } else if (/^collateral\d*type$/i.test(field.name)) {
                              const collateralNumber =
                                getCollateralNumberFromFieldName(field.name) || 1;

                              // Switching collateral type invalidates whatever was
                              // previously filled in for this collateral (e.g. Property
                              // fields when switching to Fixed Deposit) — clear it so
                              // stale values from the old type never reach the save API.
                              fields
                                .filter(
                                  (otherField: any) =>
                                    otherField.name !== field.name &&
                                    fieldBelongsToCollateralNumber(
                                      otherField.name,
                                      collateralNumber
                                    )
                                )
                                .forEach((otherField: any) => {
                                  form.setFieldValue(otherField.name, "", false);
                                  form.setFieldTouched(otherField.name, false, false);
                                  handleFilledFieldsCount(otherField.name, "");
                                });

                              form.setFieldValue(field.name, value);
                              handleDropdownChange(field.name, value, form);
                            } else {
                              form.setFieldValue(field.name, value);
                              handleDropdownChange(field.name, value, form);
                            }
                            handleFilledFieldsCount(field.name, value);
                            // Clear this field's error immediately when a value is selected
                            if (value) {
                              form.setFieldError(field.name, undefined);
                            }
                          }

                          if (
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 5
                          ) {
                            // Persist all form values to Redux for refresh survival
                            if (formikRef?.current?.values) {
                              // dispatch(
                              //   updateFormData({
                              //     ...formikRef.current.values,
                              //     [field.name]: value,
                              //   })
                              // );
                              dispatch(
                                updateFormData({
                                  [field.name]: value,
                                })
                              );
                            }
                          }

                          // Check and uncheck address checkbox if address fields change
                          if (
                            /^(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name) ||
                            /^addressCoApplicant\d+(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name)
                          ) {
                            setTimeout(() => {
                              checkAndUncheckAddressCheckbox();
                            }, 0);
                          }

                          if (field.name == "salutation") {
                            const fatherName = form?.values?.fatherName;
                            const motherName = form?.values?.motherName;
                            const gender = form?.values?.gender;
                            const aadhaar = form?.values?.aadhaar;
                            const dob = form?.values?.dob;
                            const firstName =
                              form?.values?.firstName ||
                              form?.values?.studentDetailsFirstName;
                            const lastName =
                              form?.values?.lastName ||
                              form?.values?.studentDetailsLastName;
                            const phone_number =
                              form?.values?.phone_number ||
                              form?.values?.studentDetailsPhone_number;
                            const email =
                              form?.values?.email ||
                              form?.values?.studentDetailEmail;
                            const isAadhaarVerified = form?.values?.isAadhaarVerified;
                            const isEmailVerified = form?.values?.isEmailVerified;
                            const isMobileVerified = form?.values?.isMobileVerified;
                            const isPanVerified = form?.values?.isPanVerified;
                            dispatch(
                              updateFormData({
                                [field?.name]: value,
                                fatherName,
                                motherName,
                                gender,
                                aadhaar,
                                dob,
                                firstName: formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || "",
                                lastName: formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || "",
                                phone_number,
                                email,
                                isAadhaarVerified: isAadhaarVerified ?? false,
                                isEmailVerified,
                                isMobileVerified,
                                isPanVerified,
                              })
                            );
                          }
                        }}
                        options={options}
                        placeholder={
                          field.name?.includes("salutation")
                            ? 'Select Salutation'
                            : field.name === "coreScoreReceived" || field.name === "languageScoreReceived"
                              ? 'Select Status'
                              : `Select ${field.label}`
                        }
                        isMandatory={
                          /^collateral\d*type$/i.test(field.name)
                            ? Boolean(field.required) &&
                              (formikRef?.current?.values?.collateral === "Yes" ||
                                Boolean(f.value))
                            : field.required || false
                        }
                        error={!!(form.touched[field.name] && form.errors[field.name])}
                        helperText={form.touched[field.name] && form.errors[field.name] ? String(form.errors[field.name]) : ""}
                        isApplicant={field.name === "employmentType" ? true : false}
                        disabled={field?.disabled || false}
                      // disabled={
                      //   field.name === "permanentAddressType" ||
                      //   field.name === "currentAddressType" ||
                      //   /^addressCoApplicant\d+permanentAddressType$/.test(
                      //     field.name
                      //   ) ||
                      //   /^addressCoApplicant\d+currentAddressType$/.test(
                      //     field.name
                      //   )
                      //     ? true
                      //     : false
                      // }
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>

            {/* This renders the whitespace (empty box) only next to Employment Type */}
            {/* {field.name === 'employmentType' && !isXsOrSm && (
               <Grid item xs={12} sm={6} />
            )} */}
          </>
        );
      case "radio":
        if (
          pageType === "SUMMARY" &&
          isSummaryEligibilityStep0 &&
          field.name === "applicantType"
        ) {
          return (
            <Grid
              item
              xs={12}
              sm={smForSummaryEligibility(12)}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    const applicantTypeOptions = (
                      field.options?.options || []
                    ).map((opt: string) => ({
                      value: String(opt).toLowerCase(),
                      label: opt,
                    }));
                    const normalizedValue =
                      typeof f.value === "string"
                        ? f.value.toLowerCase()
                        : f.value;
                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          const valToStore =
                            typeof value === "object" &&
                            value !== null &&
                            "value" in value
                              ? value.value
                              : value;
                          handleFilledFieldsCount(field.name, valToStore);
                          handleRadioChange(field.name, valToStore, form);
                        }}
                        options={applicantTypeOptions}
                        placeholder={`Select ${field.label}`}
                        isMandatory={field.required || false}
                        disabled
                        error={!!(form.touched[field.name] && form.errors[field.name])}
                        helperText={
                          form.touched[field.name] && form.errors[field.name]
                            ? String(form.errors[field.name])
                            : ""
                        }
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }
        return (
          <Grid
            item
            xs={12}
            sm={smForSummaryEligibility(12)}
            key={field.id}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, form, meta }: any) => {
                  const errorMessage = meta?.error || form.errors[field.name];
                  const showError = Boolean(
                    (meta?.touched || form.touched[field.name]) && errorMessage
                  );
                  const helperText = showError ? String(errorMessage) : null;

                  return (
                  <CustomRadioGroup
                    error={showError}
                    helperText={helperText}
                    hasBg={
                      activeHorizontalIndex === 0 && activeVerticalIndex === 0
                    }
                    isRequired={true}
                    label={field.label}
                    options={(field.options?.options || []).map(
                      (opt: string) => ({
                        value:
                          activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 0
                            ? opt?.toLowerCase()
                            : opt,
                        label: opt,
                      })
                    )}
                    value={
                      field?.disabled && field?.value !== undefined
                        ? field.value
                        : f.value
                    }
                    disabled={Boolean(field?.disabled)}
                    onChange={(value) => {
                      handleFilledFieldsCount(field.name, value);
                      handleRadioChange(field.name, value, form);
                      form.setFieldTouched(field.name, true, false);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }
                    }}
                  />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "checkbox":
        if (
          pageType === "SUMMARY" &&
          activeHorizontalIndex === 0 &&
          activeVerticalIndex === 0 &&
          (field.name === "terms_conditions" ||
            field.name === "privacy_policy")
        ) {
          return null;
        }
        return (
          <Grid item xs={12} sm={12} key={field.id} sx={{ mb: 0, mt: 0, p: 0 }}>
            <Box sx={{ m: 0, p: 0 }}>
              <Field name={field.name}>
                {({ field: f }: any) => {
                  const safeLabel = DOMPurify.sanitize(field?.label); // sanitize before rendering
                  const hasPurposesAnchor = hasSpecificPurposesAnchor(
                    field?.label
                  );

                  return (
                    <div
                      className="checkbox-wrapper"
                      style={{ margin: 0, padding: 0 }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!f.value}
                            {...f}
                            onChange={(event: any) => {
                              let checked = event.target.checked;
                              if (field.name === "currentsameAsPermanent") {
                                setIsCurrentSameAsPermanent(checked);
                                handleFilledCurrentAddressFields(checked);
                              }
                              const match = field.name.match(
                                /^addressCoApplicant(\d+)currentsameAsPermanent$/
                              );
                              if (match) {
                                if (checked) {
                                  handleInvokZipCode(
                                    String(formikRef?.current?.values?.[`addressCoApplicant${match[1]}permanentPincode`]),
                                    undefined,
                                    "current"
                                  )
                                }
                                handleFilledCurrentAddressFieldsCoApplicant(
                                  match[1],
                                  checked
                                );
                              }
                              handleFilledFieldsCount(field.name, event);
                              // Set the boolean directly instead of f.onChange(event): Formik's
                              // own checkbox handling (getValueForCheckbox) only returns a
                              // boolean when the field's CURRENT value is already a boolean —
                              // otherwise it falls back to array/value-attribute heuristics and
                              // can end up storing the DOM's default checkbox value ("on")
                              // instead of true/false. That happens for any co-applicant whose
                              // "same as permanent" field was never initialized to a boolean
                              // (e.g. one added after the initial Co-Applicant Details step),
                              // and the backend then rejects the saved value.
                              formikRef?.current?.setFieldValue(field.name, checked, true);
                            }}
                            sx={{
                              p: 0.5,
                              "&.Mui-checked": {
                                color: "#33C2C4",
                              },
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            component="span"
                            onClick={
                              hasPurposesAnchor
                                ? handlePurposesClick
                                : undefined
                            }
                            sx={{
                              fontFamily: "Jost, sans-serif",
                              fontWeight: 400,
                              fontSize: isXsOrSm ? "12px" : "15px",
                              lineHeight: "22px",
                              textAlign: "left",
                              color: "#4B465C",
                              display: "inline-block",
                              borderRadius: "4px",
                              padding: "2px 0px",
                              cursor: hasPurposesAnchor ? "pointer" : "default",
                              "& a": {
                                color: "#33C2C4",
                                textDecoration: "underline",
                                transition: "color 0.2s ease-in-out",
                                "&:hover": {
                                  color: "#33C2C4",
                                },
                              },
                            }}
                            dangerouslySetInnerHTML={{ __html: safeLabel }} // sanitized HTML
                          />
                        }
                        sx={{ m: 0, alignItems: "flex-start !important" }}
                      />
                    </div>
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "autocomplete":
        // Restrict duplicate course types
        const keyItem: any = field.name.match(
          /^basicCoApplicant(\d+)RelationWithStudent$/
        );
        return (
          <Grid
            item
             xs={isXsOrSm ? 12: pageType === "SUMMARY" ? 3 : 12} 
            sm={
              isXsOrSm ? 12: activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                   ? 12  
                  : pageType === "SUMMARY" ? 3 : 6
            }
            key={field.id}
          // sx={{
          //   minWidth:
          //     activeHorizontalIndex === 1 && activeVerticalIndex === 3
          //       ? "100% !important"
          //       : "",
          // }}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, form, meta }: any) => {
                  // For RelationWithStudent, convert stored value to option object for display
                  let displayValue = f.value || "";
                  if (
                    field.name.match(/^basicCoApplicant\d+RelationWithStudent$/)
                  ) {
                    const options = relationshipOptions;
                    // Find the option that matches the stored value
                    const matchedOption = options.find(
                      (opt: any) => opt.value === f.value
                    );
                    displayValue = matchedOption || "";
                  }

                  // For employmentDesignation, convert stored value to option object for display
                  if (
                    field.name.match("employmentDesignation") ||
                    /^employmentCoApplicant\d+designation$/i.test(field.name)
                  ) {
                    const options = getDropdownOptions(field);
                    // Match the stored code, or the full name once saved data reloads
                    const matchedOption = options.find(
                      (opt: any) => opt.value === f.value || opt.label === f.value
                    );
                    displayValue = matchedOption || "";
                  }

                  const isBirthCityField =
                    /birth.*city|city.*birth/i.test(String(field?.name || "")) ||
                    /birth.*city|city.*birth/i.test(String(field?.label || "")) ||
                    String(field?.name || "").toLowerCase().includes("cityofbirth");

                  if (isBirthCityField && f.value) {
                    const cityOptions = getDropdownOptions(field) || birthCityList || [];
                    if (typeof f.value === "object") {
                      displayValue =
                        normalizeBirthCityOption(f.value, cityOptions) || f.value;
                    } else if (typeof f.value === "string" && f.value !== "") {
                      const matchedCity = cityOptions.find((opt: any) => {
                        if (typeof opt === "string") {
                          return opt.toLowerCase() === String(f.value || "").toLowerCase();
                        }
                        return (
                          String(opt?.label || "").toLowerCase() ===
                            String(f.value || "").toLowerCase() ||
                          String(opt?.value || "").toLowerCase() ===
                            String(f.value || "").toLowerCase()
                        );
                      });
                      displayValue =
                        matchedCity ||
                        normalizeBirthCityOption(f.value, cityOptions) ||
                        String(f.value);
                    }
                  }
                  const coOwnerNameOptions = isCoOwnerCollateralNameField(field.name)
                    ? getCoOwnerNameAutocompleteOptions(form.values || {}, field.name, f.value)
                    : null;
                  return (
                    <AutoCompleteOptions
                      isNotList={
                        field.name.toLowerCase() == "university" ||
                        field.name.toLowerCase() == "institute" ||
                        field.name.toLowerCase() == "coursename"
                      }
                      formikRef={formikRef}
                      label={field.label}
                      fieldProps={{ ...f }}
                      options={
                        coOwnerNameOptions ??
                        (field.name.includes(keyItem?.[0])
                          ? relationshipOptions
                          : getDropdownOptions(field))
                      }
                      value={displayValue}
                      form={form}
                      onChange={(value: any, reason?: string) => {
                        if (isCoOwnerCollateralNameField(field.name)) {
                          handleCoOwnerNameSelection(
                            field.name,
                            value,
                            form,
                            handleFilledFieldsCount,
                            handleDropdownChange,
                          );
                          return;
                        }
                        const isCoApplicantCityOfBirthField =
                          /^basicCoApplicant\d+CityOfBirth$/i.test(
                            String(field?.name || ""),
                          );
                        // if (
                        //   isCoApplicantCityOfBirthField &&
                        //   (reason === "selectOption" ||
                        //     reason === undefined ||
                        //     reason === "clear")
                        // ) {
                        //   const normalizedCityOption =
                        //     reason === "clear" ||
                        //     value === null ||
                        //     value === undefined
                        //       ? ""
                        //       : normalizeBirthCityOption(value, birthCityList);
                        //   form.setFieldValue(field.name, normalizedCityOption, false);
                        //   form.setFieldError(field.name, undefined);
                        //   form.setFieldTouched(field.name, true, false);
                        //   handleFilledFieldsCount(field.name, normalizedCityOption);
                        //   return;
                        // }
                        if (
                          field.name.match(
                            /^basicCoApplicant\d+RelationWithStudent$/
                          )
                        ) {
                          const relationValue = value?.value || value;
                          const relationLabel = value?.label || value;

                          // Set the field value to only the value. shouldValidate
                          // is explicitly false on both calls — see the
                          // CityOfBirth/CountryOfBirth branches below for why:
                          // Formik's default validation reads from the
                          // pre-update closure, so the second setFieldValue call
                          // would revalidate against a stale snapshot and its
                          // later-resolving async validation could overwrite
                          // this field's correct, error-free result with a
                          // phantom "required" error.
                          form.setFieldValue(field.name, relationValue, false);
                          form.setFieldValue(
                            `${field.name}Name`,
                            relationLabel,
                            false
                          );
                          if (relationValue) {
                            form.setFieldError(field.name, undefined);
                            form.setFieldTouched(field.name, true, false);
                          }

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = relationValue;
                          currentFormData[`${field.name}Name`] = relationLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, relationValue);
                        } else if (
                          field.name.match("employmentDesignation") ||
                          /^employmentCoApplicant\d+designation$/i.test(field.name)
                        ) {
                          // Extract value (code) from the selected option
                          const designationValue = value?.value || value;

                          // Set the field value to only the designation code
                          form.setFieldValue(field.name, designationValue);
                          handleFilledFieldsCount(field.name, designationValue);
                        } else if (
                            field.name.match(
                              /^basicCoApplicant\d+MaritalStatus$/
                            )
                          ) {
                            const maritalValue = value?.value || value;
                            const maritalLabel = value?.label || value;


                            // Set the field value to only the value. See the
                            // RelationWithStudent branch above for why
                            // shouldValidate is explicitly false here.
                            form.setFieldValue(field.name, maritalLabel, false);
                            form.setFieldValue(
                              `${field.name}Name`,
                              maritalLabel,
                              false
                            );
                            if (maritalLabel) {
                              form.setFieldError(field.name, undefined);
                              form.setFieldTouched(field.name, true, false);
                            }

                            // Update Redux with RelationWithStudent value and name
                            const currentFormData = { ...formData };
                            currentFormData[field.name] = maritalValue;
                            currentFormData[`${field.name}Name`] = maritalLabel;
                            dispatch(updateFormData(currentFormData));

                            handleFilledFieldsCount(field.name, maritalValue);
                          } else if (
                            field.name.match(
                              /^basicCoApplicant\d+Nationality$/
                            )
                          ) {
                            const nationalityValue = value?.value || value;
                            const nationalityLabel = value?.label || value;


                            // Set the field value to only the value. See the
                            // RelationWithStudent branch above for why
                            // shouldValidate is explicitly false here.
                            form.setFieldValue(field.name, nationalityLabel, false);
                            form.setFieldValue(
                              `${field.name}Name`,
                              nationalityLabel,
                              false
                            );
                            if (nationalityLabel) {
                              form.setFieldError(field.name, undefined);
                              form.setFieldTouched(field.name, true, false);
                            }

                            // Update Redux with RelationWithStudent value and name
                            const currentFormData = { ...formData };
                            currentFormData[field.name] = nationalityValue;
                            currentFormData[`${field.name}Name`] = nationalityLabel;
                            dispatch(updateFormData(currentFormData));

                            handleFilledFieldsCount(field.name, nationalityValue);
                          }else if (
                            field.name.match(
                              /^basicCoApplicant\d+CountryOfBirth$/
                            )
                          ) {
                            const countryOfBirthValue = value?.value || value;
                            const countryOfBirthLabel = value?.label || value;
                            const cityOfBirthFieldName = field.name.replace(
                              /CountryOfBirth$/i,
                              "CityOfBirth",
                            );
                            
  
                            // Set the field value to only the value
                            form.setFieldValue(field.name, countryOfBirthLabel);
                            form.setFieldValue(
                              `${field.name}Name`,
                              countryOfBirthLabel
                            );
                            form.setFieldValue(cityOfBirthFieldName, "");
                            handleInvokStatesByCountryApi(String(countryOfBirthLabel || ""));
  
                            // Update Redux with RelationWithStudent value and name
                            const currentFormData = { ...formData };
                            currentFormData[field.name] = countryOfBirthValue;
                            currentFormData[`${field.name}Name`] = countryOfBirthLabel;
                            currentFormData[cityOfBirthFieldName] = "";
                            dispatch(updateFormData(currentFormData));
  
                            handleFilledFieldsCount(field.name, countryOfBirthValue);
                          }
                          else if (
                            field.name.match(
                              /^basicCoApplicant\d+CityOfBirth$/
                            )
                          ) {
                            const cityOfBirthValue = value?.value || value;
                            const cityOfBirthLabel = value?.label || value;
                            
  
                            // Set the field value to only the value
                            form.setFieldValue(field.name, cityOfBirthLabel);
                            form.setFieldValue(
                              `${field.name}Name`,
                              cityOfBirthLabel
                            );
  
                            // Update Redux with RelationWithStudent value and name
                            const currentFormData = { ...formData };
                            currentFormData[field.name] = cityOfBirthValue;
                            currentFormData[`${field.name}Name`] = cityOfBirthLabel;
                            dispatch(updateFormData(currentFormData));
  
                            handleFilledFieldsCount(field.name, cityOfBirthValue);
                          } else {
                          handleFilledFieldsCount(field.name, value);
                          // For step (0,1) university/institute/courseName: pass shouldValidate=false
                          // to prevent async Yup validation from re-setting errors after we clear them
                          const isEligibilityAutocomplete =
                            activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 1 &&
                            (field.name === "university" ||
                              field.name === "institute" ||
                              field.name === "courseName");
                          handleDropdownChange(
                            field.name,
                            value,
                            form,
                          );
                          handleFilledFieldsCount(field.name, value);
                          // Clear the field's own error when a value is selected
                          if (value) {
                            form.setFieldError(field.name, undefined);
                          }
                          // When admissionStatus changes to Undecided, clear dependent field errors
                          if (
                            field.name.toLowerCase().includes("admissionstatus") &&
                            (value === "Undecided" || value?.value === "Undecided")
                          ) {
                            form.setFieldError("university", undefined);
                            form.setFieldError("institute", undefined);
                            form.setFieldError("courseName", undefined);
                          }
                        }

                        // Check and uncheck address checkbox if address fields change
                        if (
                          /^(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name) ||
                          /^addressCoApplicant\d+(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name)
                        ) {
                          setTimeout(() => {
                            checkAndUncheckAddressCheckbox();
                          }, 0);
                        }
                        if (value && Object.keys(value).length > 0) {
                          if (field.name === "country") {
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          }

                          if (field.name === "university") {
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              institutes: [],
                              courses: [],
                            }));
                          }

                          if (field.name === "institute") {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          }
                        }

                        // Clear dropdown options if value is cleared (cross button)
                        if (!value || value == null) {
                          if (
                            field.name === "courseCategory" ||
                            field.name.toLowerCase().includes("study") ||
                            field.name.toLowerCase().includes("admissionstatus")
                          ) {
                            form.setFieldValue("country", "");
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              countries: [],
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "country") {
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "university") {
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "institute") {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            // setDropdownData((prev) => ({
                            //   ...prev,
                            //   institutes: [],
                            // }));
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          } else if (
                            field.name === "courseName" ||
                            field.name === "course"
                          ) {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          } else if (
                            field.name.match(
                              /^basicCoApplicant(\d+)RelationWithStudent$/
                            )
                          ) {
                            // Clear RelationWithStudent name field
                            form.setFieldValue(`${field.name}Name`, "");
                          }
                        }
                      }}
                      onInputChange={(e: any, inputValue: any, reason: any) => {
                        // Call API when typing, but not on selection (reset) or if value already in options
                        if (
                          field.name === "university" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.universities?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              universityName: inputValue,
                            }));
                            // Prevent duplicate calls for same value
                            if (lastUniversityQueryRef.current !== inputValue) {
                              lastUniversityQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (
                          field.name === "institute" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.institutes?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              instituteName: inputValue,
                            }));
                            if (lastInstituteQueryRef.current !== inputValue) {
                              lastInstituteQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (
                          (field.name === "courseName" ||
                            field.name === "course" ||
                            field.name === "cource") &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.courses?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              courseName: inputValue,
                            }));
                            if (lastCourseQueryRef.current !== inputValue) {
                              lastCourseQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (field.name === "salutation") {
                          setFormValues((prev) => ({
                            ...prev,
                            salutation: inputValue,
                          }));
                        } else if (
                          field.name === "currentPincode" &&
                          inputValue?.length == 6
                        ) {
                          setFormValues((prev) => ({
                            ...prev,
                            salutation: inputValue.label,
                          }));
                        }
                      }}
                      // isMandatory: non-mandatory on (0,1) when admissionStatus is Undecided for University/Institute/Course
                      isMandatory={
                        (() => {
                          const nameLower = field.name.toLowerCase();
                          const applyAdmissionUndecided =
                            activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 1 &&
                            form?.values?.admissionStatus === "Undecided";
                          const isTargetField =
                            nameLower === "university" ||
                            nameLower === "institute" ||
                            nameLower === "coursename";
                          return field.required && !(applyAdmissionUndecided && isTargetField);
                        })()
                      }
                      loading={isBirthCityField ? birthCityLoading : isDropdownLoading(field)}
                      placeholder={
                        field.name.toLowerCase() === "university"
                          ? "Type 3 Letters of University Name"
                          : field.name.toLowerCase() === "institute"
                            ? "Type 3 Letters of Institute Name"
                            : field.name.toLowerCase() === "coursename"
                              ? "Type 3 Letters of Course Name"
                              : `Select ${field.label}`
                      }
                      noOptionText={
                        field.name.toLowerCase() === "university"
                          ? "Select Not In List and Enter the University Name"
                          : field.name.toLowerCase() === "institute"
                            ? "Select Not In List and Enter the Institute Name"
                            : field.name.toLowerCase() === "coursename"
                              ? "Select Not In List and Enter the Course Name"
                              : "No Options"
                      }
                      error={!!meta?.touched && !!meta?.error}
                      helperText={meta?.touched && meta?.error}
                      disabled={handleDisablePermanentPincodeBasedFields(field)}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "date": {
        const isScoreExpectedField = /scoreExpectedOn/i.test(field.name);
        // The field is named "loanDateOfDisbursement" (label re-mapped for
        // display to "Expected Of Disbursement" in ApplicantAdditionalTab.tsx)
        // — match on the field name's "disbursement" substring rather than
        // the display label, which isn't consistently applied everywhere
        // this field renders.
        const isFutureOnlyDateField =
          isScoreExpectedField || /disbursement/i.test(field.name);
        return (
          <Grid
            item
            xs={12}
            sm={
              (activeHorizontalIndex === 1 && activeVerticalIndex === 3) || (activeHorizontalIndex === 1 && activeVerticalIndex === 4) || (activeHorizontalIndex === 1 && activeVerticalIndex === 5)
                ? pageType === "SUMMARY" ? 12 : 12
                : pageType === "SUMMARY" ? 3 : 6
            }
            key={field.id}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => {
                  // Disable DOB for a co-applicant if their PAN is verified
                  let disableDate = Boolean(field?.disabled);
                  const coApplicantDobMatch = field.name.match(/^basicCoApplicant(\d+)dob$/);
                  if (coApplicantDobMatch) {
                    const idx = String(Number(coApplicantDobMatch[1]) - 1);
                    const panVerifiedFlag =
                      formikRef.current?.values?.[
                        `basicCoApplicant${Number(idx) + 1}IsPanVerified`
                      ];
                    // API/Formik may send "false"/"true" strings; only treat strict truthy flags as verified.
                    disableDate =
                      Boolean(field?.disabled) ||
                      isTruthyFormFlag(panVerifiedFlag);
                  }

                  // Disable main applicant DOB if main PAN is verified
                  if (field.name === "dob" && isPanVerified) {
                    disableDate = true;
                  }
                  const dateValue = useMemo(
                    () => (f.value ? dayjs(f.value) : null),
                    [f.value]
                  );
                  return (
                    <BasicDatePicker
                      label={field.label==="Language Score Expected On"?"Score Expected On":field.label}
                      required={field.required}
                      value={dateValue}
                      onChange={(date) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : "";

                        handleFilledFieldsCount(field.name, formattedDate);

                        // prevent validation on each change
                        form.setFieldValue(field.name, formattedDate, false);
                        // Clear stale required/type errors when user selects a date
                        if (formattedDate) {
                          form.setFieldError(field.name, undefined);
                        }
                        const value = form.values[field.name];
                        dispatch(updateFormData({ [field.name]: formattedDate }));
                      }}
                      onBlur={() => {
                        // dispatch only once on blur (much faster)
                        const value = form.values[field.name];
                        dispatch(updateFormData({ [field.name]: value }));
                      }}
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error}
                      width="100%"
                      readOnly={false}
                      minDate={isFutureOnlyDateField ? dayjs().startOf("day") : dayjs("1900-01-01")}
                      maxDate={isFutureOnlyDateField ? dayjs("9999-12-31") : dayjs()}
                      disabled={disableDate}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      }
      case "hidden":
        return (
          <Field name={field.name}>
            {({ field: f }: any) => (
              <input
                type="hidden"
                name={f.name}
                autoComplete="new-password"
                value={f.value || ""}
                onChange={f.onChange}
                onBlur={f.onBlur}
              />
            )}
          </Field>
        );
      default:
        return null;
    }
  };

  // useEffect(() => {
  //   // For each course score type, if initial value is CGPA, set cgpaModes in Redux to true
  //   const allFields = fields;
  //   allFields.forEach((field) => {
  //     const match = field.name.match(/^course(\d+)ScoreType$/);
  //     if (match) {
  //       const courseNum = match[1];
  //       // Check initial value (from initialValues or formData)
  //       const initial =
  //         (formData && formData[field.name]) ||
  //         initialValues[field.name] ||
  //         "CGPA";
  //       if (initial === "CGPA") {
  //         dispatch(setCgpaMode({ courseNum, mode: true }));
  //       } else {
  //         dispatch(setCgpaMode({ courseNum, mode: false }));
  //       }
  //     }
  //   });
  //   // Only run on mount or when fields/extraCourses change
  //   // eslint-disable-next-line
  // }, [fields, extraCourses, activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    // dispatch(setHasPan(""));

    const normalizedPanAvailability = String(formData?.pan ?? "")
      .trim()
      .toLowerCase();
    const formDataPan = String(formData?.pan ?? "").toUpperCase();
    const isValidFormDataPan = /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formDataPan);
    const formDataMobile = String(
      formData?.phone_number ?? formData?.studentDetailsPhone_number ?? ""
    ).trim();
    const formDataEmail = String(
      formData?.email ?? formData?.studentDetailEmail ?? ""
    )
      .trim()
      .toLowerCase();
    const isFormDataMobileVerified =
      formData?.isMobileVerified === true || formData?.isMobileVerified === "true";
    const isFormDataPanVerified =
      formData?.isPanVerified === true || formData?.isPanVerified === "true";
    const isFormDataEmailVerified =
      isTruthyFormFlag(formData?.isEmailVerified) ||
      isTruthyFormFlag((formData as any)?.emailAddressVerifiedFlag);

    // Keep verification anchors in sync after save/rehydration so UI does not fall back to "Verify".
    if (isValidFormDataPan && isFormDataPanVerified) {
      dispatch(setLastPanNumber(formDataPan));
      dispatch(setIsPanVerified(true));
    }
    if (formDataMobile && isFormDataMobileVerified) {
      dispatch(setLastVerifiedPhoneNumber(formDataMobile));
      dispatch(setIsMobileVerified(true));
    }
    if (formDataEmail && isFormDataEmailVerified) {
      dispatch(setLastVerifiedEmail(formDataEmail));
      dispatch(setIsEmailVerified(true));
    }

    if (formData.pan) {
      if (normalizedPanAvailability === "yes" || normalizedPanAvailability === "no") {
        dispatch(setHasPan(normalizedPanAvailability));
        if (normalizedPanAvailability === "no") {
          setPanNumberValue("");
          dispatch(setPanNumber(""));
          dispatch(setLastPanNumber(""));
          dispatch(setIsPanVerified(false));
        }
        // if (formData.pan == "yes" && panNumber == reduxLastPanNumber) {
        //   dispatch(setAadhaarMandatory(true));
        // }
      } else if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData?.pan?.toUpperCase())) {
        dispatch(setHasPan("yes"));
        dispatch(setPanNumber(formData?.pan?.toUpperCase()));
        dispatch(setAadhaarMandatory(formData?.isPanVerified));
        dispatch(setIsPanVerified(isLoadTesting ? true : Boolean(formData?.isPanVerified)));
      }
    } else if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan?.toUpperCase())) {
      // If PAN is a valid PAN number, treat as 'yes' and set PAN number
      dispatch(setHasPan("yes"));
      dispatch(setPanNumber(formData.pan?.toUpperCase()));
      setPanNumberValue(formData.pan?.toUpperCase());
      dispatch(setIsPanVerified(isLoadTesting ? true : formData.isPanVerified));
      dispatch(setShowAadhaar(formData.isAadhaarVerified));
      dispatch(setAadhaarMandatory(formData.isAadhaarVerified));

      if (formData.aadhaar) {
        formikRef?.current?.setFieldValue("aadhaar", formData.aadhaar);
        dispatch(setAadhaarApplicationNo(formData.aadhaar));
      }
      // Handle per-coapplicant Aadhaar application numbers if present in formData
      Object.keys(formData).forEach((key) => {
        const aadhaarMatch = key.match(/^basicCoApplicant(\d+)AadhaarNumber$/);
        if (aadhaarMatch && formData[key]) {
          const coAppKey = aadhaarMatch[1];
          dispatch(
            setAadhaarApplicationNoCoApplicant({
              coAppKey,
              applicationNo: formData[key],
            })
          );
        }
        // Handle per-coapplicant isDocumentVerifiedCoApplicant if present in formData
        const verifiedMatch = key.match(
          /^basicCoApplicant(\d+)AadhaarVerified$/
        );
        if (verifiedMatch && formData[key] !== undefined) {
          const coAppKey = verifiedMatch[1];
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              isVerified: isLoadTesting ? true : Boolean(formData[key]),
            })
          );
        }
      });
      // dispatch(setIsDocumentVerified(formData?.aadhaar ? true : false));
      // dispatch(setAadhaarMandatory(formData?.aadhaar ? true : false));
    }

    // aadhaar key is removed from getdata api so using isAadhaarVerified to check aadhaar verification.
    // formData.aadhaar is dropped from this check entirely — it only ever
    // holds the DigiLocker application/reference number (not a verified
    // confirmation), so treating it as proof of verification was a
    // false-positive risk with no upside now that isAadhaarVerified exists.
    if (
      formData.isAadhaarVerified === true ||
      formData.isAadhaarVerified === "true"
    ) {
      dispatch(setIsDocumentVerified(true));
    } else if (!isLoadTesting) {
      // Without this, isDocumentVerified only ever gets set to true and never
      // back to false — so isAadhaarVerified (mirrored from it a few effects
      // up) stays stuck true forever once set, even for an applicant/session
      // whose fetched formData no longer says they're actually verified.
      dispatch(setIsDocumentVerified(false));
    }
    if (hasPan === "no") {
      dispatch(setAadhaarMandatory(true));
    }
  }, [formData, hasPan]);



  const [panNumberValue, setPanNumberValue] = useState("");
  const [isPanLoading, setIsPanLoading] = useState(false);

  useEffect(() => {
    const getApplicationNo = async () => {
      // For main applicant
      const applicationNo = localStorage.getItem("applicationNo");
      if (applicationNo) {
        dispatch(setAadhaarApplicationNo(applicationNo));
      }

      // For co-applicants: look for keys like "applicationNo_CoApplicant1", "applicationNo_CoApplicant2", etc.
      Object.keys(localStorage).forEach((key) => {
        const match = key.match(/^applicationNo_CoApplicant(\d+)$/);
        if (match) {
          const coAppKey = match[1];
          const coAppApplicationNo = localStorage.getItem(key);
          if (coAppApplicationNo) {
            dispatch(
              setAadhaarApplicationNoCoApplicant({
                coAppKey,
                applicationNo: coAppApplicationNo,
              })
            );
          }
        }
      });
    };
    getApplicationNo();
  }, [formikRef]);

  useEffect(() => {
    if (panNumber) {
      // dispatch(setIsPanVerified(true));
      // dispatch(setAadhaarMandatory(true));
      setPanNumberValue(panNumber);
    }
  }, [panNumber]);

  // useEffect(() => {
  //   if (hasPan === "yes") {
  //     if (panNumber === reduxLastPanNumber && panNumber !== "") {
  //       dispatch(setIsPanVerified(true));
  //     } else {
  //       dispatch(setIsPanVerified(false));
  //     }
  //   }
  // }, [panNumber, reduxLastPanNumber, hasPan]);
  // PAN and Aadhaar related fields
  const renderPanAadhaarFields = (
    values: any,
    shouldDisableFields: boolean,
    setFieldValue: any,
    // Formik's PAN error once the field is touched (Save touches every field).
    // The SUMMARY block below is custom-rendered, so without this a blocking
    // "verification pending" error was never shown and Save did nothing.
    panFieldError?: string
  ) => {
    if (pageType === "SUMMARY") {
      const rawPanForDisplay = panNumberValue || values?.pan || "";
      const panValue =
        String(rawPanForDisplay).toLowerCase() === "yes" ||
        String(rawPanForDisplay).toLowerCase() === "no"
          ? ""
          : String(rawPanForDisplay).toUpperCase();
      const studentEmailValue =
        values?.studentDetailEmail ||
        values?.email ||
        formData?.studentDetailEmail ||
        formData?.email ||
        "";
      const aadhaarValue =
        values?.aadhaar || aadhaarApplicationNo || formData?.aadhaar || "";
      const normalizedSummaryStudentEmail = String(studentEmailValue || "")
        .trim()
        .toLowerCase();
      const normLastVerifiedEmail = String(lastVerifiedEmail || "")
        .trim()
        .toLowerCase();
      const summaryEmailVerifiedFlags =
        isTruthyFormFlag(isEmailVerified) ||
        isTruthyFormFlag(values?.isEmailVerified) ||
        isTruthyFormFlag(formData?.isEmailVerified) ||
        isTruthyFormFlag((formData as any)?.emailAddressVerifiedFlag);
      // Require current email === OTP anchor so stale API flags alone cannot show "Verified".
      const isEmailVerifiedInSummary = Boolean(
        !!normalizedSummaryStudentEmail &&
          !!normLastVerifiedEmail &&
          normalizedSummaryStudentEmail === normLastVerifiedEmail &&
          summaryEmailVerifiedFlags
      );

      const duplicateSummaryApplicantStudentEmail =
        !!normalizedSummaryStudentEmail &&
        normalizedSummaryStudentEmail ===
          String(formikRef.current?.values?.basicCoApplicant1Email || "")
            .trim()
            .toLowerCase();

      const isPanAvailableInSummary =
        String(hasPan || values?.pan || formData?.pan || "")
          .trim()
          .toLowerCase() !== "no";
      const isPanVerifiedInSummary =
        isPanAvailableInSummary &&
        (isTruthyFormFlag(isPanVerified) ||
          isTruthyFormFlag(values?.isPanVerified) ||
          isTruthyFormFlag(formData?.isPanVerified));
      const isAadhaarVerifiedInSummary = Boolean(
        isDocumentVerified || values?.isAadhaarVerified || formData?.isAadhaarVerified
      );
      const showEmailField = Boolean(studentEmailValue);
      const panStrForVisibility = String(values?.pan || "").trim();
      const panIsYesNoToken =
        panStrForVisibility.toLowerCase() === "yes" ||
        panStrForVisibility.toLowerCase() === "no";
      const showPanInput =
        hasPan !== "no" &&
        (hasPan === "yes" ||
          Boolean(panNumberValue) ||
          (Boolean(panStrForVisibility) && !panIsYesNoToken));
      const hideAadhaarOnSummaryPanStep =
        pageType === "SUMMARY" &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 0;
      // Student Details (horizontal 1 / vertical 0) should still show the
      // Verify button when the email isn't verified, not a locked "Not Verified" badge.
      const disableApplicantStudentEmailOnSummaryPanBlock =
        activeHorizontalIndex === 0 && activeVerticalIndex === 0;
      const showAadhaarField =
        !hideAadhaarOnSummaryPanStep &&
        isAadhaarVerifiedInSummary &&
        Boolean(aadhaarValue);

      return (
        <>
          {showEmailField && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography className="text-lable" sx={{ mb: 0.5 }}>
                Student Email ID
              </Typography>
              {isEmailVerifiedInSummary ? (
                <InputField
                  fullWidth
                  value={studentEmailValue}
                  disabled
                  placeholder=""
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "#28c76f",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          <img
                            src={greenCheckVerified}
                            alt="Verified"
                            style={{ width: 14, height: 14 }}
                          />
                          Verified
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                />
              ) : (
                <InputField
                  fullWidth
                  value={studentEmailValue}
                  placeholder="Enter Email ID and verify"
                  autoComplete="new-password"
                  inputProps={{ autoComplete: "off", maxLength: 40 }}
                  error={duplicateSummaryApplicantStudentEmail}
                  helperText={
                    duplicateSummaryApplicantStudentEmail
                      ? "This email is already used in another field."
                      : ""
                  }
                  onChange={(e) => {
                    if (disableApplicantStudentEmailOnSummaryPanBlock) {
                      return;
                    }
                    const inputValue = e.target.value;
                    setFieldValue?.("email", inputValue, false);
                    setFieldValue?.("studentDetailEmail", inputValue, false);
                    dispatch(
                      updateFormData({
                        email: inputValue,
                        studentDetailEmail: inputValue,
                      })
                    );
                    const norm = String(inputValue || "").trim().toLowerCase();
                    const normLast = String(lastVerifiedEmail || "")
                      .trim()
                      .toLowerCase();
                    if (norm !== normLast) {
                      dispatch(setIsEmailVerified(false));
                    }
                  }}
                  InputProps={{
                    readOnly:
                      disableApplicantStudentEmailOnSummaryPanBlock ||
                      isApiLoading,
                    endAdornment: disableApplicantStudentEmailOnSummaryPanBlock ? (
                      <InputAdornment position="end">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mr: 0.5,
                            px: 1,
                            py: 0.35,
                            borderRadius: "4px",
                            bgcolor: "rgba(255, 159, 67, 0.14)",
                            border: "1px solid rgba(255, 159, 67, 0.45)",
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              color: "#ff9f43",
                              fontSize: "11px",
                              fontWeight: 600,
                              lineHeight: 1.2,
                            }}
                          >
                            Not Verified
                          </Typography>
                        </Box>
                      </InputAdornment>
                    ) : (
                      <Button
                        sx={{
                          backgroundColor: isEmailVerifiedInSummary
                            ? "transparent"
                            : "#FEC10D",
                          color: isEmailVerifiedInSummary ? "#28C76F" : "#000000",
                          "&:hover": {
                            backgroundColor: isEmailVerifiedInSummary
                              ? "transparent"
                              : "#FEC10D",
                            color: isEmailVerifiedInSummary ? "#28C76F" : "#000000",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: isEmailVerifiedInSummary
                              ? "transparent"
                              : "#FEC10D",
                            color: isEmailVerifiedInSummary ? "#28C76F" : "#000000",
                            WebkitTextFillColor: isEmailVerifiedInSummary
                              ? "#28C76F"
                              : "#000000",
                            opacity: 1,
                          },
                          "& img": {
                            opacity: 1,
                            filter: "brightness(1)",
                          },
                          textTransform: "none",
                          fontSize: isEmailVerifiedInSummary ? "16px" : "10px",
                          fontWeight: isEmailVerifiedInSummary ? 400 : 700,
                          px: "15px",
                          borderRadius: "4px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: "none",
                          height: "100%",
                          mr: 0.5,
                        }}
                        onClick={
                          isApiLoading
                            ? undefined
                            : async () => {
                                if (
                                  isEmailVerifiedInSummary ||
                                  duplicateSummaryApplicantStudentEmail ||
                                  !normalizedSummaryStudentEmail
                                ) {
                                  return;
                                }
                                try {
                                  let name =
                                    `${values?.studentDetailsFirstName || values?.firstName || ""} ${values?.studentDetailsLastName || values?.lastName || ""}`.trim();
                                  const email = String(
                                    studentEmailValue || ""
                                  ).trim();
                                  setOtpEmail(email);
                                  setOtpEmailFieldName("studentDetailEmail");
                                  dispatch(setCurrentCoApplicantIdx(null));

                                  const resp =
                                    await eligibilityCheckServices.sendOtp({
                                      name,
                                      email: email.toLowerCase(),
                                    });
                                  if (resp?.data?.status === "fail") {
                                    dispatch(
                                      setStatusPopup({
                                        status: "error",
                                        message: resp.data.message,
                                      })
                                    );
                                    return;
                                  }
                                  setOtpEmailKey(resp.data.data.value);
                                  setOtpEmailTime(resp.data.data.otpTime);
                                  setOpenEmailOtp(true);
                                } catch (err: any) {
                                  const apiMsg =
                                    err?.response?.data?.errors?.[0]
                                      ?.constraints?.isEmail;
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message: apiMsg,
                                    })
                                  );
                                }
                              }
                        }
                        disabled={
                          isApiLoading ||
                          isEmailVerifiedInSummary ||
                          duplicateSummaryApplicantStudentEmail ||
                          !normalizedSummaryStudentEmail
                        }
                      >
                        <Typography variant="inherit">Verify</Typography>
                        <img
                          src={arrowRightVerify}
                          alt="Verified"
                          style={{
                            height: "15px",
                            objectFit: "contain",
                            imageRendering: "-webkit-optimize-contrast",
                          }}
                        />
                      </Button>
                    ),
                  }}
                />
              )}
            </Grid>
          )}

          {isPanVerifiedInSummary ? (
            <Grid item xs={12} sm={6} md={3}>
              <Typography className="text-lable" sx={{ mb: 0.5 }}>
                PAN Number
              </Typography>
              <InputField
                fullWidth
                value={panValue}
                disabled
                placeholder=""
                autoComplete="new-password"
                inputProps={{ maxLength: 10, style: { textTransform: "uppercase" } }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          color: "#28c76f",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      >
                        <img
                          src={greenCheckVerified}
                          alt="Verified"
                          style={{ width: 14, height: 14 }}
                        />
                        Verified
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={showEmailField ? 3 : 12}
                md={showEmailField ? 3 : 12}
              >
                {!isXsOrSm ? (
                  <label className="text-lable">
                    Do you have PAN? <span style={{ color: "red" }}>*</span>
                  </label>
                ) : (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#4B465C",
                      mb: 0.5,
                    }}
                  >
                    Do you have PAN? <span style={{ color: "red" }}>*</span>
                  </Typography>
                )}
                <RadioGroup
                  row
                  name="has_pan"
                  value={hasPan}
                  onChange={(e) => {
                    const choice = e.target.value;
                    const dobValue = values?.dob;
                    const motherName = values?.motherName;
                    const fatherName = values?.fatherName;
                    const gender = values?.gender;
                    const aadhaar = values?.aadhaar;
                    const firstName = values?.firstName;
                    const lastName = values?.lastName;

                    dispatch(setHasPan(choice));

                    if (choice === "no") {
                      dispatch(setLastPanNumber(panNumber));
                      setPanNumberValue("");
                      dispatch(setPanNumber(""));
                      dispatch(setIsPanVerified(false));
                      setFieldValue?.("pan", "");
                      dispatch(
                        updateFormData({
                          pan: "",
                          dob: dobValue,
                          motherName,
                          fatherName,
                          gender,
                          aadhaar,
                          firstName,
                          lastName,
                        })
                      );
                      dispatch(setAadhaarMandatory(true));
                      dispatch(setShowAadhaar(true));
                    } else {
                      const restored =
                        reduxLastPanNumber &&
                        /^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(reduxLastPanNumber)
                          ? reduxLastPanNumber.toUpperCase()
                          : "";
                      setPanNumberValue(restored);
                      dispatch(setPanNumber(restored));
                      setFieldValue?.("pan", restored);
                      dispatch(
                        updateFormData({
                          pan: restored,
                          dob: dobValue,
                          motherName,
                          fatherName,
                          gender,
                          aadhaar,
                          firstName,
                          lastName,
                        })
                      );
                      if (!urlParams.get("document_verified")) {
                        dispatch(
                          setAadhaarMandatory(
                            panNumber == reduxLastPanNumber &&
                              panNumber != "" &&
                              isPanVerified
                          )
                        );
                        dispatch(
                          setShowAadhaar(
                            panNumber == reduxLastPanNumber &&
                              panNumber !== "" &&
                              isPanVerified
                          )
                        );
                      }
                    }
                    dispatch(
                      setVerificationMessage({
                        index: "",
                        applicantType: "",
                        field: "",
                        status: "",
                        message: "",
                      })
                    );
                  }}
                  sx={{ flexDirection: "row" }}
                >
                  <FormControlLabel
                    value="yes"
                    control={<RadioButton />}
                    label="Yes"
                    classes={{ label: "text-lable" }}
                  />
                  <FormControlLabel
                    value="no"
                    control={<RadioButton />}
                    label="No"
                    classes={{ label: "text-lable" }}
                  />
                </RadioGroup>
                {!showPanInput && panFieldError && (
                  <Typography sx={{ fontSize: "12px", fontWeight: 500, mt: 0.5, color: "error.main" }}>
                    {panFieldError}
                  </Typography>
                )}
              </Grid>
              {showPanInput && (
                <Grid item xs={12} sm={6} md={3}>
                  <Typography className="text-lable" sx={{ mb: 0.5 }}>
                    PAN Number
                  </Typography>
                  <InputField
                    fullWidth
                    value={panValue}
                    disabled={isApiLoading}
                    placeholder=""
                    autoComplete="new-password"
                    inputProps={{ maxLength: 10, style: { textTransform: "uppercase" } }}
                    onChange={(e) => {
                      let newPan = e.target.value?.toUpperCase() || "";
                      if (newPan.length > 10) {
                        newPan = newPan.slice(0, 10);
                      }
                      setPanNumberValue(newPan);
                      dispatch(setPanNumber(newPan));
                      setFieldValue && setFieldValue("pan", newPan);
                      dispatch(setIsPanVerified(false));
                      dispatch(
                        setVerificationMessage({
                          applicantType: "applicant",
                          field: "pan",
                          status: "",
                          message: "",
                        })
                      );
                    }}
                    InputProps={{
                      readOnly: isApiLoading || isPanVerifiedInSummary,
                      endAdornment: (
                        <Button
                          sx={{
                            backgroundColor: "#FEC10D",
                            color: "#000000",
                            "&:hover": {
                              backgroundColor: "#FEC10D",
                              color: "#000000",
                            },
                            textTransform: "none",
                            fontSize: "10px",
                            fontWeight: 700,
                            px: "15px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "none",
                            height: "100%",
                            mr: 0.5,
                          }}
                          onClick={isApiLoading ? undefined : async () => {
                            try {
                              setIsPanLoading(true);
                              if (!values?.dob) {
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "error",
                                    message:
                                      "Please enter your Date of Birth before verifying your PAN.",
                                  })
                                );
                                return;
                              }
                              if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panValue)) {
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "error",
                                    message: "Please enter a valid PAN number.",
                                  })
                                );
                                return;
                              }

                              const piiPublicKey = await fetchSanitizedPiiPublicKey();
                              if (!piiPublicKey) return;

                              const payload = await encryptData(
                                {
                                  panNumber: panValue,
                                  fullName: `${values.firstName || ""} ${values.lastName || ""}`.trim(),
                                  dob: values.dob
                                    ? new Date(values.dob).toLocaleDateString("en-GB")
                                    : "",
                                  trackingId: trackingId,
                                  applicantType: "Applicant",
                                },
                                ["panNumber"],
                                piiPublicKey
                              );

                              const resp = await applicantDetailsServices.verifyPan(payload);
                              if (resp.status === 200) {
                                dispatch(setPanNumber(panValue));
                                dispatch(setIsPanVerified(true));
                                dispatch(setLastPanNumber(panValue));
                                setFieldValue && setFieldValue("pan", panValue);
                                setFieldValue &&
                                  setFieldValue("isPanVerified", true);
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "success",
                                    message: "Yay! Your PAN has been verified successfully.",
                                  })
                                );
                              } else {
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "error",
                                    message:
                                      "Uh-oh! PAN verification failed. Please check the details and try again.",
                                  })
                                );
                              }
                            } catch {
                              dispatch(
                                setVerificationMessage({
                                  applicantType: "applicant",
                                  field: "pan",
                                  status: "error",
                                  message:
                                    "Uh-oh! PAN verification failed. Please check the details and try again.",
                                })
                              );
                            } finally {
                              setIsPanLoading(false);
                            }
                          }}
                          disabled={isApiLoading || isPanLoading || !panValue}
                        >
                          {isPanLoading ? (
                            <CircularProgress size={16} color="inherit" />
                          ) : (
                            <>
                              <Typography variant="inherit">Verify</Typography>
                              <img
                                src={arrowRightVerify}
                                alt="Verify"
                                style={{
                                  height: "15px",
                                  objectFit: "contain",
                                  imageRendering: "-webkit-optimize-contrast",
                                }}
                              />
                            </>
                          )}
                        </Button>
                      ),
                    }}
                  />
                  {verificationMessage?.message &&
                    verificationMessage?.field === "pan" && (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          mt: 0.5,
                          color:
                            verificationMessage?.status === "success"
                              ? "success.main"
                              : "error.main",
                        }}
                      >
                        {verificationMessage?.message}
                      </Typography>
                    )}
                  {!(verificationMessage?.message && verificationMessage?.field === "pan") &&
                    panFieldError && (
                      <Typography sx={{ fontSize: "12px", fontWeight: 500, mt: 0.5, color: "error.main" }}>
                        {panFieldError}
                      </Typography>
                    )}
                </Grid>
              )}
            </>
          )}
        </>
      );
    }

    return (
      <>
      <Grid container className="inner-form-box" ml={2} mt={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <img src={idIcon} alt="icon" style={{ width: 20, height: 20 }} />

            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#4B465C",
              }}
            >
              Verify your PAN now to speed up the process
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          {!isXsOrSm ? (
            <label className="text-lable">Do you have PAN? <span style={{ color: "red" }}>*</span></label>
          ) : (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#4B465C",
                mt: 2,
              }}
            >
              Do you have PAN? <span style={{ color: "red" }}>*</span>
            </Typography>
          )}

          <RadioGroup
            row
            name="has_pan"
            value={hasPan}
            onChange={(e) => {
              const choice = e.target.value;
              // Preserve dob value in Redux formData when toggling PAN radio
              const dobValue = values?.dob;
              const motherName = values?.motherName;
              const fatherName = values?.fatherName;
              const gender = values?.gender;
              const aadhaar = values?.aadhaar;
              const firstName = values?.firstName;
              const lastName = values?.lastName;

              dispatch(setHasPan(choice));

              if (choice === "no") {
                dispatch(setLastPanNumber(panNumber));
                setPanNumberValue("");
                dispatch(setPanNumber(""));
                dispatch(setIsPanVerified(false));
                setFieldValue?.("pan", "");
                dispatch(
                  updateFormData({
                    pan: "",
                    dob: dobValue,
                    motherName,
                    fatherName,
                    gender,
                    aadhaar,
                    firstName,
                    lastName,
                  })
                );
                dispatch(setAadhaarMandatory(true));
                dispatch(setShowAadhaar(true));
              } else {
                const restored =
                  reduxLastPanNumber &&
                  /^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(reduxLastPanNumber)
                    ? reduxLastPanNumber.toUpperCase()
                    : "";
                setPanNumberValue(restored);
                dispatch(setPanNumber(restored));
                setFieldValue?.("pan", restored);
                dispatch(
                  updateFormData({
                    pan: restored,
                    dob: dobValue,
                    motherName,
                    fatherName,
                    gender,
                    aadhaar,
                    firstName,
                    lastName,
                  })
                );

                if (!urlParams.get("document_verified")) {
                  dispatch(
                    setAadhaarMandatory(
                      panNumber == reduxLastPanNumber &&
                        panNumber != "" &&
                        isPanVerified
                    )
                  );
                  dispatch(
                    setShowAadhaar(
                      panNumber == reduxLastPanNumber &&
                        panNumber !== "" &&
                        isPanVerified
                    )
                  );
                }
              }

              dispatch(
                setVerificationMessage({
                  index: "",
                  applicantType: "",
                  field: "",
                  status: "",
                  message: "",
                })
              );
            }}
            sx={{ flexDirection: "row" }}
          >
            <FormControlLabel
              value="yes"
              control={<RadioButton />}
              label="Yes"
              classes={{ label: "text-lable" }}
            // disabled={true}
            />
            <FormControlLabel
              value="no"
              control={<RadioButton />}
              label="No"
              classes={{ label: "text-lable" }}
              disabled={isPanVerified}
            />
          </RadioGroup>
        </Grid>

        {(() => {
          const panVis = String(values?.pan || "").trim();
          const panVisIsYesNo =
            panVis.toLowerCase() === "yes" || panVis.toLowerCase() === "no";
          return (
            hasPan === "yes" ||
            Boolean(panNumberValue) ||
            (Boolean(panVis) && !panVisIsYesNo)
          );
        })() && (
          <>
            <Grid item xs={12} sm={8} md={8}>
              <FormGrid
                fields={[
                  {
                    label: "PAN Number",
                    component: (
                      <InputField
                        fullWidth
                        placeholder=""
                        value={panNumberValue?.toUpperCase()}
                        // disabled={isApiLoading || isPanVerified}
                        inputProps={{ maxLength: 10 }}
                        autoComplete="new-password"
                        onKeyDown={(e) => {
                          // Block leading space: allow spaces only after first character
                          if (e.key === " ") {
                            const target = e.target as HTMLInputElement;
                            const start = target.selectionStart ?? 0;
                            if (start === 0) {
                              e.preventDefault();
                            }
                          }
                        }}
                        onChange={(e) => {
                          let newPan = e.target.value?.toUpperCase();
                          // Preserve dob value in Redux formData when toggling PAN radio
                          const dobValue = values?.dob;
                          if (newPan.length > 10) {
                            newPan = newPan.slice(0, 10);
                          }
                          setPanNumberValue(newPan);
                          dispatch(setPanNumber(newPan));
                          setFieldValue && setFieldValue("pan", newPan);
                          // Mark as touched and force validation on every change for immediate error display
                          if (formikRef.current?.setFieldTouched) {
                            formikRef.current.setFieldTouched(
                              "pan",
                              true,
                              false
                            );
                          }
                          // Use setTimeout to ensure Formik state is updated before validation
                          if (formikRef.current?.validateField) {
                            setTimeout(() => {
                              formikRef.current?.validateField("pan");
                            }, 0);
                          }
                          // Always run filled fields/verification logic for any 10-char input
                          handleFilledFieldsCount("pan", newPan);
                          if (newPan === "") {
                            dispatch(setIsPanVerified(false));
                          } else {
                            if (newPan === reduxLastPanNumber) {
                              dispatch(setIsPanVerified(true));
                            } else {
                              dispatch(setIsPanVerified(false));
                            }
                          }

                          // setting empty data on input value changes
                          dispatch(
                            setVerificationMessage({
                              index: "",
                              applicantType: "",
                              field: "",
                              status: "",
                              message: "",
                            })
                          );
                        }}
                        error={
                          (verificationMessage?.field === "pan" &&
                            verificationMessage?.status === "error" &&
                            !!verificationMessage?.message) ||
                          (!!formikRef.current?.touched?.pan &&
                            !!panNumberValue &&
                            !!formikRef.current?.errors?.pan)
                        }
                        helperText={
                          // A PAN verify message is shown below; don't stack the schema error with it
                          verificationMessage?.field === "pan" &&
                            !!verificationMessage?.message
                            ? undefined
                            : formikRef.current?.touched?.pan &&
                              !!panNumberValue &&
                              typeof formikRef.current?.errors?.pan === "string"
                              ? formikRef.current?.errors?.pan
                              : undefined
                        }
                        variant="outlined"
                        InputProps={{
                          readOnly: isApiLoading || isPanVerified,
                          style: { textTransform: "uppercase" },
                          endAdornment: (
                            <Button
                              sx={{
                                backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                color: isPanVerified ? "#28C76F" : "#000000",
                                "&:hover": {
                                  backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                  color: isPanVerified ? "#28C76F" : "#000000",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                  color: isPanVerified ? "#28C76F" : "#000000",
                                  WebkitTextFillColor: isPanVerified ? "#28C76F" : "#000000",
                                  opacity: 1,
                                },
                                "& img": {
                                  opacity: 1,
                                  filter: "brightness(1)",
                                },
                                textTransform: "none",
                                fontSize: isPanVerified ? "16px" : "10px",
                                fontWeight: isPanVerified ? 400 : 700,
                                px: "15px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "none",
                                height: '100%',
                                mr: 0.5,
                              }}
                              onClick={isApiLoading || isPanVerified ? undefined : async () => {
                                try {
                                  setIsPanLoading(true);
                                  if (!values.dob) {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please enter your Date of Birth before verifying your PAN.",
                                      })
                                    );
                                    return;
                                  }
                                  if (!String(panNumberValue || "").trim()) {
                                    dispatch(
                                      setVerificationMessage({
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please enter your PAN to proceed with verification.",
                                      })
                                    );
                                    return;
                                  }
                                  if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(panNumberValue).trim().toUpperCase())) {
                                    dispatch(
                                      setVerificationMessage({
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please enter a valid 10-digit PAN number.",
                                      })
                                    );
                                    return;
                                  }


                                  const piiPublicKey =
                                    await fetchSanitizedPiiPublicKey();
                                  if (!piiPublicKey) return;

                                  const payload = await encryptData(
                                    {
                                      panNumber: panNumberValue,
                                      fullName: `${values.firstName || ""} ${values.lastName || ""
                                        }`.trim(),
                                      dob: values.dob
                                        ? new Date(
                                          values.dob
                                        ).toLocaleDateString("en-GB")
                                        : "",
                                      trackingId: trackingId,
                                      applicantType: "Applicant",
                                    },
                                    ["panNumber"],
                                    piiPublicKey
                                  );

                                  const resp =
                                    await applicantDetailsServices.verifyPan(payload);
                                  if (
                                    resp.status === 200 &&
                                    resp.data?.data?.dateOfBirth === "invalid" &&
                                    values.dob
                                  ) {

                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                      })
                                    );
                                  } else if (
                                    resp.status === 200 &&
                                    resp.data?.data?.dateOfBirth.toLowerCase() === "invalid" &&
                                    resp.data?.data?.panStatus.toLowerCase() === "invalid"
                                  ) {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                      })
                                    );
                                  } else if (resp.status === 200) {
                                    const isAadhaarSeeded =
                                      String(
                                        resp?.data?.data
                                          ?.aadhaarSeedingStatus || ""
                                      ).toLowerCase() === "y";
                                    dispatch(
                                      updateFormData({
                                        pan: panNumber,
                                        dob: values.dob,
                                      })
                                    );
                                    dispatch(
                                      setAadhaarSeedingStatus(isAadhaarSeeded)
                                    );
                                    setPanNumberValue(panNumber);
                                    setFieldValue("pan", panNumberValue);
                                    dispatch(setPanNumber(panNumberValue));
                                    dispatch(setIsPanVerified(true));
                                    dispatch(setLastPanNumber(panNumberValue));
                                    dispatch(
                                      setAadhaarMandatory(
                                        resp.data.data.adharMandatory
                                      )
                                    );
                                    dispatch(
                                      setShowAadhaar(
                                        resp.data.data.adharMandatory
                                      )
                                    );

                                    trackCustomerJourneyEvent(
                                      `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                      decrypt(userProfile?.id) ?? "",
                                      trackingId,
                                      {
                                        label: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        category: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        action: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        page: "ProvisionalOff_Student Details_PAN Verification",
                                      }
                                    );

                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "success",
                                        message:
                                          "Yay! Your PAN has been verified successfully.",
                                      })
                                    );

                                    // Add this line:
                                    handleFilledFieldsCount("pan", panNumber);
                                  } else if (resp.status === 400) {
                                    dispatch(
                                      setVerificationMessage({
                                        index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message:
                                          "Uh-oh! We are experiencing some technical issues fetching PAN details. Please try again later.",
                                      })
                                    );
                                  } else {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message:
                                          "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                      })
                                    );
                                  }
                                } catch (err: any) {
                                  dispatch(
                                    setVerificationMessage({
                                      // index: "",
                                      applicantType: "applicant",
                                      field: "pan",
                                      status: "error",
                                      message: err?.response?.data?.errors?.[0]?.property === "dob" ?
                                        "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them."
                                        : err?.response?.data?.message,
                                    })
                                  );
                                } finally {
                                  setIsPanLoading(false);
                                }
                              }}
                              disabled={isPanLoading || isPanVerified}
                            >
                              {isPanLoading
                                ? <CircularProgress size={16} />
                                : isPanVerified ? (
                                  <>
                                    <img
                                      src={greenCheckVerified}
                                      alt="Verified"
                                      style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                    <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="inherit">Verify</Typography>
                                    <img
                                      src={arrowRightVerify}
                                      alt="Verified"
                                      style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                  </>
                                )
                              }
                            </Button>
                          ),
                        }}
                      />
                    ),
                  },
                ]}
              />
            </Grid>

            {/* displaying PAN activity related messages */}
            <Grid item xs={12} mt={1}>
              {verificationMessage?.message &&
                verificationMessage?.field === "pan" && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color:
                        verificationMessage?.status === "success"
                          ? "success.main"
                          : "error.main",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {verificationMessage?.message}
                  </Typography>
                )}
            </Grid>
          </>
        )}
      </Grid>
    </>
    );
  };
  
  // Current Address fields
  const currFields = fields.filter(
    (f) => f.required && f.name?.toLowerCase()?.startsWith("current")
  );
  // Employment Address fields
  const employmentFields = fields.filter(
    (f) =>
      f.required &&
      f.name?.toLowerCase().includes("employment") &&
      !f.name?.toLowerCase().includes("employmentcompany")
  );

  // Company Address fields
  const companyFields = fields.filter(
    (f) =>
      f.required &&
      f.name?.toLowerCase().includes("employmentcompany") &&
      f.name !== "employmentCompanyName"
  );

  // Core and Language fields from Entrance Exam
  const coreFields = fields.filter((f) => f.name?.startsWith("core"));
  const languageFields = fields.filter((f) => f.name?.startsWith("language"));

  const otherFields = fields.filter(
    (f) =>
      f.required &&
      !f.name?.toLowerCase()?.startsWith("current") &&
      !f.name?.toLowerCase().includes("employmentcompany") &&
      f.name !== "employmentCompanyName"
  );

  const getFilledCount = (fieldSubset: any[], values: any) => {
    if (!Array.isArray(fieldSubset)) return 0;
    return fieldSubset.filter((field: any) => {
      if (!field?.name) return false;

      // Exclude checkboxes for step 1, form 1
      if (
        field.type === "checkbox" &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 0
      ) {
        return false;
      }

      const val = values?.[field.name];

      // Handle checkboxes separately
      if (field.type === "checkbox") {
        // Accept both boolean true and string 'true' as checked
        return val === true || val === "true";
      }

      // For arrays (like multi-select), check length
      if (Array.isArray(val)) {
        return val.length > 0;
      }

      // For normal text/number fields
      return val !== undefined && val !== null && val !== "";
    }).length;
  };

  const getFilledCountWithPanAadhaar = (fieldSubset: any[], values: any) => {
    let count = getFilledCount(fieldSubset, values);
    return count;
  };

  const fatherName = aadhaarVerifiedDetails?.careOf || formikRef?.current?.values?.fatherName;

  // Function to check and uncheck address checkbox
  const checkAndUncheckAddressCheckbox = useCallback(() => {
    const values = formikRef?.current?.values;
    if (!values) return;

    // Helper function to normalize values for comparison
    const normalizeValue = (val: any) => {
      if (val === null || val === undefined || val === '') return '';
      return String(val).trim();
    };

    // Helper function to check if at least one address field is filled
    const hasAddressData = (prefix = '', addressType = 'permanent') => {
      const owner = normalizeValue(values[`${prefix}${addressType}OwnershipStatus`]);
      const yearsInCurrentAddress = normalizeValue(values[`${prefix}${addressType}YearsInCurrentAddress`]);
      const YearsInCurrentCity = normalizeValue(values[`${prefix}${addressType}YearsInCurrentCity`]);
      const line1 = normalizeValue(values[`${prefix}${addressType}AddressLine1`]);
      const line2 = normalizeValue(values[`${prefix}${addressType}AddressLine2`]);
      const line3 = normalizeValue(values[`${prefix}${addressType}AddressLine3`]);
      const pincode = normalizeValue(values[`${prefix}${addressType}Pincode`]);
      const city = normalizeValue(values[`${prefix}${addressType}City`]);
      const state = normalizeValue(values[`${prefix}${addressType}State`]);
      const country = normalizeValue(values[`${prefix}${addressType}Country`]);

      return owner || yearsInCurrentAddress || YearsInCurrentCity || line1 || line2 || line3 || pincode || city || state || country;
    };

    // Helper function to compare addresses
    const areAddressesDifferent = (prefix = '') => {
      const hasPermanentData = hasAddressData(prefix, 'permanent');
      const hasCurrentData = hasAddressData(prefix, 'current');
      if (!hasPermanentData || !hasCurrentData) {
        return false;
      }
      const permanentOwnershipStatus = normalizeValue(values[`${prefix}permanentOwnershipStatus`]);
      const permanentYearsInCurrentAddress = normalizeValue(values[`${prefix}permanentYearsInCurrentAddress`]);
      const permanentYearsInCurrentCity = normalizeValue(values[`${prefix}permanentYearsInCurrentCity`]);
      const permanentAddressLine1 = normalizeValue(values[`${prefix}permanentAddressLine1`]);
      const permanentAddressLine2 = normalizeValue(values[`${prefix}permanentAddressLine2`]);
      const permanentAddressLine3 = normalizeValue(values[`${prefix}permanentAddressLine3`]);
      const permanentPincode = normalizeValue(values[`${prefix}permanentPincode`]);
      const permanentCity = normalizeValue(values[`${prefix}permanentCity`]);
      const permanentState = normalizeValue(values[`${prefix}permanentState`]);
      const permanentCountry = normalizeValue(values[`${prefix}permanentCountry`]);

      const currentOwnershipStatus = normalizeValue(values[`${prefix}currentOwnershipStatus`]);
      const currentYearsInCurrentAddress = normalizeValue(values[`${prefix}currentYearsInCurrentAddress`]);
      const currentYearsInCurrentCity = normalizeValue(values[`${prefix}currentYearsInCurrentCity`]);
      const currentAddressLine1 = normalizeValue(values[`${prefix}currentAddressLine1`]);
      const currentAddressLine2 = normalizeValue(values[`${prefix}currentAddressLine2`]);
      const currentAddressLine3 = normalizeValue(values[`${prefix}currentAddressLine3`]);
      const currentPincode = normalizeValue(values[`${prefix}currentPincode`]);
      const currentCity = normalizeValue(values[`${prefix}currentCity`]);
      const currentState = normalizeValue(values[`${prefix}currentState`]);
      const currentCountry = normalizeValue(values[`${prefix}currentCountry`]);

      return (
        permanentOwnershipStatus !== currentOwnershipStatus ||
        permanentYearsInCurrentAddress !== currentYearsInCurrentAddress ||
        permanentYearsInCurrentCity !== currentYearsInCurrentCity ||
        permanentAddressLine1 !== currentAddressLine1 ||
        permanentAddressLine2 !== currentAddressLine2 ||
        permanentAddressLine3 !== currentAddressLine3 ||
        permanentPincode !== currentPincode ||
        permanentCity !== currentCity ||
        permanentState !== currentState ||
        permanentCountry !== currentCountry
      );
    };

    // Check for main applicant
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      if (values.currentsameAsPermanent && areAddressesDifferent('')) {
        formikRef?.current?.setFieldValue('currentsameAsPermanent', false);
        setIsCurrentSameAsPermanent(false);
      }
      if (!areAddressesDifferent('')) {
        formikRef?.current?.setFieldValue('currentsameAsPermanent', true);
        setIsCurrentSameAsPermanent(true);
      }
    }

    // Check for co-applicants
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
      Object.keys(values).forEach((key) => {
        const coAppMatch = key.match(/^addressCoApplicant(\d+)currentsameAsPermanent$/);
        if (coAppMatch) {
          const coAppNum = coAppMatch[1];
          const prefix = `addressCoApplicant${coAppNum}`;

          if (values[key] && areAddressesDifferent(prefix)) {
            formikRef?.current?.setFieldValue(key, false);
          }
        }
      });
    }
  }, [activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    if (
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 || activeVerticalIndex === 1)
    ) {
      formikRef?.current?.setFieldValue(
        "permanentCountry",
        formikRef?.current?.values?.permanentCountry ||
        aadhaarVerifiedDetails?.country
      );
      formikRef?.current?.setFieldValue(
        "permanentPincode",
        formikRef?.current?.values?.permanentPincode ||
        aadhaarVerifiedDetails?.pincode
      );
      formikRef?.current?.setFieldValue(
        "permanentState",
        formikRef?.current?.values?.permanentState ||
        aadhaarVerifiedDetails?.state
      );

      const conCatAddress: string = [
        handleUnwanted(aadhaarVerifiedDetails?.house),
        handleUnwanted(aadhaarVerifiedDetails?.street),
        handleUnwanted(aadhaarVerifiedDetails?.landmark),
        handleUnwanted(aadhaarVerifiedDetails?.locality),
        //aadhaarVerifiedDetails?.vtc,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      let chunkSize: boolean = conCatAddress.length > 50; // Condition applied here

      // Check if user has manually entered any address data (from formik values OR from formData/Redux)
      const hasManualPermanentAddress = (
        (formikRef?.current?.values?.permanentAddressLine1 && formikRef?.current?.values?.permanentAddressLine1.trim() !== "") ||
        (formikRef?.current?.values?.permanentAddressLine2 && formikRef?.current?.values?.permanentAddressLine2.trim() !== "") ||
        (formikRef?.current?.values?.permanentAddressLine3 && formikRef?.current?.values?.permanentAddressLine3.trim() !== "") ||
        (formData?.permanentAddressLine1 && formData?.permanentAddressLine1.trim() !== "") ||
        (formData?.permanentAddressLine2 && formData?.permanentAddressLine2.trim() !== "") ||
        (formData?.permanentAddressLine3 && formData?.permanentAddressLine3.trim() !== "")
      );

      if (hasManualPermanentAddress) {
        // User has entered data, preserve it
        // Don't overwrite with Aadhaar data
      } else if (chunkSize) {
        const addressLines = splitAddressByWords(conCatAddress);
        const addr1: string = addressLines[0] || "";
        const addr2: string = addressLines[1] || "";
        const addr3: string = addressLines[2] || "";
        formikRef?.current?.setFieldValue("permanentAddressLine1", addr1);
        formikRef?.current?.setFieldValue("permanentAddressLine2", addr2);
        formikRef?.current?.setFieldValue("permanentAddressLine3", addr3);
      } else {

        formikRef?.current?.setFieldValue(
          "permanentAddressLine1",
          aadhaarVerifiedDetails?.house || ""
        );
        formikRef?.current?.setFieldValue(
          "permanentAddressLine2",
          `${aadhaarVerifiedDetails?.street || ""} ${aadhaarVerifiedDetails?.landmark || ""
            }`.trim()
        );
        formikRef?.current?.setFieldValue(
          "permanentAddressLine3",
          `${aadhaarVerifiedDetails?.locality || ""}`.trim()
        );
      }

      formikRef?.current?.setFieldValue(
        "permanentCity",
        formikRef?.current?.values?.permanentCity ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.vtc) ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.district)
      );

      formikRef?.current?.setFieldValue(
        "currentCountry",
        formikRef?.current?.values?.currentCountry ||
        aadhaarVerifiedDetails?.country
      );
      formikRef?.current?.setFieldValue(
        "currentPincode",
        formikRef?.current?.values?.currentPincode ||
        aadhaarVerifiedDetails?.pincode
      );
      formikRef?.current?.setFieldValue(
        "currentState",
        formikRef?.current?.values?.currentState ||
        aadhaarVerifiedDetails?.state
      );

      const conCatCurrentAddress: string = [
        handleUnwanted(aadhaarVerifiedDetails?.house),
        handleUnwanted(aadhaarVerifiedDetails?.street),
        handleUnwanted(aadhaarVerifiedDetails?.landmark),
        handleUnwanted(aadhaarVerifiedDetails?.locality),
        //aadhaarVerifiedDetails?.vtc,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      let chunkSize2: boolean = conCatCurrentAddress.length > 50; // Condition applied here

      // Check if user has manually entered any address data (from formik values OR from formData/Redux)
      const hasManualCurrentAddress = (
        (formikRef?.current?.values?.currentAddressLine1 && formikRef?.current?.values?.currentAddressLine1.trim() !== "") ||
        (formikRef?.current?.values?.currentAddressLine2 && formikRef?.current?.values?.currentAddressLine2.trim() !== "") ||
        (formikRef?.current?.values?.currentAddressLine3 && formikRef?.current?.values?.currentAddressLine3.trim() !== "") ||
        (formData?.currentAddressLine1 && formData?.currentAddressLine1.trim() !== "") ||
        (formData?.currentAddressLine2 && formData?.currentAddressLine2.trim() !== "") ||
        (formData?.currentAddressLine3 && formData?.currentAddressLine3.trim() !== "")
      );

      if (hasManualCurrentAddress) {
        // User has entered data, preserve it
        // Don't overwrite with Aadhaar data
      } else if (chunkSize2) {
        const addressLines = splitAddressByWords(conCatCurrentAddress);
        const currentAddr1: string = addressLines[0] || "";
        const currentAddr2: string = addressLines[1] || "";
        const currentAddr3: string = addressLines[2] || "";
        formikRef?.current?.setFieldValue(
          "currentAddressLine1",
          currentAddr1 || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine2",
          currentAddr2 || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine3",
          currentAddr3 || ""
        );
      } else {
        formikRef?.current?.setFieldValue(
          "currentAddressLine1",
          aadhaarVerifiedDetails?.house || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine2",
          `${aadhaarVerifiedDetails?.street || ""} ${aadhaarVerifiedDetails?.landmark || ""
            }`.trim()
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine3",
          `${aadhaarVerifiedDetails?.locality || ""}`.trim()
        );
      }

      formikRef?.current?.setFieldValue(
        "currentCity",
        formikRef?.current?.values?.currentCity ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.vtc) ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.district)
      );

      const dobValue =
        formikRef?.current?.values?.dob ||
        (aadhaarVerifiedDetails?.dob
          ? aadhaarVerifiedDetails.dob.split("-")?.reverse()?.join("-")
          : "");

      formikRef?.current?.setFieldValue("dob", dobValue);
      const genderValue =
        formikRef?.current?.values?.gender ||
        (aadhaarVerifiedDetails?.gender === "M"
          ? "male"
          : aadhaarVerifiedDetails?.gender === "F"
            ? "female"
            : "");

      formikRef?.current?.setFieldValue("gender", genderValue);
      formikRef?.current?.setFieldValue("fatherName", formikRef?.current?.values?.fatherName || fatherName);
    }
  }, [
    formikRef,
    aadhaarVerifiedDetails,
    fatherName,
    activeHorizontalIndex,
    activeVerticalIndex,
    formikRef?.current?.values?.currentPincode
  ]);

  // Per-co-applicant: prepopulate address and personal fields from Aadhaar verification details
  useEffect(() => {
    if (!aadhaarVerifiedDetailsCoApplicant) return;
    Object.entries(aadhaarVerifiedDetailsCoApplicant).forEach(
      ([coAppKey, detailsRaw]) => {
        // coAppKey is like 'CoApplicant1', extract number
        const match = coAppKey.match(/CoApplicant(\d+)/);
        if (!match) return;
        const num = match[1];
        const details = detailsRaw as any;
        if (!details) return;
        // Address fields

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentCountry`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentCountry`
          ] || details?.country
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentPincode`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentPincode`
          ] || details?.pincode
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentState`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentState`
          ] || details?.state
        );

        const conCatPermanentAddress: string = [
          handleUnwanted(details?.house),
          handleUnwanted(details?.street),
          handleUnwanted(details?.landmark),
          handleUnwanted(details?.locality),
          //details?.vtc,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();

        let chunkSize: boolean = conCatPermanentAddress.length > 50; // Condition applied here
        if (chunkSize) {
          const addressLines = splitAddressByWords(conCatPermanentAddress);
          const permanentAddr1: string = addressLines[0] || "";
          const permanentAddr2: string = addressLines[1] || "";
          const permanentAddr3: string = addressLines[2] || "";
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine1`,
            permanentAddr1 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine2`,
            permanentAddr2 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine3`,
            permanentAddr3 || ""
          );
        } else {
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine1`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine1`
            ] || details?.house
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine2`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine2`
            ] || `${details?.street} ${details?.landmark}`
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine3`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine3`
            ] || `${details?.locality}`
          );
        }

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentCity`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentCity`
          ] ||
          normalizeAadhaarAddressPart(details?.vtc) ||
          normalizeAadhaarAddressPart(details?.district)
        );

        // Current address fields
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentCountry`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentCountry`
          ] || details?.country
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentPincode`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentPincode`
          ] || details?.pincode
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentState`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentState`
          ] || details?.state
        );

        const conCatCurrentAddress: string = [
          handleUnwanted(details?.house),
          handleUnwanted(details?.street),
          handleUnwanted(details?.landmark),
          handleUnwanted(details?.locality),
          //details?.vtc,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();

        let chunkSize2: boolean = conCatCurrentAddress.length > 50; // Condition applied here

        if (chunkSize2) {
          const addressLines = splitAddressByWords(conCatCurrentAddress);
          const currentAddr1: string = addressLines[0] || "";
          const currentAddr2: string = addressLines[1] || "";
          const currentAddr3: string = addressLines[2] || "";
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine1`,
            currentAddr1 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine2`,
            currentAddr2 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine3`,
            currentAddr3 || ""
          );
        } else {
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine1`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine1`
            ] || details?.house
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine2`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine2`
            ] || `${details?.street} ${details?.landmark}`
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine3`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine3`
            ] || `${details?.locality}`
          );
        }

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentCity`,
          formikRef?.current?.values?.[`addressCoApplicant${num}currentCity`] ||
          normalizeAadhaarAddressPart(details?.vtc) ||
          normalizeAadhaarAddressPart(details?.district)
        );

        // DOB and gender
        const dobValue =
          formikRef?.current?.values?.[`basicCoApplicant${num}dob`] ||
          (details?.dob ? details.dob.split("-").reverse().join("-") : "");
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}dob`,
          dobValue
        );
        const genderValue =
          formikRef?.current?.values?.[`basicCoApplicant${num}Gender`] ||
          formData?.[`basicCoApplicant${num}Gender`] ||
          (details?.gender === "M"
            ? "male"
            : details?.gender === "F"
              ? "female"
              : "");
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}Gender`,
          genderValue
        );
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}fatherName`,
          formikRef?.current?.values?.[`basicCoApplicant${num}fatherName`] ||
          removeSalutation(details?.careOf)
        );
        [
          "FirstName",
          "LastName",
          "PhoneNumber",
          "Email",
          "salutation",
          "MaritalStatus",
        ].forEach((suffix) => {
          const fieldName = `basicCoApplicant${num}${suffix}`;
          const existingValue = formikRef?.current?.values?.[fieldName];
          if (existingValue === undefined || existingValue === null || existingValue === "") {
            const restoredValue = formData?.[fieldName];
            if (restoredValue !== undefined && restoredValue !== null && restoredValue !== "") {
              formikRef?.current?.setFieldValue(fieldName, restoredValue);
            }
          }
        });
      }
    );
  }, [aadhaarVerifiedDetailsCoApplicant]);

  function getCoApplicantGroups(fields: any) {
    // Find all unique co-applicant prefixes (e.g. coApplicant1, coApplicant2, ...)
    const coApplicantRegex = /^coApplicant(\d+)/;
    const groups: any = {};

    fields.forEach((field: any) => {
      const match: any = field.name.match(coApplicantRegex);
      if (match) {
        const idx = match[1];
        if (!groups[idx]) groups[idx] = [];
        groups[idx].push(field);
      }
    });

    // Sort by index
    return Object.keys(groups)
      .sort((a, b) => Number(a) - Number(b))
      .map((idx) => ({
        label: `Co-Applicant ${idx}`,
        fields: groups[idx],
      }));
  }

  
  function areAllCoApplicantsVerified(values: any) {
    // const groups = getCoApplicantGroups(fields);
    const groups = getCoApplicantGroups(fields);

    return groups.every((group) => {
      const coIdx: any = group.label.split(" ").pop();
      const reduxIdx = String(Number(coIdx) - 1); // zero-based index as string
      const verification = coApplicantVerification[reduxIdx];

      // Only check if co-applicant has a name (i.e., is filled)
      const nameField: any = group.fields.find((fld: any) =>
        fld.name.toLowerCase().endsWith("name")
      );
      const hasName = nameField && values[nameField.name];
      if (!hasName) return true; // skip empty co-applicant
      return (
        verification?.panVerified &&
        // verification?.emailVerified &&
        verification?.mobileVerified
      );
    });
  }

  const getSectionSubtitle = (step: number, form: number) => {
    if (step === 0) {
      if (form === 0) return "Verification Related Details";
      if (form === 1) return "Course Related Details";
      if (form === 2) return "Loan Related Details";
    }
    if (step === 1) {
      if (form === 0) return "Student Related Details";
      if (form === 1) return "Student Permanent Address Related Details";
      if (form === 2) return "Employment Related Details";
      if (form === 3) return "Academic Related Details";
      if (form === 4) return "Entrance Exam Related Details";
      if (form === 5) return "Loan Related Details";
    }
    return "Details";
  };

  function getEntranceExamCompletion(
    values: any,
    fields: any[],
    otherFields: any[],
    getFilledCountWithPanAadhaar: any
  ) {
    const coreExam = values.coreExamApplied;
    const languageExam = values.languageExamApplied;

    // Dynamically get radio fields for denominator
    const radioFields = fields.filter(
      (f) => f.name === "coreExamApplied" || f.name === "languageExamApplied"
    );
    const radioFieldNames = radioFields.map((f) => f.name);

    // Both "No"
    if (coreExam === "No" && languageExam === "No") {
      const filled = radioFieldNames.filter((name) => values[name]).length;
      return `${filled} / ${radioFieldNames.length}`;
    }

    // Only core "No"
    if (coreExam === "No" && languageExam === "Yes") {
      // Exclude languageExamScore/TotalMarks fields if their ScoreReceived is No
      const languageFieldObjs = fields.filter(
        (f) => f.name?.startsWith("language") && f.name !== "languageExamApplied"
      );
      const filteredLanguageFields = languageFieldObjs.filter((f) => {
        if (
          /^languageExamScore(_\d+)?$/.test(f.name) ||
          /^languageTotalMarks(_\d+)?$/.test(f.name)
        ) {
          const match = f.name.match(
            /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "languageScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `languageScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        return true;
      });
      const filled =
        radioFieldNames.filter((name) => values[name]).length +
        filteredLanguageFields.filter(
          (f) => values[f.name] !== undefined && values[f.name] !== ""
        ).length;
      return `${filled} / ${filteredLanguageFields.length + 2}`;
    }

    // Only language "No"
    if (coreExam === "Yes" && languageExam === "No") {
      // Exclude coreExamScore/TotalMarks fields if their ScoreReceived is No
      const coreFieldObjs = fields.filter(
        (f) => f.name?.startsWith("core") && f.name !== "coreExamApplied"
      );
      const filteredCoreFields = coreFieldObjs.filter((f) => {
        if (
          /^coreExamScore(_\d+)?$/.test(f.name) ||
          /^coreTotalMarks(_\d+)?$/.test(f.name)
        ) {
          const match = f.name.match(
            /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "coreScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `coreScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        return true;
      });
      const filled =
        radioFieldNames.filter((name) => values[name]).length +
        filteredCoreFields.filter(
          (f) => values[f.name] !== undefined && values[f.name] !== ""
        ).length;
      return `${filled} / ${filteredCoreFields.length + 2}`;
    }

    // Both "Yes" (default)
    // Exclude exam score and total marks fields from otherFields if Score Received is 'No'
    const filteredOtherFields = otherFields.filter((f) => {
      // For core
      if (
        /^coreExamScore(_\d+)?$/.test(f.name) ||
        /^coreTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding coreScoreReceived field (dynamic)
        const match = f.name.match(
          /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "coreScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `coreScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
      }
      // For language
      if (
        /^languageExamScore(_\d+)?$/.test(f.name) ||
        /^languageTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding languageScoreReceived field (dynamic)
        const match = f.name.match(
          /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "languageScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `languageScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
      }
      return true;
    });

    return `${getFilledCountWithPanAadhaar(filteredOtherFields, values)} / ${filteredOtherFields.length
      }`;
  }

  const isEntranceExamContinueDisabled = (values: any) => {
    const coreExam = values.coreExamApplied;
    const languageExam = values.languageExamApplied;

    const allScoreReceivedFields = fields.filter((f) => {
      if (/^coreScoreReceived(_\d+)?$/.test(f.name)) return coreExam === "Yes";
      if (/^languageScoreReceived(_\d+)?$/.test(f.name)) return languageExam === "Yes";
      return false;
    });
    const hasMissingExpectedDate = allScoreReceivedFields.some((f) => {
      if (values[f.name] !== "No") return false;
      const suffix = f.name.match(/(_\d+)$/)?.[1] ?? "";
      const expectedOnField = f.name?.startsWith("core")
        ? `coreScoreExpectedOn${suffix}`
        : `languageScoreExpectedOn${suffix}`;
      return !values[expectedOnField];
    });
    if (hasMissingExpectedDate) return true;

    // Dynamically get core and language fields
    const coreFields = fields
      .filter((f) => f.name?.startsWith("core") && f.name !== "coreExamApplied")
      .map((f) => f.name);
    const languageFields = fields
      .filter(
        (f) => f.name?.startsWith("language") && f.name !== "languageExamApplied"
      )
      .map((f) => f.name);
    // Both "No"
    if (coreExam === "No" && languageExam === "No") {
      return !coreExam || !languageExam;
    }
    // Only core "No"
    if (coreExam === "No" && languageExam === "Yes") {
      // Exclude languageExamScore/TotalMarks fields if their ScoreReceived is No (dynamic)
      const filteredLanguageFields = languageFields.filter((fieldName) => {
        if (
          /^languageExamScore(_\d+)?$/.test(fieldName) ||
          /^languageTotalMarks(_\d+)?$/.test(fieldName)
        ) {
          const match = fieldName.match(
            /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "languageScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `languageScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        if (
          /^languageExamID(_\d+)?$/.test(fieldName) ||
          /^languageExamId(_\d+)?$/.test(fieldName)
        ) {
          return false;
        }
        // ScoreExpectedOn is only relevant (and required) when the score
        // hasn't been received yet — when scoreReceived is "Yes" it's
        // correctly left blank, so don't count it against "all filled".
        if (/^languageScoreExpectedOn(_\d+)?$/.test(fieldName)) {
          const expectedOnMatch = fieldName.match(
            /^languageScoreExpectedOn_(\d+)$/
          );
          const scoreReceivedKey = expectedOnMatch
            ? `languageScoreReceived_${expectedOnMatch[1]}`
            : "languageScoreReceived";
          return values[scoreReceivedKey] === "No";
        }
        return true;
      });
      const allFilled = filteredLanguageFields.every(
        (f) => values[f] !== undefined && values[f] !== ""
      );
      return !coreExam || !languageExam || !allFilled;
    }
    // Only language "No"
    if (coreExam === "Yes" && languageExam === "No") {
      // Exclude coreExamScore/TotalMarks fields if their ScoreReceived is No (dynamic)
      const filteredCoreFields = coreFields.filter((fieldName) => {
        if (
          /^coreExamScore(_\d+)?$/.test(fieldName) ||
          /^coreTotalMarks(_\d+)?$/.test(fieldName)
        ) {
          const match = fieldName.match(
            /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "coreScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `coreScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        if (
          /^coreExamID(_\d+)?$/.test(fieldName) ||
          /^coreExamId(_\d+)?$/.test(fieldName)
        ) {
          return false;
        }
        if (/^coreScoreExpectedOn(_\d+)?$/.test(fieldName)) {
          const expectedOnMatch = fieldName.match(/^coreScoreExpectedOn_(\d+)$/);
          const scoreReceivedKey = expectedOnMatch
            ? `coreScoreReceived_${expectedOnMatch[1]}`
            : "coreScoreReceived";
          return values[scoreReceivedKey] === "No";
        }
        return true;
      });
      const allFilled = filteredCoreFields.every(
        (f) => values[f] !== undefined && values[f] !== ""
      );
      return !coreExam || !languageExam || !allFilled;
    }
    // Both "Yes"
    // Exclude exam score and total marks fields from otherFields if Score Received is 'No'

    const filteredOtherFields = otherFields.filter((f) => {
      // For core
      if (
        /^coreExamScore(_\d+)?$/.test(f.name) ||
        /^coreTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding coreScoreReceived field (dynamic)
        const match = f.name.match(
          /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "coreScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `coreScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
      }
      // For language
      if (
        /^languageExamScore(_\d+)?$/.test(f.name) ||
        /^languageTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding languageScoreReceived field (dynamic)
        const match = f.name.match(
          /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "languageScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `languageScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
      }
      if (
        /^coreExamID(_\d+)?$/.test(f.name) ||
        /^coreExamId(_\d+)?$/.test(f.name) ||
        /^languageExamID(_\d+)?$/.test(f.name) ||
        /^languageExamId(_\d+)?$/.test(f.name)
      ) {
        return false;
      }
      // ScoreExpectedOn is only relevant (and required) when the score
      // hasn't been received yet — when scoreReceived is "Yes" it's
      // correctly left blank, so don't count it against "all filled".
      if (/^coreScoreExpectedOn(_\d+)?$/.test(f.name)) {
        const expectedOnMatch = f.name.match(/^coreScoreExpectedOn_(\d+)$/);
        const scoreReceivedKey = expectedOnMatch
          ? `coreScoreReceived_${expectedOnMatch[1]}`
          : "coreScoreReceived";
        return values[scoreReceivedKey] === "No";
      }
      if (/^languageScoreExpectedOn(_\d+)?$/.test(f.name)) {
        const expectedOnMatch = f.name.match(/^languageScoreExpectedOn_(\d+)$/);
        const scoreReceivedKey = expectedOnMatch
          ? `languageScoreReceived_${expectedOnMatch[1]}`
          : "languageScoreReceived";
        return values[scoreReceivedKey] === "No";
      }
      return true;
    });
    return (
      getFilledCountWithPanAadhaar(filteredOtherFields, values) !==
      filteredOtherFields.length
    );
  };

  function getEmploymentCompletion(
    values: any,
    fields: any[],
    getFilledCountWithPanAadhaar: any
  ) {
    // if the main question is not answered, completion is 0
    if (!values.employmentisEmployed) {
      return `0 / ${fields.length}`;
    }

    // Find all employment-related fields except the main radio
    const employmentRadio = fields.find(
      (f) => f.name === "employmentisEmployed"
    );

    // Define companyFields as per selector
    const companyFields = fields.filter(
      (f) =>
        f.required &&
        f.name?.toLowerCase().includes("employmentcompany") &&
        f.name !== "employmentCompanyName"
    );

    // Employment fields: start with employment or employmentCompany, not the radio, and not in companyFields
    const employmentFieldsBase = fields.filter(
      (f) =>
        f.name !== "employmentisEmployed" &&
        (f.name?.startsWith("employment") ||
          f.name?.startsWith("employmentCompany")) &&
        !companyFields.some((cf) => cf.name === f.name)
    );

    // When employmentType is "Others", only count required employment fields and exclude the Year field
    const selectedEmploymentType = getAutocompleteOptionValue(values?.employmentType);
    const employmentFields =
      !selectedEmploymentType
        ? employmentFieldsBase.filter((f) => f.name === "employmentType")
        : selectedEmploymentType === "Others"
        ? employmentFieldsBase.filter(
          (f) =>
            f.required &&
            f.name !== "employmentYear" &&
            f.name !== "employmentMonth" &&
            f.name !== "employmentDesignation"
        )
        : employmentFieldsBase;

    // If "No" is selected, only the required radio fields are required
    if (values.employmentisEmployed === "No") {
      // Find all required employment radio fields (usually just employmentisEmployed, but could be more)
      const requiredEmploymentRadios = fields.filter(
        (f) =>
          f.required &&
          f.type === "radio" &&
          (f.name?.toLowerCase()?.startsWith("employment") ||
            f.name?.toLowerCase()?.startsWith("employmentcompany"))
      );
      const filledRadios = requiredEmploymentRadios.filter(
        (f) => values[f.name] !== undefined && values[f.name] !== ""
      ).length;
      return `${filledRadios} / ${requiredEmploymentRadios.length}`;
    }

    // If "Yes" is selected, count all employment fields (including radio)
    const allFields = [employmentRadio, ...employmentFields].filter(Boolean);
    const filled = getFilledCountWithPanAadhaar(allFields, values);
    return `${filled} / ${allFields.length}`;
  }

  useEffect(() => {
    const handlers: Array<{
      el: HTMLInputElement;
      onFocus: () => void;
    }> = [];

    autoCompleteOffFields.forEach((field) => {
      const el = document.querySelector<HTMLInputElement>(
        `[name="${field}"]`
      );

      if (!el) return;

      el.setAttribute("autocomplete", "new-password");
      el.readOnly = true;

      const onFocus = () => {
        el.readOnly = false;
      };

      el.addEventListener("focus", onFocus);
      handlers.push({ el, onFocus });
    });

    // Cleanup on unmount
    return () => {
      handlers.forEach(({ el, onFocus }) => {
        el.removeEventListener("focus", onFocus);
      });
    };
  }, []);

  useEffect(() => {
    if (!formikRef.current) return;
    formikRef.current.setTouched({}, false);
    formikRef.current.setErrors({});
  }, [activeHorizontalIndex, activeVerticalIndex, pageType]);

  return (
    <Box sx={{ width: "100%" }}>
      {activeVerticalIndex === 3 && activeHorizontalIndex == 0 ? (
        !isCheckingOffer ? (
          <EligibilityConfirmation
            firstName={formData.firstName}
            provisionalOffer={breData}
            onNext={moveToNextStep}
          />
        ) : null
      ) : (
        <>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            validate={(vals) =>
              isReferenceCollateralEditStep
                ? getReferenceCollateralValidationErrors(fields, vals)
                : preferSchemaMessages(getRequiredFieldErrors(vals), vals)
            }
            onSubmit={handleSubmit}
            enableReinitialize={
              activeHorizontalIndex === 1 &&
              (activeVerticalIndex === 0 || activeVerticalIndex === 1)
            }
            validateOnChange={true}
            validateOnBlur={true}
          >
            {({
              isSubmitting,
              errors,
              touched,
              values,
              setFieldValue,
              setTouched,
              setErrors,
              validateForm,
              submitForm,
              ...otherFormikProps
            }) => {
              const employmentAndCompanyFields = fields
                .filter(
                  (f) =>
                    f.required &&
                    (f.name?.toLowerCase()?.startsWith("employment") ||
                      f.name?.toLowerCase()?.startsWith("employmentcompany")) &&
                    f.name !== "employmentisEmployed"
                )
                .map((f) => f.name);

              const employmentNotWorking =
                values.employmentisEmployed === "No" ||
                values.employmentisEmployed === false ||
                String(values?.employmentisEmployed ?? "").toLowerCase() ===
                  "no";

              const isExcludedField = (name: string) => {
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  employmentNotWorking &&
                  employmentAndCompanyFields.includes(name)
                ) {
                  return true;
                }
                // When employmentType is Others, skip validation for employmentYear
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  values.employmentisEmployed === "Yes" &&
                  !getAutocompleteOptionValue(values?.employmentType) &&
                  name !== "employmentType" &&
                  (name?.toLowerCase().startsWith("employment") ||
                    name?.toLowerCase().startsWith("employmentcompany"))
                ) {
                  return true;
                }
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  values?.employmentType === "Others" &&
                  (name === "employmentYear" || name === "employmentMonth")
                ) {
                  return true;
                }
                // Exclude University/Institute/Course validation errors on step (0,1) when admissionStatus is Undecided (both dropdown and not-in-list mode)
                if (activeHorizontalIndex === 0 && activeVerticalIndex === 1) {
                  const applyAdmissionUndecided = values?.admissionStatus === "Undecided";
                  const uniExcluded = (name === "university") && applyAdmissionUndecided;
                  const instExcluded = (name === "institute") && applyAdmissionUndecided;
                  const courseExcluded = (name === "courseName") && applyAdmissionUndecided;
                  if (uniExcluded || instExcluded || courseExcluded) {
                    return true;
                  }
                }
                // Entrance Exam Details (1,4): exclude hidden score/marks/date fields
                // based on the ScoreReceived ("Received Your Results?") value
                if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
                  // Static fields
                  const coreScoreReceived = values?.coreScoreReceived;
                  const languageScoreReceived = values?.languageScoreReceived;
                  if (
                    coreScoreReceived === "No" &&
                    (name === "coreExamScore" || name === "coreTotalMarks")
                  ) return true;
                  if (
                    coreScoreReceived !== "No" &&
                    name === "coreScoreExpectedOn"
                  ) return true;
                  if (
                    languageScoreReceived === "No" &&
                    (name === "languageExamScore" || name === "languageTotalMarks")
                  ) return true;
                  if (
                    languageScoreReceived !== "No" &&
                    name === "languageScoreExpectedOn"
                  ) return true;
                  // Dynamic fields (suffixed with _N)
                  const dynMatch = name.match(/^(core|language)(.+)_(\d+)$/);
                  if (dynMatch) {
                    const prefix = dynMatch[1];
                    const fieldPart = dynMatch[2];
                    const suffix = dynMatch[3];
                    const dynScoreReceived = values?.[`${prefix}ScoreReceived_${suffix}`];
                    if (
                      dynScoreReceived === "No" &&
                      (fieldPart === "ExamScore" || fieldPart === "TotalMarks")
                    ) return true;
                    if (
                      dynScoreReceived !== "No" &&
                      fieldPart === "ScoreExpectedOn"
                    ) return true;
                  }
                }
                return [
                  "employmentisEmployed",
                  "coreExamApplied",
                  "languageExamApplied",
                ].includes(name);
              };

              const currentStepFieldNames = fields.map((f) => f.name);

              /** Normalize Yup / manual message to a display string. */
              const toErrorString = (e: unknown): string =>
                typeof e === "string"
                  ? e
                  : e != null && typeof e === "object" && "message" in (e as any)
                    ? String((e as { message?: unknown }).message ?? "")
                    : String(e ?? "");

              /** True when a required field still has no usable value (covers types Yup may skip). */
              const isRequiredFieldValueMissing = (f: any, val: any): boolean => {
                const t = f?.type;
                if (t === "checkbox") return val !== true;
                if (val === null || val === undefined) return true;
                if (t === "number") {
                  return val === "" || (typeof val === "number" && Number.isNaN(val));
                }
                if (t === "date") {
                  return val === "" || val == null;
                }
                if (typeof val === "string") return val.trim() === "";
                if (typeof val === "object") {
                  const inner =
                    (val as { value?: unknown }).value ??
                    (val as { label?: unknown }).label;
                  if (inner == null) return true;
                  return String(inner).trim() === "";
                }
                return false;
              };

              const hideSummarySecHeader = (title: string) => {
                if(title === "Verify Yourself and Provide Consent") {
                  return true
                } else if(title === "Provide Course Details") {
                  return true
                } else if(title === "Provide Loan Details") {
                  return true
                } else if(title === "Student Details") {
                  return true
                } else if(title === "Employment Details") {
                  return true
                } else if(title === "Academic Details") {
                  return true
                } else if(title === "Entrance Exam Details") {
                  return true
                }
                return false;
              } 

              /** Same set as validationSchemas `EMPLOYMENT_WHEN_EMPLOYED_NOT_OTHERS_REQUIRED` — UI can show * via isEmployeeRequiredField while `required` is false. */
              const EMPLOYMENT_MANUAL_REQUIRED_WHEN_EMPLOYED = new Set([
                "employmentCompanyName",
                "employmentCompanyAddress1",
                "employmentCompanyAddress2",
                "employmentCompanyAddress3",
                "employmentLandmark",
                "employmentCompanyPincode",
                "employmentCompanyCity",
                "employmentCompanyState",
                "employmentCompanyCountry",
                "employmentDesignation",
              ]);

              const employedYesForManualValidation =
                values?.employmentisEmployed === "Yes" ||
                values?.employmentisEmployed === true ||
                String(values?.employmentisEmployed ?? "").toLowerCase() ===
                  "yes";

              /** Align with validationSchemas entrance step — JSON often has required:false while UI shows *. */
              const entranceAnswerYes = (v: unknown) =>
                v === "Yes" ||
                v === true ||
                String(v ?? "").toLowerCase() === "yes";

              const scoreReceivedForEntranceRow = (
                vals: Record<string, unknown>,
                prefix: "coreScoreReceived" | "languageScoreReceived",
                suffix: string
              ) => {
                const key = `${prefix}${suffix}`;
                const direct = vals[key];
                if (direct !== undefined && direct !== null && direct !== "") {
                  return direct;
                }
                if (suffix === "_0") {
                  const base = vals[prefix];
                  if (base !== undefined && base !== null && base !== "") {
                    return base;
                  }
                }
                return direct;
              };

              const isFieldRequired = (f: any) => {
                if (
                  f?.required === true ||
                  f?.required === "true" ||
                  String(f?.required ?? "").toLowerCase() === "yes"
                ) {
                  return true;
                }
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  employedYesForManualValidation &&
                  values?.employmentType !== "Others" &&
                  EMPLOYMENT_MANUAL_REQUIRED_WHEN_EMPLOYED.has(f?.name)
                ) {
                  return true;
                }
                if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
                  const n = f?.name || "";
                  if (/^coreTotalMarks(_\d+)?$/.test(n)) {
                    if (entranceAnswerYes(values?.coreExamApplied)) return true;
                  }
                  if (/^languageTotalMarks(_\d+)?$/.test(n)) {
                    if (entranceAnswerYes(values?.languageExamApplied)) {
                      return true;
                    }
                  }
                  if (/^coreExamScore(_\d+)?$/.test(n)) {
                    const sfx = n.match(/(_\d+)$/)?.[0] ?? "";
                    const recv = scoreReceivedForEntranceRow(
                      values as Record<string, unknown>,
                      "coreScoreReceived",
                      sfx
                    );
                    if (
                      entranceAnswerYes(values?.coreExamApplied) &&
                      entranceAnswerYes(recv)
                    ) {
                      return true;
                    }
                  }
                  if (/^languageExamScore(_\d+)?$/.test(n)) {
                    const sfx = n.match(/(_\d+)$/)?.[0] ?? "";
                    const recv = scoreReceivedForEntranceRow(
                      values as Record<string, unknown>,
                      "languageScoreReceived",
                      sfx
                    );
                    if (
                      entranceAnswerYes(values?.languageExamApplied) &&
                      entranceAnswerYes(recv)
                    ) {
                      return true;
                    }
                  }
                }
                return false;
              };

              const currentStepErrors = Object.keys(errors).filter(
                (key) =>
                  currentStepFieldNames.includes(key) && !isExcludedField(key)
              );
              // Remove errors for employment/company fields from Formik errors if "No" is selected
              if (
                activeHorizontalIndex === 1 &&
                activeVerticalIndex === 2 &&
                employmentNotWorking
              ) {
                employmentAndCompanyFields.forEach((field) => {
                  if (errors[field]) {
                    delete errors[field];
                  }
                });
              }
              // Remove errors for University/Institute/Course on step (0,1) when admissionStatus is Undecided only if NOT in notInList (when "not in list" is selected, show required value error)
              if (activeHorizontalIndex === 0 && activeVerticalIndex === 1) {
                const applyAdmissionUndecided = values?.admissionStatus === "Undecided";
                if (applyAdmissionUndecided) {
                  if (errors["country"]) delete errors["country"];
                  if (!notInList?.includes("University Name") && errors["university"]) delete errors["university"];
                  if (!notInList?.includes("Institute Name") && errors["institute"]) delete errors["institute"];
                  if (!notInList?.includes("Course Name") && errors["courseName"]) delete errors["courseName"];
                }
              }
              return (
                <Form autoComplete="off">
                  
                  {pageType == "FORM" && (
                    <Box sx={{ mb: 2, mt: 2 }}>
                      <SectionHeader
                        icon={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 40,
                              height: 40,
                              borderRadius: "8px",
                              bgcolor: "#e5feffff",
                            }}
                          >
                            <img
                              src={
                                activeHorizontalIndex === 0 // activeHorizontalIndex === 0
                                  ? activeVerticalIndex === 0
                                    ? idIcon
                                    : activeVerticalIndex === 1
                                      ? booksIcon
                                      : loanIcon
                                  : activeVerticalIndex === 0 // activeHorizontalIndex === 1
                                    ? idIcon
                                    : activeVerticalIndex === 1
                                      ? locationIcon
                                      : activeVerticalIndex === 2
                                        ? idIcon
                                        : academicIcon
                              }
                              alt="icon"
                              style={{
                                width: 28,
                                height: 28,
                              }}
                            />
                          </Box>
                        }
                        title={
                          horizontalSteps[activeHorizontalIndex]?.verticalSteps[
                            activeVerticalIndex
                          ]?.stepLabel === "Address Details"
                            ? "Permanent Address"
                            : horizontalSteps[activeHorizontalIndex]
                              ?.verticalSteps[activeVerticalIndex]?.stepLabel
                        }
                        subtitle={getSectionSubtitle(
                          activeHorizontalIndex,
                          activeVerticalIndex
                        )}
                        completion={
                          activeHorizontalIndex === 1 && activeVerticalIndex === 4
                            ? getEntranceExamCompletion(
                              values,
                              fields,
                              otherFields,
                              getFilledCountWithPanAadhaar
                            )
                            : activeHorizontalIndex === 1 &&
                              activeVerticalIndex === 2
                              ? `${getEmploymentCompletion(
                                values,
                                fields,
                                getFilledCountWithPanAadhaar
                              )}`
                              : `${getFilledCountWithPanAadhaar(
                                otherFields.filter((f) => {
                                  const isUniversity = f.name === "university";
                                  const isInstitute = f.name === "institute";
                                  const isCourseName = f.name === "courseName";
                                  const applyAdmissionUndecided =
                                    activeHorizontalIndex === 0 &&
                                    activeVerticalIndex === 1 &&
                                    values?.admissionStatus === "Undecided";
                                  const exclude = applyAdmissionUndecided &&
                                    (isUniversity || isInstitute || isCourseName);
                                  return !exclude;
                                }),
                                values
                              )} / ${otherFields.filter((f) => {
                                const isUniversity = f.name === "university";
                                const isInstitute = f.name === "institute";
                                const isCourseName = f.name === "courseName";
                                const applyAdmissionUndecided =
                                  activeHorizontalIndex === 0 &&
                                  activeVerticalIndex === 1 &&
                                  values?.admissionStatus === "Undecided";
                                const exclude = applyAdmissionUndecided &&
                                  (isUniversity || isInstitute || isCourseName);
                                return !exclude;
                              }).length
                              }`
                        }
                      />
                    </Box>
                  )}
                  {pageType === "SUMMARY" &&
                    !(activeHorizontalIndex === 1 && activeVerticalIndex === 5) && !(activeHorizontalIndex === 4 && activeVerticalIndex === 0) && !(activeHorizontalIndex === 4 && activeVerticalIndex === 2)&& !isReferenceCollateralEditStep && 
                    !hideSummarySecHeader(horizontalSteps[activeHorizontalIndex]?.verticalSteps[activeVerticalIndex]?.stepLabel) && (
                    <Box sx={{ mb: 2, mt: 2 }}>
                      <SummarySectionHeader
                        title={
                          horizontalSteps[activeHorizontalIndex]?.verticalSteps[
                            activeVerticalIndex
                          ]?.stepLabel === "Address Details"
                            ? "Permanent Address"
                            : horizontalSteps[activeHorizontalIndex]
                              ?.verticalSteps[activeVerticalIndex]?.stepLabel
                        }
                      />
                    </Box>
                    )}
                  {/* Form Fields */}
                  <Grid container spacing={2}>
                    {activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 2 ? (
                      <>
                        {/* Always render the "Are you employed?" radio field */}
                        {fields
                          .filter((f) => f.name === "employmentisEmployed")
                          .map((field) => renderField(field))}

                        {/* If "Yes" is selected, render the rest of the employment fields */}
                        {values.employmentisEmployed === "Yes" &&
                          (() => {
                            let hasInsertedCompanyHeader = false;
                            // When employmentType is "Others", show only required fields in this section
                            const allEmploymentFields = fields.filter(
                              (f) => f.name !== "employmentisEmployed"
                            );
                            const selectedEmploymentType =
                              getAutocompleteOptionValue(values?.employmentType);
                            const shouldShowOnlyRequired =
                              selectedEmploymentType === "Others";
                            const fieldsToRenderBase = !selectedEmploymentType
                              ? allEmploymentFields.filter(
                                (f) => f.name === "employmentType"
                              )
                              : shouldShowOnlyRequired
                              ? allEmploymentFields.filter(
                                (f) =>
                                  f.required &&
                                  f.name !== "employmentYear" &&
                                  f.name !== "employmentDesignation"
                              )
                              : allEmploymentFields;
                              // SUMMARY: show "Help us with your work experience" below Monthly Income
                            let fieldsToRender = fieldsToRenderBase;
                            if (pageType === "SUMMARY") {
                              const yearField = fieldsToRenderBase.find(
                                (f) => f.name === "employmentYear"
                              );
                              const withoutWorkExp = fieldsToRenderBase.filter(
                                (f) =>
                                  f.name !== "employmentYear" &&
                                  f.name !== "employmentMonth"
                              );
                              if (
                                yearField &&
                                selectedEmploymentType !== "Others"
                              ) {
                                const incomeIdx = withoutWorkExp.findIndex(
                                  (f) => f.name === "employmentMonthlyIncome"
                                );
                                fieldsToRender =
                                  incomeIdx >= 0
                                    ? [
                                      ...withoutWorkExp.slice(0, incomeIdx + 1),
                                      yearField,
                                      ...withoutWorkExp.slice(incomeIdx + 1),
                                    ]
                                    : [...withoutWorkExp, yearField];
                              } else {
                                fieldsToRender = withoutWorkExp;
                              }
                            }
                            return fieldsToRender.map((field) => {
                              const elements: React.ReactNode[] = [];

                              // Insert header before the *first* company field
                              if (
                                !hasInsertedCompanyHeader &&
                                field.name
                                  ?.toLowerCase()
                                  .includes("employmentcompany") &&
                                field.name !== "employmentCompanyName"
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="company-section-header"
                                  >
                                    <Box sx={{ mt: 3, mb: 1 }}>
                                       {pageType === "SUMMARY" ? (
                                        <SummarySectionHeader title="Company Address" />
                                      ) : (
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Company Address"
                                          subtitle="Company Address Related Details"
                                          completion={`${companyFields.length > 0
                                            ? `${getFilledCount(
                                              companyFields,
                                              values
                                            )} / ${companyFields.length}`
                                            : ""
                                            }`}
                                        />
                                      )}
                                    </Box>
                                  </Grid>
                                );
                                hasInsertedCompanyHeader = true;
                              }

                              elements.push(renderField(field));
                              return elements;
                            });
                          })()}
                      </>
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 4 ? (
                      <>
                        {/* Entrance Exam Details Sections */}
                        <Grid container ml={2} mt={2}>
                          {/* Render Core Entrance Exam Section */}
                          <EntranceExamDetailsSection
                            fields={fields.filter((f: any) =>
                              f.name?.startsWith("core")
                            )}
                            sectionPrefix="core"
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            renderField={renderField}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            formikRef={formikRef}
                            dropdownData={dropdownData}
                            trackingId={trackingId}
                          />

                          {/* Render Language Entrance Exam Section */}
                          <EntranceExamDetailsSection
                            fields={fields.filter((f: any) =>
                              f.name?.startsWith("language")
                            )}
                            sectionPrefix="language"
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            renderField={renderField}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            formikRef={formikRef}
                            dropdownData={dropdownData}
                            trackingId={trackingId}
                          />
                        </Grid>
                      </>
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 3 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Course Details Section */}
                            <CourseDetailsSection
                              fields={fields}
                              horizontalSteps={horizontalSteps}
                              activeHorizontalIndex={activeHorizontalIndex}
                              activeVerticalIndex={activeVerticalIndex}
                              renderField={renderField}
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={otherFormikProps.handleChange}
                              formikRef={formikRef}
                              trackingId={trackingId}
                              pageType="SUMMARY"
                            />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 5 ? (
                      forceInlineFieldRender && pageType === "SUMMARY" ? (
                        <>
                           <SingleCoApplicantAdditionalDetails
                            fields={fields}
                            renderField={renderField}
                            values={values}
                            formikRef={formikRef}
                          />
                        </>
                      ) : (
                        <>
                          {/* Render CoApplicant Details Section */}
                          <CoApplicantDetailsSection
                            fields={fields}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            pageType={pageType}
                            selectedCoApplicantKey={
                              loanDetailCoApplicantCollapseValue
                            }
                            getCoApplicantGroups={getCoApplicantGroups}
                            renderField={renderField}
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            handleChange={otherFormikProps.handleChange}
                            formikRef={formikRef}
                            pinCodeData={{ permanent: permanentCodeData, current: currentCodeData }}
                            dropdownData={dropdownData}
                            handleInvokZipCode={handleInvokZipCode}
                            relationshipOptionsList={relationshipOptions}
                            salutationOptionsList={
                              dropdownData?.salutations || []
                            }
                            tabIndex={tabIndex}
                            setTabIndex={setTabIndex}
                            zipCodeLoading={zipCodeLoading}
                            checkIsLeadApiInvoked={checkIsLeadApiInvoked}
                            handleLeadCreationFlow={handleLeadCreationFlow}
                            getLeadPayload={getLeadPayload}
                          />
                        </>
                      )
                    ): 
                    activeHorizontalIndex === 4 &&
                    activeVerticalIndex === 0 ? (
                    (() => {
                      return (
                        <>
                          {/* Render Applicant Details Section */}
                          <ApplicantAdditionalDetails
                            fields={fields}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            renderField={renderField}
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            handleChange={otherFormikProps.handleChange}
                            formikRef={formikRef}
                            nationalityOptions={applicantNationalityOptions}
                            birthCityOptions={birthCityList}
                            dropdownData={dropdownData}
                            pageType={"SUMMARY"}
                            isDIYJourney={isDIYJourney}
                          />
                        </>
                      );
                    })()
                  )
                    : isReferenceCollateralEditStep ? (
                    (() => {
                      return (
                        <>
                          {/* Render Reference & Collateral Details Section */}
                          <ReferenceCollateralDetails
                            fields={fields}
                            renderField={renderField}
                            formikRef={formikRef}
                            values={values}
                            errors={errors}
                            touched={touched}
                            isSaving={isSubmittingToAPI}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            pageType={pageType}
                            isDIYJourney={isDIYJourney}
                            summaryLockedTab={
                              pageType === "SUMMARY" &&
                              typeof initialReferenceCollateralTab === "number"
                                ? (initialReferenceCollateralTab as 0 | 1)
                                : undefined
                            }
                            summarySaveRequestId={targetedSummarySaveRequestId}
                            onSummarySaveSuccess={async () => {
                              await refreshReduxFromUserApplicationFetch();
                              dispatch(setSummaryApplicationEditActive(false));
                            }}
                            onReferenceSaveAndNext={async (selectedReferenceNumber: number) => {
                              if (isSubmittingToAPI) return false;
                              const currentValues =
                                formikRef?.current?.values || values || {};
                              const requestKey = `reference-${selectedReferenceNumber}-${trackingId}-${applicationIdApp}-${referenceOneId}-${referenceTwoId}`;
                              if (lastReferenceCollateralSaveRequestRef.current === requestKey) return false;
                              lastReferenceCollateralSaveRequestRef.current = requestKey;
                              setIsSubmittingToAPI(true);
                              try {
                                let saveSucceeded = false;
                                const referenceNumber = selectedReferenceNumber || 1;
                                const shouldCallCreateApi = referenceNumber === 2;
                                
                                const referenceData: any[] = (fields || [])
                                  .filter((field: any) => {
                                    if (!field?.id) return false;
                                    const normalizedName = String(field?.name || "")
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]/g, "");
                                    return (
                                      normalizedName.startsWith(`basicreference${referenceNumber}`) ||
                                      normalizedName.startsWith(`addressreference${referenceNumber}`)
                                    );
                                  })
                                  .map((field: any) => {
                                    const rawValue = currentValues?.[field.name];
                                    const normalizedValue =
                                      rawValue && typeof rawValue === "object"
                                        ? "value" in rawValue
                                          ? rawValue.value
                                          : "label" in rawValue
                                            ? rawValue.label
                                            : rawValue
                                        : rawValue;
                                    return {
                                      formFieldId: field.id,
                                      formFieldKey: field.name,
                                      formFieldValue: String(normalizedValue ?? ""),
                                    };
                                  });
                                const isAadhaarSeededPayload =
                                  aadhaarSeedingStatus === undefined ||
                                  aadhaarSeedingStatus === null ||
                                  aadhaarSeedingStatus === ""
                                    ? false
                                    : aadhaarSeedingStatus;

                                const referencePayload = {
                                  data: referenceData,
                                  trackingId: trackingId,
                                  templateId: templateId,
                                  formName:
                                    horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
                                  mobileNumber:
                                    currentValues?.phone_number || formData?.phone_number,
                                  isAadhaarSeeded: isAadhaarSeededPayload,
                                };

                                // let referenceResp: any = null;
                                // if (shouldCallCreateApi) {
                                  let referenceResp: any = 
                                    await applicantDetailsServices.createApplicant(
                                      referencePayload,
                                    );
                                if (
                                  shouldCallCreateApi &&
                                  referenceResp?.data?.status !== "success"
                                ) {
                                  throw new Error(
                                    referenceResp?.data?.message ||
                                      "Unable to save Reference and Collateral details.",
                                  );
                                }

                                if (referenceResp?.data?.data?.trackingId) {
                                  dispatch(
                                    setTrackingId(referenceResp?.data?.data?.trackingId),
                                  );
                                }
                                if (referenceResp?.data?.data?.applicationId) {
                                  dispatch(
                                    setApplicationId(
                                      String(referenceResp?.data?.data?.applicationId),
                                    ),
                                  );
                                }
                                if (referenceResp?.data?.data?.applicantId) {
                                  dispatch(
                                    setApplicantId(referenceResp?.data?.data?.applicantId),
                                  );
                                }

                                const toValue = (val: any) => {
                                  if (val && typeof val === "object" && "value" in val) {
                                    return val.value;
                                  }
                                  return val;
                                };

                                
                                const resolvedTrackingId = resolveRefreshSubmissionIdFromResponse(
                                  referenceResp,
                                  trackingId || ""
                                );
                                const resolvedApplicationId =
                                  referenceResp?.data?.data?.applicationId ||
                                  applicationIdApp ||
                                  "";

                                // Fetch any existing Reference One/Two IDs before saving, so an
                                // already-saved reference is updated instead of duplicated.
                                let fetchedReferenceOneId: any = null;
                                let fetchedReferenceTwoId: any = null;
                                if (resolvedTrackingId) {
                                  try {
                                    const referenceIdsResp = await losServices.getReferenceIds(
                                      resolvedTrackingId,
                                    );
                                    fetchedReferenceOneId =
                                      referenceIdsResp?.data?.data?.referenceOneId || null;
                                    fetchedReferenceTwoId =
                                      referenceIdsResp?.data?.data?.referenceTwoId || null;
                                    if (fetchedReferenceOneId) {
                                      dispatch(setreferenceOneId(fetchedReferenceOneId));
                                    }
                                    if (fetchedReferenceTwoId) {
                                      dispatch(setreferenceTwoId(fetchedReferenceTwoId));
                                    }
                                  } catch (error) {
                                    
                                  }
                                }

                                const resolvedReferenceId =referenceNumber === 2?
                                  (fetchedReferenceTwoId || referenceTwoId):
                                  (fetchedReferenceOneId || referenceOneId);

                                const selectedReferenceCodeData =
                                  referenceNumber === 2
                                    ? reference2CodeData
                                    : reference1CodeData;

                                const saveReferencePayload:any = {
                                  trackingId: resolvedTrackingId,
                                  eventName: `APPLICANT_APPLICATION_REFERENCE_${selectedReferenceNumber===1?"ONE":"TWO"}_DETAILS`,
                                  applicantType: "Applicant",
                                  applicationId: Number(resolvedApplicationId) || 0,
                                  emailAddress:currentValues?.[`basicReference${referenceNumber}Email`],
                                  firstName:currentValues?.[`basicReference${referenceNumber}FirstName`],
                                  lastName:currentValues?.[`basicReference${referenceNumber}LastName`],
                                  fullName:`${currentValues?.[`basicReference${referenceNumber}FirstName`]} ${currentValues?.[`basicReference${referenceNumber}LastName`]}`.trim(),
                                  active: true,
                                  referenceType : selectedReferenceNumber===1?"one":"two",
                                  mobileNo: Number(currentValues?.[`basicReference${referenceNumber}PhoneNumber`]),
                                  referenceAddress: {
                                    addressTypeDescription: "RESI ALTERNATE ADDRESS",
                                    addressTypeId: "ALTRESI",
                                    landmark: currentValues?.[`addressReference${referenceNumber}Landmark`] || "",
                                    addressLine1: currentValues?.[`addressReference${referenceNumber}AddressLine1`] || "",
                                    addressLine2: currentValues?.[`addressReference${referenceNumber}AddressLine2`] || "",
                                    area: currentValues?.[`addressReference${referenceNumber}Area`] || "",
                                    locality: currentValues?.[`addressReference${referenceNumber}Locality`] || "",
                                    cityId:selectedReferenceCodeData?.city ||
                                      "",
                                    cityName: currentValues?.[`addressReference${referenceNumber}City`] || "",
                                    countryId:dropdownData?.countries.find(
                                        (country: any) =>
                                          country.label ===
                                          (typeof values?.currentCountry === "object"
                                            ? values.currentCountry.label
                                            : currentValues?.[`addressReference${referenceNumber}Country`]),
                                      )?.value ||
                                      "IN",
                                    countryName: currentValues?.[`addressReference${referenceNumber}Country`] || "",
                                    pincodeId:selectedReferenceCodeData?.pinCodeId? Number(selectedReferenceCodeData?.pinCodeId) : "",
                                    pincode: String(currentValues?.[`addressReference${referenceNumber}Pincode`]) || "",
                                  },
                                };
                                if(resolvedReferenceId){
                                  saveReferencePayload.referenceId= Number(resolvedReferenceId) || resolvedReferenceId;
                                  await losServices.updateReference(saveReferencePayload);
                                }else{
                                  await losServices.saveReference(saveReferencePayload);
                                }
                                // Move to Collateral only once both references are saved
                                const isOtherReferenceSaved =
                                  referenceNumber === 2
                                    ? Boolean(fetchedReferenceOneId || referenceOneId)
                                    : Boolean(fetchedReferenceTwoId || referenceTwoId);
                                if (isOtherReferenceSaved) {
                                  setActiveTab(1);
                                }
                                dispatch(updateFormData(currentValues));
                                saveSucceeded = true;
                                return saveSucceeded;
                              } catch (error: any) {
                                dispatch(
                                  setStatusPopup({
                                    status: "error",
                                    message:
                                      error?.response?.data?.message ||
                                      (error as any)?.message ||
                                      "Unable to save Reference and Collateral details.",
                                  }),
                                );
                                return false;
                              } finally {
                                setIsSubmittingToAPI(false);
                              }
                            }}
                            onCollateralSaveAndNext={async (selectedCollateralNumber: number) => {
                              setIsSubmittingToAPI(true);
                              try {
                                let saveSucceeded = false;
                                const currentValues =
                                  formikRef?.current?.values || values || {};
                                const horizontalStepLabel =
                                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel;
                                
                                const mergedFields = getMergedCollateralFieldDefinitions(
                                  horizontalSteps,
                                  fields,
                                  horizontalStepLabel,
                                );
                                const hasCollateralAnswer = (() => {
                                  const raw = currentValues?.hasCollateral;
                                  const val =
                                    raw && typeof raw === "object"
                                      ? (raw as any).value ?? (raw as any).label
                                      : raw;
                                  return String(val ?? "").trim();
                                })();

                                 if (hasCollateralAnswer.toLowerCase() === "no") {
                                  const noCollateralData = buildCollateralFormDataEntries(
                                    mergedFields,
                                    currentValues,
                                    1,
                                    true,
                                  );
                                  const noCollateralResp: any = await losServices.createCollateral({
                                    formData: noCollateralData,
                                    trackingId,
                                    collateralSequenceType: `COLLATERAL_${numberToWord[1]}`,
                                  });
                                  if (noCollateralResp?.data?.status !== "success") {
                                    throw new Error(
                                      noCollateralResp?.data?.message ||
                                        "Unable to save Collateral details.",
                                    );
                                  }
                                  const noCollateralTrackingId =
                                    noCollateralResp?.data?.data?.trackingId || trackingId;
                                  if (noCollateralResp?.data?.data?.trackingId) {
                                    dispatch(setTrackingId(noCollateralTrackingId));
                                  }
                                  if (pageType === "SUMMARY") {
                                    await refreshReduxFromUserApplicationFetch(noCollateralTrackingId);
                                  } else {
                                    dispatch(updateFormData(currentValues));
                                  }
                                  setenableContinue(true);
                                  saveSucceeded = true;
                                  return saveSucceeded;
                                }

                                const collateralNumbersToSave = resolveCollateralNumbersToSave(
                                  pageType,
                                  selectedCollateralNumber,
                                  mergedFields,
                                  currentValues,
                                );

                                if (collateralNumbersToSave.length === 0) {
                                  throw new Error(
                                    "Please complete all required Collateral fields before saving.",
                                  );
                                }

                                if (pageType === "SUMMARY") {
                                  for (const collateralNumber of collateralNumbersToSave) {
                                    const summaryCollateralData = buildCollateralFormDataEntries(
                                      mergedFields,
                                      currentValues,
                                      collateralNumber,
                                      isFirstCollateralWithData(mergedFields, currentValues, collateralNumber),
                                    );
                                    if (summaryCollateralData.length === 0) {
                                      throw new Error(
                                        `Please fill Collateral ${collateralNumber} details before saving.`,
                                      );
                                    }
                                  }
                                }

                                for (const collateralNumber of collateralNumbersToSave) {
                                  if (
                                    hasDuplicateCoOwnerNamesForCollateral(
                                      currentValues,
                                      collateralNumber,
                                    )
                                  ) {
                                    throw new Error(
                                      `Duplicate co-owner names are not allowed within Collateral ${collateralNumber}.`,
                                    );
                                  }
                                }

                                const toValue = (val: any) => {
                                  if (val && typeof val === "object" && "value" in val) {
                                    return val.value;
                                  }
                                  return val;
                                };

                                const toLabel = (val: any) => {
                                  if (val && typeof val === "object" && "label" in val) {
                                    return val.label;
                                  }
                                  return val;
                                };

                                let resolvedTrackingId = trackingId || "";
                                let resolvedApplicationId = applicationIdApp || "";
                                let resolvedApplicantId = applicantIdApp || "";

                                for (const collateralNumber of collateralNumbersToSave) {
                                  const collateralData = buildCollateralFormDataEntries(
                                    mergedFields,
                                    currentValues,
                                    collateralNumber,
                                    isFirstCollateralWithData(mergedFields, currentValues, collateralNumber),
                                  );

                                  const collateralPayload = {
                                    formData: collateralData,
                                    trackingId: resolvedTrackingId,
                                    collateralSequenceType: `COLLATERAL_${
                                      numberToWord[collateralNumber] || numberToWord[1]
                                    }`,
                                  };

                                  const collateralResp: any =
                                    await losServices.createCollateral(collateralPayload);

                                  if (collateralResp?.data?.status !== "success") {
                                    throw new Error(
                                      collateralResp?.data?.message ||
                                        `Unable to save Collateral ${collateralNumber} details.`,
                                    );
                                  }

                                  const collateralResponseTrackingId = resolveRefreshSubmissionIdFromResponse(
                                    collateralResp,
                                    resolvedTrackingId || ""
                                  );
                                  if (collateralResponseTrackingId) {
                                    resolvedTrackingId = collateralResponseTrackingId;
                                    dispatch(setTrackingId(resolvedTrackingId));
                                  }
                                  if (collateralResp?.data?.data?.applicationId) {
                                    resolvedApplicationId =
                                      collateralResp?.data?.data?.applicationId;
                                    dispatch(
                                      setApplicationId(String(resolvedApplicationId)),
                                    );
                                  }
                                  if (collateralResp?.data?.data?.applicantId) {
                                    resolvedApplicantId =
                                      collateralResp?.data?.data?.applicantId;
                                    dispatch(setApplicantId(resolvedApplicantId));
                                  }
                                  let collaterIdData=await eligibilityCheckServices.getCollateralIds(collateralResp?.data?.data?.trackingId);
                                   let resolvedCollateralId = null;
                                    let resolvedCollateralOwnerId=null;
                                    let resolvedOwnerAddressId=null;
                                    let resolvedOwnerCreatedBy=null;
                                    let resolvedCollateralRecord:any=null;
                                    if(collaterIdData?.data?.data){
                                      let sequenceType=`COLLATERAL_${
                                        numberToWord[collateralNumber] || numberToWord[1]
                                      }`;
                                      let val=collaterIdData?.data?.data.findLast((item:any) => item.collateralSequenceType === sequenceType)
                                      resolvedCollateralId=val?.collateralId ? Number(val?.collateralId):null;
                                      resolvedCollateralOwnerId=val?.collateralOwnerDetailsId? Number(val?.collateralOwnerDetailsId):null;
                                      resolvedOwnerAddressId=val?.ownerAddressId ?? null;
                                      resolvedOwnerCreatedBy=val?.createdBy ?? null;
                                      resolvedCollateralRecord=val ?? null;
                                    }

                                  const collateralTypeRaw = getCollateralFormValue(
                                    currentValues,
                                    collateralNumber,
                                    "Type",
                                  );
                                  const pincodeRaw = getCollateralFormValue(
                                    currentValues,
                                    collateralNumber,
                                    "pincode",
                                  );
                                  const collateralType = String(
                                    toLabel(collateralTypeRaw) || "",
                                  );
                                const collateralTypeVal = mapCollateral().filter((item:any)=>item.value === collateralType)?.[0]?.value || 0
                                  let collateralTypeId=Number(toValue(collateralTypeVal)) || 0;
                                  const isPropertyCollateral =
                                    collateralTypeId === 308 ||
                                    collateralType.toLowerCase().includes("property");
                                  let selectedCollateralCodeData =
                                    collateralCodeDataByNumber[
                                      String(collateralNumber)
                                    ] || null;
                                  if (
                                    isPropertyCollateral &&
                                    !selectedCollateralCodeData?.city
                                  ) {
                                    const pin = String(toValue(pincodeRaw) || "");
                                    if (pin.length === 6) {
                                      try {
                                        const zipResp =
                                          await eligibilityCheckServices.getZipCode(
                                            pin,
                                          );
                                        const stateCodeFromZip =
                                          zipResp?.data?.data?.[0]?.stateCode;
                                        const pinResp =
                                          await eligibilityCheckServices.getPinCode(
                                            pin,
                                          );
                                        if (pinResp?.data?.data?.[0]) {
                                          selectedCollateralCodeData = {
                                            ...pinResp.data.data[0],
                                            stateCode: stateCodeFromZip,
                                          };
                                          setCollateralCodeDataByNumber((prev) => ({
                                            ...prev,
                                            [String(collateralNumber)]:
                                              selectedCollateralCodeData,
                                          }));
                                        }
                                      } catch {
                                        // keep null; payload will send empty ids
                                      }
                                    }
                                  }
                                  const countryRaw = getCollateralFormValue(
                                    currentValues,
                                    collateralNumber,
                                    "country",
                                  );
                                  const countryLabel = String(
                                    toLabel(countryRaw) || toValue(countryRaw) || "",
                                  );
                                  const resolvedCountryId =
                                    dropdownData?.countries?.find(
                                      (country: any) =>
                                        country.label === countryLabel ||
                                        String(country.value) ===
                                          String(toValue(countryRaw) || ""),
                                    )?.value ||
                                    toValue(countryRaw) ||
                                    "IN";

                                const propertyTypeRaw = currentValues[`collateral${collateralNumber}propertypeName`];
                                const propertySubTypeRaw = getCollateralFormValue(
                                  currentValues,
                                  collateralNumber,
                                  "PropertySubTypeName",
                                );
                                const selectedPropertyTypeCode = String(
                                  toValue(propertyTypeRaw) || "",
                                );
                                const selectedPropertySubTypeCode = String(
                                  toValue(propertySubTypeRaw) || "",
                                );
                                 const collateralValue=currentValues[`collateral${collateralNumber}Value`];
                                let resolvedPropertyTypeId: any = toValue(propertyTypeRaw);
                                let resolvedPropertySubTypeId: any = toValue(propertySubTypeRaw);
                                const addressTypeRaw = getCollateralFormValue(
                                  currentValues,
                                  collateralNumber,
                                  "AddressType",
                                );
                                const selectedAddressTypeCode = String(
                                  toValue(addressTypeRaw) || "",
                                );
                                let resolvedAddressTypeDescription: any = toLabel(addressTypeRaw);
                                if (isPropertyCollateral) {
                                  try {
                                    if (selectedPropertyTypeCode) {
                                      const propertyTypeMaster =
                                        await dropdownService.getPropertyTypes();
                                      resolvedPropertyTypeId =
                                        propertyTypeMaster.find(
                                          (opt: any) =>
                                            String(opt.value) === selectedPropertyTypeCode,
                                        )?.serialId ?? resolvedPropertyTypeId;
                                    }
                                    if (selectedPropertySubTypeCode) {
                                      const propertySubTypeMaster =
                                        await dropdownService.getPropertySubTypes(
                                          selectedPropertyTypeCode,
                                        );
                                      resolvedPropertySubTypeId =
                                        propertySubTypeMaster.find(
                                          (opt: any) =>
                                            String(opt.value) === selectedPropertySubTypeCode,
                                        )?.serialId ?? resolvedPropertySubTypeId;
                                    }
                                    if (selectedAddressTypeCode) {
                                      const addressTypeMaster =
                                        await dropdownService.getAddressTypes();
                                      resolvedAddressTypeDescription =
                                        addressTypeMaster.find(
                                          (opt: any) =>
                                            String(opt.value) === selectedAddressTypeCode,
                                        )?.label ?? resolvedAddressTypeDescription;
                                    }
                                  } catch {
                                    // keep raw code/label value; payload will fall back to it
                                  }
                                }

                                const coOwnerApplicantIdByPrefix =
                                  await resolveCoOwnerApplicantIdMap(
                                    mergedFields,
                                    currentValues,
                                    collateralNumber,
                                    resolvedApplicantId,
                                    async (coApplicantType: string) => {
                                      try {
                                        const coOwnerApplicantResp: any =
                                          await losServices.getCoApplicantDetails({
                                            trackingId: resolvedTrackingId,
                                            coApplicantType,
                                          });
                                        return coOwnerApplicantResp?.data?.data?.applicantId;
                                      } catch {
                                        return 0;
                                      }
                                    },
                                  );

                                const saveCollateralPayload = buildSaveCollateralPayload({
                                  currentValues,
                                  mergedFields,
                                  collateralNumber,
                                  applicationId: resolvedApplicationId?resolvedApplicationId:0,
                                  applicantId: resolvedApplicantId,
                                  resolvedCollateralId,
                                  resolvedCollateralOwnerId,
                                  ownerAddressId: resolvedOwnerAddressId,
                                  createdBy: resolvedOwnerCreatedBy,
                                  selectedCollateralCodeData,
                                  resolvedCountryId,
                                  propertyTypeId: resolvedPropertyTypeId,
                                  propertySubTypeId: resolvedPropertySubTypeId,
                                  addressTypeDescription: resolvedAddressTypeDescription,
                                  coOwnerApplicantIdByPrefix,
                                  fetchedCollateral: resolvedCollateralRecord,
                                });
                                let payloadColl={
                                      ...saveCollateralPayload,
                                      trackingId: resolvedTrackingId,
                                      eventName:
                                        `APPLICANT_APPLICATION_COLLATERAL_${
                                        numberToWord[collateralNumber] || numberToWord[1]
                                      }_OWNERSHIP_DETAILS`,
                                      applicantType: "Applicant",
                                      "collateralSequenceType":`COLLATERAL_${
                                        numberToWord[collateralNumber] || numberToWord[1]
                                      }`,
                                      collateralValue:Number(collateralValue),
                                      //"applicantId": resolvedApplicantId,

                                    }
                                // "No" is handled entirely above and already returned by
                                // this point, so every collateral reaching here is real.
                                await losServices.saveCollateral(payloadColl);
                                window.dispatchEvent(
                                  new CustomEvent("collateral:saved", {
                                    detail: { collateralNumber },
                                  })
                                );
                                }
                                if(pageType === "SUMMARY"){
                                  await refreshReduxFromUserApplicationFetch(resolvedTrackingId);
                                }
                                setenableContinue(true);
                                 if(pageType !== "SUMMARY"){
                                  dispatch(updateFormData(currentValues));
                                  // SUMMARY refetches above; elsewhere keep the fetched
                                  // snapshot in sync with the saved co-owners so the
                                  // co-applicant Name/Mobile lock applies without a reload.
                                  dispatch(
                                    setFetchUserApplicationData(
                                      mergeSavedCoOwnersIntoFetchedData(
                                        fetchUserApplicationData,
                                        currentValues,
                                        collateralNumbersToSave,
                                      ),
                                    ),
                                  );
                                 }
                                saveSucceeded = true;
                                return saveSucceeded;
                              } catch (error: any) {
                                dispatch(
                                  setStatusPopup({
                                    status: "error",
                                    message: getCollateralSaveErrorMessage(error),
                                  }),
                                );
                                return false;
                              } finally {
                                setIsSubmittingToAPI(false);
                              }
                            }}
                          />
                        </>
                      );
                    })()
                  ) : activeHorizontalIndex === 3 &&
                    activeVerticalIndex === 4 ? (
                    (() => {
                      return (
                        <>
                          <AdditionalSummaryDetail dropdownData={dropdownData} />
                        </>
                      );
                    })()
                  ) : activeHorizontalIndex ===4 &&
                    activeVerticalIndex === 2 ? (
                    (() => {
                      return (
                        <>
                          {/* Render Fund & Expense Details Section */}
                          <FundExpenseDetails
                            fields={fields}
                            renderField={renderField}
                            formikRef={formikRef}
                            values={values}
                            pageType={"SUMMARY"}
                          />
                        </>
                      );
                    })()
                  )
                    : activeHorizontalIndex === 4 &&
                        activeVerticalIndex === 1 ? (
                        (() => {
                          return (
                            <>
                              {/* Render Academic Details Section */}
                              <CoApplicantAdditionalDetails
                                fields={fields}
                                horizontalSteps={horizontalSteps}
                                activeHorizontalIndex={activeHorizontalIndex}
                                activeVerticalIndex={activeVerticalIndex}
                                renderField={renderField}
                                values={values}
                                setFieldValue={setFieldValue}
                                errors={errors}
                                touched={touched}
                                handleChange={otherFormikProps.handleChange}
                                formikRef={formikRef}
                                dropdownData={dropdownData}
                                handleInvokZipCode={handleInvokZipCode}
                                relationshipOptionsList={relationshipOptions}
                                salutationOptionsList={
                                  dropdownData?.salutations || []
                                }
                                zipCodeLoading={zipCodeLoading}
                                tabIndex={tabIndex}
                                setTabIndex={setTabIndex}
                                checkIsLeadApiInvoked={checkIsLeadApiInvoked}
                                handleLeadCreationFlow={handleLeadCreationFlow}
                                getLeadPayload={getLeadPayload}
                                pageType={pageType}
                              />
                            </>
                          );
                        })()
                      ) :
                     (
                      <>
                        {(() => {
                          const isSummaryStudentDetailsSection =
                            pageType === "SUMMARY" &&
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 0;
                          const summaryEmailFieldNames = [
                            "email",
                            "studentDetailEmail",
                            "studentDetailsEmail",
                            "studentEmail",
                          ];
                          // Fields excluding pan and aadhaar
                          const baseFields = fields.filter(
                            (field) =>
                              field.name !== "pan" && field.name !== "aadhaar"
                          );
                          const emailIndex = baseFields.findIndex((field) =>
                            summaryEmailFieldNames.includes(field.name)
                          );
                          const filteredFields = isSummaryStudentDetailsSection
                            ? baseFields.filter(
                                (field) =>
                                  !summaryEmailFieldNames.includes(field.name)
                              )
                            : baseFields;

                          // Find index of first dob-related field
                          const dobIndex = filteredFields.findIndex(
                            (field) =>
                              field.name?.toLowerCase().includes("dob") ||
                              field.label?.toLowerCase().includes("dob") ||
                              field.label?.toLowerCase().includes("date of birth")
                          );
                          const panInsertionIndex =
                            isSummaryStudentDetailsSection && emailIndex !== -1
                              ? emailIndex
                              : isSummaryStudentDetailsSection
                                ? dobIndex
                                : dobIndex + 1;

                          if (dobIndex === -1) {
                            let hasInsertedCurrHeader = false; // <-- track insertion

                            return filteredFields.map((field) => {
                              const elements: React.ReactNode[] = [];

                              // Insert header before the *first* field with prefix "current"
                              if (
                                !hasInsertedCurrHeader &&
                                field.name?.toLowerCase()?.startsWith("current")
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="current-section-header"
                                  >
                                    <Box
                                      sx={{ mt: 3, mb: 1 }}
                                      key="current-section-header"
                                    >
                                         {pageType === "SUMMARY" ? (
                                        <SummarySectionHeader title="Current Address" />
                                      ) : (
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Current Address"
                                          subtitle="Student Current Address Related Details "
                                          completion={`${getFilledCount(
                                            currFields,
                                            values
                                          )} / ${currFields.length}`}
                                        />
                                      )}
                                    </Box>
                                  </Grid>
                                );
                                hasInsertedCurrHeader = true;
                              }

                              elements.push(renderField(field));
                              return elements;
                            });
                          }

                          // Before PAN/Aadhaar insertion point
                          const beforeDob = filteredFields.slice(
                            0,
                            panInsertionIndex
                          );

                          // After PAN/Aadhaar insertion point
                          const afterDob = filteredFields.slice(
                            panInsertionIndex
                          );

                          let hasInsertedCurrHeader = false;


                          return (
                            <>
                              {/* Fields before dob */}
                              {beforeDob.map((field) => {
                                const elements: React.ReactNode[] = [];

                                if (
                                  !hasInsertedCurrHeader &&
                                  field.name
                                    ?.toLowerCase()
                                    ?.startsWith("current")
                                ) {
                                  elements.push(
                                    <Grid
                                      item
                                      xs={12}
                                      key="current-section-header"
                                    >
                                      <Box
                                        sx={{ mt: 3, mb: 1 }}
                                        key="current-section-header"
                                      >
                                         {pageType === "SUMMARY" ? (
                                          <SummarySectionHeader title="Current Address" />
                                        ) : (
                                          <SectionHeader
                                            icon={
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  width: 40,
                                                  height: 40,
                                                  borderRadius: "8px",
                                                  bgcolor: "#e5feffff",
                                                }}
                                              >
                                                <img
                                                  src={locationIcon}
                                                  alt="icon"
                                                  style={{
                                                    width: 28,
                                                    height: 28,
                                                  }}
                                                />
                                              </Box>
                                            }
                                            title="Current Address"
                                            subtitle="Student Current Address Related Details "
                                            completion={`${getFilledCount(
                                              currFields,
                                              values
                                            )} / ${currFields.length}`}
                                          />
                                        )}
                                      </Box>
                                    </Grid>
                                  );
                                  hasInsertedCurrHeader = true;
                                }

                                elements.push(renderField(field));
                                return elements;
                              })}
                              {/* For Pan and Aadhaar Section */}
                              {isPanStep &&
                                renderPanAadhaarFields(
                                  values,
                                  shouldDisableFields,
                                  setFieldValue,
                                  touched?.pan ? (errors?.pan as string) : undefined
                                )}
                              {/* Fields after dob */}
                              {afterDob.map((field) => {
                                const elements: React.ReactNode[] = [];

                                // Insert header before the *first* field with prefix "current"
                                if (
                                  !hasInsertedCurrHeader &&
                                  field.name
                                    ?.toLowerCase()
                                    ?.startsWith("current")
                                ) {
                                  elements.push(
                                    <Box
                                      sx={{ mt: 3, mb: 1 }}
                                      key="current-section-header"
                                    >
                                       {pageType === "SUMMARY" ? (
                                        <SummarySectionHeader title="Current Address" />
                                      ) : (
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Current Address"
                                          subtitle="Student Current Address Related Details "
                                          completion={`${getFilledCount(
                                            currFields,
                                            values
                                          )} / ${currFields.length}`}
                                        />
                                      )}
                                    </Box>
                                  );
                                  hasInsertedCurrHeader = true;
                                }

                                elements.push(renderField(field));
                                return elements;
                              })}
                              {/* <AdhaarVerifyFiled
                                isAadharLoading={isAadharLoading}
                                values={values}
                                trackingId={trackingId}
                                isDocumentVerified={
                                  (formData?.isAadhaarVerified === "true" ||
                                  formData?.isAadhaarVerified === true) ? true : false
                                }
                              /> */}
                            </>
                          );
                        })()}
                      </>
                    )}
                  </Grid>

                   {/* Actions Back & Continue (hidden on SUMMARY view) */}
                  {pageType !== "SUMMARY" && (
                    <Box mt={2}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        {/* Show Back button only if not on first form and not on step 3 */}
                        {((activeHorizontalIndex === 0 &&
                          activeVerticalIndex > 0 &&
                          activeVerticalIndex < 3) ||
                          (activeHorizontalIndex === 1 &&
                            activeVerticalIndex > 0)) && isPreviousButton === true && !isXsOrSm ? (
                          <Box sx={{ width: { xs: "100%", sm: 134 }, mb: isXsOrSm ? 2 : "0", mr: !isXsOrSm ? 2 : "0", }}>
                            <OutlinedPrimaryButton
                              width={isXsOrSm ? "100%" : "134px"}
                              type="button"
                              fullWidth
                              variant="outlined"
                              onClick={() => {
                                dispatch(prevVerticalStep());
                                window.scrollTo({ top: 0, behavior: "smooth" });
                              }}
                              disabled={isSubmitting || isSubmittingToAPI}
                            >
                              <ArrowBackIcon sx={{ mr: !isXsOrSm ? 1 : 0 }} />

                              {"Previous"}
                            </OutlinedPrimaryButton>
                          </Box>
                        ) : null}
                        {/* Continue Button */}
                        {(activeHorizontalIndex !== 1 ||
                          activeVerticalIndex !== 5) && (
                            <Box sx={{ width: { xs: "100%", sm: 220 } }}>
                              <PrimaryButton
                                type="button"
                                fullWidth         
                                disabled={
                                  zipCodeLoading ||
                                  isSubmitting ||
                                  isSubmittingToAPI ||
                                  !isMobileVerified ||
                                  !isEmailVerified ||
                                  (activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 2 &&
                                    values.employmentisEmployed === "No"
                                    ? !values.employmentisEmployed
                                    : activeHorizontalIndex === 1 &&
                                      activeVerticalIndex === 2
                                      ? (() => {
                                        // For Employment step when "Yes", ensure displayed fields are filled.
                                        const allEmploymentFields = fields.filter(
                                          (f) => f.name !== "employmentisEmployed"
                                        );
                                        const selectedEmploymentType =
                                          getAutocompleteOptionValue(values?.employmentType);
                                        const shouldShowOnlyRequired =
                                          selectedEmploymentType === "Others";
                                        const fieldsToCheck = !selectedEmploymentType
                                          ? allEmploymentFields.filter(
                                            (f) => f.name === "employmentType"
                                          )
                                          : shouldShowOnlyRequired
                                          ? allEmploymentFields.filter(
                                            (f) =>
                                              f.required &&
                                              f.name !== "employmentYear" &&
                                              f.name !== "employmentMonth" &&
                                              f.name !== "employmentDesignation"
                                          )
                                          : allEmploymentFields;
                                        return (
                                          getFilledCountWithPanAadhaar(fieldsToCheck, values) !==
                                          fieldsToCheck.length
                                        );
                                      })()
                                      : activeHorizontalIndex === 1 &&
                                        activeVerticalIndex === 4
                                        ? isEntranceExamContinueDisabled(values)
                                        : (() => {
                                          const filteredOtherFields = otherFields.filter((f) => {
                                            const isUniversity = f.name === "university";
                                            const isInstitute = f.name === "institute";
                                            const isCourseName = f.name === "courseName";
                                            const applyAdmissionUndecided =
                                              activeHorizontalIndex === 0 &&
                                              activeVerticalIndex === 1 &&
                                              values?.admissionStatus === "Undecided";
                                            const exclude = applyAdmissionUndecided &&
                                              (isUniversity || isInstitute || isCourseName);
                                            return !exclude;
                                          });
                                          return (
                                            getFilledCountWithPanAadhaar(
                                              filteredOtherFields,
                                              values
                                            ) !== filteredOtherFields.length
                                          );
                                        })()) ||
                                  (activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 2 &&
                                    values.employmentisEmployed === "No"
                                    ? false
                                    : getFilledCount(currFields, values) !==
                                    currFields.length ||
                                    getFilledCount(companyFields, values) !==
                                    companyFields.length) ||
                                  !areAllCoApplicantsVerified(values) ||
                                  (isLoadTesting
                                    ? false
                                    : activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 0 &&
                                    (formikRef.current?.values
                                      .isAadhaarVerified === false ||
                                      formikRef.current?.values
                                        .isAadhaarVerified === ""))
                                }
                                onClick={
                                  activeHorizontalIndex < 3 ?async () => {
                                    const errs = await validateForm();
                                    const currentStepFieldNames = fields.map((f) => f.name);
  
                                    const extraErrors: Record<string, string> = {};
  
                                    if (activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
                                      const applicantType = formikRef.current?.values?.applicantType;
                                      if (!applicantType) {
                                        extraErrors["applicantType"] =
                                          "Please select whether you are applying as a Student or a Co-applicant.";
                                    }
                                      const phoneVal = formikRef.current?.values?.phone_number;
                                      if (phoneVal && !isMobileVerified) {
                                        extraErrors["phone_number"] =
                                          "Mobile number verification is pending. Please enter the OTP to verify.";
                                      }
                                      const emailVal = formikRef.current?.values?.email;
                                      if (emailVal && !isEmailVerified) {
                                        extraErrors["email"] =
                                          "Email verification is pending. Please enter the OTP to verify.";
                                      }
                                    }
  
                                    const yupErrors = await validateForm();
                                    const mergedErrs = { ...yupErrors, ...extraErrors };
                                    const stepErrors = Object.keys(mergedErrs).filter(
                                      (key) => currentStepFieldNames.includes(key) && !isExcludedField(key)
                                    );
                                    
                                    if (Object.keys(extraErrors).length > 0) {
                                      Object.entries(extraErrors).forEach(([k, v]) =>
                                        formikRef.current?.setFieldError(k, v)
                                      );
                                    }
  
                                    if (stepErrors.length > 0) {
                                      const touchedObj: any = {};
                                      stepErrors.forEach((k) => (touchedObj[k] = true));
                                      formikRef.current?.setTouched({ ...formikRef.current?.touched, ...touchedObj }, false);
  
                                      const firstField = stepErrors[0];
                                      setTimeout(() => {
                                        const el = document.querySelector(`[name="${firstField}"]`) as HTMLElement | null;
                                        if (el && typeof el.scrollIntoView === "function") {
                                          el.scrollIntoView({ behavior: "smooth", block: "center" });
                                          try { el.focus(); } catch (e) {}
                                        } else {
                                          window.scrollTo({ top: 0, behavior: "smooth" });
                                        }
                                      }, 50);
  
                                      if(activeHorizontalIndex > 0) {
                                        dispatch(
                                          setStatusPopup({
                                            status: "error",
                                            message: "Please fill all required fields.",
                                          })
                                        );
                                      }
                                    } else {
                                      submitForm();
                                    }
                                  } : async () => {
                                    // Keep additional-details flow deterministic:
                                    // Applicant Additional -> Co-Applicant Additional -> Fund & Expense -> Reference & Collateral
                                    submitForm();
                                  }
                                }
                              >
                                {isSubmittingToAPI ? (
                                  <CircularProgress size={16} />
                                ) : isXsOrSm ? (
                                  "Save & Continue"
                                ) : (
                                  "Continue"
                                )}
                              </PrimaryButton>
                            </Box>
                          )}
                        {((activeHorizontalIndex === 0 &&
                          activeVerticalIndex > 0 &&
                          activeVerticalIndex < 3) ||
                          (activeHorizontalIndex === 1 &&
                            activeVerticalIndex > 0)) && isXsOrSm && isPreviousButton === true ? (
                          <Box sx={{ width: { xs: "100%", sm: 134 }, mb: isXsOrSm ? 2 : "0", mr: !isXsOrSm ? 2 : "0", mt: 2 }}>
                            <OutlinedPrimaryButton
                              width={isXsOrSm ? "100%" : "134px"}
                              type="button"
                              fullWidth
                              variant="outlined"
                              onClick={() => dispatch(prevVerticalStep())}
                              disabled={isSubmitting || isSubmittingToAPI}
                            >
                              <ArrowBackIcon sx={{ mr: !isXsOrSm ? 1 : 0 }} />

                              {"Previous"}
                            </OutlinedPrimaryButton>
                          </Box>
                        ) : null}
                      </Box>
                    </Box>
                  )}
                  
                </Form>
              );
            }}
          </Formik>
        </>
      )}

      <LoaderBackdrop
        open={
          isAadharLoading ||
          Object.values(isAadharCoApplicantLoading).some(Boolean)
        }
      />

      {/* Mobile OTP Modal */}
      <ModalPopup
        isOpen={openOtpModal}
        onClose={() => {
          setOpenOtpModal(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{ maxWidth: isAuthenticated && (otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/) ? true : !isEmailVerified) ? "600px" : "450px" }}
      >
        <OtpInputForm
          mobileMasked={otpMobileNumber.replace(/.(?=.{4})/g, "x")}
          onOtpSubmit={async (otp) => {
            try {
              const coApplicantPhoneMatch = otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/);

              // Determine the userType string
              let currentUserType = "Applicant"; // Default
              if (coApplicantPhoneMatch) {
                const coAppIndex = coApplicantPhoneMatch[1]; // This is '1', '2', etc.
                currentUserType = `Co-Applicant ${coAppIndex}`;
              }

              const verifyResp = await eligibilityCheckServices.verifyOtp({
                type: "mobile",
                mobileNumber: otpMobileNumber,
                key: otpKey,
                mobileOtp: otp,
                mobileOtpCrtdAt: otpTime,
                userType: currentUserType,
                ...(isAuthenticated && {
                  trackingId: trackingId,
                }),
              });
              if (verifyResp?.data?.status === "success") {

                if (activeHorizontalIndex === 0) {

                  trackCustomerJourneyEvent(
                    `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      category: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      action: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      page: "EligibiityCheck_Verify Yourself and Provide Consent_Mobile",
                    }
                  );

                } else if (activeHorizontalIndex === 1) {
                  const coApplicantPhoneMatchForOtp = otpMobileFieldName.match(
                    /^basicCoApplicant(\d+)PhoneNumber$/
                  );
                  const coAppNum = coApplicantPhoneMatchForOtp
                    ? String(Number(coApplicantPhoneMatchForOtp[1]))
                    : "0";
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      page: `ProvisionalOff_Loan Details_COAPP(${coAppNum}) Mobile Verification`,
                    }
                  );
                }
                setSnackbar({
                  open: true,
                  message: verifyResp?.data?.message,
                  severity: "success",
                });
                setOpenOtpModal(false);

                // Check which field is being verified
                const coApplicantPhoneMatch = otpMobileFieldName.match(
                  /^basicCoApplicant(\d+)PhoneNumber$/
                );
                if (coApplicantPhoneMatch) {
                  const idx = String(Number(coApplicantPhoneMatch[1]) - 1);
                  dispatch(
                    setCoApplicantVerification({
                      index: idx,
                      data: {
                        mobileVerified: true,
                        lastVerifiedMobileNumber: otpMobileNumber,
                      },
                    })
                  );
                  // Map value to Formik field
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      otpMobileFieldName,
                      otpMobileNumber
                    );
                  }
                } else {
                  dispatch(setIsMobileVerified(true));
                  dispatch(setLastVerifiedPhoneNumber(otpMobileNumber));
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      "phone_number",
                      otpMobileNumber
                    );
                  }
                }
              } else {
                dispatch(
                  setStatusPopup({
                    status: "error",
                    message: verifyResp?.data?.message,
                  })
                );
              }
            } catch (err: any) {
              setErrorMsg(
                // err?.response?.data?.message ||
                'Oops! Looks like you have entered the wrong OTP. Please try again or click "Resend OTP" to get a new one.'
              );
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          onResendOtp={async () => {
            let name = `${formikRef?.current?.values?.studentDetailsFirstName || ""} ${formikRef?.current?.values?.studentDetailsLastName || ""}`.trim();
            const coApplicantPhoneMatch = otpMobileFieldName.match(
              /^basicCoApplicant(\d+)PhoneNumber$/
            );
            if (coApplicantPhoneMatch) {
              // this will only work for coapplicant
              const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantPhoneMatch[1]))}FirstName`;
              name = formData[dynamicNameKey];   // co-applicant name
            }

            const resp = await eligibilityCheckServices.sendOtp({
              name: name,
              mobileNumber: otpMobileNumber,
            });
            setOtpKey(resp.data.data.value);
            setOtpTime(resp.data.data.otpTime);
            setErrorMsg(
              "A new OTP has been sent to your registered mobile number."
            );
          }}
          showConsentMessage={
            isAuthenticated ?
              otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/)
                ? true // Always true for Co-applicants on Mobile
                : !customerConsentTime// For Applicant: only true if consent not yet given AND email not yet verified
              : false
          }
        />
      </ModalPopup>

      {/* Email OTP Modal */}
      <ModalPopup
        isOpen={openEmailOtp}
        onClose={() => {
          setOpenEmailOtp(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{ maxWidth: isAuthenticated && (otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/) ? false : !isMobileVerified) ? "600px" : "450px" }}
      >
        <OtpInputForm
          emailMasked={
            otpEmail.length > 3
              ? otpEmail.slice(0, 3) +
              otpEmail.slice(3).replace(/.(?=.{4})/g, "x")
              : otpEmail.replace(/.(?=.{4})/g, "x")
          }
          onOtpSubmit={async (otp) => {
            try {
              const coApplicantEmailMatch = otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/);

              // Determine the userType string
              let currentUserType = "Applicant"; // Default
              if (coApplicantEmailMatch) {
                const coAppIndex = coApplicantEmailMatch[1]; // This is '1', '2', etc.
                currentUserType = `Co-Applicant ${coAppIndex}`;
              }
              const verifyResp = await eligibilityCheckServices.verifyOtp({
                type: "email",
                email: otpEmail,
                key: otpEmailKey,
                emailOtp: otp,
                emailOtpCrtdAt: otpEmailTime,
                userType: currentUserType,
                ...(isAuthenticated && {
                  trackingId: trackingId,
                }),
              });

              if (verifyResp?.data?.status === "success") {
                const isProvisionalStudentDetailsEmail =
                  activeHorizontalIndex === 1 && activeVerticalIndex === 0;
                const emailVerifyGaPrefix = isProvisionalStudentDetailsEmail
                  ? handleGAProvisionalOfferStatments
                  : handleGAEligibilityStatments;
                const emailVerifyGaEvent = isProvisionalStudentDetailsEmail
                  ? `${emailVerifyGaPrefix}_STDUENTDET_EMAIL_PAGE5`
                  : `${emailVerifyGaPrefix}_VERIFYYOURSELF_EMAIL_PAGE1`;
                const emailVerifyGaPage = isProvisionalStudentDetailsEmail
                  ? "ProvisionalOff_Student Details_Email"
                  : "EligibiityCheck_Verify Yourself and Provide Consent_Email";

                trackCustomerJourneyEvent(
                  emailVerifyGaEvent,
                  decrypt(userProfile?.id) ?? "",
                  trackingId,
                  {
                    label: emailVerifyGaEvent,
                    category: emailVerifyGaEvent,
                    action: emailVerifyGaEvent,
                    page: emailVerifyGaPage,
                  }
                );


                setSnackbar({
                  open: true,
                  message: verifyResp?.data?.message,
                  severity: "success",
                });
                setOpenEmailOtp(false);

                // Check which field is being verified
                const coApplicantEmailMatch = otpEmailFieldName.match(
                  /^basicCoApplicant(\d+)Email$/
                );
                if (coApplicantEmailMatch) {
                  const idx = String(Number(coApplicantEmailMatch[1]) - 1);
                  dispatch(
                    setCoApplicantVerification({
                      index: idx,
                      data: {
                        emailVerified: true,
                        lastVerifiedEmail: otpEmail,
                      },
                    })
                  );
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      otpEmailFieldName,
                      otpEmail
                    );
                  }
                } else {
                  dispatch(setIsEmailVerified(true));
                  dispatch(setLastVerifiedEmail(otpEmail));
                  if (formikRef.current) {
                    formikRef.current.setFieldValue("email", otpEmail);
                    formikRef.current.setFieldValue("studentDetailEmail", otpEmail);
                    formikRef.current.setFieldValue("isEmailVerified", true, false);
                  }
                  dispatch(
                    updateFormData({
                      email: otpEmail,
                      studentDetailEmail: otpEmail,
                      isEmailVerified: true,
                    })
                  );
                }
              } else {
                dispatch(
                  setStatusPopup({
                    status: "error",
                    message: verifyResp?.data?.message,
                  })
                );
              }
            } catch (err: any) {
              setErrorMsg(
                // err?.response?.data?.message ||
                'Oops! Looks like you have entered the wrong OTP. Please try again or click "Resend OTP" to get a new one.'
              );
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          onResendOtp={async () => {
            let name = `${formikRef?.current?.values?.studentDetailsFirstName || ""} ${formikRef?.current?.values?.studentDetailsLastName || ""}`.trim();

            const coApplicantEmailMatch = otpEmailFieldName.match(
              /^basicCoApplicant(\d+)Email$/
            );
            if (coApplicantEmailMatch) {
              // this will only work for coapplicant
              const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantEmailMatch[1]))}FirstName`;
              name = formData[dynamicNameKey];   // co-applicant name
            }

            const resp = await eligibilityCheckServices.sendOtp({
              name: name,
              email: otpEmail.toLowerCase(),
            });
            setOtpEmailKey(resp.data.data.value);
            setOtpEmailTime(resp.data.data.otpTime);
            setErrorMsg("A new OTP has been sent to your registered email ID.");
          }}
          showConsentMessage={
            isAuthenticated
              ? otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/)
                ? false // Always false for Co-applicants on Email
                : !customerConsentTime// For Applicant: only true if consent not yet given AND mobile not yet verified
              : false
          }
        />
      </ModalPopup>

      {/* Co-Applicant Modal */}
      <ModalPopup
        isOpen={openCoApplicantModal}
        onClose={() => setOpenCoApplicantModal(false)}
        title="Co-Applicant Selected"
      >
        <Typography sx={{ mt: 2 }}>
          Please enter the applicant's details.
        </Typography>
      </ModalPopup>

      {/* Purposes Anchor Modal */}
      <ModalPopup
        isOpen={openAnchorModal}
        onClose={() => setOpenAnchorModal(false)}
        title=""
      >
        {purposeItems.length > 0 ? (
          <Box component="ul" sx={{ pl: 3, mt: 1, mb: 0 }}>
            {purposeItems.map((item, idx) => (
              <Box component="li" key={idx} sx={{ mb: 1.25 }}>
                <Typography sx={{ m: 0 }}>{item}</Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography sx={{ mt: 2, whiteSpace: "pre-line" }}>
            {anchorModalContent}
          </Typography>
        )}
      </ModalPopup>

      {/* Alert  */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {/* Loader Backdrop for BRE checkOffer API */}
      <OfferCheckLoader
        open={isCheckingOffer}
        content="We are checking your eligibility"
      />
    </Box>
  );
};

export default React.memo(FormEdit);